import * as Types from 'graphql/types.generated'

import gql from 'graphql-tag'
import * as ApolloReactCommon from '@apollo/react-common'
import * as ApolloReactHooks from 'graphql/hooks'

export const AcessoAdministradorMunicipalFragmentDoc = gql`
  fragment AcessoAdministradorMunicipal on AdministradorMunicipal {
    municipio {
      id
      nome
    }
  }
`
export const AcessoGestorEstadualFragmentDoc = gql`
  fragment AcessoGestorEstadual on GestorEstadual {
    uf {
      id
      nome
    }
  }
`
export const AcessoGestorMunicipalFragmentDoc = gql`
  fragment AcessoGestorMunicipal on GestorMunicipal {
    municipio {
      id
      nome
    }
  }
`
export const AcessoLotacaoFragmentDoc = gql`
  fragment AcessoLotacao on Lotacao {
    cbo {
      id
      nome
      cbo2002
    }
    equipe {
      id
      nome
      ine
    }
    unidadeSaude {
      id
      nome
    }
  }
`
export const SessaoDataFragmentDoc = gql`
  fragment SessaoData on Sessao {
    id
    timeout
    recursos
    acesso {
      id
      tipo
      moduloInicial
      municipio {
        id
        nome
        uf {
          id
          nome
          sigla
        }
      }
      perfis {
        id
        nome
      }
      ... on AdministradorMunicipal {
        autorizado
        habilitado
      }
      ... on Lotacao {
        unidadeSaude {
          id
          nome
        }
        equipe {
          id
          nome
          ine
          tipoEquipe {
            id
            descricao
            nome
            sigla
          }
        }
        cbo {
          id
          nome
          cbo2002
        }
      }
    }
    profissional {
      id
      cns
      nome
      conselhoClasse {
        id
        sigla
        descricao
      }
      numeroConselhoClasse
      ufEmissoraConselhoClasse {
        id
        nome
        sigla
      }
      usuario {
        id
        aceitouTermosUso
        trocarSenha
        visualizouNovidades
        mostrarPesquisaSatisfacao
        hashId
      }
      acessos {
        id
        tipo
        ... on AdministradorMunicipal {
          ...AcessoAdministradorMunicipal
        }
        ... on GestorEstadual {
          ...AcessoGestorEstadual
        }
        ... on GestorMunicipal {
          ...AcessoGestorMunicipal
        }
        ... on Lotacao {
          ...AcessoLotacao
        }
      }
    }
  }
  ${AcessoAdministradorMunicipalFragmentDoc}
  ${AcessoGestorEstadualFragmentDoc}
  ${AcessoGestorMunicipalFragmentDoc}
  ${AcessoLotacaoFragmentDoc}
`
export const PageInfoFragmentDoc = gql`
  fragment PageInfo on PageInfo {
    number
    size
    totalPages
    totalElements
    sort
    first
    last
    numberOfElements
  }
`
export const ProcedimentoFragmentDoc = gql`
  fragment Procedimento on Procedimento {
    id
    descricao
    codigo
    procedimentoReferencia {
      id
      descricao
      codigo
    }
  }
`
export const ProfissionalDetailFragmentDoc = gql`
  fragment ProfissionalDetail on Profissional {
    cns
    conselhoClasse {
      id
      descricao
      sigla
    }
    cpf
    dataNascimento
    email
    endereco {
      bairro
      cep
      complemento
      logradouro
      numero
      pontoReferencia
      municipio {
        id
        ibge
        nome
        uf {
          id
          nome
          sigla
        }
      }
      semNumero
      tipoLogradouro {
        id
        nome
        numeroDne
      }
      uf {
        id
        nome
        sigla
      }
    }
    id
    nome
    numeroConselhoClasse
    sexo
    telefone
    ufEmissoraConselhoClasse {
      id
      nome
      sigla
    }
  }
`
export const LogoutDocument = gql`
  mutation Logout {
    logout {
      ...SessaoData
    }
  }
  ${SessaoDataFragmentDoc}
`
export type LogoutMutationFn = ApolloReactCommon.MutationFunction<Types.LogoutMutation, Types.LogoutMutationVariables>

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<Types.LogoutMutation, Types.LogoutMutationVariables>
) {
  return ApolloReactHooks.useMutation<Types.LogoutMutation, Types.LogoutMutationVariables>(LogoutDocument, baseOptions)
}
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>
export type LogoutMutationResult = ApolloReactCommon.MutationResult<Types.LogoutMutation>
export type LogoutMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.LogoutMutation,
  Types.LogoutMutationVariables
>
export const SessaoDocument = gql`
  query Sessao {
    sessao {
      ...SessaoData
    }
  }
  ${SessaoDataFragmentDoc}
`

/**
 * __useSessaoQuery__
 *
 * To run a query within a React component, call `useSessaoQuery` and pass it any options that fit your needs.
 * When your component renders, `useSessaoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSessaoQuery({
 *   variables: {
 *   },
 * });
 */
export function useSessaoQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.SessaoQuery, Types.SessaoQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.SessaoQuery, Types.SessaoQueryVariables>(SessaoDocument, baseOptions)
}
export function useSessaoLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.SessaoQuery, Types.SessaoQueryVariables>
) {
  return ApolloReactHooks.useLazyQuery<Types.SessaoQuery, Types.SessaoQueryVariables>(SessaoDocument, baseOptions)
}
export type SessaoQueryHookResult = ReturnType<typeof useSessaoQuery>
export type SessaoLazyQueryHookResult = ReturnType<typeof useSessaoLazyQuery>
export type SessaoQueryResult = ApolloReactCommon.QueryResult<Types.SessaoQuery, Types.SessaoQueryVariables>
export const EsusViewMountTargetDocument = gql`
  query EsusViewMountTarget {
    info {
      oldPecConnected
    }
  }
`

/**
 * __useEsusViewMountTargetQuery__
 *
 * To run a query within a React component, call `useEsusViewMountTargetQuery` and pass it any options that fit your needs.
 * When your component renders, `useEsusViewMountTargetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEsusViewMountTargetQuery({
 *   variables: {
 *   },
 * });
 */
export function useEsusViewMountTargetQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.EsusViewMountTargetQuery,
    Types.EsusViewMountTargetQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<Types.EsusViewMountTargetQuery, Types.EsusViewMountTargetQueryVariables>(
    EsusViewMountTargetDocument,
    baseOptions
  )
}
export function useEsusViewMountTargetLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.EsusViewMountTargetQuery,
    Types.EsusViewMountTargetQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<Types.EsusViewMountTargetQuery, Types.EsusViewMountTargetQueryVariables>(
    EsusViewMountTargetDocument,
    baseOptions
  )
}
export type EsusViewMountTargetQueryHookResult = ReturnType<typeof useEsusViewMountTargetQuery>
export type EsusViewMountTargetLazyQueryHookResult = ReturnType<typeof useEsusViewMountTargetLazyQuery>
export type EsusViewMountTargetQueryResult = ApolloReactCommon.QueryResult<
  Types.EsusViewMountTargetQuery,
  Types.EsusViewMountTargetQueryVariables
>
export const FirebaseDocument = gql`
  query Firebase {
    info {
      firebaseEnabled
    }
  }
`

/**
 * __useFirebaseQuery__
 *
 * To run a query within a React component, call `useFirebaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useFirebaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFirebaseQuery({
 *   variables: {
 *   },
 * });
 */
export function useFirebaseQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.FirebaseQuery, Types.FirebaseQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.FirebaseQuery, Types.FirebaseQueryVariables>(FirebaseDocument, baseOptions)
}
export function useFirebaseLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.FirebaseQuery, Types.FirebaseQueryVariables>
) {
  return ApolloReactHooks.useLazyQuery<Types.FirebaseQuery, Types.FirebaseQueryVariables>(FirebaseDocument, baseOptions)
}
export type FirebaseQueryHookResult = ReturnType<typeof useFirebaseQuery>
export type FirebaseLazyQueryHookResult = ReturnType<typeof useFirebaseLazyQuery>
export type FirebaseQueryResult = ApolloReactCommon.QueryResult<Types.FirebaseQuery, Types.FirebaseQueryVariables>
export const EnderecoDocument = gql`
  query Endereco($cep: String!) {
    endereco(cep: $cep) {
      municipio {
        id
        nome
      }
      uf {
        id
        nome
        sigla
      }
      logradouro
      tipoLogradouro {
        id
        nome
      }
      bairro {
        id
        nome
      }
    }
  }
`

/**
 * __useEnderecoQuery__
 *
 * To run a query within a React component, call `useEnderecoQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnderecoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnderecoQuery({
 *   variables: {
 *      cep: // value for 'cep'
 *   },
 * });
 */
export function useEnderecoQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.EnderecoQuery, Types.EnderecoQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.EnderecoQuery, Types.EnderecoQueryVariables>(EnderecoDocument, baseOptions)
}
export function useEnderecoLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.EnderecoQuery, Types.EnderecoQueryVariables>
) {
  return ApolloReactHooks.useLazyQuery<Types.EnderecoQuery, Types.EnderecoQueryVariables>(EnderecoDocument, baseOptions)
}
export type EnderecoQueryHookResult = ReturnType<typeof useEnderecoQuery>
export type EnderecoLazyQueryHookResult = ReturnType<typeof useEnderecoLazyQuery>
export type EnderecoQueryResult = ApolloReactCommon.QueryResult<Types.EnderecoQuery, Types.EnderecoQueryVariables>
export const BairroSelectFieldDocument = gql`
  query BairroSelectField($input: BairroInput!) {
    bairros(input: $input) {
      content {
        id
        nome
        municipio {
          id
          nome
        }
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${PageInfoFragmentDoc}
`

/**
 * __useBairroSelectFieldQuery__
 *
 * To run a query within a React component, call `useBairroSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useBairroSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBairroSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBairroSelectFieldQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.BairroSelectFieldQuery, Types.BairroSelectFieldQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.BairroSelectFieldQuery, Types.BairroSelectFieldQueryVariables>(
    BairroSelectFieldDocument,
    baseOptions
  )
}
export function useBairroSelectFieldLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.BairroSelectFieldQuery,
    Types.BairroSelectFieldQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<Types.BairroSelectFieldQuery, Types.BairroSelectFieldQueryVariables>(
    BairroSelectFieldDocument,
    baseOptions
  )
}
export type BairroSelectFieldQueryHookResult = ReturnType<typeof useBairroSelectFieldQuery>
export type BairroSelectFieldLazyQueryHookResult = ReturnType<typeof useBairroSelectFieldLazyQuery>
export type BairroSelectFieldQueryResult = ApolloReactCommon.QueryResult<
  Types.BairroSelectFieldQuery,
  Types.BairroSelectFieldQueryVariables
>
export const CboSelectFieldDocument = gql`
  query CboSelectField($input: CbosMunicipioQueryInput!) {
    cbos(input: $input) {
      content {
        cbo {
          id
          nome
          cbo2002
        }
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${PageInfoFragmentDoc}
`

/**
 * __useCboSelectFieldQuery__
 *
 * To run a query within a React component, call `useCboSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useCboSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCboSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCboSelectFieldQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.CboSelectFieldQuery, Types.CboSelectFieldQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.CboSelectFieldQuery, Types.CboSelectFieldQueryVariables>(
    CboSelectFieldDocument,
    baseOptions
  )
}
export function useCboSelectFieldLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CboSelectFieldQuery, Types.CboSelectFieldQueryVariables>
) {
  return ApolloReactHooks.useLazyQuery<Types.CboSelectFieldQuery, Types.CboSelectFieldQueryVariables>(
    CboSelectFieldDocument,
    baseOptions
  )
}
export type CboSelectFieldQueryHookResult = ReturnType<typeof useCboSelectFieldQuery>
export type CboSelectFieldLazyQueryHookResult = ReturnType<typeof useCboSelectFieldLazyQuery>
export type CboSelectFieldQueryResult = ApolloReactCommon.QueryResult<
  Types.CboSelectFieldQuery,
  Types.CboSelectFieldQueryVariables
>
export const CiapCid10SelectFieldDocument = gql`
  query CiapCid10SelectField($inputCiap: CiapQueryInput!, $inputCid10: Cid10QueryInput!) {
    ciaps(input: $inputCiap) {
      content {
        id
        codigo
        nome: descricao
      }
      pageInfo {
        ...PageInfo
      }
    }
    cids(input: $inputCid10) {
      content {
        id
        codigo
        nome
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${PageInfoFragmentDoc}
`

/**
 * __useCiapCid10SelectFieldQuery__
 *
 * To run a query within a React component, call `useCiapCid10SelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useCiapCid10SelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCiapCid10SelectFieldQuery({
 *   variables: {
 *      inputCiap: // value for 'inputCiap'
 *      inputCid10: // value for 'inputCid10'
 *   },
 * });
 */
export function useCiapCid10SelectFieldQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.CiapCid10SelectFieldQuery,
    Types.CiapCid10SelectFieldQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<Types.CiapCid10SelectFieldQuery, Types.CiapCid10SelectFieldQueryVariables>(
    CiapCid10SelectFieldDocument,
    baseOptions
  )
}
export function useCiapCid10SelectFieldLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.CiapCid10SelectFieldQuery,
    Types.CiapCid10SelectFieldQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<Types.CiapCid10SelectFieldQuery, Types.CiapCid10SelectFieldQueryVariables>(
    CiapCid10SelectFieldDocument,
    baseOptions
  )
}
export type CiapCid10SelectFieldQueryHookResult = ReturnType<typeof useCiapCid10SelectFieldQuery>
export type CiapCid10SelectFieldLazyQueryHookResult = ReturnType<typeof useCiapCid10SelectFieldLazyQuery>
export type CiapCid10SelectFieldQueryResult = ApolloReactCommon.QueryResult<
  Types.CiapCid10SelectFieldQuery,
  Types.CiapCid10SelectFieldQueryVariables
>
export const CiapSelectFieldDocument = gql`
  query CiapSelectField($input: CiapQueryInput!) {
    ciaps(input: $input) {
      content {
        id
        codigo
        nome: descricao
        inclui
        exclui
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${PageInfoFragmentDoc}
`

/**
 * __useCiapSelectFieldQuery__
 *
 * To run a query within a React component, call `useCiapSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useCiapSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCiapSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCiapSelectFieldQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.CiapSelectFieldQuery, Types.CiapSelectFieldQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.CiapSelectFieldQuery, Types.CiapSelectFieldQueryVariables>(
    CiapSelectFieldDocument,
    baseOptions
  )
}
export function useCiapSelectFieldLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CiapSelectFieldQuery, Types.CiapSelectFieldQueryVariables>
) {
  return ApolloReactHooks.useLazyQuery<Types.CiapSelectFieldQuery, Types.CiapSelectFieldQueryVariables>(
    CiapSelectFieldDocument,
    baseOptions
  )
}
export type CiapSelectFieldQueryHookResult = ReturnType<typeof useCiapSelectFieldQuery>
export type CiapSelectFieldLazyQueryHookResult = ReturnType<typeof useCiapSelectFieldLazyQuery>
export type CiapSelectFieldQueryResult = ApolloReactCommon.QueryResult<
  Types.CiapSelectFieldQuery,
  Types.CiapSelectFieldQueryVariables
>
export const CidSelectFieldDocument = gql`
  query CidSelectField($input: Cid10QueryInput!) {
    cids(input: $input) {
      content {
        id
        codigo
        nome
        ciapsRelacionadas {
          id
        }
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${PageInfoFragmentDoc}
`

/**
 * __useCidSelectFieldQuery__
 *
 * To run a query within a React component, call `useCidSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useCidSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCidSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCidSelectFieldQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.CidSelectFieldQuery, Types.CidSelectFieldQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.CidSelectFieldQuery, Types.CidSelectFieldQueryVariables>(
    CidSelectFieldDocument,
    baseOptions
  )
}
export function useCidSelectFieldLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CidSelectFieldQuery, Types.CidSelectFieldQueryVariables>
) {
  return ApolloReactHooks.useLazyQuery<Types.CidSelectFieldQuery, Types.CidSelectFieldQueryVariables>(
    CidSelectFieldDocument,
    baseOptions
  )
}
export type CidSelectFieldQueryHookResult = ReturnType<typeof useCidSelectFieldQuery>
export type CidSelectFieldLazyQueryHookResult = ReturnType<typeof useCidSelectFieldLazyQuery>
export type CidSelectFieldQueryResult = ApolloReactCommon.QueryResult<
  Types.CidSelectFieldQuery,
  Types.CidSelectFieldQueryVariables
>
export const CidadaoAtendimentoSelectFieldDocument = gql`
  query CidadaoAtendimentoSelectField($input: CidadaosComboQueryInput!) {
    cidadaosCombo(input: $input) {
      id
      nome
      nomeSocial
      cpf
      cns
      nomeMae
      dataNascimento
      presenteListaAtendimento
    }
  }
`

/**
 * __useCidadaoAtendimentoSelectFieldQuery__
 *
 * To run a query within a React component, call `useCidadaoAtendimentoSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useCidadaoAtendimentoSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCidadaoAtendimentoSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCidadaoAtendimentoSelectFieldQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.CidadaoAtendimentoSelectFieldQuery,
    Types.CidadaoAtendimentoSelectFieldQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    Types.CidadaoAtendimentoSelectFieldQuery,
    Types.CidadaoAtendimentoSelectFieldQueryVariables
  >(CidadaoAtendimentoSelectFieldDocument, baseOptions)
}
export function useCidadaoAtendimentoSelectFieldLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.CidadaoAtendimentoSelectFieldQuery,
    Types.CidadaoAtendimentoSelectFieldQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    Types.CidadaoAtendimentoSelectFieldQuery,
    Types.CidadaoAtendimentoSelectFieldQueryVariables
  >(CidadaoAtendimentoSelectFieldDocument, baseOptions)
}
export type CidadaoAtendimentoSelectFieldQueryHookResult = ReturnType<typeof useCidadaoAtendimentoSelectFieldQuery>
export type CidadaoAtendimentoSelectFieldLazyQueryHookResult = ReturnType<
  typeof useCidadaoAtendimentoSelectFieldLazyQuery
>
export type CidadaoAtendimentoSelectFieldQueryResult = ApolloReactCommon.QueryResult<
  Types.CidadaoAtendimentoSelectFieldQuery,
  Types.CidadaoAtendimentoSelectFieldQueryVariables
>
export const CidadaoSelectFieldDocument = gql`
  query CidadaoSelectField($input: CidadaosQueryInput!) {
    cidadaos(input: $input) {
      content {
        id
        nome
        nomeSocial
        cpf
        cns
        nomeMae
        dataNascimento
        sexo
        identidadeGeneroDbEnum
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${PageInfoFragmentDoc}
`

/**
 * __useCidadaoSelectFieldQuery__
 *
 * To run a query within a React component, call `useCidadaoSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useCidadaoSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCidadaoSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCidadaoSelectFieldQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.CidadaoSelectFieldQuery, Types.CidadaoSelectFieldQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.CidadaoSelectFieldQuery, Types.CidadaoSelectFieldQueryVariables>(
    CidadaoSelectFieldDocument,
    baseOptions
  )
}
export function useCidadaoSelectFieldLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.CidadaoSelectFieldQuery,
    Types.CidadaoSelectFieldQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<Types.CidadaoSelectFieldQuery, Types.CidadaoSelectFieldQueryVariables>(
    CidadaoSelectFieldDocument,
    baseOptions
  )
}
export type CidadaoSelectFieldQueryHookResult = ReturnType<typeof useCidadaoSelectFieldQuery>
export type CidadaoSelectFieldLazyQueryHookResult = ReturnType<typeof useCidadaoSelectFieldLazyQuery>
export type CidadaoSelectFieldQueryResult = ApolloReactCommon.QueryResult<
  Types.CidadaoSelectFieldQuery,
  Types.CidadaoSelectFieldQueryVariables
>
export const ConselhoClasseSelectDocument = gql`
  query ConselhoClasseSelect($input: ConselhoClasseQueryInput!) {
    conselhosClasse(input: $input) {
      content {
        id
        descricao
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${PageInfoFragmentDoc}
`

/**
 * __useConselhoClasseSelectQuery__
 *
 * To run a query within a React component, call `useConselhoClasseSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useConselhoClasseSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConselhoClasseSelectQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConselhoClasseSelectQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.ConselhoClasseSelectQuery,
    Types.ConselhoClasseSelectQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<Types.ConselhoClasseSelectQuery, Types.ConselhoClasseSelectQueryVariables>(
    ConselhoClasseSelectDocument,
    baseOptions
  )
}
export function useConselhoClasseSelectLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.ConselhoClasseSelectQuery,
    Types.ConselhoClasseSelectQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<Types.ConselhoClasseSelectQuery, Types.ConselhoClasseSelectQueryVariables>(
    ConselhoClasseSelectDocument,
    baseOptions
  )
}
export type ConselhoClasseSelectQueryHookResult = ReturnType<typeof useConselhoClasseSelectQuery>
export type ConselhoClasseSelectLazyQueryHookResult = ReturnType<typeof useConselhoClasseSelectLazyQuery>
export type ConselhoClasseSelectQueryResult = ApolloReactCommon.QueryResult<
  Types.ConselhoClasseSelectQuery,
  Types.ConselhoClasseSelectQueryVariables
>
export const EquipeSelectFieldDocument = gql`
  query EquipeSelectField($unidadeSaudeId: ID!, $input: EquipesConnectionInput!) {
    unidadeSaude(id: $unidadeSaudeId) {
      id
      equipes(input: $input) {
        content {
          id
          nome
          ine
          tipoEquipe {
            id
            nome
            sigla
          }
        }
        pageInfo {
          ...PageInfo
        }
      }
    }
  }
  ${PageInfoFragmentDoc}
`

/**
 * __useEquipeSelectFieldQuery__
 *
 * To run a query within a React component, call `useEquipeSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useEquipeSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEquipeSelectFieldQuery({
 *   variables: {
 *      unidadeSaudeId: // value for 'unidadeSaudeId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEquipeSelectFieldQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.EquipeSelectFieldQuery, Types.EquipeSelectFieldQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.EquipeSelectFieldQuery, Types.EquipeSelectFieldQueryVariables>(
    EquipeSelectFieldDocument,
    baseOptions
  )
}
export function useEquipeSelectFieldLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.EquipeSelectFieldQuery,
    Types.EquipeSelectFieldQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<Types.EquipeSelectFieldQuery, Types.EquipeSelectFieldQueryVariables>(
    EquipeSelectFieldDocument,
    baseOptions
  )
}
export type EquipeSelectFieldQueryHookResult = ReturnType<typeof useEquipeSelectFieldQuery>
export type EquipeSelectFieldLazyQueryHookResult = ReturnType<typeof useEquipeSelectFieldLazyQuery>
export type EquipeSelectFieldQueryResult = ApolloReactCommon.QueryResult<
  Types.EquipeSelectFieldQuery,
  Types.EquipeSelectFieldQueryVariables
>
export const EtniaSelectFieldDocument = gql`
  query EtniaSelectField($input: EtniaQueryInput!) {
    etnias(input: $input) {
      content {
        id
        nome
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${PageInfoFragmentDoc}
`

/**
 * __useEtniaSelectFieldQuery__
 *
 * To run a query within a React component, call `useEtniaSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useEtniaSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEtniaSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEtniaSelectFieldQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.EtniaSelectFieldQuery, Types.EtniaSelectFieldQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.EtniaSelectFieldQuery, Types.EtniaSelectFieldQueryVariables>(
    EtniaSelectFieldDocument,
    baseOptions
  )
}
export function useEtniaSelectFieldLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.EtniaSelectFieldQuery, Types.EtniaSelectFieldQueryVariables>
) {
  return ApolloReactHooks.useLazyQuery<Types.EtniaSelectFieldQuery, Types.EtniaSelectFieldQueryVariables>(
    EtniaSelectFieldDocument,
    baseOptions
  )
}
export type EtniaSelectFieldQueryHookResult = ReturnType<typeof useEtniaSelectFieldQuery>
export type EtniaSelectFieldLazyQueryHookResult = ReturnType<typeof useEtniaSelectFieldLazyQuery>
export type EtniaSelectFieldQueryResult = ApolloReactCommon.QueryResult<
  Types.EtniaSelectFieldQuery,
  Types.EtniaSelectFieldQueryVariables
>
export const FichaNotificacaoCasoSuspeitoSelectFieldDocument = gql`
  query FichaNotificacaoCasoSuspeitoSelectField($input: FichaNotificacaoQueryInput!) {
    fichasNotificacao(input: $input) {
      content {
        id
        descricao
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${PageInfoFragmentDoc}
`

/**
 * __useFichaNotificacaoCasoSuspeitoSelectFieldQuery__
 *
 * To run a query within a React component, call `useFichaNotificacaoCasoSuspeitoSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useFichaNotificacaoCasoSuspeitoSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFichaNotificacaoCasoSuspeitoSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFichaNotificacaoCasoSuspeitoSelectFieldQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.FichaNotificacaoCasoSuspeitoSelectFieldQuery,
    Types.FichaNotificacaoCasoSuspeitoSelectFieldQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    Types.FichaNotificacaoCasoSuspeitoSelectFieldQuery,
    Types.FichaNotificacaoCasoSuspeitoSelectFieldQueryVariables
  >(FichaNotificacaoCasoSuspeitoSelectFieldDocument, baseOptions)
}
export function useFichaNotificacaoCasoSuspeitoSelectFieldLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.FichaNotificacaoCasoSuspeitoSelectFieldQuery,
    Types.FichaNotificacaoCasoSuspeitoSelectFieldQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    Types.FichaNotificacaoCasoSuspeitoSelectFieldQuery,
    Types.FichaNotificacaoCasoSuspeitoSelectFieldQueryVariables
  >(FichaNotificacaoCasoSuspeitoSelectFieldDocument, baseOptions)
}
export type FichaNotificacaoCasoSuspeitoSelectFieldQueryHookResult = ReturnType<
  typeof useFichaNotificacaoCasoSuspeitoSelectFieldQuery
>
export type FichaNotificacaoCasoSuspeitoSelectFieldLazyQueryHookResult = ReturnType<
  typeof useFichaNotificacaoCasoSuspeitoSelectFieldLazyQuery
>
export type FichaNotificacaoCasoSuspeitoSelectFieldQueryResult = ApolloReactCommon.QueryResult<
  Types.FichaNotificacaoCasoSuspeitoSelectFieldQuery,
  Types.FichaNotificacaoCasoSuspeitoSelectFieldQueryVariables
>
export const FormaFarmaceuticaSelectFieldDocument = gql`
  query FormaFarmaceuticaSelectField($input: FormaFarmaceuticaQueryInput!) {
    formasFarmaceuticas(input: $input) {
      content {
        id
        nome
      }
    }
  }
`

/**
 * __useFormaFarmaceuticaSelectFieldQuery__
 *
 * To run a query within a React component, call `useFormaFarmaceuticaSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormaFarmaceuticaSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormaFarmaceuticaSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFormaFarmaceuticaSelectFieldQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.FormaFarmaceuticaSelectFieldQuery,
    Types.FormaFarmaceuticaSelectFieldQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    Types.FormaFarmaceuticaSelectFieldQuery,
    Types.FormaFarmaceuticaSelectFieldQueryVariables
  >(FormaFarmaceuticaSelectFieldDocument, baseOptions)
}
export function useFormaFarmaceuticaSelectFieldLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.FormaFarmaceuticaSelectFieldQuery,
    Types.FormaFarmaceuticaSelectFieldQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    Types.FormaFarmaceuticaSelectFieldQuery,
    Types.FormaFarmaceuticaSelectFieldQueryVariables
  >(FormaFarmaceuticaSelectFieldDocument, baseOptions)
}
export type FormaFarmaceuticaSelectFieldQueryHookResult = ReturnType<typeof useFormaFarmaceuticaSelectFieldQuery>
export type FormaFarmaceuticaSelectFieldLazyQueryHookResult = ReturnType<
  typeof useFormaFarmaceuticaSelectFieldLazyQuery
>
export type FormaFarmaceuticaSelectFieldQueryResult = ApolloReactCommon.QueryResult<
  Types.FormaFarmaceuticaSelectFieldQuery,
  Types.FormaFarmaceuticaSelectFieldQueryVariables
>
export const GrupoCondicaoSelectFieldDocument = gql`
  query GrupoCondicaoSelectField($inputGrupo: GrupoCondicaoQueryInput!) {
    grupos(input: $inputGrupo) {
      content {
        id
        grupoCondicao
        ciaps {
          id
          codigo
          nome: descricao
        }
        cids {
          id
          codigo
          nome
        }
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${PageInfoFragmentDoc}
`

/**
 * __useGrupoCondicaoSelectFieldQuery__
 *
 * To run a query within a React component, call `useGrupoCondicaoSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useGrupoCondicaoSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGrupoCondicaoSelectFieldQuery({
 *   variables: {
 *      inputGrupo: // value for 'inputGrupo'
 *   },
 * });
 */
export function useGrupoCondicaoSelectFieldQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GrupoCondicaoSelectFieldQuery,
    Types.GrupoCondicaoSelectFieldQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<Types.GrupoCondicaoSelectFieldQuery, Types.GrupoCondicaoSelectFieldQueryVariables>(
    GrupoCondicaoSelectFieldDocument,
    baseOptions
  )
}
export function useGrupoCondicaoSelectFieldLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GrupoCondicaoSelectFieldQuery,
    Types.GrupoCondicaoSelectFieldQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    Types.GrupoCondicaoSelectFieldQuery,
    Types.GrupoCondicaoSelectFieldQueryVariables
  >(GrupoCondicaoSelectFieldDocument, baseOptions)
}
export type GrupoCondicaoSelectFieldQueryHookResult = ReturnType<typeof useGrupoCondicaoSelectFieldQuery>
export type GrupoCondicaoSelectFieldLazyQueryHookResult = ReturnType<typeof useGrupoCondicaoSelectFieldLazyQuery>
export type GrupoCondicaoSelectFieldQueryResult = ApolloReactCommon.QueryResult<
  Types.GrupoCondicaoSelectFieldQuery,
  Types.GrupoCondicaoSelectFieldQueryVariables
>
export const LogradouroSelectFieldDocument = gql`
  query LogradouroSelectField($input: LogradouroInput!) {
    logradouros(input: $input) {
      content {
        id
        nome
        nomeExibicao
        cep
        bairro {
          id
          nome
          municipio {
            id
            nome
            uf {
              id
              sigla
            }
          }
        }
        tipoLogradouro {
          id
          nome
        }
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${PageInfoFragmentDoc}
`

/**
 * __useLogradouroSelectFieldQuery__
 *
 * To run a query within a React component, call `useLogradouroSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useLogradouroSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLogradouroSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLogradouroSelectFieldQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.LogradouroSelectFieldQuery,
    Types.LogradouroSelectFieldQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<Types.LogradouroSelectFieldQuery, Types.LogradouroSelectFieldQueryVariables>(
    LogradouroSelectFieldDocument,
    baseOptions
  )
}
export function useLogradouroSelectFieldLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.LogradouroSelectFieldQuery,
    Types.LogradouroSelectFieldQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<Types.LogradouroSelectFieldQuery, Types.LogradouroSelectFieldQueryVariables>(
    LogradouroSelectFieldDocument,
    baseOptions
  )
}
export type LogradouroSelectFieldQueryHookResult = ReturnType<typeof useLogradouroSelectFieldQuery>
export type LogradouroSelectFieldLazyQueryHookResult = ReturnType<typeof useLogradouroSelectFieldLazyQuery>
export type LogradouroSelectFieldQueryResult = ApolloReactCommon.QueryResult<
  Types.LogradouroSelectFieldQuery,
  Types.LogradouroSelectFieldQueryVariables
>
export const LotacaoProfissionalSelectDocument = gql`
  query LotacaoProfissionalSelect($input: LotacoesInput!) {
    lotacoes(input: $input) {
      content {
        id
        cbo {
          id
          nome
          cbo2002
        }
        equipe {
          id
          nome
          ine
        }
        unidadeSaude {
          id
          nome
          cnes
        }
        profissional {
          id
          nome
          cns
        }
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${PageInfoFragmentDoc}
`

/**
 * __useLotacaoProfissionalSelectQuery__
 *
 * To run a query within a React component, call `useLotacaoProfissionalSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useLotacaoProfissionalSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLotacaoProfissionalSelectQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLotacaoProfissionalSelectQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.LotacaoProfissionalSelectQuery,
    Types.LotacaoProfissionalSelectQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<Types.LotacaoProfissionalSelectQuery, Types.LotacaoProfissionalSelectQueryVariables>(
    LotacaoProfissionalSelectDocument,
    baseOptions
  )
}
export function useLotacaoProfissionalSelectLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.LotacaoProfissionalSelectQuery,
    Types.LotacaoProfissionalSelectQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    Types.LotacaoProfissionalSelectQuery,
    Types.LotacaoProfissionalSelectQueryVariables
  >(LotacaoProfissionalSelectDocument, baseOptions)
}
export type LotacaoProfissionalSelectQueryHookResult = ReturnType<typeof useLotacaoProfissionalSelectQuery>
export type LotacaoProfissionalSelectLazyQueryHookResult = ReturnType<typeof useLotacaoProfissionalSelectLazyQuery>
export type LotacaoProfissionalSelectQueryResult = ApolloReactCommon.QueryResult<
  Types.LotacaoProfissionalSelectQuery,
  Types.LotacaoProfissionalSelectQueryVariables
>
export const MedicamentoCatmatSelectFieldDocument = gql`
  query MedicamentoCatmatSelectField($input: MedicamentoCatmatQueryInput!) {
    medicamentosCatmat(input: $input) {
      content {
        id
        volume
        medicamento {
          id
          principioAtivo
          unidadeFornecimento
          concentracao
          formaFarmaceutica {
            id
            nome
          }
        }
        codigoCatMat
        codigoRename
        unidadeFornecimento {
          id
          nome
          nomePlural
        }
        principioAtivo {
          id
          nome
          listaMaterial {
            id
            nome
            tipoReceita
          }
        }
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${PageInfoFragmentDoc}
`

/**
 * __useMedicamentoCatmatSelectFieldQuery__
 *
 * To run a query within a React component, call `useMedicamentoCatmatSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useMedicamentoCatmatSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMedicamentoCatmatSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMedicamentoCatmatSelectFieldQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.MedicamentoCatmatSelectFieldQuery,
    Types.MedicamentoCatmatSelectFieldQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    Types.MedicamentoCatmatSelectFieldQuery,
    Types.MedicamentoCatmatSelectFieldQueryVariables
  >(MedicamentoCatmatSelectFieldDocument, baseOptions)
}
export function useMedicamentoCatmatSelectFieldLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.MedicamentoCatmatSelectFieldQuery,
    Types.MedicamentoCatmatSelectFieldQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    Types.MedicamentoCatmatSelectFieldQuery,
    Types.MedicamentoCatmatSelectFieldQueryVariables
  >(MedicamentoCatmatSelectFieldDocument, baseOptions)
}
export type MedicamentoCatmatSelectFieldQueryHookResult = ReturnType<typeof useMedicamentoCatmatSelectFieldQuery>
export type MedicamentoCatmatSelectFieldLazyQueryHookResult = ReturnType<
  typeof useMedicamentoCatmatSelectFieldLazyQuery
>
export type MedicamentoCatmatSelectFieldQueryResult = ApolloReactCommon.QueryResult<
  Types.MedicamentoCatmatSelectFieldQuery,
  Types.MedicamentoCatmatSelectFieldQueryVariables
>
export const MunicipioSelectFieldDocument = gql`
  query MunicipioSelectField($input: MunicipiosQueryInput!) {
    municipios(input: $input) {
      content {
        id
        nome
        uf {
          id
          nome
          sigla
        }
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${PageInfoFragmentDoc}
`

/**
 * __useMunicipioSelectFieldQuery__
 *
 * To run a query within a React component, call `useMunicipioSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useMunicipioSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMunicipioSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMunicipioSelectFieldQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.MunicipioSelectFieldQuery,
    Types.MunicipioSelectFieldQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<Types.MunicipioSelectFieldQuery, Types.MunicipioSelectFieldQueryVariables>(
    MunicipioSelectFieldDocument,
    baseOptions
  )
}
export function useMunicipioSelectFieldLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.MunicipioSelectFieldQuery,
    Types.MunicipioSelectFieldQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<Types.MunicipioSelectFieldQuery, Types.MunicipioSelectFieldQueryVariables>(
    MunicipioSelectFieldDocument,
    baseOptions
  )
}
export type MunicipioSelectFieldQueryHookResult = ReturnType<typeof useMunicipioSelectFieldQuery>
export type MunicipioSelectFieldLazyQueryHookResult = ReturnType<typeof useMunicipioSelectFieldLazyQuery>
export type MunicipioSelectFieldQueryResult = ApolloReactCommon.QueryResult<
  Types.MunicipioSelectFieldQuery,
  Types.MunicipioSelectFieldQueryVariables
>
export const PaisSelectFieldDocument = gql`
  query PaisSelectField($input: PaisQueryInput!) {
    paises(input: $input) {
      content {
        id
        nome
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${PageInfoFragmentDoc}
`

/**
 * __usePaisSelectFieldQuery__
 *
 * To run a query within a React component, call `usePaisSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaisSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaisSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePaisSelectFieldQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.PaisSelectFieldQuery, Types.PaisSelectFieldQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.PaisSelectFieldQuery, Types.PaisSelectFieldQueryVariables>(
    PaisSelectFieldDocument,
    baseOptions
  )
}
export function usePaisSelectFieldLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.PaisSelectFieldQuery, Types.PaisSelectFieldQueryVariables>
) {
  return ApolloReactHooks.useLazyQuery<Types.PaisSelectFieldQuery, Types.PaisSelectFieldQueryVariables>(
    PaisSelectFieldDocument,
    baseOptions
  )
}
export type PaisSelectFieldQueryHookResult = ReturnType<typeof usePaisSelectFieldQuery>
export type PaisSelectFieldLazyQueryHookResult = ReturnType<typeof usePaisSelectFieldLazyQuery>
export type PaisSelectFieldQueryResult = ApolloReactCommon.QueryResult<
  Types.PaisSelectFieldQuery,
  Types.PaisSelectFieldQueryVariables
>
export const PerfilSelectFieldDocument = gql`
  query PerfilSelectField($input: PerfisQueryInput!) {
    perfis(input: $input) {
      content {
        id
        nome
        ativo
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${PageInfoFragmentDoc}
`

/**
 * __usePerfilSelectFieldQuery__
 *
 * To run a query within a React component, call `usePerfilSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `usePerfilSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePerfilSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePerfilSelectFieldQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.PerfilSelectFieldQuery, Types.PerfilSelectFieldQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.PerfilSelectFieldQuery, Types.PerfilSelectFieldQueryVariables>(
    PerfilSelectFieldDocument,
    baseOptions
  )
}
export function usePerfilSelectFieldLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.PerfilSelectFieldQuery,
    Types.PerfilSelectFieldQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<Types.PerfilSelectFieldQuery, Types.PerfilSelectFieldQueryVariables>(
    PerfilSelectFieldDocument,
    baseOptions
  )
}
export type PerfilSelectFieldQueryHookResult = ReturnType<typeof usePerfilSelectFieldQuery>
export type PerfilSelectFieldLazyQueryHookResult = ReturnType<typeof usePerfilSelectFieldLazyQuery>
export type PerfilSelectFieldQueryResult = ApolloReactCommon.QueryResult<
  Types.PerfilSelectFieldQuery,
  Types.PerfilSelectFieldQueryVariables
>
export const ProblemaCondicaoSelectFieldDocument = gql`
  query ProblemaCondicaoSelectField($filtro: ProblemaQueryInput!) {
    problemas(input: $filtro) {
      content {
        id
        situacao
        ciap {
          id
          codigo
          descricao
        }
        cid10 {
          id
          codigo
          nome
        }
        descricaoOutro
        ultimaEvolucao {
          id
          dataInicio
          dataFim
          observacao
        }
      }
    }
  }
`

/**
 * __useProblemaCondicaoSelectFieldQuery__
 *
 * To run a query within a React component, call `useProblemaCondicaoSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useProblemaCondicaoSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProblemaCondicaoSelectFieldQuery({
 *   variables: {
 *      filtro: // value for 'filtro'
 *   },
 * });
 */
export function useProblemaCondicaoSelectFieldQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.ProblemaCondicaoSelectFieldQuery,
    Types.ProblemaCondicaoSelectFieldQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    Types.ProblemaCondicaoSelectFieldQuery,
    Types.ProblemaCondicaoSelectFieldQueryVariables
  >(ProblemaCondicaoSelectFieldDocument, baseOptions)
}
export function useProblemaCondicaoSelectFieldLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.ProblemaCondicaoSelectFieldQuery,
    Types.ProblemaCondicaoSelectFieldQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    Types.ProblemaCondicaoSelectFieldQuery,
    Types.ProblemaCondicaoSelectFieldQueryVariables
  >(ProblemaCondicaoSelectFieldDocument, baseOptions)
}
export type ProblemaCondicaoSelectFieldQueryHookResult = ReturnType<typeof useProblemaCondicaoSelectFieldQuery>
export type ProblemaCondicaoSelectFieldLazyQueryHookResult = ReturnType<typeof useProblemaCondicaoSelectFieldLazyQuery>
export type ProblemaCondicaoSelectFieldQueryResult = ApolloReactCommon.QueryResult<
  Types.ProblemaCondicaoSelectFieldQuery,
  Types.ProblemaCondicaoSelectFieldQueryVariables
>
export const ProcedimentoOdontoSelectFieldDocument = gql`
  query ProcedimentoOdontoSelectField($input: ProcedimentoOdontoQueryInput!) {
    procedimentosEvolucaoOdonto(input: $input) {
      content {
        ...Procedimento
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${ProcedimentoFragmentDoc}
  ${PageInfoFragmentDoc}
`

/**
 * __useProcedimentoOdontoSelectFieldQuery__
 *
 * To run a query within a React component, call `useProcedimentoOdontoSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcedimentoOdontoSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcedimentoOdontoSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProcedimentoOdontoSelectFieldQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.ProcedimentoOdontoSelectFieldQuery,
    Types.ProcedimentoOdontoSelectFieldQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    Types.ProcedimentoOdontoSelectFieldQuery,
    Types.ProcedimentoOdontoSelectFieldQueryVariables
  >(ProcedimentoOdontoSelectFieldDocument, baseOptions)
}
export function useProcedimentoOdontoSelectFieldLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.ProcedimentoOdontoSelectFieldQuery,
    Types.ProcedimentoOdontoSelectFieldQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    Types.ProcedimentoOdontoSelectFieldQuery,
    Types.ProcedimentoOdontoSelectFieldQueryVariables
  >(ProcedimentoOdontoSelectFieldDocument, baseOptions)
}
export type ProcedimentoOdontoSelectFieldQueryHookResult = ReturnType<typeof useProcedimentoOdontoSelectFieldQuery>
export type ProcedimentoOdontoSelectFieldLazyQueryHookResult = ReturnType<
  typeof useProcedimentoOdontoSelectFieldLazyQuery
>
export type ProcedimentoOdontoSelectFieldQueryResult = ApolloReactCommon.QueryResult<
  Types.ProcedimentoOdontoSelectFieldQuery,
  Types.ProcedimentoOdontoSelectFieldQueryVariables
>
export const ProcedimentoSelectFieldDocument = gql`
  query ProcedimentoSelectField($input: ProcedimentoQueryInput!) {
    procedimentos(input: $input) {
      content {
        ...Procedimento
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${ProcedimentoFragmentDoc}
  ${PageInfoFragmentDoc}
`

/**
 * __useProcedimentoSelectFieldQuery__
 *
 * To run a query within a React component, call `useProcedimentoSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcedimentoSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcedimentoSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProcedimentoSelectFieldQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.ProcedimentoSelectFieldQuery,
    Types.ProcedimentoSelectFieldQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<Types.ProcedimentoSelectFieldQuery, Types.ProcedimentoSelectFieldQueryVariables>(
    ProcedimentoSelectFieldDocument,
    baseOptions
  )
}
export function useProcedimentoSelectFieldLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.ProcedimentoSelectFieldQuery,
    Types.ProcedimentoSelectFieldQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<Types.ProcedimentoSelectFieldQuery, Types.ProcedimentoSelectFieldQueryVariables>(
    ProcedimentoSelectFieldDocument,
    baseOptions
  )
}
export type ProcedimentoSelectFieldQueryHookResult = ReturnType<typeof useProcedimentoSelectFieldQuery>
export type ProcedimentoSelectFieldLazyQueryHookResult = ReturnType<typeof useProcedimentoSelectFieldLazyQuery>
export type ProcedimentoSelectFieldQueryResult = ApolloReactCommon.QueryResult<
  Types.ProcedimentoSelectFieldQuery,
  Types.ProcedimentoSelectFieldQueryVariables
>
export const ProfissionaisRelatorioInconsistenciaDocument = gql`
  query ProfissionaisRelatorioInconsistencia($filtro: ProfissionaisRelatorioInconsistenciaQueryInput!) {
    profissionaisRelatorioInconsistencia(filtro: $filtro) {
      content {
        responsavel
        cpfResponsavel
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${PageInfoFragmentDoc}
`

/**
 * __useProfissionaisRelatorioInconsistenciaQuery__
 *
 * To run a query within a React component, call `useProfissionaisRelatorioInconsistenciaQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfissionaisRelatorioInconsistenciaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfissionaisRelatorioInconsistenciaQuery({
 *   variables: {
 *      filtro: // value for 'filtro'
 *   },
 * });
 */
export function useProfissionaisRelatorioInconsistenciaQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.ProfissionaisRelatorioInconsistenciaQuery,
    Types.ProfissionaisRelatorioInconsistenciaQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    Types.ProfissionaisRelatorioInconsistenciaQuery,
    Types.ProfissionaisRelatorioInconsistenciaQueryVariables
  >(ProfissionaisRelatorioInconsistenciaDocument, baseOptions)
}
export function useProfissionaisRelatorioInconsistenciaLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.ProfissionaisRelatorioInconsistenciaQuery,
    Types.ProfissionaisRelatorioInconsistenciaQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    Types.ProfissionaisRelatorioInconsistenciaQuery,
    Types.ProfissionaisRelatorioInconsistenciaQueryVariables
  >(ProfissionaisRelatorioInconsistenciaDocument, baseOptions)
}
export type ProfissionaisRelatorioInconsistenciaQueryHookResult = ReturnType<
  typeof useProfissionaisRelatorioInconsistenciaQuery
>
export type ProfissionaisRelatorioInconsistenciaLazyQueryHookResult = ReturnType<
  typeof useProfissionaisRelatorioInconsistenciaLazyQuery
>
export type ProfissionaisRelatorioInconsistenciaQueryResult = ApolloReactCommon.QueryResult<
  Types.ProfissionaisRelatorioInconsistenciaQuery,
  Types.ProfissionaisRelatorioInconsistenciaQueryVariables
>
export const ProfissionalSelectDocument = gql`
  query ProfissionalSelect($input: ProfissionaisQueryInput!) {
    profissionais(input: $input) {
      content {
        id
        nome
        cpf
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${PageInfoFragmentDoc}
`

/**
 * __useProfissionalSelectQuery__
 *
 * To run a query within a React component, call `useProfissionalSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfissionalSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfissionalSelectQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProfissionalSelectQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ProfissionalSelectQuery, Types.ProfissionalSelectQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.ProfissionalSelectQuery, Types.ProfissionalSelectQueryVariables>(
    ProfissionalSelectDocument,
    baseOptions
  )
}
export function useProfissionalSelectLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.ProfissionalSelectQuery,
    Types.ProfissionalSelectQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<Types.ProfissionalSelectQuery, Types.ProfissionalSelectQueryVariables>(
    ProfissionalSelectDocument,
    baseOptions
  )
}
export type ProfissionalSelectQueryHookResult = ReturnType<typeof useProfissionalSelectQuery>
export type ProfissionalSelectLazyQueryHookResult = ReturnType<typeof useProfissionalSelectLazyQuery>
export type ProfissionalSelectQueryResult = ApolloReactCommon.QueryResult<
  Types.ProfissionalSelectQuery,
  Types.ProfissionalSelectQueryVariables
>
export const TipoEventoSelectFieldDocument = gql`
  query TipoEventoSelectField {
    auditoriaTipoEvento {
      id
      nome
    }
  }
`

/**
 * __useTipoEventoSelectFieldQuery__
 *
 * To run a query within a React component, call `useTipoEventoSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useTipoEventoSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTipoEventoSelectFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useTipoEventoSelectFieldQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.TipoEventoSelectFieldQuery,
    Types.TipoEventoSelectFieldQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<Types.TipoEventoSelectFieldQuery, Types.TipoEventoSelectFieldQueryVariables>(
    TipoEventoSelectFieldDocument,
    baseOptions
  )
}
export function useTipoEventoSelectFieldLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.TipoEventoSelectFieldQuery,
    Types.TipoEventoSelectFieldQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<Types.TipoEventoSelectFieldQuery, Types.TipoEventoSelectFieldQueryVariables>(
    TipoEventoSelectFieldDocument,
    baseOptions
  )
}
export type TipoEventoSelectFieldQueryHookResult = ReturnType<typeof useTipoEventoSelectFieldQuery>
export type TipoEventoSelectFieldLazyQueryHookResult = ReturnType<typeof useTipoEventoSelectFieldLazyQuery>
export type TipoEventoSelectFieldQueryResult = ApolloReactCommon.QueryResult<
  Types.TipoEventoSelectFieldQuery,
  Types.TipoEventoSelectFieldQueryVariables
>
export const TipoLogradouroSelectFieldDocument = gql`
  query TipoLogradouroSelectField($input: TipoLogradouroInput!) {
    tiposLogradouro(input: $input) {
      content {
        id
        nome
        numeroDne
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${PageInfoFragmentDoc}
`

/**
 * __useTipoLogradouroSelectFieldQuery__
 *
 * To run a query within a React component, call `useTipoLogradouroSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useTipoLogradouroSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTipoLogradouroSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTipoLogradouroSelectFieldQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.TipoLogradouroSelectFieldQuery,
    Types.TipoLogradouroSelectFieldQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<Types.TipoLogradouroSelectFieldQuery, Types.TipoLogradouroSelectFieldQueryVariables>(
    TipoLogradouroSelectFieldDocument,
    baseOptions
  )
}
export function useTipoLogradouroSelectFieldLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.TipoLogradouroSelectFieldQuery,
    Types.TipoLogradouroSelectFieldQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    Types.TipoLogradouroSelectFieldQuery,
    Types.TipoLogradouroSelectFieldQueryVariables
  >(TipoLogradouroSelectFieldDocument, baseOptions)
}
export type TipoLogradouroSelectFieldQueryHookResult = ReturnType<typeof useTipoLogradouroSelectFieldQuery>
export type TipoLogradouroSelectFieldLazyQueryHookResult = ReturnType<typeof useTipoLogradouroSelectFieldLazyQuery>
export type TipoLogradouroSelectFieldQueryResult = ApolloReactCommon.QueryResult<
  Types.TipoLogradouroSelectFieldQuery,
  Types.TipoLogradouroSelectFieldQueryVariables
>
export const TipoRegistroAfetadoSelectFieldDocument = gql`
  query TipoRegistroAfetadoSelectField {
    auditoriaTipoRegistroAfetado {
      id
      nome
    }
  }
`

/**
 * __useTipoRegistroAfetadoSelectFieldQuery__
 *
 * To run a query within a React component, call `useTipoRegistroAfetadoSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useTipoRegistroAfetadoSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTipoRegistroAfetadoSelectFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useTipoRegistroAfetadoSelectFieldQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.TipoRegistroAfetadoSelectFieldQuery,
    Types.TipoRegistroAfetadoSelectFieldQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    Types.TipoRegistroAfetadoSelectFieldQuery,
    Types.TipoRegistroAfetadoSelectFieldQueryVariables
  >(TipoRegistroAfetadoSelectFieldDocument, baseOptions)
}
export function useTipoRegistroAfetadoSelectFieldLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.TipoRegistroAfetadoSelectFieldQuery,
    Types.TipoRegistroAfetadoSelectFieldQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    Types.TipoRegistroAfetadoSelectFieldQuery,
    Types.TipoRegistroAfetadoSelectFieldQueryVariables
  >(TipoRegistroAfetadoSelectFieldDocument, baseOptions)
}
export type TipoRegistroAfetadoSelectFieldQueryHookResult = ReturnType<typeof useTipoRegistroAfetadoSelectFieldQuery>
export type TipoRegistroAfetadoSelectFieldLazyQueryHookResult = ReturnType<
  typeof useTipoRegistroAfetadoSelectFieldLazyQuery
>
export type TipoRegistroAfetadoSelectFieldQueryResult = ApolloReactCommon.QueryResult<
  Types.TipoRegistroAfetadoSelectFieldQuery,
  Types.TipoRegistroAfetadoSelectFieldQueryVariables
>
export const TipoServicoSelectFieldDocument = gql`
  query TipoServicoSelectField($input: TipoServicoQueryInput!) {
    tiposServico(input: $input) {
      content {
        id
        nome
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${PageInfoFragmentDoc}
`

/**
 * __useTipoServicoSelectFieldQuery__
 *
 * To run a query within a React component, call `useTipoServicoSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useTipoServicoSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTipoServicoSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTipoServicoSelectFieldQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.TipoServicoSelectFieldQuery,
    Types.TipoServicoSelectFieldQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<Types.TipoServicoSelectFieldQuery, Types.TipoServicoSelectFieldQueryVariables>(
    TipoServicoSelectFieldDocument,
    baseOptions
  )
}
export function useTipoServicoSelectFieldLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.TipoServicoSelectFieldQuery,
    Types.TipoServicoSelectFieldQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<Types.TipoServicoSelectFieldQuery, Types.TipoServicoSelectFieldQueryVariables>(
    TipoServicoSelectFieldDocument,
    baseOptions
  )
}
export type TipoServicoSelectFieldQueryHookResult = ReturnType<typeof useTipoServicoSelectFieldQuery>
export type TipoServicoSelectFieldLazyQueryHookResult = ReturnType<typeof useTipoServicoSelectFieldLazyQuery>
export type TipoServicoSelectFieldQueryResult = ApolloReactCommon.QueryResult<
  Types.TipoServicoSelectFieldQuery,
  Types.TipoServicoSelectFieldQueryVariables
>
export const UnidadesSaudeSelectFieldDocument = gql`
  query UnidadesSaudeSelectField($input: UnidadesSaudeQueryInput!) {
    unidadesSaude(input: $input) {
      content {
        id
        cnes
        nome
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${PageInfoFragmentDoc}
`

/**
 * __useUnidadesSaudeSelectFieldQuery__
 *
 * To run a query within a React component, call `useUnidadesSaudeSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnidadesSaudeSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnidadesSaudeSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnidadesSaudeSelectFieldQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.UnidadesSaudeSelectFieldQuery,
    Types.UnidadesSaudeSelectFieldQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<Types.UnidadesSaudeSelectFieldQuery, Types.UnidadesSaudeSelectFieldQueryVariables>(
    UnidadesSaudeSelectFieldDocument,
    baseOptions
  )
}
export function useUnidadesSaudeSelectFieldLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.UnidadesSaudeSelectFieldQuery,
    Types.UnidadesSaudeSelectFieldQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    Types.UnidadesSaudeSelectFieldQuery,
    Types.UnidadesSaudeSelectFieldQueryVariables
  >(UnidadesSaudeSelectFieldDocument, baseOptions)
}
export type UnidadesSaudeSelectFieldQueryHookResult = ReturnType<typeof useUnidadesSaudeSelectFieldQuery>
export type UnidadesSaudeSelectFieldLazyQueryHookResult = ReturnType<typeof useUnidadesSaudeSelectFieldLazyQuery>
export type UnidadesSaudeSelectFieldQueryResult = ApolloReactCommon.QueryResult<
  Types.UnidadesSaudeSelectFieldQuery,
  Types.UnidadesSaudeSelectFieldQueryVariables
>
export const ViaAdministracaoSelectFieldDocument = gql`
  query ViaAdministracaoSelectField($input: AplicacaoMedicamentoQueryInput!) {
    aplicacoesMedicamento(input: $input) {
      content {
        id
        nome
      }
    }
  }
`

/**
 * __useViaAdministracaoSelectFieldQuery__
 *
 * To run a query within a React component, call `useViaAdministracaoSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useViaAdministracaoSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViaAdministracaoSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useViaAdministracaoSelectFieldQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.ViaAdministracaoSelectFieldQuery,
    Types.ViaAdministracaoSelectFieldQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    Types.ViaAdministracaoSelectFieldQuery,
    Types.ViaAdministracaoSelectFieldQueryVariables
  >(ViaAdministracaoSelectFieldDocument, baseOptions)
}
export function useViaAdministracaoSelectFieldLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.ViaAdministracaoSelectFieldQuery,
    Types.ViaAdministracaoSelectFieldQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    Types.ViaAdministracaoSelectFieldQuery,
    Types.ViaAdministracaoSelectFieldQueryVariables
  >(ViaAdministracaoSelectFieldDocument, baseOptions)
}
export type ViaAdministracaoSelectFieldQueryHookResult = ReturnType<typeof useViaAdministracaoSelectFieldQuery>
export type ViaAdministracaoSelectFieldLazyQueryHookResult = ReturnType<typeof useViaAdministracaoSelectFieldLazyQuery>
export type ViaAdministracaoSelectFieldQueryResult = ApolloReactCommon.QueryResult<
  Types.ViaAdministracaoSelectFieldQuery,
  Types.ViaAdministracaoSelectFieldQueryVariables
>
export const InstalacaoHeaderDocument = gql`
  query InstalacaoHeader {
    info {
      treinamento
      versao
    }
  }
`

/**
 * __useInstalacaoHeaderQuery__
 *
 * To run a query within a React component, call `useInstalacaoHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useInstalacaoHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInstalacaoHeaderQuery({
 *   variables: {
 *   },
 * });
 */
export function useInstalacaoHeaderQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.InstalacaoHeaderQuery, Types.InstalacaoHeaderQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.InstalacaoHeaderQuery, Types.InstalacaoHeaderQueryVariables>(
    InstalacaoHeaderDocument,
    baseOptions
  )
}
export function useInstalacaoHeaderLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.InstalacaoHeaderQuery, Types.InstalacaoHeaderQueryVariables>
) {
  return ApolloReactHooks.useLazyQuery<Types.InstalacaoHeaderQuery, Types.InstalacaoHeaderQueryVariables>(
    InstalacaoHeaderDocument,
    baseOptions
  )
}
export type InstalacaoHeaderQueryHookResult = ReturnType<typeof useInstalacaoHeaderQuery>
export type InstalacaoHeaderLazyQueryHookResult = ReturnType<typeof useInstalacaoHeaderLazyQuery>
export type InstalacaoHeaderQueryResult = ApolloReactCommon.QueryResult<
  Types.InstalacaoHeaderQuery,
  Types.InstalacaoHeaderQueryVariables
>
export const DefinirModuloInicialDocument = gql`
  mutation DefinirModuloInicial($input: SelecionarModuloInicialInput!) {
    definirModuloInicial(input: $input) {
      id
      moduloInicial
    }
  }
`
export type DefinirModuloInicialMutationFn = ApolloReactCommon.MutationFunction<
  Types.DefinirModuloInicialMutation,
  Types.DefinirModuloInicialMutationVariables
>

/**
 * __useDefinirModuloInicialMutation__
 *
 * To run a mutation, you first call `useDefinirModuloInicialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDefinirModuloInicialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [definirModuloInicialMutation, { data, loading, error }] = useDefinirModuloInicialMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDefinirModuloInicialMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.DefinirModuloInicialMutation,
    Types.DefinirModuloInicialMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<Types.DefinirModuloInicialMutation, Types.DefinirModuloInicialMutationVariables>(
    DefinirModuloInicialDocument,
    baseOptions
  )
}
export type DefinirModuloInicialMutationHookResult = ReturnType<typeof useDefinirModuloInicialMutation>
export type DefinirModuloInicialMutationResult = ApolloReactCommon.MutationResult<Types.DefinirModuloInicialMutation>
export type DefinirModuloInicialMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.DefinirModuloInicialMutation,
  Types.DefinirModuloInicialMutationVariables
>
export const InitialViewDocument = gql`
  query InitialView {
    info {
      ativado
    }
  }
`

/**
 * __useInitialViewQuery__
 *
 * To run a query within a React component, call `useInitialViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useInitialViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInitialViewQuery({
 *   variables: {
 *   },
 * });
 */
export function useInitialViewQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.InitialViewQuery, Types.InitialViewQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.InitialViewQuery, Types.InitialViewQueryVariables>(
    InitialViewDocument,
    baseOptions
  )
}
export function useInitialViewLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.InitialViewQuery, Types.InitialViewQueryVariables>
) {
  return ApolloReactHooks.useLazyQuery<Types.InitialViewQuery, Types.InitialViewQueryVariables>(
    InitialViewDocument,
    baseOptions
  )
}
export type InitialViewQueryHookResult = ReturnType<typeof useInitialViewQuery>
export type InitialViewLazyQueryHookResult = ReturnType<typeof useInitialViewLazyQuery>
export type InitialViewQueryResult = ApolloReactCommon.QueryResult<
  Types.InitialViewQuery,
  Types.InitialViewQueryVariables
>
export const BuscaCidadaoListagemDocument = gql`
  query BuscaCidadaoListagem($input: AcompanhamentoCondicaoSaudeQueryInput!) {
    acompanhamentoCondicaoSaude(input: $input) {
      content {
        id
        dataNascimento
        nome
        nomeSocial
        cpf
        telefoneResidencial
        telefoneCelular
        telefoneContato
        dataUltimoAtendimento
        endereco {
          logradouro
          numero
          complemento
          bairro
          municipio {
            nome
          }
          tipoLogradouro {
            nome
          }
          uf {
            sigla
          }
          cep
        }
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${PageInfoFragmentDoc}
`

/**
 * __useBuscaCidadaoListagemQuery__
 *
 * To run a query within a React component, call `useBuscaCidadaoListagemQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuscaCidadaoListagemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuscaCidadaoListagemQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBuscaCidadaoListagemQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.BuscaCidadaoListagemQuery,
    Types.BuscaCidadaoListagemQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<Types.BuscaCidadaoListagemQuery, Types.BuscaCidadaoListagemQueryVariables>(
    BuscaCidadaoListagemDocument,
    baseOptions
  )
}
export function useBuscaCidadaoListagemLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.BuscaCidadaoListagemQuery,
    Types.BuscaCidadaoListagemQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<Types.BuscaCidadaoListagemQuery, Types.BuscaCidadaoListagemQueryVariables>(
    BuscaCidadaoListagemDocument,
    baseOptions
  )
}
export type BuscaCidadaoListagemQueryHookResult = ReturnType<typeof useBuscaCidadaoListagemQuery>
export type BuscaCidadaoListagemLazyQueryHookResult = ReturnType<typeof useBuscaCidadaoListagemLazyQuery>
export type BuscaCidadaoListagemQueryResult = ApolloReactCommon.QueryResult<
  Types.BuscaCidadaoListagemQuery,
  Types.BuscaCidadaoListagemQueryVariables
>
export const BuscaCidadaoRelatoriosOperacionaisDocument = gql`
  query BuscaCidadaoRelatoriosOperacionais($input: AcompanhamentoCondicaoSaudeQueryInput!) {
    acompanhamentoCondicaoSaude(input: $input) {
      content {
        id
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${PageInfoFragmentDoc}
`

/**
 * __useBuscaCidadaoRelatoriosOperacionaisQuery__
 *
 * To run a query within a React component, call `useBuscaCidadaoRelatoriosOperacionaisQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuscaCidadaoRelatoriosOperacionaisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuscaCidadaoRelatoriosOperacionaisQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBuscaCidadaoRelatoriosOperacionaisQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.BuscaCidadaoRelatoriosOperacionaisQuery,
    Types.BuscaCidadaoRelatoriosOperacionaisQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    Types.BuscaCidadaoRelatoriosOperacionaisQuery,
    Types.BuscaCidadaoRelatoriosOperacionaisQueryVariables
  >(BuscaCidadaoRelatoriosOperacionaisDocument, baseOptions)
}
export function useBuscaCidadaoRelatoriosOperacionaisLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.BuscaCidadaoRelatoriosOperacionaisQuery,
    Types.BuscaCidadaoRelatoriosOperacionaisQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    Types.BuscaCidadaoRelatoriosOperacionaisQuery,
    Types.BuscaCidadaoRelatoriosOperacionaisQueryVariables
  >(BuscaCidadaoRelatoriosOperacionaisDocument, baseOptions)
}
export type BuscaCidadaoRelatoriosOperacionaisQueryHookResult = ReturnType<
  typeof useBuscaCidadaoRelatoriosOperacionaisQuery
>
export type BuscaCidadaoRelatoriosOperacionaisLazyQueryHookResult = ReturnType<
  typeof useBuscaCidadaoRelatoriosOperacionaisLazyQuery
>
export type BuscaCidadaoRelatoriosOperacionaisQueryResult = ApolloReactCommon.QueryResult<
  Types.BuscaCidadaoRelatoriosOperacionaisQuery,
  Types.BuscaCidadaoRelatoriosOperacionaisQueryVariables
>
export const EquipeAdSelectFieldDocument = gql`
  query EquipeAdSelectField($input: EquipesAdQueryInput!) {
    equipesAD(input: $input) {
      content {
        id
        nome
        ine
        tipoEquipe {
          id
          nome
          sigla
        }
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${PageInfoFragmentDoc}
`

/**
 * __useEquipeAdSelectFieldQuery__
 *
 * To run a query within a React component, call `useEquipeAdSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useEquipeAdSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEquipeAdSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEquipeAdSelectFieldQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.EquipeAdSelectFieldQuery,
    Types.EquipeAdSelectFieldQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<Types.EquipeAdSelectFieldQuery, Types.EquipeAdSelectFieldQueryVariables>(
    EquipeAdSelectFieldDocument,
    baseOptions
  )
}
export function useEquipeAdSelectFieldLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.EquipeAdSelectFieldQuery,
    Types.EquipeAdSelectFieldQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<Types.EquipeAdSelectFieldQuery, Types.EquipeAdSelectFieldQueryVariables>(
    EquipeAdSelectFieldDocument,
    baseOptions
  )
}
export type EquipeAdSelectFieldQueryHookResult = ReturnType<typeof useEquipeAdSelectFieldQuery>
export type EquipeAdSelectFieldLazyQueryHookResult = ReturnType<typeof useEquipeAdSelectFieldLazyQuery>
export type EquipeAdSelectFieldQueryResult = ApolloReactCommon.QueryResult<
  Types.EquipeAdSelectFieldQuery,
  Types.EquipeAdSelectFieldQueryVariables
>
export const ProfissionalAdSelectFieldDocument = gql`
  query ProfissionalAdSelectField($inputEquipe: EquipesAdQueryInput!, $inputProf: ProfissionaisAdQueryInput!) {
    profissionaisAD(equipeFilter: $inputEquipe, profissionalFilter: $inputProf) {
      content {
        id
        nome
        cpf
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${PageInfoFragmentDoc}
`

/**
 * __useProfissionalAdSelectFieldQuery__
 *
 * To run a query within a React component, call `useProfissionalAdSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfissionalAdSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfissionalAdSelectFieldQuery({
 *   variables: {
 *      inputEquipe: // value for 'inputEquipe'
 *      inputProf: // value for 'inputProf'
 *   },
 * });
 */
export function useProfissionalAdSelectFieldQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.ProfissionalAdSelectFieldQuery,
    Types.ProfissionalAdSelectFieldQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<Types.ProfissionalAdSelectFieldQuery, Types.ProfissionalAdSelectFieldQueryVariables>(
    ProfissionalAdSelectFieldDocument,
    baseOptions
  )
}
export function useProfissionalAdSelectFieldLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.ProfissionalAdSelectFieldQuery,
    Types.ProfissionalAdSelectFieldQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    Types.ProfissionalAdSelectFieldQuery,
    Types.ProfissionalAdSelectFieldQueryVariables
  >(ProfissionalAdSelectFieldDocument, baseOptions)
}
export type ProfissionalAdSelectFieldQueryHookResult = ReturnType<typeof useProfissionalAdSelectFieldQuery>
export type ProfissionalAdSelectFieldLazyQueryHookResult = ReturnType<typeof useProfissionalAdSelectFieldLazyQuery>
export type ProfissionalAdSelectFieldQueryResult = ApolloReactCommon.QueryResult<
  Types.ProfissionalAdSelectFieldQuery,
  Types.ProfissionalAdSelectFieldQueryVariables
>
export const SalvarApoioEmapEmadDocument = gql`
  mutation SalvarApoioEmapEmad($input: ConfigAtendimentoDomInput!) {
    salvarConfigAtendimentoDomTipoApoio(input: $input) {
      id
    }
  }
`
export type SalvarApoioEmapEmadMutationFn = ApolloReactCommon.MutationFunction<
  Types.SalvarApoioEmapEmadMutation,
  Types.SalvarApoioEmapEmadMutationVariables
>

/**
 * __useSalvarApoioEmapEmadMutation__
 *
 * To run a mutation, you first call `useSalvarApoioEmapEmadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvarApoioEmapEmadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvarApoioEmapEmadMutation, { data, loading, error }] = useSalvarApoioEmapEmadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSalvarApoioEmapEmadMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.SalvarApoioEmapEmadMutation,
    Types.SalvarApoioEmapEmadMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<Types.SalvarApoioEmapEmadMutation, Types.SalvarApoioEmapEmadMutationVariables>(
    SalvarApoioEmapEmadDocument,
    baseOptions
  )
}
export type SalvarApoioEmapEmadMutationHookResult = ReturnType<typeof useSalvarApoioEmapEmadMutation>
export type SalvarApoioEmapEmadMutationResult = ApolloReactCommon.MutationResult<Types.SalvarApoioEmapEmadMutation>
export type SalvarApoioEmapEmadMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.SalvarApoioEmapEmadMutation,
  Types.SalvarApoioEmapEmadMutationVariables
>
export const SalvarPodeAtenderEmadDocument = gql`
  mutation SalvarPodeAtenderEmad($input: ConfigAtendimentoDomInput!) {
    salvarConfigAtendimentoDomTipoPodeAtender(input: $input) {
      id
    }
  }
`
export type SalvarPodeAtenderEmadMutationFn = ApolloReactCommon.MutationFunction<
  Types.SalvarPodeAtenderEmadMutation,
  Types.SalvarPodeAtenderEmadMutationVariables
>

/**
 * __useSalvarPodeAtenderEmadMutation__
 *
 * To run a mutation, you first call `useSalvarPodeAtenderEmadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvarPodeAtenderEmadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvarPodeAtenderEmadMutation, { data, loading, error }] = useSalvarPodeAtenderEmadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSalvarPodeAtenderEmadMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.SalvarPodeAtenderEmadMutation,
    Types.SalvarPodeAtenderEmadMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    Types.SalvarPodeAtenderEmadMutation,
    Types.SalvarPodeAtenderEmadMutationVariables
  >(SalvarPodeAtenderEmadDocument, baseOptions)
}
export type SalvarPodeAtenderEmadMutationHookResult = ReturnType<typeof useSalvarPodeAtenderEmadMutation>
export type SalvarPodeAtenderEmadMutationResult = ApolloReactCommon.MutationResult<Types.SalvarPodeAtenderEmadMutation>
export type SalvarPodeAtenderEmadMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.SalvarPodeAtenderEmadMutation,
  Types.SalvarPodeAtenderEmadMutationVariables
>
export const ConfiguracoesAtencaoDomDocument = gql`
  query ConfiguracoesAtencaoDom($input: ConfiguracoesAtendimentosDomInput) {
    configuracoesAtencaoDom {
      duracao
      emadsAtendemEmads(input: $input) {
        content {
          id
          identificadorNacionalEquipePai {
            id
            nome
            ine
          }
          identificadorNacionalEquipeFilho {
            id
            nome
            ine
          }
        }
        pageInfo {
          ...PageInfo
        }
      }
      emapsApoiamEmads(input: $input) {
        content {
          id
          identificadorNacionalEquipePai {
            id
            nome
            ine
          }
          identificadorNacionalEquipeFilho {
            id
            nome
            ine
          }
        }
        pageInfo {
          ...PageInfo
        }
      }
    }
  }
  ${PageInfoFragmentDoc}
`

/**
 * __useConfiguracoesAtencaoDomQuery__
 *
 * To run a query within a React component, call `useConfiguracoesAtencaoDomQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfiguracoesAtencaoDomQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfiguracoesAtencaoDomQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfiguracoesAtencaoDomQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.ConfiguracoesAtencaoDomQuery,
    Types.ConfiguracoesAtencaoDomQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<Types.ConfiguracoesAtencaoDomQuery, Types.ConfiguracoesAtencaoDomQueryVariables>(
    ConfiguracoesAtencaoDomDocument,
    baseOptions
  )
}
export function useConfiguracoesAtencaoDomLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.ConfiguracoesAtencaoDomQuery,
    Types.ConfiguracoesAtencaoDomQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<Types.ConfiguracoesAtencaoDomQuery, Types.ConfiguracoesAtencaoDomQueryVariables>(
    ConfiguracoesAtencaoDomDocument,
    baseOptions
  )
}
export type ConfiguracoesAtencaoDomQueryHookResult = ReturnType<typeof useConfiguracoesAtencaoDomQuery>
export type ConfiguracoesAtencaoDomLazyQueryHookResult = ReturnType<typeof useConfiguracoesAtencaoDomLazyQuery>
export type ConfiguracoesAtencaoDomQueryResult = ApolloReactCommon.QueryResult<
  Types.ConfiguracoesAtencaoDomQuery,
  Types.ConfiguracoesAtencaoDomQueryVariables
>
export const EquipesAtencaoDomDocument = gql`
  query EquipesAtencaoDom($input: EquipeADInput) {
    equipesAtencaoDom(input: $input) {
      content {
        id
        nome
        ine
        tipoEquipe {
          id
          nome
          sigla
        }
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${PageInfoFragmentDoc}
`

/**
 * __useEquipesAtencaoDomQuery__
 *
 * To run a query within a React component, call `useEquipesAtencaoDomQuery` and pass it any options that fit your needs.
 * When your component renders, `useEquipesAtencaoDomQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEquipesAtencaoDomQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEquipesAtencaoDomQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.EquipesAtencaoDomQuery, Types.EquipesAtencaoDomQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.EquipesAtencaoDomQuery, Types.EquipesAtencaoDomQueryVariables>(
    EquipesAtencaoDomDocument,
    baseOptions
  )
}
export function useEquipesAtencaoDomLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.EquipesAtencaoDomQuery,
    Types.EquipesAtencaoDomQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<Types.EquipesAtencaoDomQuery, Types.EquipesAtencaoDomQueryVariables>(
    EquipesAtencaoDomDocument,
    baseOptions
  )
}
export type EquipesAtencaoDomQueryHookResult = ReturnType<typeof useEquipesAtencaoDomQuery>
export type EquipesAtencaoDomLazyQueryHookResult = ReturnType<typeof useEquipesAtencaoDomLazyQuery>
export type EquipesAtencaoDomQueryResult = ApolloReactCommon.QueryResult<
  Types.EquipesAtencaoDomQuery,
  Types.EquipesAtencaoDomQueryVariables
>
export const ExcluirConfigAtendimentoDomDocument = gql`
  mutation ExcluirConfigAtendimentoDom($idConfig: ID!) {
    excluirConfigAtendimentoDom(idConfig: $idConfig)
  }
`
export type ExcluirConfigAtendimentoDomMutationFn = ApolloReactCommon.MutationFunction<
  Types.ExcluirConfigAtendimentoDomMutation,
  Types.ExcluirConfigAtendimentoDomMutationVariables
>

/**
 * __useExcluirConfigAtendimentoDomMutation__
 *
 * To run a mutation, you first call `useExcluirConfigAtendimentoDomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExcluirConfigAtendimentoDomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [excluirConfigAtendimentoDomMutation, { data, loading, error }] = useExcluirConfigAtendimentoDomMutation({
 *   variables: {
 *      idConfig: // value for 'idConfig'
 *   },
 * });
 */
export function useExcluirConfigAtendimentoDomMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.ExcluirConfigAtendimentoDomMutation,
    Types.ExcluirConfigAtendimentoDomMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    Types.ExcluirConfigAtendimentoDomMutation,
    Types.ExcluirConfigAtendimentoDomMutationVariables
  >(ExcluirConfigAtendimentoDomDocument, baseOptions)
}
export type ExcluirConfigAtendimentoDomMutationHookResult = ReturnType<typeof useExcluirConfigAtendimentoDomMutation>
export type ExcluirConfigAtendimentoDomMutationResult = ApolloReactCommon.MutationResult<
  Types.ExcluirConfigAtendimentoDomMutation
>
export type ExcluirConfigAtendimentoDomMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.ExcluirConfigAtendimentoDomMutation,
  Types.ExcluirConfigAtendimentoDomMutationVariables
>
export const SalvarDuracaoAgendamentoAdDocument = gql`
  mutation SalvarDuracaoAgendamentoAD($input: DuracaoAgendamentoAtencaoDomInput!) {
    salvarDuracaoAgendamentoAtencaoDom(input: $input) {
      duracaoAgendamento
    }
  }
`
export type SalvarDuracaoAgendamentoAdMutationFn = ApolloReactCommon.MutationFunction<
  Types.SalvarDuracaoAgendamentoAdMutation,
  Types.SalvarDuracaoAgendamentoAdMutationVariables
>

/**
 * __useSalvarDuracaoAgendamentoAdMutation__
 *
 * To run a mutation, you first call `useSalvarDuracaoAgendamentoAdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvarDuracaoAgendamentoAdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvarDuracaoAgendamentoAdMutation, { data, loading, error }] = useSalvarDuracaoAgendamentoAdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSalvarDuracaoAgendamentoAdMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.SalvarDuracaoAgendamentoAdMutation,
    Types.SalvarDuracaoAgendamentoAdMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    Types.SalvarDuracaoAgendamentoAdMutation,
    Types.SalvarDuracaoAgendamentoAdMutationVariables
  >(SalvarDuracaoAgendamentoAdDocument, baseOptions)
}
export type SalvarDuracaoAgendamentoAdMutationHookResult = ReturnType<typeof useSalvarDuracaoAgendamentoAdMutation>
export type SalvarDuracaoAgendamentoAdMutationResult = ApolloReactCommon.MutationResult<
  Types.SalvarDuracaoAgendamentoAdMutation
>
export type SalvarDuracaoAgendamentoAdMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.SalvarDuracaoAgendamentoAdMutation,
  Types.SalvarDuracaoAgendamentoAdMutationVariables
>
export const CidadaoAdLoadDocument = gql`
  query CidadaoADLoad($input: ID!) {
    cidadaoAD(input: $input) {
      id
      cidadao {
        id
        nome
        dataNascimento
        nomeMae
        nomeSocial
        nomeResponsavel
        dtNascimentoResponsavel
        cpfCnsResponsavel
        naoPossuiCuidador
        cpfCnsCuidador
        nomeCuidador
        dtNascimentoCuidador
        tipoCuidador
        sexo
        identidadeGeneroDbEnum
        dataObito
      }
      cidadaoAdEmObito {
        id
        cidadao {
          id
          nome
          nomeSocial
          dataNascimento
          dataObito
        }
      }
      cidadaosAdEmPosObito {
        id
        cidadao {
          id
          nome
          nomeSocial
          cpf
          cns
        }
      }
      modalidade
      procedencia
      procedenciaEspecificacao
      cid10Principal {
        id
        nome
        codigo
      }
      cid10Secundario1 {
        id
        nome
        codigo
      }
      cid10Secundario2 {
        id
        nome
        codigo
      }
      condutaDesfecho
      dataAdmissao
      dataSaida
      dataObito
      dataAgendado
      dataUltimaVisita
      numeroDocumentoObito
      actions {
        permissaoEditarAD {
          enabled
          hint
        }
      }
    }
  }
`

/**
 * __useCidadaoAdLoadQuery__
 *
 * To run a query within a React component, call `useCidadaoAdLoadQuery` and pass it any options that fit your needs.
 * When your component renders, `useCidadaoAdLoadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCidadaoAdLoadQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCidadaoAdLoadQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.CidadaoAdLoadQuery, Types.CidadaoAdLoadQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.CidadaoAdLoadQuery, Types.CidadaoAdLoadQueryVariables>(
    CidadaoAdLoadDocument,
    baseOptions
  )
}
export function useCidadaoAdLoadLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CidadaoAdLoadQuery, Types.CidadaoAdLoadQueryVariables>
) {
  return ApolloReactHooks.useLazyQuery<Types.CidadaoAdLoadQuery, Types.CidadaoAdLoadQueryVariables>(
    CidadaoAdLoadDocument,
    baseOptions
  )
}
export type CidadaoAdLoadQueryHookResult = ReturnType<typeof useCidadaoAdLoadQuery>
export type CidadaoAdLoadLazyQueryHookResult = ReturnType<typeof useCidadaoAdLoadLazyQuery>
export type CidadaoAdLoadQueryResult = ApolloReactCommon.QueryResult<
  Types.CidadaoAdLoadQuery,
  Types.CidadaoAdLoadQueryVariables
>
export const CidadaoAdSaveDocument = gql`
  mutation CidadaoADSave($input: AtencaoDomiciliarCidadaoInput!) {
    salvarCidadaoAtencaoDomiciliar(input: $input) {
      id
    }
  }
`
export type CidadaoAdSaveMutationFn = ApolloReactCommon.MutationFunction<
  Types.CidadaoAdSaveMutation,
  Types.CidadaoAdSaveMutationVariables
>

/**
 * __useCidadaoAdSaveMutation__
 *
 * To run a mutation, you first call `useCidadaoAdSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCidadaoAdSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cidadaoAdSaveMutation, { data, loading, error }] = useCidadaoAdSaveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCidadaoAdSaveMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<Types.CidadaoAdSaveMutation, Types.CidadaoAdSaveMutationVariables>
) {
  return ApolloReactHooks.useMutation<Types.CidadaoAdSaveMutation, Types.CidadaoAdSaveMutationVariables>(
    CidadaoAdSaveDocument,
    baseOptions
  )
}
export type CidadaoAdSaveMutationHookResult = ReturnType<typeof useCidadaoAdSaveMutation>
export type CidadaoAdSaveMutationResult = ApolloReactCommon.MutationResult<Types.CidadaoAdSaveMutation>
export type CidadaoAdSaveMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.CidadaoAdSaveMutation,
  Types.CidadaoAdSaveMutationVariables
>
export const EquipeCidadaoAdListaDocument = gql`
  query EquipeCidadaoADLista($input: CidadaosAdQueryInput!) {
    cidadaosAD(input: $input) {
      content {
        id
        cidadao {
          id
        }
        equipe {
          id
          nome
          ine
        }
      }
    }
  }
`

/**
 * __useEquipeCidadaoAdListaQuery__
 *
 * To run a query within a React component, call `useEquipeCidadaoAdListaQuery` and pass it any options that fit your needs.
 * When your component renders, `useEquipeCidadaoAdListaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEquipeCidadaoAdListaQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEquipeCidadaoAdListaQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.EquipeCidadaoAdListaQuery,
    Types.EquipeCidadaoAdListaQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<Types.EquipeCidadaoAdListaQuery, Types.EquipeCidadaoAdListaQueryVariables>(
    EquipeCidadaoAdListaDocument,
    baseOptions
  )
}
export function useEquipeCidadaoAdListaLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.EquipeCidadaoAdListaQuery,
    Types.EquipeCidadaoAdListaQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<Types.EquipeCidadaoAdListaQuery, Types.EquipeCidadaoAdListaQueryVariables>(
    EquipeCidadaoAdListaDocument,
    baseOptions
  )
}
export type EquipeCidadaoAdListaQueryHookResult = ReturnType<typeof useEquipeCidadaoAdListaQuery>
export type EquipeCidadaoAdListaLazyQueryHookResult = ReturnType<typeof useEquipeCidadaoAdListaLazyQuery>
export type EquipeCidadaoAdListaQueryResult = ApolloReactCommon.QueryResult<
  Types.EquipeCidadaoAdListaQuery,
  Types.EquipeCidadaoAdListaQueryVariables
>
export const CidadaoAdExcluirDocument = gql`
  mutation CidadaoADExcluir($id: ID!) {
    excluirCidadaoAtendimentoDomiciliar(id: $id)
  }
`
export type CidadaoAdExcluirMutationFn = ApolloReactCommon.MutationFunction<
  Types.CidadaoAdExcluirMutation,
  Types.CidadaoAdExcluirMutationVariables
>

/**
 * __useCidadaoAdExcluirMutation__
 *
 * To run a mutation, you first call `useCidadaoAdExcluirMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCidadaoAdExcluirMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cidadaoAdExcluirMutation, { data, loading, error }] = useCidadaoAdExcluirMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCidadaoAdExcluirMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.CidadaoAdExcluirMutation,
    Types.CidadaoAdExcluirMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<Types.CidadaoAdExcluirMutation, Types.CidadaoAdExcluirMutationVariables>(
    CidadaoAdExcluirDocument,
    baseOptions
  )
}
export type CidadaoAdExcluirMutationHookResult = ReturnType<typeof useCidadaoAdExcluirMutation>
export type CidadaoAdExcluirMutationResult = ApolloReactCommon.MutationResult<Types.CidadaoAdExcluirMutation>
export type CidadaoAdExcluirMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.CidadaoAdExcluirMutation,
  Types.CidadaoAdExcluirMutationVariables
>
export const ListaAdTableDocument = gql`
  query ListaADTable($input: CidadaosAdQueryInput!) {
    cidadaosAD(input: $input) {
      content {
        id
        cidadao {
          id
          nome
          cpf
          cns
          nomeSocial
        }
        equipe {
          id
          nome
        }
        modalidade
        condutaDesfecho
        dataAgendado
        dataUltimaVisita
        actions {
          permissaoEditarAD {
            enabled
            hint
          }
          adEncerrado {
            enabled
            hint
          }
          permissaoExcluirAD {
            enabled
            hint
          }
        }
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${PageInfoFragmentDoc}
`

/**
 * __useListaAdTableQuery__
 *
 * To run a query within a React component, call `useListaAdTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useListaAdTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListaAdTableQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListaAdTableQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ListaAdTableQuery, Types.ListaAdTableQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.ListaAdTableQuery, Types.ListaAdTableQueryVariables>(
    ListaAdTableDocument,
    baseOptions
  )
}
export function useListaAdTableLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ListaAdTableQuery, Types.ListaAdTableQueryVariables>
) {
  return ApolloReactHooks.useLazyQuery<Types.ListaAdTableQuery, Types.ListaAdTableQueryVariables>(
    ListaAdTableDocument,
    baseOptions
  )
}
export type ListaAdTableQueryHookResult = ReturnType<typeof useListaAdTableQuery>
export type ListaAdTableLazyQueryHookResult = ReturnType<typeof useListaAdTableLazyQuery>
export type ListaAdTableQueryResult = ApolloReactCommon.QueryResult<
  Types.ListaAdTableQuery,
  Types.ListaAdTableQueryVariables
>
export const CidadaoAdSelectFieldDocument = gql`
  query CidadaoADSelectField($input: CidadaosAdQueryInput!) {
    cidadaosAD(input: $input) {
      content {
        id
        cidadao {
          id
          nome
          cpf
          cns
          nomeSocial
          dataNascimento
          nomeMae
          dataObito
        }
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${PageInfoFragmentDoc}
`

/**
 * __useCidadaoAdSelectFieldQuery__
 *
 * To run a query within a React component, call `useCidadaoAdSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useCidadaoAdSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCidadaoAdSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCidadaoAdSelectFieldQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.CidadaoAdSelectFieldQuery,
    Types.CidadaoAdSelectFieldQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<Types.CidadaoAdSelectFieldQuery, Types.CidadaoAdSelectFieldQueryVariables>(
    CidadaoAdSelectFieldDocument,
    baseOptions
  )
}
export function useCidadaoAdSelectFieldLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.CidadaoAdSelectFieldQuery,
    Types.CidadaoAdSelectFieldQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<Types.CidadaoAdSelectFieldQuery, Types.CidadaoAdSelectFieldQueryVariables>(
    CidadaoAdSelectFieldDocument,
    baseOptions
  )
}
export type CidadaoAdSelectFieldQueryHookResult = ReturnType<typeof useCidadaoAdSelectFieldQuery>
export type CidadaoAdSelectFieldLazyQueryHookResult = ReturnType<typeof useCidadaoAdSelectFieldLazyQuery>
export type CidadaoAdSelectFieldQueryResult = ApolloReactCommon.QueryResult<
  Types.CidadaoAdSelectFieldQuery,
  Types.CidadaoAdSelectFieldQueryVariables
>
export const CidadaoListaAdDocument = gql`
  query CidadaoListaAD($id: ID!) {
    cidadao(id: $id) {
      id
      nome
      nomeSocial
      cpf
      cns
      nomeMae
      dataNascimento
      sexo
      identidadeGeneroDbEnum
    }
  }
`

/**
 * __useCidadaoListaAdQuery__
 *
 * To run a query within a React component, call `useCidadaoListaAdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCidadaoListaAdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCidadaoListaAdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCidadaoListaAdQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.CidadaoListaAdQuery, Types.CidadaoListaAdQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.CidadaoListaAdQuery, Types.CidadaoListaAdQueryVariables>(
    CidadaoListaAdDocument,
    baseOptions
  )
}
export function useCidadaoListaAdLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CidadaoListaAdQuery, Types.CidadaoListaAdQueryVariables>
) {
  return ApolloReactHooks.useLazyQuery<Types.CidadaoListaAdQuery, Types.CidadaoListaAdQueryVariables>(
    CidadaoListaAdDocument,
    baseOptions
  )
}
export type CidadaoListaAdQueryHookResult = ReturnType<typeof useCidadaoListaAdQuery>
export type CidadaoListaAdLazyQueryHookResult = ReturnType<typeof useCidadaoListaAdLazyQuery>
export type CidadaoListaAdQueryResult = ApolloReactCommon.QueryResult<
  Types.CidadaoListaAdQuery,
  Types.CidadaoListaAdQueryVariables
>
export const CidadaoListaAdSelectFieldDocument = gql`
  query CidadaoListaADSelectField($input: CidadaosQueryInput!) {
    cidadaos(input: $input) {
      content {
        id
        nome
        nomeSocial
        cpf
        cns
        nomeMae
        dataNascimento
        sexo
        identidadeGeneroDbEnum
        equipeAtendimentoAd {
          id
          nome
          ine
        }
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${PageInfoFragmentDoc}
`

/**
 * __useCidadaoListaAdSelectFieldQuery__
 *
 * To run a query within a React component, call `useCidadaoListaAdSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useCidadaoListaAdSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCidadaoListaAdSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCidadaoListaAdSelectFieldQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.CidadaoListaAdSelectFieldQuery,
    Types.CidadaoListaAdSelectFieldQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<Types.CidadaoListaAdSelectFieldQuery, Types.CidadaoListaAdSelectFieldQueryVariables>(
    CidadaoListaAdSelectFieldDocument,
    baseOptions
  )
}
export function useCidadaoListaAdSelectFieldLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.CidadaoListaAdSelectFieldQuery,
    Types.CidadaoListaAdSelectFieldQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    Types.CidadaoListaAdSelectFieldQuery,
    Types.CidadaoListaAdSelectFieldQueryVariables
  >(CidadaoListaAdSelectFieldDocument, baseOptions)
}
export type CidadaoListaAdSelectFieldQueryHookResult = ReturnType<typeof useCidadaoListaAdSelectFieldQuery>
export type CidadaoListaAdSelectFieldLazyQueryHookResult = ReturnType<typeof useCidadaoListaAdSelectFieldLazyQuery>
export type CidadaoListaAdSelectFieldQueryResult = ApolloReactCommon.QueryResult<
  Types.CidadaoListaAdSelectFieldQuery,
  Types.CidadaoListaAdSelectFieldQueryVariables
>
export const AlterarSenhaDocument = gql`
  mutation AlterarSenha($input: AlterarSenhaInput!) {
    alterarSenha(input: $input) {
      id
      trocarSenha
    }
  }
`
export type AlterarSenhaMutationFn = ApolloReactCommon.MutationFunction<
  Types.AlterarSenhaMutation,
  Types.AlterarSenhaMutationVariables
>

/**
 * __useAlterarSenhaMutation__
 *
 * To run a mutation, you first call `useAlterarSenhaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlterarSenhaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alterarSenhaMutation, { data, loading, error }] = useAlterarSenhaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAlterarSenhaMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AlterarSenhaMutation, Types.AlterarSenhaMutationVariables>
) {
  return ApolloReactHooks.useMutation<Types.AlterarSenhaMutation, Types.AlterarSenhaMutationVariables>(
    AlterarSenhaDocument,
    baseOptions
  )
}
export type AlterarSenhaMutationHookResult = ReturnType<typeof useAlterarSenhaMutation>
export type AlterarSenhaMutationResult = ApolloReactCommon.MutationResult<Types.AlterarSenhaMutation>
export type AlterarSenhaMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.AlterarSenhaMutation,
  Types.AlterarSenhaMutationVariables
>
export const AgendadoAtendimentoFormDocument = gql`
  query AgendadoAtendimentoForm($id: ID!) {
    agendado(id: $id) {
      id
      lotacaoAgendada {
        id
        profissional {
          id
          nome
        }
        equipe {
          id
          nome
          ine
          tipoEquipe {
            id
            nome
            sigla
          }
        }
      }
    }
  }
`

/**
 * __useAgendadoAtendimentoFormQuery__
 *
 * To run a query within a React component, call `useAgendadoAtendimentoFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgendadoAtendimentoFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgendadoAtendimentoFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAgendadoAtendimentoFormQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.AgendadoAtendimentoFormQuery,
    Types.AgendadoAtendimentoFormQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<Types.AgendadoAtendimentoFormQuery, Types.AgendadoAtendimentoFormQueryVariables>(
    AgendadoAtendimentoFormDocument,
    baseOptions
  )
}
export function useAgendadoAtendimentoFormLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.AgendadoAtendimentoFormQuery,
    Types.AgendadoAtendimentoFormQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<Types.AgendadoAtendimentoFormQuery, Types.AgendadoAtendimentoFormQueryVariables>(
    AgendadoAtendimentoFormDocument,
    baseOptions
  )
}
export type AgendadoAtendimentoFormQueryHookResult = ReturnType<typeof useAgendadoAtendimentoFormQuery>
export type AgendadoAtendimentoFormLazyQueryHookResult = ReturnType<typeof useAgendadoAtendimentoFormLazyQuery>
export type AgendadoAtendimentoFormQueryResult = ApolloReactCommon.QueryResult<
  Types.AgendadoAtendimentoFormQuery,
  Types.AgendadoAtendimentoFormQueryVariables
>
export const AgendamentosDiaDocument = gql`
  query AgendamentosDia($input: AgendadosQueryInput!) {
    agendados(input: $input) {
      content {
        id
        horarioInicial
        lotacaoAgendada {
          id
          profissional {
            id
            nome
          }
        }
      }
    }
  }
`

/**
 * __useAgendamentosDiaQuery__
 *
 * To run a query within a React component, call `useAgendamentosDiaQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgendamentosDiaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgendamentosDiaQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAgendamentosDiaQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.AgendamentosDiaQuery, Types.AgendamentosDiaQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.AgendamentosDiaQuery, Types.AgendamentosDiaQueryVariables>(
    AgendamentosDiaDocument,
    baseOptions
  )
}
export function useAgendamentosDiaLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AgendamentosDiaQuery, Types.AgendamentosDiaQueryVariables>
) {
  return ApolloReactHooks.useLazyQuery<Types.AgendamentosDiaQuery, Types.AgendamentosDiaQueryVariables>(
    AgendamentosDiaDocument,
    baseOptions
  )
}
export type AgendamentosDiaQueryHookResult = ReturnType<typeof useAgendamentosDiaQuery>
export type AgendamentosDiaLazyQueryHookResult = ReturnType<typeof useAgendamentosDiaLazyQuery>
export type AgendamentosDiaQueryResult = ApolloReactCommon.QueryResult<
  Types.AgendamentosDiaQuery,
  Types.AgendamentosDiaQueryVariables
>
export const AtendimentoIndividualViewDocument = gql`
  query AtendimentoIndividualView($atendimentoId: ID!) {
    atendimento(id: $atendimentoId) {
      id
      iniciadoEm
      agendado {
        id
        lotacaoAgendada {
          id
        }
      }
      tiposServico {
        id
      }
      cidadao {
        id
        cpf
        cns
        nome
        nomeSocial
        dataNascimento
        sexo
        nomeMae
        area
        microArea
        identidadeGeneroDbEnum
        informarDum
        idade
        isGestante
        stCompartilhaProntuario
        gestacoes {
          inicio
          fim
        }
        ultimaDum {
          dum
          registradoEm
        }
      }
      atendimentoProfissional {
        id
        tipo
      }
      prontuario {
        id
      }
    }
    procedimentosAutomaticos {
      ...Procedimento
    }
  }
  ${ProcedimentoFragmentDoc}
`

/**
 * __useAtendimentoIndividualViewQuery__
 *
 * To run a query within a React component, call `useAtendimentoIndividualViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useAtendimentoIndividualViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAtendimentoIndividualViewQuery({
 *   variables: {
 *      atendimentoId: // value for 'atendimentoId'
 *   },
 * });
 */
export function useAtendimentoIndividualViewQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.AtendimentoIndividualViewQuery,
    Types.AtendimentoIndividualViewQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<Types.AtendimentoIndividualViewQuery, Types.AtendimentoIndividualViewQueryVariables>(
    AtendimentoIndividualViewDocument,
    baseOptions
  )
}
export function useAtendimentoIndividualViewLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.AtendimentoIndividualViewQuery,
    Types.AtendimentoIndividualViewQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    Types.AtendimentoIndividualViewQuery,
    Types.AtendimentoIndividualViewQueryVariables
  >(AtendimentoIndividualViewDocument, baseOptions)
}
export type AtendimentoIndividualViewQueryHookResult = ReturnType<typeof useAtendimentoIndividualViewQuery>
export type AtendimentoIndividualViewLazyQueryHookResult = ReturnType<typeof useAtendimentoIndividualViewLazyQuery>
export type AtendimentoIndividualViewQueryResult = ApolloReactCommon.QueryResult<
  Types.AtendimentoIndividualViewQuery,
  Types.AtendimentoIndividualViewQueryVariables
>
export const FinalizarAtendimentoIndividualDocument = gql`
  mutation FinalizarAtendimentoIndividual($input: FinalizarAtendimentoIndividualInput!) {
    finalizarAtendimentoIndividual(input: $input) {
      id
    }
  }
`
export type FinalizarAtendimentoIndividualMutationFn = ApolloReactCommon.MutationFunction<
  Types.FinalizarAtendimentoIndividualMutation,
  Types.FinalizarAtendimentoIndividualMutationVariables
>

/**
 * __useFinalizarAtendimentoIndividualMutation__
 *
 * To run a mutation, you first call `useFinalizarAtendimentoIndividualMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinalizarAtendimentoIndividualMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finalizarAtendimentoIndividualMutation, { data, loading, error }] = useFinalizarAtendimentoIndividualMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFinalizarAtendimentoIndividualMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.FinalizarAtendimentoIndividualMutation,
    Types.FinalizarAtendimentoIndividualMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    Types.FinalizarAtendimentoIndividualMutation,
    Types.FinalizarAtendimentoIndividualMutationVariables
  >(FinalizarAtendimentoIndividualDocument, baseOptions)
}
export type FinalizarAtendimentoIndividualMutationHookResult = ReturnType<
  typeof useFinalizarAtendimentoIndividualMutation
>
export type FinalizarAtendimentoIndividualMutationResult = ApolloReactCommon.MutationResult<
  Types.FinalizarAtendimentoIndividualMutation
>
export type FinalizarAtendimentoIndividualMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.FinalizarAtendimentoIndividualMutation,
  Types.FinalizarAtendimentoIndividualMutationVariables
>
export const AtendimentoVacinacaoViewDocument = gql`
  query AtendimentoVacinacaoView($atendimentoId: ID!) {
    atendimento(id: $atendimentoId) {
      id
      iniciadoEm
      agendado {
        id
      }
      cidadao {
        id
        cpf
        cns
        nome
        nomeSocial
        dataNascimento
        sexo
        nomeMae
        area
        microArea
        identidadeGeneroDbEnum
        informarDum
        idade
        isGestante
        stCompartilhaProntuario
      }
      prontuario {
        id
        gestante
        puerpera
      }
    }
  }
`

/**
 * __useAtendimentoVacinacaoViewQuery__
 *
 * To run a query within a React component, call `useAtendimentoVacinacaoViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useAtendimentoVacinacaoViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAtendimentoVacinacaoViewQuery({
 *   variables: {
 *      atendimentoId: // value for 'atendimentoId'
 *   },
 * });
 */
export function useAtendimentoVacinacaoViewQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.AtendimentoVacinacaoViewQuery,
    Types.AtendimentoVacinacaoViewQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<Types.AtendimentoVacinacaoViewQuery, Types.AtendimentoVacinacaoViewQueryVariables>(
    AtendimentoVacinacaoViewDocument,
    baseOptions
  )
}
export function useAtendimentoVacinacaoViewLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.AtendimentoVacinacaoViewQuery,
    Types.AtendimentoVacinacaoViewQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    Types.AtendimentoVacinacaoViewQuery,
    Types.AtendimentoVacinacaoViewQueryVariables
  >(AtendimentoVacinacaoViewDocument, baseOptions)
}
export type AtendimentoVacinacaoViewQueryHookResult = ReturnType<typeof useAtendimentoVacinacaoViewQuery>
export type AtendimentoVacinacaoViewLazyQueryHookResult = ReturnType<typeof useAtendimentoVacinacaoViewLazyQuery>
export type AtendimentoVacinacaoViewQueryResult = ApolloReactCommon.QueryResult<
  Types.AtendimentoVacinacaoViewQuery,
  Types.AtendimentoVacinacaoViewQueryVariables
>
export const EsquemaCalendarioVacinalDocument = gql`
  query EsquemaCalendarioVacinal($input: EsquemaCalendarioVacinalQueryInput!) {
    esquemaCalendarioVacinal(input: $input) {
      id
      descricaoImunobiologico
      idadeRecomendada
      mostrarNoCalendarioDoGrupo
      imunobiologico {
        id
      }
      dose {
        id
        nomeApresentacaoDose
      }
      faixaEtaria {
        id
        diasInicio
        diasFim
      }
    }
  }
`

/**
 * __useEsquemaCalendarioVacinalQuery__
 *
 * To run a query within a React component, call `useEsquemaCalendarioVacinalQuery` and pass it any options that fit your needs.
 * When your component renders, `useEsquemaCalendarioVacinalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEsquemaCalendarioVacinalQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEsquemaCalendarioVacinalQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.EsquemaCalendarioVacinalQuery,
    Types.EsquemaCalendarioVacinalQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<Types.EsquemaCalendarioVacinalQuery, Types.EsquemaCalendarioVacinalQueryVariables>(
    EsquemaCalendarioVacinalDocument,
    baseOptions
  )
}
export function useEsquemaCalendarioVacinalLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.EsquemaCalendarioVacinalQuery,
    Types.EsquemaCalendarioVacinalQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    Types.EsquemaCalendarioVacinalQuery,
    Types.EsquemaCalendarioVacinalQueryVariables
  >(EsquemaCalendarioVacinalDocument, baseOptions)
}
export type EsquemaCalendarioVacinalQueryHookResult = ReturnType<typeof useEsquemaCalendarioVacinalQuery>
export type EsquemaCalendarioVacinalLazyQueryHookResult = ReturnType<typeof useEsquemaCalendarioVacinalLazyQuery>
export type EsquemaCalendarioVacinalQueryResult = ApolloReactCommon.QueryResult<
  Types.EsquemaCalendarioVacinalQuery,
  Types.EsquemaCalendarioVacinalQueryVariables
>
export const FinalizarAtendimentoVacinacaoDocument = gql`
  mutation FinalizarAtendimentoVacinacao($input: AtendimentoVacinacaoInput!) {
    finalizarAtendimentoVacinacao(input: $input) {
      id
    }
  }
`
export type FinalizarAtendimentoVacinacaoMutationFn = ApolloReactCommon.MutationFunction<
  Types.FinalizarAtendimentoVacinacaoMutation,
  Types.FinalizarAtendimentoVacinacaoMutationVariables
>

/**
 * __useFinalizarAtendimentoVacinacaoMutation__
 *
 * To run a mutation, you first call `useFinalizarAtendimentoVacinacaoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinalizarAtendimentoVacinacaoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finalizarAtendimentoVacinacaoMutation, { data, loading, error }] = useFinalizarAtendimentoVacinacaoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFinalizarAtendimentoVacinacaoMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.FinalizarAtendimentoVacinacaoMutation,
    Types.FinalizarAtendimentoVacinacaoMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    Types.FinalizarAtendimentoVacinacaoMutation,
    Types.FinalizarAtendimentoVacinacaoMutationVariables
  >(FinalizarAtendimentoVacinacaoDocument, baseOptions)
}
export type FinalizarAtendimentoVacinacaoMutationHookResult = ReturnType<
  typeof useFinalizarAtendimentoVacinacaoMutation
>
export type FinalizarAtendimentoVacinacaoMutationResult = ApolloReactCommon.MutationResult<
  Types.FinalizarAtendimentoVacinacaoMutation
>
export type FinalizarAtendimentoVacinacaoMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.FinalizarAtendimentoVacinacaoMutation,
  Types.FinalizarAtendimentoVacinacaoMutationVariables
>
export const AtendimentoCidadaoHeaderDocument = gql`
  query AtendimentoCidadaoHeader($atendimentoId: ID!) {
    atendimento(id: $atendimentoId) {
      id
      cidadao {
        id
        cpf
        cns
        nome
        nomeSocial
        dataNascimento
        sexo
        nomeMae
        area
        microArea
      }
      unidadeSaude {
        id
        nome
      }
    }
  }
`

/**
 * __useAtendimentoCidadaoHeaderQuery__
 *
 * To run a query within a React component, call `useAtendimentoCidadaoHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useAtendimentoCidadaoHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAtendimentoCidadaoHeaderQuery({
 *   variables: {
 *      atendimentoId: // value for 'atendimentoId'
 *   },
 * });
 */
export function useAtendimentoCidadaoHeaderQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.AtendimentoCidadaoHeaderQuery,
    Types.AtendimentoCidadaoHeaderQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<Types.AtendimentoCidadaoHeaderQuery, Types.AtendimentoCidadaoHeaderQueryVariables>(
    AtendimentoCidadaoHeaderDocument,
    baseOptions
  )
}
export function useAtendimentoCidadaoHeaderLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.AtendimentoCidadaoHeaderQuery,
    Types.AtendimentoCidadaoHeaderQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    Types.AtendimentoCidadaoHeaderQuery,
    Types.AtendimentoCidadaoHeaderQueryVariables
  >(AtendimentoCidadaoHeaderDocument, baseOptions)
}
export type AtendimentoCidadaoHeaderQueryHookResult = ReturnType<typeof useAtendimentoCidadaoHeaderQuery>
export type AtendimentoCidadaoHeaderLazyQueryHookResult = ReturnType<typeof useAtendimentoCidadaoHeaderLazyQuery>
export type AtendimentoCidadaoHeaderQueryResult = ApolloReactCommon.QueryResult<
  Types.AtendimentoCidadaoHeaderQuery,
  Types.AtendimentoCidadaoHeaderQueryVariables
>
export const AtendimentoViewDocument = gql`
  query AtendimentoView($id: ID!) {
    atendimento(id: $id) {
      id
      atendimentoProfissional {
        id
        tipo
        lotacao {
          id
        }
      }
    }
  }
`

/**
 * __useAtendimentoViewQuery__
 *
 * To run a query within a React component, call `useAtendimentoViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useAtendimentoViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAtendimentoViewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAtendimentoViewQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.AtendimentoViewQuery, Types.AtendimentoViewQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.AtendimentoViewQuery, Types.AtendimentoViewQueryVariables>(
    AtendimentoViewDocument,
    baseOptions
  )
}
export function useAtendimentoViewLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AtendimentoViewQuery, Types.AtendimentoViewQueryVariables>
) {
  return ApolloReactHooks.useLazyQuery<Types.AtendimentoViewQuery, Types.AtendimentoViewQueryVariables>(
    AtendimentoViewDocument,
    baseOptions
  )
}
export type AtendimentoViewQueryHookResult = ReturnType<typeof useAtendimentoViewQuery>
export type AtendimentoViewLazyQueryHookResult = ReturnType<typeof useAtendimentoViewLazyQuery>
export type AtendimentoViewQueryResult = ApolloReactCommon.QueryResult<
  Types.AtendimentoViewQuery,
  Types.AtendimentoViewQueryVariables
>
export const CancelarAtendimentoDocument = gql`
  mutation CancelarAtendimento($atendimentoId: ID!) {
    cancelarAtendimento(atendimento: $atendimentoId) {
      id
      statusAtendimento
      atendimentoProfissional {
        id
      }
    }
  }
`
export type CancelarAtendimentoMutationFn = ApolloReactCommon.MutationFunction<
  Types.CancelarAtendimentoMutation,
  Types.CancelarAtendimentoMutationVariables
>

/**
 * __useCancelarAtendimentoMutation__
 *
 * To run a mutation, you first call `useCancelarAtendimentoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelarAtendimentoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelarAtendimentoMutation, { data, loading, error }] = useCancelarAtendimentoMutation({
 *   variables: {
 *      atendimentoId: // value for 'atendimentoId'
 *   },
 * });
 */
export function useCancelarAtendimentoMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.CancelarAtendimentoMutation,
    Types.CancelarAtendimentoMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<Types.CancelarAtendimentoMutation, Types.CancelarAtendimentoMutationVariables>(
    CancelarAtendimentoDocument,
    baseOptions
  )
}
export type CancelarAtendimentoMutationHookResult = ReturnType<typeof useCancelarAtendimentoMutation>
export type CancelarAtendimentoMutationResult = ApolloReactCommon.MutationResult<Types.CancelarAtendimentoMutation>
export type CancelarAtendimentoMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.CancelarAtendimentoMutation,
  Types.CancelarAtendimentoMutationVariables
>
export const EvolucoesProblemaModalDocument = gql`
  query EvolucoesProblemaModal($problemaId: ID!) {
    problema(id: $problemaId) {
      id
      evolucoes {
        id
        dataInicio
        dataFim
        situacao
        observacao
        atualizadoEm
        atendimentoProfissional {
          id
          lotacao {
            id
            cbo {
              id
              nome
            }
            profissional {
              id
              nome
            }
          }
        }
      }
    }
  }
`

/**
 * __useEvolucoesProblemaModalQuery__
 *
 * To run a query within a React component, call `useEvolucoesProblemaModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useEvolucoesProblemaModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEvolucoesProblemaModalQuery({
 *   variables: {
 *      problemaId: // value for 'problemaId'
 *   },
 * });
 */
export function useEvolucoesProblemaModalQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.EvolucoesProblemaModalQuery,
    Types.EvolucoesProblemaModalQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<Types.EvolucoesProblemaModalQuery, Types.EvolucoesProblemaModalQueryVariables>(
    EvolucoesProblemaModalDocument,
    baseOptions
  )
}
export function useEvolucoesProblemaModalLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.EvolucoesProblemaModalQuery,
    Types.EvolucoesProblemaModalQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<Types.EvolucoesProblemaModalQuery, Types.EvolucoesProblemaModalQueryVariables>(
    EvolucoesProblemaModalDocument,
    baseOptions
  )
}
export type EvolucoesProblemaModalQueryHookResult = ReturnType<typeof useEvolucoesProblemaModalQuery>
export type EvolucoesProblemaModalLazyQueryHookResult = ReturnType<typeof useEvolucoesProblemaModalLazyQuery>
export type EvolucoesProblemaModalQueryResult = ApolloReactCommon.QueryResult<
  Types.EvolucoesProblemaModalQuery,
  Types.EvolucoesProblemaModalQueryVariables
>
export const ExisteProblemaResolvidoDocument = gql`
  query ExisteProblemaResolvido($prontuarioId: ID!) {
    existeProblemaResolvido(input: $prontuarioId)
  }
`

/**
 * __useExisteProblemaResolvidoQuery__
 *
 * To run a query within a React component, call `useExisteProblemaResolvidoQuery` and pass it any options that fit your needs.
 * When your component renders, `useExisteProblemaResolvidoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExisteProblemaResolvidoQuery({
 *   variables: {
 *      prontuarioId: // value for 'prontuarioId'
 *   },
 * });
 */
export function useExisteProblemaResolvidoQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.ExisteProblemaResolvidoQuery,
    Types.ExisteProblemaResolvidoQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<Types.ExisteProblemaResolvidoQuery, Types.ExisteProblemaResolvidoQueryVariables>(
    ExisteProblemaResolvidoDocument,
    baseOptions
  )
}
export function useExisteProblemaResolvidoLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.ExisteProblemaResolvidoQuery,
    Types.ExisteProblemaResolvidoQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<Types.ExisteProblemaResolvidoQuery, Types.ExisteProblemaResolvidoQueryVariables>(
    ExisteProblemaResolvidoDocument,
    baseOptions
  )
}
export type ExisteProblemaResolvidoQueryHookResult = ReturnType<typeof useExisteProblemaResolvidoQuery>
export type ExisteProblemaResolvidoLazyQueryHookResult = ReturnType<typeof useExisteProblemaResolvidoLazyQuery>
export type ExisteProblemaResolvidoQueryResult = ApolloReactCommon.QueryResult<
  Types.ExisteProblemaResolvidoQuery,
  Types.ExisteProblemaResolvidoQueryVariables
>
export const ProblemasModalDocument = gql`
  query ProblemasModal($filtro: ProblemaQueryInput!) {
    problemas(input: $filtro) {
      content {
        id
        situacao
        ciap {
          id
          codigo
          descricao
        }
        cid10 {
          id
          codigo
          nome
        }
        descricaoOutro
        ultimaEvolucao {
          id
          dataInicio
          dataFim
          atualizadoEm
        }
      }
    }
  }
`

/**
 * __useProblemasModalQuery__
 *
 * To run a query within a React component, call `useProblemasModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useProblemasModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProblemasModalQuery({
 *   variables: {
 *      filtro: // value for 'filtro'
 *   },
 * });
 */
export function useProblemasModalQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ProblemasModalQuery, Types.ProblemasModalQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.ProblemasModalQuery, Types.ProblemasModalQueryVariables>(
    ProblemasModalDocument,
    baseOptions
  )
}
export function useProblemasModalLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ProblemasModalQuery, Types.ProblemasModalQueryVariables>
) {
  return ApolloReactHooks.useLazyQuery<Types.ProblemasModalQuery, Types.ProblemasModalQueryVariables>(
    ProblemasModalDocument,
    baseOptions
  )
}
export type ProblemasModalQueryHookResult = ReturnType<typeof useProblemasModalQuery>
export type ProblemasModalLazyQueryHookResult = ReturnType<typeof useProblemasModalLazyQuery>
export type ProblemasModalQueryResult = ApolloReactCommon.QueryResult<
  Types.ProblemasModalQuery,
  Types.ProblemasModalQueryVariables
>
export const MedicamentoUsoModalDocument = gql`
  query MedicamentoUsoModal($input: ListaMedicamentoAtivoConcluidoQueryInput!) {
    listaMedicamento(input: $input) {
      content {
        id
        medicamento {
          id
          principioAtivo
          concentracao
        }
        usoContinuo
        posologia
        dtInicioTratamento
        dtFimTratamento
        medidaTempoTratamento
        tipoReceita
        recomendacoes
        tratamentoInterrompido
        justificativaInterrupcao
        dtInterrupcao
        atendProf {
          id
          versaoAnterior
        }
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${PageInfoFragmentDoc}
`

/**
 * __useMedicamentoUsoModalQuery__
 *
 * To run a query within a React component, call `useMedicamentoUsoModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useMedicamentoUsoModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMedicamentoUsoModalQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMedicamentoUsoModalQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.MedicamentoUsoModalQuery,
    Types.MedicamentoUsoModalQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<Types.MedicamentoUsoModalQuery, Types.MedicamentoUsoModalQueryVariables>(
    MedicamentoUsoModalDocument,
    baseOptions
  )
}
export function useMedicamentoUsoModalLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.MedicamentoUsoModalQuery,
    Types.MedicamentoUsoModalQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<Types.MedicamentoUsoModalQuery, Types.MedicamentoUsoModalQueryVariables>(
    MedicamentoUsoModalDocument,
    baseOptions
  )
}
export type MedicamentoUsoModalQueryHookResult = ReturnType<typeof useMedicamentoUsoModalQuery>
export type MedicamentoUsoModalLazyQueryHookResult = ReturnType<typeof useMedicamentoUsoModalLazyQuery>
export type MedicamentoUsoModalQueryResult = ApolloReactCommon.QueryResult<
  Types.MedicamentoUsoModalQuery,
  Types.MedicamentoUsoModalQueryVariables
>
export const MedicoesAtendimentosAnterioresDocument = gql`
  query medicoesAtendimentosAnteriores($input: MedicoesQueryInput!) {
    medicoes(input: $input) {
      content {
        id
        dataMedicao
        dum
        valorPeso
        valorAltura
        valorFrequenciaCardiaca
        valorPressaoArterial
        valorPerimetroCefalico
        valorFrequenciaRespiratoria
        valorTemperatura
        valorSaturacaoO2
        valorGlicemia
        tipoGlicemia {
          id
          nome
          tipoGlicemiaDbEnum
        }
        atendimentoProfissional {
          iniciadoEm
          atendimento {
            lotacao {
              profissional {
                nome
              }
            }
          }
        }
        valorImc
        perimetroPanturrilha
        valorCircunferenciaAbdominal
        medicaoAnterior
        valorAlturaUterina
      }
      pageInfo {
        numberOfElements
        totalElements
      }
    }
  }
`

/**
 * __useMedicoesAtendimentosAnterioresQuery__
 *
 * To run a query within a React component, call `useMedicoesAtendimentosAnterioresQuery` and pass it any options that fit your needs.
 * When your component renders, `useMedicoesAtendimentosAnterioresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMedicoesAtendimentosAnterioresQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMedicoesAtendimentosAnterioresQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.MedicoesAtendimentosAnterioresQuery,
    Types.MedicoesAtendimentosAnterioresQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    Types.MedicoesAtendimentosAnterioresQuery,
    Types.MedicoesAtendimentosAnterioresQueryVariables
  >(MedicoesAtendimentosAnterioresDocument, baseOptions)
}
export function useMedicoesAtendimentosAnterioresLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.MedicoesAtendimentosAnterioresQuery,
    Types.MedicoesAtendimentosAnterioresQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    Types.MedicoesAtendimentosAnterioresQuery,
    Types.MedicoesAtendimentosAnterioresQueryVariables
  >(MedicoesAtendimentosAnterioresDocument, baseOptions)
}
export type MedicoesAtendimentosAnterioresQueryHookResult = ReturnType<typeof useMedicoesAtendimentosAnterioresQuery>
export type MedicoesAtendimentosAnterioresLazyQueryHookResult = ReturnType<
  typeof useMedicoesAtendimentosAnterioresLazyQuery
>
export type MedicoesAtendimentosAnterioresQueryResult = ApolloReactCommon.QueryResult<
  Types.MedicoesAtendimentosAnterioresQuery,
  Types.MedicoesAtendimentosAnterioresQueryVariables
>
export const CondicoesAutorreferidasCardDocument = gql`
  query CondicoesAutorreferidasCard($cidadaoId: ID!) {
    condicoesAutorreferidas(cidadaoId: $cidadaoId) {
      descricao
    }
  }
`

/**
 * __useCondicoesAutorreferidasCardQuery__
 *
 * To run a query within a React component, call `useCondicoesAutorreferidasCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useCondicoesAutorreferidasCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCondicoesAutorreferidasCardQuery({
 *   variables: {
 *      cidadaoId: // value for 'cidadaoId'
 *   },
 * });
 */
export function useCondicoesAutorreferidasCardQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.CondicoesAutorreferidasCardQuery,
    Types.CondicoesAutorreferidasCardQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    Types.CondicoesAutorreferidasCardQuery,
    Types.CondicoesAutorreferidasCardQueryVariables
  >(CondicoesAutorreferidasCardDocument, baseOptions)
}
export function useCondicoesAutorreferidasCardLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.CondicoesAutorreferidasCardQuery,
    Types.CondicoesAutorreferidasCardQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    Types.CondicoesAutorreferidasCardQuery,
    Types.CondicoesAutorreferidasCardQueryVariables
  >(CondicoesAutorreferidasCardDocument, baseOptions)
}
export type CondicoesAutorreferidasCardQueryHookResult = ReturnType<typeof useCondicoesAutorreferidasCardQuery>
export type CondicoesAutorreferidasCardLazyQueryHookResult = ReturnType<typeof useCondicoesAutorreferidasCardLazyQuery>
export type CondicoesAutorreferidasCardQueryResult = ApolloReactCommon.QueryResult<
  Types.CondicoesAutorreferidasCardQuery,
  Types.CondicoesAutorreferidasCardQueryVariables
>
export const ProblemasCardDocument = gql`
  query ProblemasCard($filtro: ProblemaQueryInput!) {
    problemas(input: $filtro) {
      content {
        id
        situacao
        ciap {
          id
          codigo
          descricao
        }
        cid10 {
          id
          codigo
          nome
        }
        descricaoOutro
        ultimaEvolucao {
          id
          atualizadoEm
        }
      }
    }
  }
`

/**
 * __useProblemasCardQuery__
 *
 * To run a query within a React component, call `useProblemasCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useProblemasCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProblemasCardQuery({
 *   variables: {
 *      filtro: // value for 'filtro'
 *   },
 * });
 */
export function useProblemasCardQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ProblemasCardQuery, Types.ProblemasCardQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.ProblemasCardQuery, Types.ProblemasCardQueryVariables>(
    ProblemasCardDocument,
    baseOptions
  )
}
export function useProblemasCardLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ProblemasCardQuery, Types.ProblemasCardQueryVariables>
) {
  return ApolloReactHooks.useLazyQuery<Types.ProblemasCardQuery, Types.ProblemasCardQueryVariables>(
    ProblemasCardDocument,
    baseOptions
  )
}
export type ProblemasCardQueryHookResult = ReturnType<typeof useProblemasCardQuery>
export type ProblemasCardLazyQueryHookResult = ReturnType<typeof useProblemasCardLazyQuery>
export type ProblemasCardQueryResult = ApolloReactCommon.QueryResult<
  Types.ProblemasCardQuery,
  Types.ProblemasCardQueryVariables
>
export const MedicamentoUsoBarraLateralDocument = gql`
  query MedicamentoUsoBarraLateral($input: ListaMedicamentoAtivoConcluidoQueryInput!) {
    listaMedicamento(input: $input) {
      content {
        id
        medicamento {
          id
          principioAtivo
          concentracao
        }
        posologia
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${PageInfoFragmentDoc}
`

/**
 * __useMedicamentoUsoBarraLateralQuery__
 *
 * To run a query within a React component, call `useMedicamentoUsoBarraLateralQuery` and pass it any options that fit your needs.
 * When your component renders, `useMedicamentoUsoBarraLateralQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMedicamentoUsoBarraLateralQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMedicamentoUsoBarraLateralQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.MedicamentoUsoBarraLateralQuery,
    Types.MedicamentoUsoBarraLateralQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    Types.MedicamentoUsoBarraLateralQuery,
    Types.MedicamentoUsoBarraLateralQueryVariables
  >(MedicamentoUsoBarraLateralDocument, baseOptions)
}
export function useMedicamentoUsoBarraLateralLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.MedicamentoUsoBarraLateralQuery,
    Types.MedicamentoUsoBarraLateralQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    Types.MedicamentoUsoBarraLateralQuery,
    Types.MedicamentoUsoBarraLateralQueryVariables
  >(MedicamentoUsoBarraLateralDocument, baseOptions)
}
export type MedicamentoUsoBarraLateralQueryHookResult = ReturnType<typeof useMedicamentoUsoBarraLateralQuery>
export type MedicamentoUsoBarraLateralLazyQueryHookResult = ReturnType<typeof useMedicamentoUsoBarraLateralLazyQuery>
export type MedicamentoUsoBarraLateralQueryResult = ApolloReactCommon.QueryResult<
  Types.MedicamentoUsoBarraLateralQuery,
  Types.MedicamentoUsoBarraLateralQueryVariables
>
export const PossuiTratamentoConcluidoDocument = gql`
  query PossuiTratamentoConcluido($input: PossuiTratamentoConcluidoQueryInput!) {
    possuiTratamentoConcluido(input: $input)
  }
`

/**
 * __usePossuiTratamentoConcluidoQuery__
 *
 * To run a query within a React component, call `usePossuiTratamentoConcluidoQuery` and pass it any options that fit your needs.
 * When your component renders, `usePossuiTratamentoConcluidoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePossuiTratamentoConcluidoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePossuiTratamentoConcluidoQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.PossuiTratamentoConcluidoQuery,
    Types.PossuiTratamentoConcluidoQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<Types.PossuiTratamentoConcluidoQuery, Types.PossuiTratamentoConcluidoQueryVariables>(
    PossuiTratamentoConcluidoDocument,
    baseOptions
  )
}
export function usePossuiTratamentoConcluidoLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.PossuiTratamentoConcluidoQuery,
    Types.PossuiTratamentoConcluidoQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    Types.PossuiTratamentoConcluidoQuery,
    Types.PossuiTratamentoConcluidoQueryVariables
  >(PossuiTratamentoConcluidoDocument, baseOptions)
}
export type PossuiTratamentoConcluidoQueryHookResult = ReturnType<typeof usePossuiTratamentoConcluidoQuery>
export type PossuiTratamentoConcluidoLazyQueryHookResult = ReturnType<typeof usePossuiTratamentoConcluidoLazyQuery>
export type PossuiTratamentoConcluidoQueryResult = ApolloReactCommon.QueryResult<
  Types.PossuiTratamentoConcluidoQuery,
  Types.PossuiTratamentoConcluidoQueryVariables
>
export const ListaMedicamentoDocument = gql`
  query ListaMedicamento($input: ListaMedicamentoAtivoConcluidoQueryInput!) {
    listaMedicamento(input: $input) {
      content {
        id
        medicamento {
          id
          principioAtivo
          concentracao
          unidadeFornecimento
          medicamentoCatmat {
            id
            volume
            medicamento {
              id
              principioAtivo
              unidadeFornecimento
              concentracao
              formaFarmaceutica {
                id
                nome
              }
            }
            unidadeFornecimento {
              id
              nome
              nomePlural
            }
            principioAtivo {
              id
              nome
              listaMaterial {
                id
                nome
                tipoReceita
              }
            }
          }
          formaFarmaceutica {
            id
            nome
          }
        }
        aplicacaoMedicamento {
          id
          nome
        }
        quantidadeReceitada
        recomendacoes
        dose
        frequenciaDose
        posologia
        tipoFrequenciaDose
        qtPeriodoFrequencia
        medidaTempoFrequencia
        dtInicioTratamento
        dtFimTratamento
        qtDuracaoTratamento
        medidaTempoTratamento
        usoContinuo
        registroManual
        doseUnica
        tipoReceita
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${PageInfoFragmentDoc}
`

/**
 * __useListaMedicamentoQuery__
 *
 * To run a query within a React component, call `useListaMedicamentoQuery` and pass it any options that fit your needs.
 * When your component renders, `useListaMedicamentoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListaMedicamentoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListaMedicamentoQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ListaMedicamentoQuery, Types.ListaMedicamentoQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.ListaMedicamentoQuery, Types.ListaMedicamentoQueryVariables>(
    ListaMedicamentoDocument,
    baseOptions
  )
}
export function useListaMedicamentoLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ListaMedicamentoQuery, Types.ListaMedicamentoQueryVariables>
) {
  return ApolloReactHooks.useLazyQuery<Types.ListaMedicamentoQuery, Types.ListaMedicamentoQueryVariables>(
    ListaMedicamentoDocument,
    baseOptions
  )
}
export type ListaMedicamentoQueryHookResult = ReturnType<typeof useListaMedicamentoQuery>
export type ListaMedicamentoLazyQueryHookResult = ReturnType<typeof useListaMedicamentoLazyQuery>
export type ListaMedicamentoQueryResult = ApolloReactCommon.QueryResult<
  Types.ListaMedicamentoQuery,
  Types.ListaMedicamentoQueryVariables
>
export const MedicoesCardDocument = gql`
  query MedicoesCard($filtro: UltimasMedicoesInput!) {
    ultimasMedicoesDoDia(filtro: $filtro) {
      tipo
      medicoes {
        dataMedicao
        valor
        observacao
      }
    }
    ultimasMedicoesDiasAnteriores(filtro: $filtro) {
      tipo
      medicoes {
        dataMedicao
        valor
        observacao
      }
    }
  }
`

/**
 * __useMedicoesCardQuery__
 *
 * To run a query within a React component, call `useMedicoesCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useMedicoesCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMedicoesCardQuery({
 *   variables: {
 *      filtro: // value for 'filtro'
 *   },
 * });
 */
export function useMedicoesCardQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.MedicoesCardQuery, Types.MedicoesCardQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.MedicoesCardQuery, Types.MedicoesCardQueryVariables>(
    MedicoesCardDocument,
    baseOptions
  )
}
export function useMedicoesCardLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.MedicoesCardQuery, Types.MedicoesCardQueryVariables>
) {
  return ApolloReactHooks.useLazyQuery<Types.MedicoesCardQuery, Types.MedicoesCardQueryVariables>(
    MedicoesCardDocument,
    baseOptions
  )
}
export type MedicoesCardQueryHookResult = ReturnType<typeof useMedicoesCardQuery>
export type MedicoesCardLazyQueryHookResult = ReturnType<typeof useMedicoesCardLazyQuery>
export type MedicoesCardQueryResult = ApolloReactCommon.QueryResult<
  Types.MedicoesCardQuery,
  Types.MedicoesCardQueryVariables
>
export const AtendimentoAtestadoDocument = gql`
  query AtendimentoAtestado($atendimentoId: ID!) {
    atendimento(id: $atendimentoId) {
      id
      cidadao {
        id
        nome
        nomeSocial
      }
      atendimentoProfissional {
        id
        iniciadoEm
        lotacao {
          id
          profissional {
            id
            nome
            numeroConselhoClasse
            conselhoClasse {
              id
              sigla
            }
            ufEmissoraConselhoClasse {
              id
              nome
              sigla
            }
          }
          cbo {
            id
            nome
          }
          unidadeSaude {
            id
            nome
          }
          municipio {
            id
            nome
            uf {
              id
              nome
              sigla
            }
          }
        }
      }
    }
  }
`

/**
 * __useAtendimentoAtestadoQuery__
 *
 * To run a query within a React component, call `useAtendimentoAtestadoQuery` and pass it any options that fit your needs.
 * When your component renders, `useAtendimentoAtestadoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAtendimentoAtestadoQuery({
 *   variables: {
 *      atendimentoId: // value for 'atendimentoId'
 *   },
 * });
 */
export function useAtendimentoAtestadoQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.AtendimentoAtestadoQuery,
    Types.AtendimentoAtestadoQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<Types.AtendimentoAtestadoQuery, Types.AtendimentoAtestadoQueryVariables>(
    AtendimentoAtestadoDocument,
    baseOptions
  )
}
export function useAtendimentoAtestadoLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.AtendimentoAtestadoQuery,
    Types.AtendimentoAtestadoQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<Types.AtendimentoAtestadoQuery, Types.AtendimentoAtestadoQueryVariables>(
    AtendimentoAtestadoDocument,
    baseOptions
  )
}
export type AtendimentoAtestadoQueryHookResult = ReturnType<typeof useAtendimentoAtestadoQuery>
export type AtendimentoAtestadoLazyQueryHookResult = ReturnType<typeof useAtendimentoAtestadoLazyQuery>
export type AtendimentoAtestadoQueryResult = ApolloReactCommon.QueryResult<
  Types.AtendimentoAtestadoQuery,
  Types.AtendimentoAtestadoQueryVariables
>
export const LoadAtestadoByIdDocument = gql`
  query LoadAtestadoById($id: ID!) {
    atestado(id: $id) {
      id
      descricao
      tipo
      atendimentoProfissional {
        id
        lotacao {
          id
          profissional {
            id
            nome
            numeroConselhoClasse
            conselhoClasse {
              id
              sigla
            }
            ufEmissoraConselhoClasse {
              id
              nome
              sigla
            }
          }
          municipio {
            id
            nome
            uf {
              id
              nome
              sigla
            }
          }
          unidadeSaude {
            id
            nome
          }
          cbo {
            id
            nome
          }
        }
        iniciadoEm
      }
    }
  }
`

/**
 * __useLoadAtestadoByIdQuery__
 *
 * To run a query within a React component, call `useLoadAtestadoByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadAtestadoByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadAtestadoByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLoadAtestadoByIdQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.LoadAtestadoByIdQuery, Types.LoadAtestadoByIdQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.LoadAtestadoByIdQuery, Types.LoadAtestadoByIdQueryVariables>(
    LoadAtestadoByIdDocument,
    baseOptions
  )
}
export function useLoadAtestadoByIdLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.LoadAtestadoByIdQuery, Types.LoadAtestadoByIdQueryVariables>
) {
  return ApolloReactHooks.useLazyQuery<Types.LoadAtestadoByIdQuery, Types.LoadAtestadoByIdQueryVariables>(
    LoadAtestadoByIdDocument,
    baseOptions
  )
}
export type LoadAtestadoByIdQueryHookResult = ReturnType<typeof useLoadAtestadoByIdQuery>
export type LoadAtestadoByIdLazyQueryHookResult = ReturnType<typeof useLoadAtestadoByIdLazyQuery>
export type LoadAtestadoByIdQueryResult = ApolloReactCommon.QueryResult<
  Types.LoadAtestadoByIdQuery,
  Types.LoadAtestadoByIdQueryVariables
>
export const LoadAtestadosDocument = gql`
  query LoadAtestados($input: AtestadoQueryInput!) {
    atestados(input: $input) {
      content {
        id
        atendimentoProfissional {
          id
          iniciadoEm
          lotacao {
            id
            profissional {
              id
              nome
              numeroConselhoClasse
              conselhoClasse {
                id
                sigla
              }
              ufEmissoraConselhoClasse {
                id
                nome
                sigla
              }
            }
            cbo {
              id
              nome
            }
            unidadeSaude {
              id
              nome
            }
            municipio {
              id
              nome
              uf {
                id
                nome
                sigla
              }
            }
          }
        }
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${PageInfoFragmentDoc}
`

/**
 * __useLoadAtestadosQuery__
 *
 * To run a query within a React component, call `useLoadAtestadosQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadAtestadosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadAtestadosQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoadAtestadosQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.LoadAtestadosQuery, Types.LoadAtestadosQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.LoadAtestadosQuery, Types.LoadAtestadosQueryVariables>(
    LoadAtestadosDocument,
    baseOptions
  )
}
export function useLoadAtestadosLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.LoadAtestadosQuery, Types.LoadAtestadosQueryVariables>
) {
  return ApolloReactHooks.useLazyQuery<Types.LoadAtestadosQuery, Types.LoadAtestadosQueryVariables>(
    LoadAtestadosDocument,
    baseOptions
  )
}
export type LoadAtestadosQueryHookResult = ReturnType<typeof useLoadAtestadosQuery>
export type LoadAtestadosLazyQueryHookResult = ReturnType<typeof useLoadAtestadosLazyQuery>
export type LoadAtestadosQueryResult = ApolloReactCommon.QueryResult<
  Types.LoadAtestadosQuery,
  Types.LoadAtestadosQueryVariables
>
export const EvolucoesOdontoTableDocument = gql`
  query EvolucoesOdontoTable($input: EvolucoesOdontoInput!) {
    evolucoesOdonto(input: $input) {
      content {
        id
        atendimentoProfissionalOdonto {
          id
          atendimentoProfissional {
            id
            iniciadoEm
            lotacao {
              id
              profissional {
                id
                nome
              }
              cbo {
                id
                nome
              }
            }
          }
        }
        procedimentos {
          id
          codigo
          descricao
        }
        partesBucais {
          id
          tipoParteBucal
          descricao
        }
        observacao
        descricaoParteBucal
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${PageInfoFragmentDoc}
`

/**
 * __useEvolucoesOdontoTableQuery__
 *
 * To run a query within a React component, call `useEvolucoesOdontoTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useEvolucoesOdontoTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEvolucoesOdontoTableQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEvolucoesOdontoTableQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.EvolucoesOdontoTableQuery,
    Types.EvolucoesOdontoTableQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<Types.EvolucoesOdontoTableQuery, Types.EvolucoesOdontoTableQueryVariables>(
    EvolucoesOdontoTableDocument,
    baseOptions
  )
}
export function useEvolucoesOdontoTableLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.EvolucoesOdontoTableQuery,
    Types.EvolucoesOdontoTableQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<Types.EvolucoesOdontoTableQuery, Types.EvolucoesOdontoTableQueryVariables>(
    EvolucoesOdontoTableDocument,
    baseOptions
  )
}
export type EvolucoesOdontoTableQueryHookResult = ReturnType<typeof useEvolucoesOdontoTableQuery>
export type EvolucoesOdontoTableLazyQueryHookResult = ReturnType<typeof useEvolucoesOdontoTableLazyQuery>
export type EvolucoesOdontoTableQueryResult = ApolloReactCommon.QueryResult<
  Types.EvolucoesOdontoTableQuery,
  Types.EvolucoesOdontoTableQueryVariables
>
export const OdontogramaProcedimentosDocument = gql`
  query OdontogramaProcedimentos($input: EvolucoesOdontoInput!) {
    evolucoesOdonto(input: $input) {
      content {
        id
        descricaoParteBucal
        observacao
        atendimentoProfissionalOdonto {
          id
        }
        partesBucais {
          id
          tipoParteBucal
          descricao
        }
        procedimentos {
          id
          descricao
          codigo
          procedimentoReferencia {
            id
            descricao
            codigo
          }
        }
      }
    }
  }
`

/**
 * __useOdontogramaProcedimentosQuery__
 *
 * To run a query within a React component, call `useOdontogramaProcedimentosQuery` and pass it any options that fit your needs.
 * When your component renders, `useOdontogramaProcedimentosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOdontogramaProcedimentosQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOdontogramaProcedimentosQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.OdontogramaProcedimentosQuery,
    Types.OdontogramaProcedimentosQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<Types.OdontogramaProcedimentosQuery, Types.OdontogramaProcedimentosQueryVariables>(
    OdontogramaProcedimentosDocument,
    baseOptions
  )
}
export function useOdontogramaProcedimentosLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.OdontogramaProcedimentosQuery,
    Types.OdontogramaProcedimentosQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    Types.OdontogramaProcedimentosQuery,
    Types.OdontogramaProcedimentosQueryVariables
  >(OdontogramaProcedimentosDocument, baseOptions)
}
export type OdontogramaProcedimentosQueryHookResult = ReturnType<typeof useOdontogramaProcedimentosQuery>
export type OdontogramaProcedimentosLazyQueryHookResult = ReturnType<typeof useOdontogramaProcedimentosLazyQuery>
export type OdontogramaProcedimentosQueryResult = ApolloReactCommon.QueryResult<
  Types.OdontogramaProcedimentosQuery,
  Types.OdontogramaProcedimentosQueryVariables
>
export const OdontogramaDocument = gql`
  query Odontograma($id: ID!) {
    odontograma(id: $id) {
      id
      evolucoesDente {
        id
        dente {
          id
          numero
        }
        situacoesFace
        situacoesRaiz
        situacaoCoroaCima
        situacaoCoroaBaixo
        situacaoCoroaEsquerda
        situacaoCoroaDireita
        situacaoCoroaCentro
      }
      proteseTotalInferior
      proteseTotalSuperior
      contencao
      aparelho
    }
  }
`

/**
 * __useOdontogramaQuery__
 *
 * To run a query within a React component, call `useOdontogramaQuery` and pass it any options that fit your needs.
 * When your component renders, `useOdontogramaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOdontogramaQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOdontogramaQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.OdontogramaQuery, Types.OdontogramaQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.OdontogramaQuery, Types.OdontogramaQueryVariables>(
    OdontogramaDocument,
    baseOptions
  )
}
export function useOdontogramaLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.OdontogramaQuery, Types.OdontogramaQueryVariables>
) {
  return ApolloReactHooks.useLazyQuery<Types.OdontogramaQuery, Types.OdontogramaQueryVariables>(
    OdontogramaDocument,
    baseOptions
  )
}
export type OdontogramaQueryHookResult = ReturnType<typeof useOdontogramaQuery>
export type OdontogramaLazyQueryHookResult = ReturnType<typeof useOdontogramaLazyQuery>
export type OdontogramaQueryResult = ApolloReactCommon.QueryResult<
  Types.OdontogramaQuery,
  Types.OdontogramaQueryVariables
>
export const OdontogramasDocument = gql`
  query Odontogramas($input: OdontogramasQueryInput!) {
    odontogramas(input: $input) {
      content {
        id
        evolucoesDente {
          id
          dente {
            id
            numero
          }
          situacoesRaiz
          situacoesFace
          situacaoCoroaCima
          situacaoCoroaDireita
          situacaoCoroaEsquerda
          situacaoCoroaBaixo
          situacaoCoroaCentro
        }
        proteseTotalSuperior
        proteseTotalInferior
        contencao
        aparelho
      }
    }
  }
`

/**
 * __useOdontogramasQuery__
 *
 * To run a query within a React component, call `useOdontogramasQuery` and pass it any options that fit your needs.
 * When your component renders, `useOdontogramasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOdontogramasQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOdontogramasQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.OdontogramasQuery, Types.OdontogramasQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.OdontogramasQuery, Types.OdontogramasQueryVariables>(
    OdontogramasDocument,
    baseOptions
  )
}
export function useOdontogramasLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.OdontogramasQuery, Types.OdontogramasQueryVariables>
) {
  return ApolloReactHooks.useLazyQuery<Types.OdontogramasQuery, Types.OdontogramasQueryVariables>(
    OdontogramasDocument,
    baseOptions
  )
}
export type OdontogramasQueryHookResult = ReturnType<typeof useOdontogramasQuery>
export type OdontogramasLazyQueryHookResult = ReturnType<typeof useOdontogramasLazyQuery>
export type OdontogramasQueryResult = ApolloReactCommon.QueryResult<
  Types.OdontogramasQuery,
  Types.OdontogramasQueryVariables
>
export const PeriodoOdontogramaSelectDocument = gql`
  query PeriodoOdontogramaSelect($input: OdontogramasQueryInput!) {
    odontogramas(input: $input) {
      content {
        id
        atendProfOdonto {
          id
          atendimentoProfissional {
            id
            finalizadoEm
            iniciadoEm
          }
        }
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${PageInfoFragmentDoc}
`

/**
 * __usePeriodoOdontogramaSelectQuery__
 *
 * To run a query within a React component, call `usePeriodoOdontogramaSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeriodoOdontogramaSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeriodoOdontogramaSelectQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePeriodoOdontogramaSelectQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.PeriodoOdontogramaSelectQuery,
    Types.PeriodoOdontogramaSelectQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<Types.PeriodoOdontogramaSelectQuery, Types.PeriodoOdontogramaSelectQueryVariables>(
    PeriodoOdontogramaSelectDocument,
    baseOptions
  )
}
export function usePeriodoOdontogramaSelectLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.PeriodoOdontogramaSelectQuery,
    Types.PeriodoOdontogramaSelectQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    Types.PeriodoOdontogramaSelectQuery,
    Types.PeriodoOdontogramaSelectQueryVariables
  >(PeriodoOdontogramaSelectDocument, baseOptions)
}
export type PeriodoOdontogramaSelectQueryHookResult = ReturnType<typeof usePeriodoOdontogramaSelectQuery>
export type PeriodoOdontogramaSelectLazyQueryHookResult = ReturnType<typeof usePeriodoOdontogramaSelectLazyQuery>
export type PeriodoOdontogramaSelectQueryResult = ApolloReactCommon.QueryResult<
  Types.PeriodoOdontogramaSelectQuery,
  Types.PeriodoOdontogramaSelectQueryVariables
>
export const HistoricoPrescricaoDocument = gql`
  query HistoricoPrescricao($input: HistoricoPrescricaoQueryInput!) {
    historicoPrescricao(input: $input) {
      content {
        id
        versao
        versaoAnterior
        finalizadoEm
        lotacao {
          id
          profissional {
            id
            nome
            numeroConselhoClasse
            ufEmissoraConselhoClasse {
              id
              sigla
            }
            conselhoClasse {
              id
              sigla
            }
          }
        }
        receitaMedicamento {
          id
          medicamento {
            id
            principioAtivo
            concentracao
            unidadeFornecimento
            medicamentoCatmat {
              id
              ativo
              volume
              medicamento {
                id
                principioAtivo
                unidadeFornecimento
                concentracao
                formaFarmaceutica {
                  id
                  nome
                }
              }
              unidadeFornecimento {
                id
                nome
                nomePlural
              }
              principioAtivo {
                id
                nome
                listaMaterial {
                  id
                  nome
                  tipoReceita
                }
              }
            }
            formaFarmaceutica {
              id
              nome
            }
          }
          aplicacaoMedicamento {
            id
            nome
          }
          quantidadeReceitada
          recomendacoes
          dose
          frequenciaDose
          posologia
          tipoFrequenciaDose
          qtPeriodoFrequencia
          medidaTempoFrequencia
          dtInicioTratamento
          dtFimTratamento
          qtDuracaoTratamento
          medidaTempoTratamento
          usoContinuo
          registroManual
          doseUnica
          tipoReceita
          tratamentoInterrompido
          justificativaInterrupcao
          dtInterrupcao
        }
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${PageInfoFragmentDoc}
`

/**
 * __useHistoricoPrescricaoQuery__
 *
 * To run a query within a React component, call `useHistoricoPrescricaoQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoricoPrescricaoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoricoPrescricaoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHistoricoPrescricaoQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.HistoricoPrescricaoQuery,
    Types.HistoricoPrescricaoQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<Types.HistoricoPrescricaoQuery, Types.HistoricoPrescricaoQueryVariables>(
    HistoricoPrescricaoDocument,
    baseOptions
  )
}
export function useHistoricoPrescricaoLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.HistoricoPrescricaoQuery,
    Types.HistoricoPrescricaoQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<Types.HistoricoPrescricaoQuery, Types.HistoricoPrescricaoQueryVariables>(
    HistoricoPrescricaoDocument,
    baseOptions
  )
}
export type HistoricoPrescricaoQueryHookResult = ReturnType<typeof useHistoricoPrescricaoQuery>
export type HistoricoPrescricaoLazyQueryHookResult = ReturnType<typeof useHistoricoPrescricaoLazyQuery>
export type HistoricoPrescricaoQueryResult = ApolloReactCommon.QueryResult<
  Types.HistoricoPrescricaoQuery,
  Types.HistoricoPrescricaoQueryVariables
>
export const ConexaoHorusDocument = gql`
  query ConexaoHorus {
    conexao {
      internet {
        habilitado
      }
      horus {
        habilitado
      }
    }
  }
`

/**
 * __useConexaoHorusQuery__
 *
 * To run a query within a React component, call `useConexaoHorusQuery` and pass it any options that fit your needs.
 * When your component renders, `useConexaoHorusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConexaoHorusQuery({
 *   variables: {
 *   },
 * });
 */
export function useConexaoHorusQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ConexaoHorusQuery, Types.ConexaoHorusQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.ConexaoHorusQuery, Types.ConexaoHorusQueryVariables>(
    ConexaoHorusDocument,
    baseOptions
  )
}
export function useConexaoHorusLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ConexaoHorusQuery, Types.ConexaoHorusQueryVariables>
) {
  return ApolloReactHooks.useLazyQuery<Types.ConexaoHorusQuery, Types.ConexaoHorusQueryVariables>(
    ConexaoHorusDocument,
    baseOptions
  )
}
export type ConexaoHorusQueryHookResult = ReturnType<typeof useConexaoHorusQuery>
export type ConexaoHorusLazyQueryHookResult = ReturnType<typeof useConexaoHorusLazyQuery>
export type ConexaoHorusQueryResult = ApolloReactCommon.QueryResult<
  Types.ConexaoHorusQuery,
  Types.ConexaoHorusQueryVariables
>
export const ConsultaEstoqueHorusDocument = gql`
  query ConsultaEstoqueHorus($filter: ConsultaEstoqueHorusQueryInput!) {
    consultaEstoqueHorus(input: $filter)
  }
`

/**
 * __useConsultaEstoqueHorusQuery__
 *
 * To run a query within a React component, call `useConsultaEstoqueHorusQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsultaEstoqueHorusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsultaEstoqueHorusQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useConsultaEstoqueHorusQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.ConsultaEstoqueHorusQuery,
    Types.ConsultaEstoqueHorusQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<Types.ConsultaEstoqueHorusQuery, Types.ConsultaEstoqueHorusQueryVariables>(
    ConsultaEstoqueHorusDocument,
    baseOptions
  )
}
export function useConsultaEstoqueHorusLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.ConsultaEstoqueHorusQuery,
    Types.ConsultaEstoqueHorusQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<Types.ConsultaEstoqueHorusQuery, Types.ConsultaEstoqueHorusQueryVariables>(
    ConsultaEstoqueHorusDocument,
    baseOptions
  )
}
export type ConsultaEstoqueHorusQueryHookResult = ReturnType<typeof useConsultaEstoqueHorusQuery>
export type ConsultaEstoqueHorusLazyQueryHookResult = ReturnType<typeof useConsultaEstoqueHorusLazyQuery>
export type ConsultaEstoqueHorusQueryResult = ApolloReactCommon.QueryResult<
  Types.ConsultaEstoqueHorusQuery,
  Types.ConsultaEstoqueHorusQueryVariables
>
export const ConsultaEstoqueHorusSincronizadoDocument = gql`
  subscription consultaEstoqueHorusSincronizado {
    consultaEstoqueHorusSincronizado {
      usuario
      uuid
      unidadesSaudeConsulta {
        unidadeSaude {
          id
          nome
          cnes
        }
        unidadePadrao
        quantidadeDisponivel
        disponibilidade
      }
      validadeConexao
    }
  }
`

/**
 * __useConsultaEstoqueHorusSincronizadoSubscription__
 *
 * To run a query within a React component, call `useConsultaEstoqueHorusSincronizadoSubscription` and pass it any options that fit your needs.
 * When your component renders, `useConsultaEstoqueHorusSincronizadoSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsultaEstoqueHorusSincronizadoSubscription({
 *   variables: {
 *   },
 * });
 */
export function useConsultaEstoqueHorusSincronizadoSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    Types.ConsultaEstoqueHorusSincronizadoSubscription,
    Types.ConsultaEstoqueHorusSincronizadoSubscriptionVariables
  >
) {
  return ApolloReactHooks.useSubscription<
    Types.ConsultaEstoqueHorusSincronizadoSubscription,
    Types.ConsultaEstoqueHorusSincronizadoSubscriptionVariables
  >(ConsultaEstoqueHorusSincronizadoDocument, baseOptions)
}
export type ConsultaEstoqueHorusSincronizadoSubscriptionHookResult = ReturnType<
  typeof useConsultaEstoqueHorusSincronizadoSubscription
>
export type ConsultaEstoqueHorusSincronizadoSubscriptionResult = ApolloReactCommon.SubscriptionResult<
  Types.ConsultaEstoqueHorusSincronizadoSubscription
>
export const FinalizarEscutaInicialDocument = gql`
  mutation FinalizarEscutaInicial($input: FinalizarEscutaInicialInput!) {
    finalizarEscutaInicial(input: $input) {
      id
    }
  }
`
export type FinalizarEscutaInicialMutationFn = ApolloReactCommon.MutationFunction<
  Types.FinalizarEscutaInicialMutation,
  Types.FinalizarEscutaInicialMutationVariables
>

/**
 * __useFinalizarEscutaInicialMutation__
 *
 * To run a mutation, you first call `useFinalizarEscutaInicialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinalizarEscutaInicialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finalizarEscutaInicialMutation, { data, loading, error }] = useFinalizarEscutaInicialMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFinalizarEscutaInicialMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.FinalizarEscutaInicialMutation,
    Types.FinalizarEscutaInicialMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    Types.FinalizarEscutaInicialMutation,
    Types.FinalizarEscutaInicialMutationVariables
  >(FinalizarEscutaInicialDocument, baseOptions)
}
export type FinalizarEscutaInicialMutationHookResult = ReturnType<typeof useFinalizarEscutaInicialMutation>
export type FinalizarEscutaInicialMutationResult = ApolloReactCommon.MutationResult<
  Types.FinalizarEscutaInicialMutation
>
export type FinalizarEscutaInicialMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.FinalizarEscutaInicialMutation,
  Types.FinalizarEscutaInicialMutationVariables
>
export const AtendimentoAddedDocument = gql`
  subscription atendimentoAdded($unidadeSaude: ID!) {
    atendimentoAdded(unidadeSaude: $unidadeSaude) {
      id
    }
  }
`

/**
 * __useAtendimentoAddedSubscription__
 *
 * To run a query within a React component, call `useAtendimentoAddedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAtendimentoAddedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAtendimentoAddedSubscription({
 *   variables: {
 *      unidadeSaude: // value for 'unidadeSaude'
 *   },
 * });
 */
export function useAtendimentoAddedSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    Types.AtendimentoAddedSubscription,
    Types.AtendimentoAddedSubscriptionVariables
  >
) {
  return ApolloReactHooks.useSubscription<
    Types.AtendimentoAddedSubscription,
    Types.AtendimentoAddedSubscriptionVariables
  >(AtendimentoAddedDocument, baseOptions)
}
export type AtendimentoAddedSubscriptionHookResult = ReturnType<typeof useAtendimentoAddedSubscription>
export type AtendimentoAddedSubscriptionResult = ApolloReactCommon.SubscriptionResult<
  Types.AtendimentoAddedSubscription
>
export const AtendimentoUpdatedDocument = gql`
  subscription atendimentoUpdated($unidadeSaude: ID!) {
    atendimentoUpdated(unidadeSaude: $unidadeSaude) {
      id
    }
  }
`

/**
 * __useAtendimentoUpdatedSubscription__
 *
 * To run a query within a React component, call `useAtendimentoUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAtendimentoUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAtendimentoUpdatedSubscription({
 *   variables: {
 *      unidadeSaude: // value for 'unidadeSaude'
 *   },
 * });
 */
export function useAtendimentoUpdatedSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    Types.AtendimentoUpdatedSubscription,
    Types.AtendimentoUpdatedSubscriptionVariables
  >
) {
  return ApolloReactHooks.useSubscription<
    Types.AtendimentoUpdatedSubscription,
    Types.AtendimentoUpdatedSubscriptionVariables
  >(AtendimentoUpdatedDocument, baseOptions)
}
export type AtendimentoUpdatedSubscriptionHookResult = ReturnType<typeof useAtendimentoUpdatedSubscription>
export type AtendimentoUpdatedSubscriptionResult = ApolloReactCommon.SubscriptionResult<
  Types.AtendimentoUpdatedSubscription
>
export const EquipeAtendimentoDocument = gql`
  query EquipeAtendimento($id: ID!) {
    equipe(id: $id) {
      id
      nome
      ine
      tipoEquipe {
        id
        nome
        sigla
      }
    }
  }
`

/**
 * __useEquipeAtendimentoQuery__
 *
 * To run a query within a React component, call `useEquipeAtendimentoQuery` and pass it any options that fit your needs.
 * When your component renders, `useEquipeAtendimentoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEquipeAtendimentoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEquipeAtendimentoQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.EquipeAtendimentoQuery, Types.EquipeAtendimentoQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.EquipeAtendimentoQuery, Types.EquipeAtendimentoQueryVariables>(
    EquipeAtendimentoDocument,
    baseOptions
  )
}
export function useEquipeAtendimentoLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.EquipeAtendimentoQuery,
    Types.EquipeAtendimentoQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<Types.EquipeAtendimentoQuery, Types.EquipeAtendimentoQueryVariables>(
    EquipeAtendimentoDocument,
    baseOptions
  )
}
export type EquipeAtendimentoQueryHookResult = ReturnType<typeof useEquipeAtendimentoQuery>
export type EquipeAtendimentoLazyQueryHookResult = ReturnType<typeof useEquipeAtendimentoLazyQuery>
export type EquipeAtendimentoQueryResult = ApolloReactCommon.QueryResult<
  Types.EquipeAtendimentoQuery,
  Types.EquipeAtendimentoQueryVariables
>
export const ExcluirAtendimentoDocument = gql`
  mutation ExcluirAtendimento($atendimento: ID!) {
    excluirAtendimento(atendimento: $atendimento)
  }
`
export type ExcluirAtendimentoMutationFn = ApolloReactCommon.MutationFunction<
  Types.ExcluirAtendimentoMutation,
  Types.ExcluirAtendimentoMutationVariables
>

/**
 * __useExcluirAtendimentoMutation__
 *
 * To run a mutation, you first call `useExcluirAtendimentoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExcluirAtendimentoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [excluirAtendimentoMutation, { data, loading, error }] = useExcluirAtendimentoMutation({
 *   variables: {
 *      atendimento: // value for 'atendimento'
 *   },
 * });
 */
export function useExcluirAtendimentoMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.ExcluirAtendimentoMutation,
    Types.ExcluirAtendimentoMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<Types.ExcluirAtendimentoMutation, Types.ExcluirAtendimentoMutationVariables>(
    ExcluirAtendimentoDocument,
    baseOptions
  )
}
export type ExcluirAtendimentoMutationHookResult = ReturnType<typeof useExcluirAtendimentoMutation>
export type ExcluirAtendimentoMutationResult = ApolloReactCommon.MutationResult<Types.ExcluirAtendimentoMutation>
export type ExcluirAtendimentoMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.ExcluirAtendimentoMutation,
  Types.ExcluirAtendimentoMutationVariables
>
export const ListaAtendimentoPollingDocument = gql`
  query ListaAtendimentoPolling($time: Instant!) {
    atendimentoPolling(time: $time)
  }
`

/**
 * __useListaAtendimentoPollingQuery__
 *
 * To run a query within a React component, call `useListaAtendimentoPollingQuery` and pass it any options that fit your needs.
 * When your component renders, `useListaAtendimentoPollingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListaAtendimentoPollingQuery({
 *   variables: {
 *      time: // value for 'time'
 *   },
 * });
 */
export function useListaAtendimentoPollingQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.ListaAtendimentoPollingQuery,
    Types.ListaAtendimentoPollingQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<Types.ListaAtendimentoPollingQuery, Types.ListaAtendimentoPollingQueryVariables>(
    ListaAtendimentoPollingDocument,
    baseOptions
  )
}
export function useListaAtendimentoPollingLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.ListaAtendimentoPollingQuery,
    Types.ListaAtendimentoPollingQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<Types.ListaAtendimentoPollingQuery, Types.ListaAtendimentoPollingQueryVariables>(
    ListaAtendimentoPollingDocument,
    baseOptions
  )
}
export type ListaAtendimentoPollingQueryHookResult = ReturnType<typeof useListaAtendimentoPollingQuery>
export type ListaAtendimentoPollingLazyQueryHookResult = ReturnType<typeof useListaAtendimentoPollingLazyQuery>
export type ListaAtendimentoPollingQueryResult = ApolloReactCommon.QueryResult<
  Types.ListaAtendimentoPollingQuery,
  Types.ListaAtendimentoPollingQueryVariables
>
export const ListaAtendimentoDocument = gql`
  query ListaAtendimento($input: AtendimentosQueryInput!) {
    atendimentos(input: $input) {
      content {
        id
        cidadao {
          id
          nome
          nomeSocial
          dataNascimento
        }
        iniciadoEm
        encaminhadoEm
        statusAtendimento
        agendado {
          id
          horarioInicial
        }
        classificacaoRisco
        tiposServico {
          id
          nome
        }
        equipe {
          id
          nome
          area
        }
        lotacao {
          id
          cbo {
            id
            nome
            cbo2002
          }
          profissional {
            id
            nome
          }
        }
        ultimaAlteracaoStatusEm
        finalizado
        actions {
          atender {
            hint
            enabled
          }
          escutaInicial {
            hint
            enabled
          }
          vacinacao {
            hint
            enabled
          }
          informarAusencia {
            hint
            enabled
          }
          cancelarAusencia {
            hint
            enabled
          }
          visualizarProntuario {
            hint
            enabled
          }
          visualizarEscutaInicial {
            hint
            enabled
          }
          editar {
            hint
            enabled
          }
          excluir {
            hint
            enabled
          }
          atendimentosDia {
            hint
            enabled
          }
          declaracaoComparecimento {
            hint
            enabled
          }
        }
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${PageInfoFragmentDoc}
`

/**
 * __useListaAtendimentoQuery__
 *
 * To run a query within a React component, call `useListaAtendimentoQuery` and pass it any options that fit your needs.
 * When your component renders, `useListaAtendimentoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListaAtendimentoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListaAtendimentoQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ListaAtendimentoQuery, Types.ListaAtendimentoQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.ListaAtendimentoQuery, Types.ListaAtendimentoQueryVariables>(
    ListaAtendimentoDocument,
    baseOptions
  )
}
export function useListaAtendimentoLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ListaAtendimentoQuery, Types.ListaAtendimentoQueryVariables>
) {
  return ApolloReactHooks.useLazyQuery<Types.ListaAtendimentoQuery, Types.ListaAtendimentoQueryVariables>(
    ListaAtendimentoDocument,
    baseOptions
  )
}
export type ListaAtendimentoQueryHookResult = ReturnType<typeof useListaAtendimentoQuery>
export type ListaAtendimentoLazyQueryHookResult = ReturnType<typeof useListaAtendimentoLazyQuery>
export type ListaAtendimentoQueryResult = ApolloReactCommon.QueryResult<
  Types.ListaAtendimentoQuery,
  Types.ListaAtendimentoQueryVariables
>
export const PossuiAtendimentosNaoFinalizadosDocument = gql`
  query PossuiAtendimentosNaoFinalizados($input: PossuiAtendimentosNaoFinalizadosInput!) {
    possuiAtendimentosNaoFinalizados(input: $input)
  }
`

/**
 * __usePossuiAtendimentosNaoFinalizadosQuery__
 *
 * To run a query within a React component, call `usePossuiAtendimentosNaoFinalizadosQuery` and pass it any options that fit your needs.
 * When your component renders, `usePossuiAtendimentosNaoFinalizadosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePossuiAtendimentosNaoFinalizadosQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePossuiAtendimentosNaoFinalizadosQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.PossuiAtendimentosNaoFinalizadosQuery,
    Types.PossuiAtendimentosNaoFinalizadosQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    Types.PossuiAtendimentosNaoFinalizadosQuery,
    Types.PossuiAtendimentosNaoFinalizadosQueryVariables
  >(PossuiAtendimentosNaoFinalizadosDocument, baseOptions)
}
export function usePossuiAtendimentosNaoFinalizadosLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.PossuiAtendimentosNaoFinalizadosQuery,
    Types.PossuiAtendimentosNaoFinalizadosQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    Types.PossuiAtendimentosNaoFinalizadosQuery,
    Types.PossuiAtendimentosNaoFinalizadosQueryVariables
  >(PossuiAtendimentosNaoFinalizadosDocument, baseOptions)
}
export type PossuiAtendimentosNaoFinalizadosQueryHookResult = ReturnType<
  typeof usePossuiAtendimentosNaoFinalizadosQuery
>
export type PossuiAtendimentosNaoFinalizadosLazyQueryHookResult = ReturnType<
  typeof usePossuiAtendimentosNaoFinalizadosLazyQuery
>
export type PossuiAtendimentosNaoFinalizadosQueryResult = ApolloReactCommon.QueryResult<
  Types.PossuiAtendimentosNaoFinalizadosQuery,
  Types.PossuiAtendimentosNaoFinalizadosQueryVariables
>
export const SalvarAtendimentoAgendadoDocument = gql`
  mutation SalvarAtendimentoAgendado($input: AtendimentoAgendadoInput!) {
    salvarAtendimentoAgendado(input: $input) {
      id
      cidadao {
        id
        nome
        nomeSocial
      }
    }
  }
`
export type SalvarAtendimentoAgendadoMutationFn = ApolloReactCommon.MutationFunction<
  Types.SalvarAtendimentoAgendadoMutation,
  Types.SalvarAtendimentoAgendadoMutationVariables
>

/**
 * __useSalvarAtendimentoAgendadoMutation__
 *
 * To run a mutation, you first call `useSalvarAtendimentoAgendadoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvarAtendimentoAgendadoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvarAtendimentoAgendadoMutation, { data, loading, error }] = useSalvarAtendimentoAgendadoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSalvarAtendimentoAgendadoMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.SalvarAtendimentoAgendadoMutation,
    Types.SalvarAtendimentoAgendadoMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    Types.SalvarAtendimentoAgendadoMutation,
    Types.SalvarAtendimentoAgendadoMutationVariables
  >(SalvarAtendimentoAgendadoDocument, baseOptions)
}
export type SalvarAtendimentoAgendadoMutationHookResult = ReturnType<typeof useSalvarAtendimentoAgendadoMutation>
export type SalvarAtendimentoAgendadoMutationResult = ApolloReactCommon.MutationResult<
  Types.SalvarAtendimentoAgendadoMutation
>
export type SalvarAtendimentoAgendadoMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.SalvarAtendimentoAgendadoMutation,
  Types.SalvarAtendimentoAgendadoMutationVariables
>
export const SalvarAtendimentoDocument = gql`
  mutation SalvarAtendimento($input: AtendimentoInput!) {
    salvarAtendimento(input: $input) {
      id
      cidadao {
        id
        nome
        nomeSocial
      }
    }
  }
`
export type SalvarAtendimentoMutationFn = ApolloReactCommon.MutationFunction<
  Types.SalvarAtendimentoMutation,
  Types.SalvarAtendimentoMutationVariables
>

/**
 * __useSalvarAtendimentoMutation__
 *
 * To run a mutation, you first call `useSalvarAtendimentoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvarAtendimentoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvarAtendimentoMutation, { data, loading, error }] = useSalvarAtendimentoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSalvarAtendimentoMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.SalvarAtendimentoMutation,
    Types.SalvarAtendimentoMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<Types.SalvarAtendimentoMutation, Types.SalvarAtendimentoMutationVariables>(
    SalvarAtendimentoDocument,
    baseOptions
  )
}
export type SalvarAtendimentoMutationHookResult = ReturnType<typeof useSalvarAtendimentoMutation>
export type SalvarAtendimentoMutationResult = ApolloReactCommon.MutationResult<Types.SalvarAtendimentoMutation>
export type SalvarAtendimentoMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.SalvarAtendimentoMutation,
  Types.SalvarAtendimentoMutationVariables
>
export const SalvarJustificativaAutomaticaVisualizarEscutaInicialDocument = gql`
  mutation SalvarJustificativaAutomaticaVisualizarEscutaInicial($idCidadao: ID!) {
    salvarJustificativaAutomaticaVisualizarEscutaInicial(idCidadao: $idCidadao)
  }
`
export type SalvarJustificativaAutomaticaVisualizarEscutaInicialMutationFn = ApolloReactCommon.MutationFunction<
  Types.SalvarJustificativaAutomaticaVisualizarEscutaInicialMutation,
  Types.SalvarJustificativaAutomaticaVisualizarEscutaInicialMutationVariables
>

/**
 * __useSalvarJustificativaAutomaticaVisualizarEscutaInicialMutation__
 *
 * To run a mutation, you first call `useSalvarJustificativaAutomaticaVisualizarEscutaInicialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvarJustificativaAutomaticaVisualizarEscutaInicialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvarJustificativaAutomaticaVisualizarEscutaInicialMutation, { data, loading, error }] = useSalvarJustificativaAutomaticaVisualizarEscutaInicialMutation({
 *   variables: {
 *      idCidadao: // value for 'idCidadao'
 *   },
 * });
 */
export function useSalvarJustificativaAutomaticaVisualizarEscutaInicialMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.SalvarJustificativaAutomaticaVisualizarEscutaInicialMutation,
    Types.SalvarJustificativaAutomaticaVisualizarEscutaInicialMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    Types.SalvarJustificativaAutomaticaVisualizarEscutaInicialMutation,
    Types.SalvarJustificativaAutomaticaVisualizarEscutaInicialMutationVariables
  >(SalvarJustificativaAutomaticaVisualizarEscutaInicialDocument, baseOptions)
}
export type SalvarJustificativaAutomaticaVisualizarEscutaInicialMutationHookResult = ReturnType<
  typeof useSalvarJustificativaAutomaticaVisualizarEscutaInicialMutation
>
export type SalvarJustificativaAutomaticaVisualizarEscutaInicialMutationResult = ApolloReactCommon.MutationResult<
  Types.SalvarJustificativaAutomaticaVisualizarEscutaInicialMutation
>
export type SalvarJustificativaAutomaticaVisualizarEscutaInicialMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.SalvarJustificativaAutomaticaVisualizarEscutaInicialMutation,
  Types.SalvarJustificativaAutomaticaVisualizarEscutaInicialMutationVariables
>
export const SalvarJustificativaAutomaticaVisualizarProntuarioDocument = gql`
  mutation SalvarJustificativaAutomaticaVisualizarProntuario($idCidadao: ID!) {
    salvarJustificativaAutomaticaVisualizarProntuario(idCidadao: $idCidadao)
  }
`
export type SalvarJustificativaAutomaticaVisualizarProntuarioMutationFn = ApolloReactCommon.MutationFunction<
  Types.SalvarJustificativaAutomaticaVisualizarProntuarioMutation,
  Types.SalvarJustificativaAutomaticaVisualizarProntuarioMutationVariables
>

/**
 * __useSalvarJustificativaAutomaticaVisualizarProntuarioMutation__
 *
 * To run a mutation, you first call `useSalvarJustificativaAutomaticaVisualizarProntuarioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvarJustificativaAutomaticaVisualizarProntuarioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvarJustificativaAutomaticaVisualizarProntuarioMutation, { data, loading, error }] = useSalvarJustificativaAutomaticaVisualizarProntuarioMutation({
 *   variables: {
 *      idCidadao: // value for 'idCidadao'
 *   },
 * });
 */
export function useSalvarJustificativaAutomaticaVisualizarProntuarioMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.SalvarJustificativaAutomaticaVisualizarProntuarioMutation,
    Types.SalvarJustificativaAutomaticaVisualizarProntuarioMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    Types.SalvarJustificativaAutomaticaVisualizarProntuarioMutation,
    Types.SalvarJustificativaAutomaticaVisualizarProntuarioMutationVariables
  >(SalvarJustificativaAutomaticaVisualizarProntuarioDocument, baseOptions)
}
export type SalvarJustificativaAutomaticaVisualizarProntuarioMutationHookResult = ReturnType<
  typeof useSalvarJustificativaAutomaticaVisualizarProntuarioMutation
>
export type SalvarJustificativaAutomaticaVisualizarProntuarioMutationResult = ApolloReactCommon.MutationResult<
  Types.SalvarJustificativaAutomaticaVisualizarProntuarioMutation
>
export type SalvarJustificativaAutomaticaVisualizarProntuarioMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.SalvarJustificativaAutomaticaVisualizarProntuarioMutation,
  Types.SalvarJustificativaAutomaticaVisualizarProntuarioMutationVariables
>
export const AtenderDocument = gql`
  mutation Atender($atendimento: ID!) {
    atender(atendimento: $atendimento) {
      id
      statusAtendimento
      cidadao {
        id
      }
      atendimentoProfissional {
        id
      }
    }
  }
`
export type AtenderMutationFn = ApolloReactCommon.MutationFunction<
  Types.AtenderMutation,
  Types.AtenderMutationVariables
>

/**
 * __useAtenderMutation__
 *
 * To run a mutation, you first call `useAtenderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAtenderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [atenderMutation, { data, loading, error }] = useAtenderMutation({
 *   variables: {
 *      atendimento: // value for 'atendimento'
 *   },
 * });
 */
export function useAtenderMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AtenderMutation, Types.AtenderMutationVariables>
) {
  return ApolloReactHooks.useMutation<Types.AtenderMutation, Types.AtenderMutationVariables>(
    AtenderDocument,
    baseOptions
  )
}
export type AtenderMutationHookResult = ReturnType<typeof useAtenderMutation>
export type AtenderMutationResult = ApolloReactCommon.MutationResult<Types.AtenderMutation>
export type AtenderMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.AtenderMutation,
  Types.AtenderMutationVariables
>
export const CancelarAusenciaDocument = gql`
  mutation CancelarAusencia($atendimento: ID!) {
    cancelarCidadaoNaoAguardou(atendimento: $atendimento) {
      id
    }
  }
`
export type CancelarAusenciaMutationFn = ApolloReactCommon.MutationFunction<
  Types.CancelarAusenciaMutation,
  Types.CancelarAusenciaMutationVariables
>

/**
 * __useCancelarAusenciaMutation__
 *
 * To run a mutation, you first call `useCancelarAusenciaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelarAusenciaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelarAusenciaMutation, { data, loading, error }] = useCancelarAusenciaMutation({
 *   variables: {
 *      atendimento: // value for 'atendimento'
 *   },
 * });
 */
export function useCancelarAusenciaMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.CancelarAusenciaMutation,
    Types.CancelarAusenciaMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<Types.CancelarAusenciaMutation, Types.CancelarAusenciaMutationVariables>(
    CancelarAusenciaDocument,
    baseOptions
  )
}
export type CancelarAusenciaMutationHookResult = ReturnType<typeof useCancelarAusenciaMutation>
export type CancelarAusenciaMutationResult = ApolloReactCommon.MutationResult<Types.CancelarAusenciaMutation>
export type CancelarAusenciaMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.CancelarAusenciaMutation,
  Types.CancelarAusenciaMutationVariables
>
export const InformarAusenciaDocument = gql`
  mutation InformarAusencia($atendimento: ID!) {
    informarCidadaoNaoAguardou(atendimento: $atendimento) {
      id
    }
  }
`
export type InformarAusenciaMutationFn = ApolloReactCommon.MutationFunction<
  Types.InformarAusenciaMutation,
  Types.InformarAusenciaMutationVariables
>

/**
 * __useInformarAusenciaMutation__
 *
 * To run a mutation, you first call `useInformarAusenciaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInformarAusenciaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [informarAusenciaMutation, { data, loading, error }] = useInformarAusenciaMutation({
 *   variables: {
 *      atendimento: // value for 'atendimento'
 *   },
 * });
 */
export function useInformarAusenciaMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.InformarAusenciaMutation,
    Types.InformarAusenciaMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<Types.InformarAusenciaMutation, Types.InformarAusenciaMutationVariables>(
    InformarAusenciaDocument,
    baseOptions
  )
}
export type InformarAusenciaMutationHookResult = ReturnType<typeof useInformarAusenciaMutation>
export type InformarAusenciaMutationResult = ApolloReactCommon.MutationResult<Types.InformarAusenciaMutation>
export type InformarAusenciaMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.InformarAusenciaMutation,
  Types.InformarAusenciaMutationVariables
>
export const RealizarAtendimentoVacinacaoDocument = gql`
  mutation RealizarAtendimentoVacinacao($atendimento: ID!) {
    realizarAtendimentoVacinacao(atendimento: $atendimento) {
      id
      cidadao {
        id
      }
      atendimentoProfissional {
        id
      }
    }
  }
`
export type RealizarAtendimentoVacinacaoMutationFn = ApolloReactCommon.MutationFunction<
  Types.RealizarAtendimentoVacinacaoMutation,
  Types.RealizarAtendimentoVacinacaoMutationVariables
>

/**
 * __useRealizarAtendimentoVacinacaoMutation__
 *
 * To run a mutation, you first call `useRealizarAtendimentoVacinacaoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRealizarAtendimentoVacinacaoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [realizarAtendimentoVacinacaoMutation, { data, loading, error }] = useRealizarAtendimentoVacinacaoMutation({
 *   variables: {
 *      atendimento: // value for 'atendimento'
 *   },
 * });
 */
export function useRealizarAtendimentoVacinacaoMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.RealizarAtendimentoVacinacaoMutation,
    Types.RealizarAtendimentoVacinacaoMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    Types.RealizarAtendimentoVacinacaoMutation,
    Types.RealizarAtendimentoVacinacaoMutationVariables
  >(RealizarAtendimentoVacinacaoDocument, baseOptions)
}
export type RealizarAtendimentoVacinacaoMutationHookResult = ReturnType<typeof useRealizarAtendimentoVacinacaoMutation>
export type RealizarAtendimentoVacinacaoMutationResult = ApolloReactCommon.MutationResult<
  Types.RealizarAtendimentoVacinacaoMutation
>
export type RealizarAtendimentoVacinacaoMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.RealizarAtendimentoVacinacaoMutation,
  Types.RealizarAtendimentoVacinacaoMutationVariables
>
export const RealizarEscutaInicialDocument = gql`
  mutation RealizarEscutaInicial($atendimento: ID!) {
    realizarEscutaInicial(atendimento: $atendimento) {
      id
      cidadao {
        id
      }
      atendimentoProfissional {
        id
      }
    }
  }
`
export type RealizarEscutaInicialMutationFn = ApolloReactCommon.MutationFunction<
  Types.RealizarEscutaInicialMutation,
  Types.RealizarEscutaInicialMutationVariables
>

/**
 * __useRealizarEscutaInicialMutation__
 *
 * To run a mutation, you first call `useRealizarEscutaInicialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRealizarEscutaInicialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [realizarEscutaInicialMutation, { data, loading, error }] = useRealizarEscutaInicialMutation({
 *   variables: {
 *      atendimento: // value for 'atendimento'
 *   },
 * });
 */
export function useRealizarEscutaInicialMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.RealizarEscutaInicialMutation,
    Types.RealizarEscutaInicialMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    Types.RealizarEscutaInicialMutation,
    Types.RealizarEscutaInicialMutationVariables
  >(RealizarEscutaInicialDocument, baseOptions)
}
export type RealizarEscutaInicialMutationHookResult = ReturnType<typeof useRealizarEscutaInicialMutation>
export type RealizarEscutaInicialMutationResult = ApolloReactCommon.MutationResult<Types.RealizarEscutaInicialMutation>
export type RealizarEscutaInicialMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.RealizarEscutaInicialMutation,
  Types.RealizarEscutaInicialMutationVariables
>
export const AtendimentosDoDiaDocument = gql`
  query AtendimentosDoDia($id: ID!) {
    atendimentosDoDia(id: $id) {
      content {
        id
        iniciadoEm
        finalizadoEm
        lotacao {
          id
          profissional {
            id
            nome
          }
          cbo {
            id
            nome
          }
        }
        tipo
        atendimento {
          id
          iniciadoEm
          cidadao {
            id
            nome
            cpf
            cns
            dataNascimento
            nomeSocial
          }
        }
      }
    }
  }
`

/**
 * __useAtendimentosDoDiaQuery__
 *
 * To run a query within a React component, call `useAtendimentosDoDiaQuery` and pass it any options that fit your needs.
 * When your component renders, `useAtendimentosDoDiaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAtendimentosDoDiaQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAtendimentosDoDiaQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.AtendimentosDoDiaQuery, Types.AtendimentosDoDiaQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.AtendimentosDoDiaQuery, Types.AtendimentosDoDiaQueryVariables>(
    AtendimentosDoDiaDocument,
    baseOptions
  )
}
export function useAtendimentosDoDiaLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.AtendimentosDoDiaQuery,
    Types.AtendimentosDoDiaQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<Types.AtendimentosDoDiaQuery, Types.AtendimentosDoDiaQueryVariables>(
    AtendimentosDoDiaDocument,
    baseOptions
  )
}
export type AtendimentosDoDiaQueryHookResult = ReturnType<typeof useAtendimentosDoDiaQuery>
export type AtendimentosDoDiaLazyQueryHookResult = ReturnType<typeof useAtendimentosDoDiaLazyQuery>
export type AtendimentosDoDiaQueryResult = ApolloReactCommon.QueryResult<
  Types.AtendimentosDoDiaQuery,
  Types.AtendimentosDoDiaQueryVariables
>
export const CidadaoDeclaracaoComparecimentoDocument = gql`
  query CidadaoDeclaracaoComparecimento($id: ID!) {
    atendimento(id: $id) {
      id
      iniciadoEm
      lotacao {
        id
        profissional {
          id
          nome
        }
      }
      cidadao {
        id
        cpf
        cns
        dataNascimento
        nome
        nomeSocial
      }
      unidadeSaude {
        id
        nome
        endereco {
          municipio {
            id
            nome
            uf {
              id
              nome
              sigla
            }
          }
        }
      }
    }
  }
`

/**
 * __useCidadaoDeclaracaoComparecimentoQuery__
 *
 * To run a query within a React component, call `useCidadaoDeclaracaoComparecimentoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCidadaoDeclaracaoComparecimentoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCidadaoDeclaracaoComparecimentoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCidadaoDeclaracaoComparecimentoQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.CidadaoDeclaracaoComparecimentoQuery,
    Types.CidadaoDeclaracaoComparecimentoQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    Types.CidadaoDeclaracaoComparecimentoQuery,
    Types.CidadaoDeclaracaoComparecimentoQueryVariables
  >(CidadaoDeclaracaoComparecimentoDocument, baseOptions)
}
export function useCidadaoDeclaracaoComparecimentoLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.CidadaoDeclaracaoComparecimentoQuery,
    Types.CidadaoDeclaracaoComparecimentoQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    Types.CidadaoDeclaracaoComparecimentoQuery,
    Types.CidadaoDeclaracaoComparecimentoQueryVariables
  >(CidadaoDeclaracaoComparecimentoDocument, baseOptions)
}
export type CidadaoDeclaracaoComparecimentoQueryHookResult = ReturnType<typeof useCidadaoDeclaracaoComparecimentoQuery>
export type CidadaoDeclaracaoComparecimentoLazyQueryHookResult = ReturnType<
  typeof useCidadaoDeclaracaoComparecimentoLazyQuery
>
export type CidadaoDeclaracaoComparecimentoQueryResult = ApolloReactCommon.QueryResult<
  Types.CidadaoDeclaracaoComparecimentoQuery,
  Types.CidadaoDeclaracaoComparecimentoQueryVariables
>
export const AtendimentoDocument = gql`
  query Atendimento($id: ID!) {
    atendimento(id: $id) {
      id
      cidadao {
        id
        nome
        nomeSocial
        dataNascimento
        sexo
        racaCor {
          id
          nome
          codigoMS
          codigoCadsus
          racaCorDbEnum
        }
      }
      lotacao {
        id
        profissional {
          id
          nome
          cpf
        }
        cbo {
          id
          nome
          cbo2002
        }
        unidadeSaude {
          id
          nome
          cnes
        }
        equipe {
          id
          ine
          nome
          tipoEquipe {
            id
            nome
            sigla
          }
        }
      }
      equipe {
        id
        ine
        nome
        tipoEquipe {
          id
          nome
          sigla
        }
      }
      tiposServico {
        id
        nome
      }
    }
  }
`

/**
 * __useAtendimentoQuery__
 *
 * To run a query within a React component, call `useAtendimentoQuery` and pass it any options that fit your needs.
 * When your component renders, `useAtendimentoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAtendimentoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAtendimentoQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.AtendimentoQuery, Types.AtendimentoQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.AtendimentoQuery, Types.AtendimentoQueryVariables>(
    AtendimentoDocument,
    baseOptions
  )
}
export function useAtendimentoLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AtendimentoQuery, Types.AtendimentoQueryVariables>
) {
  return ApolloReactHooks.useLazyQuery<Types.AtendimentoQuery, Types.AtendimentoQueryVariables>(
    AtendimentoDocument,
    baseOptions
  )
}
export type AtendimentoQueryHookResult = ReturnType<typeof useAtendimentoQuery>
export type AtendimentoLazyQueryHookResult = ReturnType<typeof useAtendimentoLazyQuery>
export type AtendimentoQueryResult = ApolloReactCommon.QueryResult<
  Types.AtendimentoQuery,
  Types.AtendimentoQueryVariables
>
export const EditarAtendimentoDocument = gql`
  mutation EditarAtendimento($input: AtendimentoEditInput!) {
    editarAtendimento(input: $input) {
      id
      cidadao {
        id
        nome
        nomeSocial
      }
    }
  }
`
export type EditarAtendimentoMutationFn = ApolloReactCommon.MutationFunction<
  Types.EditarAtendimentoMutation,
  Types.EditarAtendimentoMutationVariables
>

/**
 * __useEditarAtendimentoMutation__
 *
 * To run a mutation, you first call `useEditarAtendimentoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditarAtendimentoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editarAtendimentoMutation, { data, loading, error }] = useEditarAtendimentoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditarAtendimentoMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.EditarAtendimentoMutation,
    Types.EditarAtendimentoMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<Types.EditarAtendimentoMutation, Types.EditarAtendimentoMutationVariables>(
    EditarAtendimentoDocument,
    baseOptions
  )
}
export type EditarAtendimentoMutationHookResult = ReturnType<typeof useEditarAtendimentoMutation>
export type EditarAtendimentoMutationResult = ApolloReactCommon.MutationResult<Types.EditarAtendimentoMutation>
export type EditarAtendimentoMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.EditarAtendimentoMutation,
  Types.EditarAtendimentoMutationVariables
>
export const AuditoriaHistoricoTableDocument = gql`
  query AuditoriaHistoricoTable($input: AuditoriaHistoricoQueryInput!) {
    auditoriaHistorico(input: $input) {
      content {
        id
        dataInicio
        dataFim
        dataSolicitacao
        status
        csv
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${PageInfoFragmentDoc}
`

/**
 * __useAuditoriaHistoricoTableQuery__
 *
 * To run a query within a React component, call `useAuditoriaHistoricoTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuditoriaHistoricoTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuditoriaHistoricoTableQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuditoriaHistoricoTableQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.AuditoriaHistoricoTableQuery,
    Types.AuditoriaHistoricoTableQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<Types.AuditoriaHistoricoTableQuery, Types.AuditoriaHistoricoTableQueryVariables>(
    AuditoriaHistoricoTableDocument,
    baseOptions
  )
}
export function useAuditoriaHistoricoTableLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.AuditoriaHistoricoTableQuery,
    Types.AuditoriaHistoricoTableQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<Types.AuditoriaHistoricoTableQuery, Types.AuditoriaHistoricoTableQueryVariables>(
    AuditoriaHistoricoTableDocument,
    baseOptions
  )
}
export type AuditoriaHistoricoTableQueryHookResult = ReturnType<typeof useAuditoriaHistoricoTableQuery>
export type AuditoriaHistoricoTableLazyQueryHookResult = ReturnType<typeof useAuditoriaHistoricoTableLazyQuery>
export type AuditoriaHistoricoTableQueryResult = ApolloReactCommon.QueryResult<
  Types.AuditoriaHistoricoTableQuery,
  Types.AuditoriaHistoricoTableQueryVariables
>
export const ProcessarAuditoriaDocument = gql`
  mutation ProcessarAuditoria($input: AuditoriaInput!) {
    processAuditoria(input: $input)
  }
`
export type ProcessarAuditoriaMutationFn = ApolloReactCommon.MutationFunction<
  Types.ProcessarAuditoriaMutation,
  Types.ProcessarAuditoriaMutationVariables
>

/**
 * __useProcessarAuditoriaMutation__
 *
 * To run a mutation, you first call `useProcessarAuditoriaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessarAuditoriaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processarAuditoriaMutation, { data, loading, error }] = useProcessarAuditoriaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProcessarAuditoriaMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.ProcessarAuditoriaMutation,
    Types.ProcessarAuditoriaMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<Types.ProcessarAuditoriaMutation, Types.ProcessarAuditoriaMutationVariables>(
    ProcessarAuditoriaDocument,
    baseOptions
  )
}
export type ProcessarAuditoriaMutationHookResult = ReturnType<typeof useProcessarAuditoriaMutation>
export type ProcessarAuditoriaMutationResult = ApolloReactCommon.MutationResult<Types.ProcessarAuditoriaMutation>
export type ProcessarAuditoriaMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.ProcessarAuditoriaMutation,
  Types.ProcessarAuditoriaMutationVariables
>
export const OnSessionEventDocument = gql`
  subscription onSessionEvent {
    sessionEvent
  }
`

/**
 * __useOnSessionEventSubscription__
 *
 * To run a query within a React component, call `useOnSessionEventSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnSessionEventSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnSessionEventSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnSessionEventSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    Types.OnSessionEventSubscription,
    Types.OnSessionEventSubscriptionVariables
  >
) {
  return ApolloReactHooks.useSubscription<Types.OnSessionEventSubscription, Types.OnSessionEventSubscriptionVariables>(
    OnSessionEventDocument,
    baseOptions
  )
}
export type OnSessionEventSubscriptionHookResult = ReturnType<typeof useOnSessionEventSubscription>
export type OnSessionEventSubscriptionResult = ApolloReactCommon.SubscriptionResult<Types.OnSessionEventSubscription>
export const AutorizarMunicipioConfigAgendaPadraoDocument = gql`
  query AutorizarMunicipioConfigAgendaPadrao {
    duracaoAtendimentoPadraoMunicipio {
      duracaoAtendimentoPadraoMunicipio
    }
    configuracaoHorariosMunicipio {
      id
      configuracaoHorarioAgenda {
        configuracaoDiasSemana {
          diaSemana
          periodos {
            periodo
            horarioInicial
            horarioFinal
          }
        }
      }
    }
  }
`

/**
 * __useAutorizarMunicipioConfigAgendaPadraoQuery__
 *
 * To run a query within a React component, call `useAutorizarMunicipioConfigAgendaPadraoQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutorizarMunicipioConfigAgendaPadraoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutorizarMunicipioConfigAgendaPadraoQuery({
 *   variables: {
 *   },
 * });
 */
export function useAutorizarMunicipioConfigAgendaPadraoQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.AutorizarMunicipioConfigAgendaPadraoQuery,
    Types.AutorizarMunicipioConfigAgendaPadraoQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    Types.AutorizarMunicipioConfigAgendaPadraoQuery,
    Types.AutorizarMunicipioConfigAgendaPadraoQueryVariables
  >(AutorizarMunicipioConfigAgendaPadraoDocument, baseOptions)
}
export function useAutorizarMunicipioConfigAgendaPadraoLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.AutorizarMunicipioConfigAgendaPadraoQuery,
    Types.AutorizarMunicipioConfigAgendaPadraoQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    Types.AutorizarMunicipioConfigAgendaPadraoQuery,
    Types.AutorizarMunicipioConfigAgendaPadraoQueryVariables
  >(AutorizarMunicipioConfigAgendaPadraoDocument, baseOptions)
}
export type AutorizarMunicipioConfigAgendaPadraoQueryHookResult = ReturnType<
  typeof useAutorizarMunicipioConfigAgendaPadraoQuery
>
export type AutorizarMunicipioConfigAgendaPadraoLazyQueryHookResult = ReturnType<
  typeof useAutorizarMunicipioConfigAgendaPadraoLazyQuery
>
export type AutorizarMunicipioConfigAgendaPadraoQueryResult = ApolloReactCommon.QueryResult<
  Types.AutorizarMunicipioConfigAgendaPadraoQuery,
  Types.AutorizarMunicipioConfigAgendaPadraoQueryVariables
>
export const SalvaAutorizarMunicipioConfiguracaoAgendaPadraoDocument = gql`
  mutation SalvaAutorizarMunicipioConfiguracaoAgendaPadrao(
    $duracaoAtendimentoPadraoMunicipioInput: DuracaoAtendimentoPadraoMunicipioInput!
    $configuracaoAgendaMunicipalInput: ConfiguracaoAgendaMunicipalInput
  ) {
    alterarDuracaoPadraoAtendimento(duracaoAtendimentoPadraoMunicipioInput: $duracaoAtendimentoPadraoMunicipioInput) {
      duracaoAtendimentoPadraoMunicipio
    }
    salvarConfiguracaoHorariosMunicipio(configuracaoAgendaMunicipalInput: $configuracaoAgendaMunicipalInput) {
      id
      configuracaoHorarioAgenda {
        configuracaoDiasSemana {
          diaSemana
          periodos {
            periodo
            horarioInicial
            horarioFinal
          }
        }
      }
    }
  }
`
export type SalvaAutorizarMunicipioConfiguracaoAgendaPadraoMutationFn = ApolloReactCommon.MutationFunction<
  Types.SalvaAutorizarMunicipioConfiguracaoAgendaPadraoMutation,
  Types.SalvaAutorizarMunicipioConfiguracaoAgendaPadraoMutationVariables
>

/**
 * __useSalvaAutorizarMunicipioConfiguracaoAgendaPadraoMutation__
 *
 * To run a mutation, you first call `useSalvaAutorizarMunicipioConfiguracaoAgendaPadraoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvaAutorizarMunicipioConfiguracaoAgendaPadraoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvaAutorizarMunicipioConfiguracaoAgendaPadraoMutation, { data, loading, error }] = useSalvaAutorizarMunicipioConfiguracaoAgendaPadraoMutation({
 *   variables: {
 *      duracaoAtendimentoPadraoMunicipioInput: // value for 'duracaoAtendimentoPadraoMunicipioInput'
 *      configuracaoAgendaMunicipalInput: // value for 'configuracaoAgendaMunicipalInput'
 *   },
 * });
 */
export function useSalvaAutorizarMunicipioConfiguracaoAgendaPadraoMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.SalvaAutorizarMunicipioConfiguracaoAgendaPadraoMutation,
    Types.SalvaAutorizarMunicipioConfiguracaoAgendaPadraoMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    Types.SalvaAutorizarMunicipioConfiguracaoAgendaPadraoMutation,
    Types.SalvaAutorizarMunicipioConfiguracaoAgendaPadraoMutationVariables
  >(SalvaAutorizarMunicipioConfiguracaoAgendaPadraoDocument, baseOptions)
}
export type SalvaAutorizarMunicipioConfiguracaoAgendaPadraoMutationHookResult = ReturnType<
  typeof useSalvaAutorizarMunicipioConfiguracaoAgendaPadraoMutation
>
export type SalvaAutorizarMunicipioConfiguracaoAgendaPadraoMutationResult = ApolloReactCommon.MutationResult<
  Types.SalvaAutorizarMunicipioConfiguracaoAgendaPadraoMutation
>
export type SalvaAutorizarMunicipioConfiguracaoAgendaPadraoMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.SalvaAutorizarMunicipioConfiguracaoAgendaPadraoMutation,
  Types.SalvaAutorizarMunicipioConfiguracaoAgendaPadraoMutationVariables
>
export const SaveAutorizarMunicipioDocument = gql`
  mutation SaveAutorizarMunicipio($input: AutorizarMunicipioInput!) {
    autorizarMunicipio(input: $input) {
      id
      autorizado
    }
  }
`
export type SaveAutorizarMunicipioMutationFn = ApolloReactCommon.MutationFunction<
  Types.SaveAutorizarMunicipioMutation,
  Types.SaveAutorizarMunicipioMutationVariables
>

/**
 * __useSaveAutorizarMunicipioMutation__
 *
 * To run a mutation, you first call `useSaveAutorizarMunicipioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAutorizarMunicipioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAutorizarMunicipioMutation, { data, loading, error }] = useSaveAutorizarMunicipioMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveAutorizarMunicipioMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.SaveAutorizarMunicipioMutation,
    Types.SaveAutorizarMunicipioMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    Types.SaveAutorizarMunicipioMutation,
    Types.SaveAutorizarMunicipioMutationVariables
  >(SaveAutorizarMunicipioDocument, baseOptions)
}
export type SaveAutorizarMunicipioMutationHookResult = ReturnType<typeof useSaveAutorizarMunicipioMutation>
export type SaveAutorizarMunicipioMutationResult = ApolloReactCommon.MutationResult<
  Types.SaveAutorizarMunicipioMutation
>
export type SaveAutorizarMunicipioMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.SaveAutorizarMunicipioMutation,
  Types.SaveAutorizarMunicipioMutationVariables
>
export const AutorizarMunicipioDocument = gql`
  query AutorizarMunicipio($acessoId: ID!) {
    info {
      treinamento
      tipoInstalacao
    }
    acesso(id: $acessoId) {
      __typename
      id
      profissional {
        id
        nome
        cpf
      }
      municipio {
        id
        nome
        uf {
          id
          nome
          sigla
        }
      }
      ... on AdministradorMunicipal {
        autorizado
        chaveMunicipio
      }
    }
  }
`

/**
 * __useAutorizarMunicipioQuery__
 *
 * To run a query within a React component, call `useAutorizarMunicipioQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutorizarMunicipioQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutorizarMunicipioQuery({
 *   variables: {
 *      acessoId: // value for 'acessoId'
 *   },
 * });
 */
export function useAutorizarMunicipioQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.AutorizarMunicipioQuery, Types.AutorizarMunicipioQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.AutorizarMunicipioQuery, Types.AutorizarMunicipioQueryVariables>(
    AutorizarMunicipioDocument,
    baseOptions
  )
}
export function useAutorizarMunicipioLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.AutorizarMunicipioQuery,
    Types.AutorizarMunicipioQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<Types.AutorizarMunicipioQuery, Types.AutorizarMunicipioQueryVariables>(
    AutorizarMunicipioDocument,
    baseOptions
  )
}
export type AutorizarMunicipioQueryHookResult = ReturnType<typeof useAutorizarMunicipioQuery>
export type AutorizarMunicipioLazyQueryHookResult = ReturnType<typeof useAutorizarMunicipioLazyQuery>
export type AutorizarMunicipioQueryResult = ApolloReactCommon.QueryResult<
  Types.AutorizarMunicipioQuery,
  Types.AutorizarMunicipioQueryVariables
>
export const ConcluirConfiguracaoMunicipioDocument = gql`
  mutation ConcluirConfiguracaoMunicipio {
    concluirConfiguracaoMunicipio {
      id
      habilitado
    }
  }
`
export type ConcluirConfiguracaoMunicipioMutationFn = ApolloReactCommon.MutationFunction<
  Types.ConcluirConfiguracaoMunicipioMutation,
  Types.ConcluirConfiguracaoMunicipioMutationVariables
>

/**
 * __useConcluirConfiguracaoMunicipioMutation__
 *
 * To run a mutation, you first call `useConcluirConfiguracaoMunicipioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConcluirConfiguracaoMunicipioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [concluirConfiguracaoMunicipioMutation, { data, loading, error }] = useConcluirConfiguracaoMunicipioMutation({
 *   variables: {
 *   },
 * });
 */
export function useConcluirConfiguracaoMunicipioMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.ConcluirConfiguracaoMunicipioMutation,
    Types.ConcluirConfiguracaoMunicipioMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    Types.ConcluirConfiguracaoMunicipioMutation,
    Types.ConcluirConfiguracaoMunicipioMutationVariables
  >(ConcluirConfiguracaoMunicipioDocument, baseOptions)
}
export type ConcluirConfiguracaoMunicipioMutationHookResult = ReturnType<
  typeof useConcluirConfiguracaoMunicipioMutation
>
export type ConcluirConfiguracaoMunicipioMutationResult = ApolloReactCommon.MutationResult<
  Types.ConcluirConfiguracaoMunicipioMutation
>
export type ConcluirConfiguracaoMunicipioMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.ConcluirConfiguracaoMunicipioMutation,
  Types.ConcluirConfiguracaoMunicipioMutationVariables
>
export const AlterarDuracaoCboDocument = gql`
  mutation AlterarDuracaoCbo($cboDuracaoForm: CboDuracaoFormInput!) {
    alterarDuracaoCbo(input: $cboDuracaoForm) {
      cbo {
        id
      }
    }
  }
`
export type AlterarDuracaoCboMutationFn = ApolloReactCommon.MutationFunction<
  Types.AlterarDuracaoCboMutation,
  Types.AlterarDuracaoCboMutationVariables
>

/**
 * __useAlterarDuracaoCboMutation__
 *
 * To run a mutation, you first call `useAlterarDuracaoCboMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlterarDuracaoCboMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alterarDuracaoCboMutation, { data, loading, error }] = useAlterarDuracaoCboMutation({
 *   variables: {
 *      cboDuracaoForm: // value for 'cboDuracaoForm'
 *   },
 * });
 */
export function useAlterarDuracaoCboMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.AlterarDuracaoCboMutation,
    Types.AlterarDuracaoCboMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<Types.AlterarDuracaoCboMutation, Types.AlterarDuracaoCboMutationVariables>(
    AlterarDuracaoCboDocument,
    baseOptions
  )
}
export type AlterarDuracaoCboMutationHookResult = ReturnType<typeof useAlterarDuracaoCboMutation>
export type AlterarDuracaoCboMutationResult = ApolloReactCommon.MutationResult<Types.AlterarDuracaoCboMutation>
export type AlterarDuracaoCboMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.AlterarDuracaoCboMutation,
  Types.AlterarDuracaoCboMutationVariables
>
export const DisponibilizarCboDocument = gql`
  mutation DisponibilizarCbo($cboDisponibilizarForm: CboDisponibilizarFormInput!) {
    disponibilizarCbo(input: $cboDisponibilizarForm) {
      cbo {
        id
      }
    }
  }
`
export type DisponibilizarCboMutationFn = ApolloReactCommon.MutationFunction<
  Types.DisponibilizarCboMutation,
  Types.DisponibilizarCboMutationVariables
>

/**
 * __useDisponibilizarCboMutation__
 *
 * To run a mutation, you first call `useDisponibilizarCboMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisponibilizarCboMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disponibilizarCboMutation, { data, loading, error }] = useDisponibilizarCboMutation({
 *   variables: {
 *      cboDisponibilizarForm: // value for 'cboDisponibilizarForm'
 *   },
 * });
 */
export function useDisponibilizarCboMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.DisponibilizarCboMutation,
    Types.DisponibilizarCboMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<Types.DisponibilizarCboMutation, Types.DisponibilizarCboMutationVariables>(
    DisponibilizarCboDocument,
    baseOptions
  )
}
export type DisponibilizarCboMutationHookResult = ReturnType<typeof useDisponibilizarCboMutation>
export type DisponibilizarCboMutationResult = ApolloReactCommon.MutationResult<Types.DisponibilizarCboMutation>
export type DisponibilizarCboMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.DisponibilizarCboMutation,
  Types.DisponibilizarCboMutationVariables
>
export const CboEditComponentDocument = gql`
  query CboEditComponent {
    conexao {
      agendaOnline {
        ativa
      }
    }
  }
`

/**
 * __useCboEditComponentQuery__
 *
 * To run a query within a React component, call `useCboEditComponentQuery` and pass it any options that fit your needs.
 * When your component renders, `useCboEditComponentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCboEditComponentQuery({
 *   variables: {
 *   },
 * });
 */
export function useCboEditComponentQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.CboEditComponentQuery, Types.CboEditComponentQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.CboEditComponentQuery, Types.CboEditComponentQueryVariables>(
    CboEditComponentDocument,
    baseOptions
  )
}
export function useCboEditComponentLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CboEditComponentQuery, Types.CboEditComponentQueryVariables>
) {
  return ApolloReactHooks.useLazyQuery<Types.CboEditComponentQuery, Types.CboEditComponentQueryVariables>(
    CboEditComponentDocument,
    baseOptions
  )
}
export type CboEditComponentQueryHookResult = ReturnType<typeof useCboEditComponentQuery>
export type CboEditComponentLazyQueryHookResult = ReturnType<typeof useCboEditComponentLazyQuery>
export type CboEditComponentQueryResult = ApolloReactCommon.QueryResult<
  Types.CboEditComponentQuery,
  Types.CboEditComponentQueryVariables
>
export const CboTableDocument = gql`
  query CboTable($input: CbosMunicipioQueryInput!) {
    cbos(input: $input) {
      content {
        disponivelLotacao
        duracao
        duracaoPadrao
        cbo {
          id
          nome
          cbo2002
        }
        possuiLotacaoComAgendaOnline
        actions {
          inativar {
            enabled
            hint
          }
        }
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${PageInfoFragmentDoc}
`

/**
 * __useCboTableQuery__
 *
 * To run a query within a React component, call `useCboTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useCboTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCboTableQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCboTableQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.CboTableQuery, Types.CboTableQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.CboTableQuery, Types.CboTableQueryVariables>(CboTableDocument, baseOptions)
}
export function useCboTableLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CboTableQuery, Types.CboTableQueryVariables>
) {
  return ApolloReactHooks.useLazyQuery<Types.CboTableQuery, Types.CboTableQueryVariables>(CboTableDocument, baseOptions)
}
export type CboTableQueryHookResult = ReturnType<typeof useCboTableQuery>
export type CboTableLazyQueryHookResult = ReturnType<typeof useCboTableLazyQuery>
export type CboTableQueryResult = ApolloReactCommon.QueryResult<Types.CboTableQuery, Types.CboTableQueryVariables>
export const BuscaCidadaoCabecalhoDocument = gql`
  query BuscaCidadaoCabecalho($id: ID!) {
    cidadao(id: $id) {
      id
      cpf
      cns
      nome
      nomeSocial
      dataNascimento
      dataAtualizado
      sexo
      nomeMae
      telefoneResidencial
      telefoneCelular
      identidadeGeneroDbEnum
      ativo
      faleceu
      possuiAgendamento
      unificado
      prontuario {
        id
      }
      cidadaoVinculacaoEquipe {
        id
        tpCdsOrigem
        unidadeSaude {
          id
          nome
        }
        equipe {
          id
          nome
          ine
        }
      }
    }
  }
`

/**
 * __useBuscaCidadaoCabecalhoQuery__
 *
 * To run a query within a React component, call `useBuscaCidadaoCabecalhoQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuscaCidadaoCabecalhoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuscaCidadaoCabecalhoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBuscaCidadaoCabecalhoQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.BuscaCidadaoCabecalhoQuery,
    Types.BuscaCidadaoCabecalhoQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<Types.BuscaCidadaoCabecalhoQuery, Types.BuscaCidadaoCabecalhoQueryVariables>(
    BuscaCidadaoCabecalhoDocument,
    baseOptions
  )
}
export function useBuscaCidadaoCabecalhoLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.BuscaCidadaoCabecalhoQuery,
    Types.BuscaCidadaoCabecalhoQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<Types.BuscaCidadaoCabecalhoQuery, Types.BuscaCidadaoCabecalhoQueryVariables>(
    BuscaCidadaoCabecalhoDocument,
    baseOptions
  )
}
export type BuscaCidadaoCabecalhoQueryHookResult = ReturnType<typeof useBuscaCidadaoCabecalhoQuery>
export type BuscaCidadaoCabecalhoLazyQueryHookResult = ReturnType<typeof useBuscaCidadaoCabecalhoLazyQuery>
export type BuscaCidadaoCabecalhoQueryResult = ApolloReactCommon.QueryResult<
  Types.BuscaCidadaoCabecalhoQuery,
  Types.BuscaCidadaoCabecalhoQueryVariables
>
export const BuscaCidadaoAtualizadoForcadoDocument = gql`
  subscription buscaCidadaoAtualizadoForcado {
    buscaCidadaoCadsusAtualizadoForcadoCompleta {
      result
      errors
      uuid
      cidadaoCadsus {
        cns
        cpf
      }
      cidadaoLocal {
        id
        cpf
        cns
        nisPisPasep
        nome
        nomeSocial
        dataNascimento
        dataObito
        numeroDocumentoObito
        sexo
        desconheceNomeMae
        nomeMae
        desconheceNomePai
        nomePai
        telefoneResidencial
        telefoneCelular
        telefoneContato
        email
        area
        microArea
        statusForaArea
        endereco {
          bairro
          cep
          complemento
          logradouro
          numero
          pontoReferencia
          municipio {
            id
            ibge
            nome
            uf {
              id
              nome
              sigla
            }
          }
          semNumero
          tipoLogradouro {
            id
            nome
            numeroDne
          }
          uf {
            id
            nome
            sigla
          }
        }
        etnia {
          id
          nome
        }
        racaCor {
          id
          nome
          racaCorDbEnum
        }
        cbo {
          id
          nome
          cbo2002
        }
        escolaridade {
          id
          nome
        }
        localidadeNascimento {
          uf {
            id
            nome
            sigla
          }
          id
          nome
        }
        faleceu
        tipoSanguineo
        desejaInformarIdentidadeGenero
        identidadeGeneroDbEnum
        desejaInformarOrientacaoSexual
        orientacaoSexualDbEnum
        estadoCivil {
          id
          nome
        }
        paisExterior {
          id
          nome
        }
        localidadeExterior
        nacionalidade {
          id
          nacionalidadeDbEnum
        }
        portariaNaturalizacao
        dataNaturalizacao
        paisNascimento {
          id
          nome
        }
        dataEntradaBrasil
        stCompartilhaProntuario
        uuidUltimaFicha
        cidadaoVinculacaoEquipe {
          id
          utilizarCadastroIndividual
          unidadeSaude {
            id
            nome
          }
          equipe {
            id
            nome
            ine
            tipoEquipe {
              id
              nome
              sigla
            }
          }
        }
      }
    }
  }
`

/**
 * __useBuscaCidadaoAtualizadoForcadoSubscription__
 *
 * To run a query within a React component, call `useBuscaCidadaoAtualizadoForcadoSubscription` and pass it any options that fit your needs.
 * When your component renders, `useBuscaCidadaoAtualizadoForcadoSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuscaCidadaoAtualizadoForcadoSubscription({
 *   variables: {
 *   },
 * });
 */
export function useBuscaCidadaoAtualizadoForcadoSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    Types.BuscaCidadaoAtualizadoForcadoSubscription,
    Types.BuscaCidadaoAtualizadoForcadoSubscriptionVariables
  >
) {
  return ApolloReactHooks.useSubscription<
    Types.BuscaCidadaoAtualizadoForcadoSubscription,
    Types.BuscaCidadaoAtualizadoForcadoSubscriptionVariables
  >(BuscaCidadaoAtualizadoForcadoDocument, baseOptions)
}
export type BuscaCidadaoAtualizadoForcadoSubscriptionHookResult = ReturnType<
  typeof useBuscaCidadaoAtualizadoForcadoSubscription
>
export type BuscaCidadaoAtualizadoForcadoSubscriptionResult = ApolloReactCommon.SubscriptionResult<
  Types.BuscaCidadaoAtualizadoForcadoSubscription
>
export const BuscaCidadaoCadsusAtualizadoDocument = gql`
  subscription buscaCidadaoCadsusAtualizado {
    buscaCidadaoCadsusAtualizadoCompleta {
      result
      errors
      uuid
      cidadaoCadsus {
        cns
        cpf
      }
      cidadaoLocal {
        id
        cpf
        cns
        nisPisPasep
        nome
        nomeSocial
        dataNascimento
        dataObito
        numeroDocumentoObito
        sexo
        desconheceNomeMae
        nomeMae
        desconheceNomePai
        nomePai
        telefoneResidencial
        telefoneCelular
        telefoneContato
        email
        area
        microArea
        statusForaArea
        endereco {
          bairro
          cep
          complemento
          logradouro
          numero
          pontoReferencia
          municipio {
            id
            ibge
            nome
            uf {
              id
              nome
              sigla
            }
          }
          semNumero
          tipoLogradouro {
            id
            nome
            numeroDne
          }
          uf {
            id
            nome
            sigla
          }
        }
        etnia {
          id
          nome
        }
        racaCor {
          id
          nome
          racaCorDbEnum
        }
        cbo {
          id
          nome
          cbo2002
        }
        escolaridade {
          id
          nome
        }
        localidadeNascimento {
          uf {
            id
            nome
            sigla
          }
          id
          nome
        }
        faleceu
        tipoSanguineo
        desejaInformarIdentidadeGenero
        identidadeGeneroDbEnum
        desejaInformarOrientacaoSexual
        orientacaoSexualDbEnum
        estadoCivil {
          id
          nome
        }
        paisExterior {
          id
          nome
        }
        localidadeExterior
        nacionalidade {
          id
          nacionalidadeDbEnum
        }
        portariaNaturalizacao
        dataNaturalizacao
        paisNascimento {
          id
          nome
        }
        dataEntradaBrasil
        stCompartilhaProntuario
        uuidUltimaFicha
        cidadaoVinculacaoEquipe {
          id
          utilizarCadastroIndividual
          unidadeSaude {
            id
            nome
          }
          equipe {
            id
            nome
            ine
            tipoEquipe {
              id
              nome
              sigla
            }
          }
        }
      }
    }
  }
`

/**
 * __useBuscaCidadaoCadsusAtualizadoSubscription__
 *
 * To run a query within a React component, call `useBuscaCidadaoCadsusAtualizadoSubscription` and pass it any options that fit your needs.
 * When your component renders, `useBuscaCidadaoCadsusAtualizadoSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuscaCidadaoCadsusAtualizadoSubscription({
 *   variables: {
 *   },
 * });
 */
export function useBuscaCidadaoCadsusAtualizadoSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    Types.BuscaCidadaoCadsusAtualizadoSubscription,
    Types.BuscaCidadaoCadsusAtualizadoSubscriptionVariables
  >
) {
  return ApolloReactHooks.useSubscription<
    Types.BuscaCidadaoCadsusAtualizadoSubscription,
    Types.BuscaCidadaoCadsusAtualizadoSubscriptionVariables
  >(BuscaCidadaoCadsusAtualizadoDocument, baseOptions)
}
export type BuscaCidadaoCadsusAtualizadoSubscriptionHookResult = ReturnType<
  typeof useBuscaCidadaoCadsusAtualizadoSubscription
>
export type BuscaCidadaoCadsusAtualizadoSubscriptionResult = ApolloReactCommon.SubscriptionResult<
  Types.BuscaCidadaoCadsusAtualizadoSubscription
>
export const BuscaCidadaoCadsusPollingDocument = gql`
  query BuscaCidadaoCadsusPolling($uuid: String!) {
    buscaCidadaosCadsusCompletoPolling(uuid: $uuid) {
      usuario
      uuid
      resultCadsus
      cidadaos {
        cpf
        cns
        nome
        nomeSocial
        nomeMae
        nomePai
        racaCor {
          id
          nome
          racaCorDbEnum
        }
        etnia {
          id
          nome
        }
        telefoneContato
        telefoneResidencial
        telefoneCelular
        dataNascimento
        dataObito
        obito
        sexo
        email
        nacionalidade {
          id
          nacionalidadeDbEnum
        }
        municipioNascimento {
          id
          ibge
          nome
          uf {
            id
            nome
            sigla
          }
        }
        paisNascimento {
          id
          nome
        }
        portariaNaturalizacao
        dataEntradaBrasil
        dataNaturalizacao
        endereco {
          bairro
          cep
          complemento
          logradouro
          municipio {
            id
            ibge
            nome
            uf {
              id
              nome
              sigla
            }
          }
          numero
          pontoReferencia
          semNumero
          tipoLogradouro {
            id
            nome
            numeroDne
          }
          uf {
            id
            nome
            sigla
          }
        }
        paisResidencia {
          id
          nome
        }
        municipioResidenciaExterior
        numeroPisPasep
      }
    }
  }
`

/**
 * __useBuscaCidadaoCadsusPollingQuery__
 *
 * To run a query within a React component, call `useBuscaCidadaoCadsusPollingQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuscaCidadaoCadsusPollingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuscaCidadaoCadsusPollingQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useBuscaCidadaoCadsusPollingQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.BuscaCidadaoCadsusPollingQuery,
    Types.BuscaCidadaoCadsusPollingQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<Types.BuscaCidadaoCadsusPollingQuery, Types.BuscaCidadaoCadsusPollingQueryVariables>(
    BuscaCidadaoCadsusPollingDocument,
    baseOptions
  )
}
export function useBuscaCidadaoCadsusPollingLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.BuscaCidadaoCadsusPollingQuery,
    Types.BuscaCidadaoCadsusPollingQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    Types.BuscaCidadaoCadsusPollingQuery,
    Types.BuscaCidadaoCadsusPollingQueryVariables
  >(BuscaCidadaoCadsusPollingDocument, baseOptions)
}
export type BuscaCidadaoCadsusPollingQueryHookResult = ReturnType<typeof useBuscaCidadaoCadsusPollingQuery>
export type BuscaCidadaoCadsusPollingLazyQueryHookResult = ReturnType<typeof useBuscaCidadaoCadsusPollingLazyQuery>
export type BuscaCidadaoCadsusPollingQueryResult = ApolloReactCommon.QueryResult<
  Types.BuscaCidadaoCadsusPollingQuery,
  Types.BuscaCidadaoCadsusPollingQueryVariables
>
export const BuscaDetailCidadaoDocument = gql`
  query BuscaDetailCidadao($id: ID!) {
    cidadao(id: $id) {
      id
      cpf
      cns
      nisPisPasep
      nome
      nomeSocial
      dataNascimento
      dataAtualizado
      dataObito
      numeroDocumentoObito
      sexo
      nomeMae
      nomePai
      telefoneResidencial
      telefoneCelular
      telefoneContato
      email
      area
      microArea
      endereco {
        cep
        uf {
          id
          nome
        }
        municipio {
          id
          nome
        }
        bairro
        tipoLogradouro {
          id
          nome
        }
        logradouro
        numero
        semNumero
        complemento
        pontoReferencia
      }
      localidadeExterior
      identidadeGeneroDbEnum
      etnia {
        id
        nome
      }
      racaCor {
        id
        nome
        racaCorDbEnum
      }
      area
      microArea
      cbo {
        id
        nome
      }
      escolaridade {
        id
        nome
      }
      ativo
      localidadeNascimento {
        id
        nome
        uf {
          id
          sigla
        }
      }
      faleceu
      possuiAgendamento
      prontuario {
        id
      }
      unificado
      cidadaoVinculacaoEquipe {
        id
        tpCdsOrigem
        utilizarCadastroIndividual
        unidadeSaude {
          id
          nome
        }
        equipe {
          id
          nome
          ine
        }
      }
      tipoSanguineo
      orientacaoSexualDbEnum
      estadoCivil {
        id
        nome
      }
      paisExterior {
        id
        nome
      }
      localidadeExterior
      nacionalidade {
        id
        nacionalidadeDbEnum
      }
      portariaNaturalizacao
      dataNaturalizacao
      paisNascimento {
        id
        nome
      }
      dataEntradaBrasil
      stCompartilhaProntuario
    }
  }
`

/**
 * __useBuscaDetailCidadaoQuery__
 *
 * To run a query within a React component, call `useBuscaDetailCidadaoQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuscaDetailCidadaoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuscaDetailCidadaoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBuscaDetailCidadaoQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.BuscaDetailCidadaoQuery, Types.BuscaDetailCidadaoQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.BuscaDetailCidadaoQuery, Types.BuscaDetailCidadaoQueryVariables>(
    BuscaDetailCidadaoDocument,
    baseOptions
  )
}
export function useBuscaDetailCidadaoLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.BuscaDetailCidadaoQuery,
    Types.BuscaDetailCidadaoQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<Types.BuscaDetailCidadaoQuery, Types.BuscaDetailCidadaoQueryVariables>(
    BuscaDetailCidadaoDocument,
    baseOptions
  )
}
export type BuscaDetailCidadaoQueryHookResult = ReturnType<typeof useBuscaDetailCidadaoQuery>
export type BuscaDetailCidadaoLazyQueryHookResult = ReturnType<typeof useBuscaDetailCidadaoLazyQuery>
export type BuscaDetailCidadaoQueryResult = ApolloReactCommon.QueryResult<
  Types.BuscaDetailCidadaoQuery,
  Types.BuscaDetailCidadaoQueryVariables
>
export const BuscaCidadaosCadsusCompletoDocument = gql`
  subscription buscaCidadaosCadsusCompleto {
    buscaCidadaosCadsusCompleto {
      usuario
      uuid
      resultCadsus
      cidadaos {
        cpf
        cns
        nome
        nomeSocial
        nomeMae
        nomePai
        racaCor {
          id
          nome
          racaCorDbEnum
        }
        etnia {
          id
          nome
        }
        telefoneContato
        telefoneResidencial
        telefoneCelular
        dataNascimento
        dataObito
        obito
        sexo
        email
        nacionalidade {
          id
          nacionalidadeDbEnum
        }
        municipioNascimento {
          id
          ibge
          nome
          uf {
            id
            nome
            sigla
          }
        }
        paisNascimento {
          id
          nome
        }
        portariaNaturalizacao
        dataEntradaBrasil
        dataNaturalizacao
        endereco {
          bairro
          cep
          complemento
          logradouro
          municipio {
            id
            ibge
            nome
            uf {
              id
              nome
              sigla
            }
          }
          numero
          pontoReferencia
          semNumero
          tipoLogradouro {
            id
            nome
            numeroDne
          }
          uf {
            id
            nome
            sigla
          }
        }
        paisResidencia {
          id
          nome
        }
        municipioResidenciaExterior
        numeroPisPasep
      }
    }
  }
`

/**
 * __useBuscaCidadaosCadsusCompletoSubscription__
 *
 * To run a query within a React component, call `useBuscaCidadaosCadsusCompletoSubscription` and pass it any options that fit your needs.
 * When your component renders, `useBuscaCidadaosCadsusCompletoSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuscaCidadaosCadsusCompletoSubscription({
 *   variables: {
 *   },
 * });
 */
export function useBuscaCidadaosCadsusCompletoSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    Types.BuscaCidadaosCadsusCompletoSubscription,
    Types.BuscaCidadaosCadsusCompletoSubscriptionVariables
  >
) {
  return ApolloReactHooks.useSubscription<
    Types.BuscaCidadaosCadsusCompletoSubscription,
    Types.BuscaCidadaosCadsusCompletoSubscriptionVariables
  >(BuscaCidadaosCadsusCompletoDocument, baseOptions)
}
export type BuscaCidadaosCadsusCompletoSubscriptionHookResult = ReturnType<
  typeof useBuscaCidadaosCadsusCompletoSubscription
>
export type BuscaCidadaosCadsusCompletoSubscriptionResult = ApolloReactCommon.SubscriptionResult<
  Types.BuscaCidadaosCadsusCompletoSubscription
>
export const CidadaoEditDocument = gql`
  query CidadaoEdit($input: BuscaCidadaoCadsusInput!) {
    buscaCidadaoCadsusAtualizado(buscaCidadaoCadsusInput: $input)
  }
`

/**
 * __useCidadaoEditQuery__
 *
 * To run a query within a React component, call `useCidadaoEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useCidadaoEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCidadaoEditQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCidadaoEditQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.CidadaoEditQuery, Types.CidadaoEditQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.CidadaoEditQuery, Types.CidadaoEditQueryVariables>(
    CidadaoEditDocument,
    baseOptions
  )
}
export function useCidadaoEditLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CidadaoEditQuery, Types.CidadaoEditQueryVariables>
) {
  return ApolloReactHooks.useLazyQuery<Types.CidadaoEditQuery, Types.CidadaoEditQueryVariables>(
    CidadaoEditDocument,
    baseOptions
  )
}
export type CidadaoEditQueryHookResult = ReturnType<typeof useCidadaoEditQuery>
export type CidadaoEditLazyQueryHookResult = ReturnType<typeof useCidadaoEditLazyQuery>
export type CidadaoEditQueryResult = ApolloReactCommon.QueryResult<
  Types.CidadaoEditQuery,
  Types.CidadaoEditQueryVariables
>
export const CidadaoListingDocument = gql`
  query CidadaoListing($filtro: CidadaosQueryInput!) {
    cidadaos(input: $filtro) {
      content {
        id
        nome
        nomeSocial
        cpf
        cns
        nomeMae
        dataNascimento
        telefoneCelular
        telefoneResidencial
        sexo
        identidadeGeneroDbEnum
        dataAtualizado
        ativo
        unificado
        prontuario {
          id
        }
        possuiAgendamento
        localidadeNascimento {
          id
          nome
          uf {
            id
            nome
            sigla
          }
        }
        faleceu
        cidadaoVinculacaoEquipe {
          id
          unidadeSaude {
            id
            nome
          }
        }
      }
      pageInfo {
        numberOfElements
        totalElements
      }
    }
  }
`

/**
 * __useCidadaoListingQuery__
 *
 * To run a query within a React component, call `useCidadaoListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useCidadaoListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCidadaoListingQuery({
 *   variables: {
 *      filtro: // value for 'filtro'
 *   },
 * });
 */
export function useCidadaoListingQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.CidadaoListingQuery, Types.CidadaoListingQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.CidadaoListingQuery, Types.CidadaoListingQueryVariables>(
    CidadaoListingDocument,
    baseOptions
  )
}
export function useCidadaoListingLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CidadaoListingQuery, Types.CidadaoListingQueryVariables>
) {
  return ApolloReactHooks.useLazyQuery<Types.CidadaoListingQuery, Types.CidadaoListingQueryVariables>(
    CidadaoListingDocument,
    baseOptions
  )
}
export type CidadaoListingQueryHookResult = ReturnType<typeof useCidadaoListingQuery>
export type CidadaoListingLazyQueryHookResult = ReturnType<typeof useCidadaoListingLazyQuery>
export type CidadaoListingQueryResult = ApolloReactCommon.QueryResult<
  Types.CidadaoListingQuery,
  Types.CidadaoListingQueryVariables
>
export const CidadaoDocument = gql`
  query Cidadao($id: ID!) {
    cidadao(id: $id) {
      id
      nome
      nomeSocial
      cpf
      cns
      nomeMae
      dataNascimento
      sexo
      identidadeGeneroDbEnum
    }
  }
`

/**
 * __useCidadaoQuery__
 *
 * To run a query within a React component, call `useCidadaoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCidadaoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCidadaoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCidadaoQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.CidadaoQuery, Types.CidadaoQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.CidadaoQuery, Types.CidadaoQueryVariables>(CidadaoDocument, baseOptions)
}
export function useCidadaoLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CidadaoQuery, Types.CidadaoQueryVariables>
) {
  return ApolloReactHooks.useLazyQuery<Types.CidadaoQuery, Types.CidadaoQueryVariables>(CidadaoDocument, baseOptions)
}
export type CidadaoQueryHookResult = ReturnType<typeof useCidadaoQuery>
export type CidadaoLazyQueryHookResult = ReturnType<typeof useCidadaoLazyQuery>
export type CidadaoQueryResult = ApolloReactCommon.QueryResult<Types.CidadaoQuery, Types.CidadaoQueryVariables>
export const ExcluirCidadaoDocument = gql`
  mutation ExcluirCidadao($cidadaoId: ID!) {
    excluirCidadao(cidadaoId: $cidadaoId)
  }
`
export type ExcluirCidadaoMutationFn = ApolloReactCommon.MutationFunction<
  Types.ExcluirCidadaoMutation,
  Types.ExcluirCidadaoMutationVariables
>

/**
 * __useExcluirCidadaoMutation__
 *
 * To run a mutation, you first call `useExcluirCidadaoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExcluirCidadaoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [excluirCidadaoMutation, { data, loading, error }] = useExcluirCidadaoMutation({
 *   variables: {
 *      cidadaoId: // value for 'cidadaoId'
 *   },
 * });
 */
export function useExcluirCidadaoMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.ExcluirCidadaoMutation,
    Types.ExcluirCidadaoMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<Types.ExcluirCidadaoMutation, Types.ExcluirCidadaoMutationVariables>(
    ExcluirCidadaoDocument,
    baseOptions
  )
}
export type ExcluirCidadaoMutationHookResult = ReturnType<typeof useExcluirCidadaoMutation>
export type ExcluirCidadaoMutationResult = ApolloReactCommon.MutationResult<Types.ExcluirCidadaoMutation>
export type ExcluirCidadaoMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.ExcluirCidadaoMutation,
  Types.ExcluirCidadaoMutationVariables
>
export const HasCidadaoAgendamentoFuturoDocument = gql`
  query HasCidadaoAgendamentoFuturo($input: CidadaoPossuiAgendamentoFuturoQueryInput!) {
    hasAgendamentoFuturo(input: $input)
  }
`

/**
 * __useHasCidadaoAgendamentoFuturoQuery__
 *
 * To run a query within a React component, call `useHasCidadaoAgendamentoFuturoQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasCidadaoAgendamentoFuturoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasCidadaoAgendamentoFuturoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHasCidadaoAgendamentoFuturoQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.HasCidadaoAgendamentoFuturoQuery,
    Types.HasCidadaoAgendamentoFuturoQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    Types.HasCidadaoAgendamentoFuturoQuery,
    Types.HasCidadaoAgendamentoFuturoQueryVariables
  >(HasCidadaoAgendamentoFuturoDocument, baseOptions)
}
export function useHasCidadaoAgendamentoFuturoLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.HasCidadaoAgendamentoFuturoQuery,
    Types.HasCidadaoAgendamentoFuturoQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    Types.HasCidadaoAgendamentoFuturoQuery,
    Types.HasCidadaoAgendamentoFuturoQueryVariables
  >(HasCidadaoAgendamentoFuturoDocument, baseOptions)
}
export type HasCidadaoAgendamentoFuturoQueryHookResult = ReturnType<typeof useHasCidadaoAgendamentoFuturoQuery>
export type HasCidadaoAgendamentoFuturoLazyQueryHookResult = ReturnType<typeof useHasCidadaoAgendamentoFuturoLazyQuery>
export type HasCidadaoAgendamentoFuturoQueryResult = ApolloReactCommon.QueryResult<
  Types.HasCidadaoAgendamentoFuturoQuery,
  Types.HasCidadaoAgendamentoFuturoQueryVariables
>
export const ReativarCidadaoDocument = gql`
  mutation ReativarCidadao($cidadaoId: ID!) {
    reativarCidadao(cidadaoId: $cidadaoId) {
      id
    }
  }
`
export type ReativarCidadaoMutationFn = ApolloReactCommon.MutationFunction<
  Types.ReativarCidadaoMutation,
  Types.ReativarCidadaoMutationVariables
>

/**
 * __useReativarCidadaoMutation__
 *
 * To run a mutation, you first call `useReativarCidadaoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReativarCidadaoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reativarCidadaoMutation, { data, loading, error }] = useReativarCidadaoMutation({
 *   variables: {
 *      cidadaoId: // value for 'cidadaoId'
 *   },
 * });
 */
export function useReativarCidadaoMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.ReativarCidadaoMutation,
    Types.ReativarCidadaoMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<Types.ReativarCidadaoMutation, Types.ReativarCidadaoMutationVariables>(
    ReativarCidadaoDocument,
    baseOptions
  )
}
export type ReativarCidadaoMutationHookResult = ReturnType<typeof useReativarCidadaoMutation>
export type ReativarCidadaoMutationResult = ApolloReactCommon.MutationResult<Types.ReativarCidadaoMutation>
export type ReativarCidadaoMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.ReativarCidadaoMutation,
  Types.ReativarCidadaoMutationVariables
>
export const SalvarCidadaoDocument = gql`
  mutation SalvarCidadao($input: CidadaoInput!) {
    salvarCidadao(input: $input) {
      id
      nome
      cns
    }
  }
`
export type SalvarCidadaoMutationFn = ApolloReactCommon.MutationFunction<
  Types.SalvarCidadaoMutation,
  Types.SalvarCidadaoMutationVariables
>

/**
 * __useSalvarCidadaoMutation__
 *
 * To run a mutation, you first call `useSalvarCidadaoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvarCidadaoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvarCidadaoMutation, { data, loading, error }] = useSalvarCidadaoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSalvarCidadaoMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<Types.SalvarCidadaoMutation, Types.SalvarCidadaoMutationVariables>
) {
  return ApolloReactHooks.useMutation<Types.SalvarCidadaoMutation, Types.SalvarCidadaoMutationVariables>(
    SalvarCidadaoDocument,
    baseOptions
  )
}
export type SalvarCidadaoMutationHookResult = ReturnType<typeof useSalvarCidadaoMutation>
export type SalvarCidadaoMutationResult = ApolloReactCommon.MutationResult<Types.SalvarCidadaoMutation>
export type SalvarCidadaoMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.SalvarCidadaoMutation,
  Types.SalvarCidadaoMutationVariables
>
export const SalvarJustificativaVisualizarProntuarioDocument = gql`
  mutation SalvarJustificativaVisualizarProntuario($input: JustificativaVisualizarProntuarioInput!) {
    salvarJustificativaVisualizarProntuario(input: $input)
  }
`
export type SalvarJustificativaVisualizarProntuarioMutationFn = ApolloReactCommon.MutationFunction<
  Types.SalvarJustificativaVisualizarProntuarioMutation,
  Types.SalvarJustificativaVisualizarProntuarioMutationVariables
>

/**
 * __useSalvarJustificativaVisualizarProntuarioMutation__
 *
 * To run a mutation, you first call `useSalvarJustificativaVisualizarProntuarioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvarJustificativaVisualizarProntuarioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvarJustificativaVisualizarProntuarioMutation, { data, loading, error }] = useSalvarJustificativaVisualizarProntuarioMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSalvarJustificativaVisualizarProntuarioMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.SalvarJustificativaVisualizarProntuarioMutation,
    Types.SalvarJustificativaVisualizarProntuarioMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    Types.SalvarJustificativaVisualizarProntuarioMutation,
    Types.SalvarJustificativaVisualizarProntuarioMutationVariables
  >(SalvarJustificativaVisualizarProntuarioDocument, baseOptions)
}
export type SalvarJustificativaVisualizarProntuarioMutationHookResult = ReturnType<
  typeof useSalvarJustificativaVisualizarProntuarioMutation
>
export type SalvarJustificativaVisualizarProntuarioMutationResult = ApolloReactCommon.MutationResult<
  Types.SalvarJustificativaVisualizarProntuarioMutation
>
export type SalvarJustificativaVisualizarProntuarioMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.SalvarJustificativaVisualizarProntuarioMutation,
  Types.SalvarJustificativaVisualizarProntuarioMutationVariables
>
export const SincronizaCidadaoCadsusPollingDocument = gql`
  query SincronizaCidadaoCadsusPolling($uuid: String!) {
    sincronizacaoCadsusPolling(uuid: $uuid) {
      result
      errors
      uuid
      camposAlterados {
        campo
        conteudo
      }
      cidadaoCadsus {
        cns
        cpf
      }
      cidadaosDuplicados {
        id
        nome
        cpf
        cns
      }
      cidadaoLocal {
        id
        cpf
        cns
        nisPisPasep
        nome
        nomeSocial
        dataNascimento
        dataObito
        numeroDocumentoObito
        sexo
        desconheceNomeMae
        nomeMae
        desconheceNomePai
        nomePai
        telefoneResidencial
        telefoneCelular
        telefoneContato
        email
        area
        microArea
        statusForaArea
        endereco {
          bairro
          cep
          complemento
          logradouro
          numero
          pontoReferencia
          municipio {
            id
            ibge
            nome
            uf {
              id
              nome
              sigla
            }
          }
          semNumero
          tipoLogradouro {
            id
            nome
            numeroDne
          }
          uf {
            id
            nome
            sigla
          }
        }
        etnia {
          id
          nome
        }
        racaCor {
          id
          nome
          racaCorDbEnum
        }
        cbo {
          id
          nome
          cbo2002
        }
        escolaridade {
          id
          nome
        }
        localidadeNascimento {
          uf {
            id
            nome
            sigla
          }
          id
          nome
        }
        faleceu
        tipoSanguineo
        desejaInformarIdentidadeGenero
        identidadeGeneroDbEnum
        desejaInformarOrientacaoSexual
        orientacaoSexualDbEnum
        estadoCivil {
          id
          nome
        }
        paisExterior {
          id
          nome
        }
        localidadeExterior
        nacionalidade {
          id
          nacionalidadeDbEnum
        }
        portariaNaturalizacao
        dataNaturalizacao
        paisNascimento {
          id
          nome
        }
        dataEntradaBrasil
        stCompartilhaProntuario
        uuidUltimaFicha
        cidadaoVinculacaoEquipe {
          id
          utilizarCadastroIndividual
          unidadeSaude {
            id
            nome
          }
          equipe {
            id
            nome
            ine
            tipoEquipe {
              id
              nome
              sigla
            }
          }
        }
      }
    }
  }
`

/**
 * __useSincronizaCidadaoCadsusPollingQuery__
 *
 * To run a query within a React component, call `useSincronizaCidadaoCadsusPollingQuery` and pass it any options that fit your needs.
 * When your component renders, `useSincronizaCidadaoCadsusPollingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSincronizaCidadaoCadsusPollingQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useSincronizaCidadaoCadsusPollingQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.SincronizaCidadaoCadsusPollingQuery,
    Types.SincronizaCidadaoCadsusPollingQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    Types.SincronizaCidadaoCadsusPollingQuery,
    Types.SincronizaCidadaoCadsusPollingQueryVariables
  >(SincronizaCidadaoCadsusPollingDocument, baseOptions)
}
export function useSincronizaCidadaoCadsusPollingLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.SincronizaCidadaoCadsusPollingQuery,
    Types.SincronizaCidadaoCadsusPollingQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    Types.SincronizaCidadaoCadsusPollingQuery,
    Types.SincronizaCidadaoCadsusPollingQueryVariables
  >(SincronizaCidadaoCadsusPollingDocument, baseOptions)
}
export type SincronizaCidadaoCadsusPollingQueryHookResult = ReturnType<typeof useSincronizaCidadaoCadsusPollingQuery>
export type SincronizaCidadaoCadsusPollingLazyQueryHookResult = ReturnType<
  typeof useSincronizaCidadaoCadsusPollingLazyQuery
>
export type SincronizaCidadaoCadsusPollingQueryResult = ApolloReactCommon.QueryResult<
  Types.SincronizaCidadaoCadsusPollingQuery,
  Types.SincronizaCidadaoCadsusPollingQueryVariables
>
export const SincronizaCidadaoCadsusCompletoDocument = gql`
  subscription sincronizaCidadaoCadsusCompleto {
    sincronizacaoCadsusCompleta {
      camposAlterados {
        campo
        conteudo
      }
      errors
      cidadaoLocal {
        id
        cpf
        cns
      }
      cidadaoCadsus {
        cpf
        cns
      }
      cidadaosDuplicados {
        id
        nome
        cpf
        cns
      }
      result
      uuid
    }
  }
`

/**
 * __useSincronizaCidadaoCadsusCompletoSubscription__
 *
 * To run a query within a React component, call `useSincronizaCidadaoCadsusCompletoSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSincronizaCidadaoCadsusCompletoSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSincronizaCidadaoCadsusCompletoSubscription({
 *   variables: {
 *   },
 * });
 */
export function useSincronizaCidadaoCadsusCompletoSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    Types.SincronizaCidadaoCadsusCompletoSubscription,
    Types.SincronizaCidadaoCadsusCompletoSubscriptionVariables
  >
) {
  return ApolloReactHooks.useSubscription<
    Types.SincronizaCidadaoCadsusCompletoSubscription,
    Types.SincronizaCidadaoCadsusCompletoSubscriptionVariables
  >(SincronizaCidadaoCadsusCompletoDocument, baseOptions)
}
export type SincronizaCidadaoCadsusCompletoSubscriptionHookResult = ReturnType<
  typeof useSincronizaCidadaoCadsusCompletoSubscription
>
export type SincronizaCidadaoCadsusCompletoSubscriptionResult = ApolloReactCommon.SubscriptionResult<
  Types.SincronizaCidadaoCadsusCompletoSubscription
>
export const UnificacoesCidadaoDocument = gql`
  query UnificacoesCidadao($id: ID!) {
    unificacoesCidadao(cidadaoId: $id) {
      id
      nomeProfissional
      dataUnificacao
      cidadaos {
        id
        cpf
        cns
        nome
        nomeSocial
        dataNascimento
        identidadeGeneroDbEnum
        sexo
        nomeMae
        localidadeNascimento {
          id
          nome
          uf {
            id
            sigla
          }
        }
      }
    }
  }
`

/**
 * __useUnificacoesCidadaoQuery__
 *
 * To run a query within a React component, call `useUnificacoesCidadaoQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnificacoesCidadaoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnificacoesCidadaoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnificacoesCidadaoQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.UnificacoesCidadaoQuery, Types.UnificacoesCidadaoQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.UnificacoesCidadaoQuery, Types.UnificacoesCidadaoQueryVariables>(
    UnificacoesCidadaoDocument,
    baseOptions
  )
}
export function useUnificacoesCidadaoLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.UnificacoesCidadaoQuery,
    Types.UnificacoesCidadaoQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<Types.UnificacoesCidadaoQuery, Types.UnificacoesCidadaoQueryVariables>(
    UnificacoesCidadaoDocument,
    baseOptions
  )
}
export type UnificacoesCidadaoQueryHookResult = ReturnType<typeof useUnificacoesCidadaoQuery>
export type UnificacoesCidadaoLazyQueryHookResult = ReturnType<typeof useUnificacoesCidadaoLazyQuery>
export type UnificacoesCidadaoQueryResult = ApolloReactCommon.QueryResult<
  Types.UnificacoesCidadaoQuery,
  Types.UnificacoesCidadaoQueryVariables
>
export const VinculacaoFichaCadastroIndividualDocument = gql`
  query VinculacaoFichaCadastroIndividual($input: CidadaoVinculacaoFichaQueryInput!) {
    vinculacaoFichaCadastroIndividual(input: $input) {
      perguntaSaidaCadastroEnum
      unidadeSaude {
        id
        nome
      }
      equipe {
        id
        ine
        nome
        tipoEquipe {
          id
          nome
          sigla
        }
      }
    }
  }
`

/**
 * __useVinculacaoFichaCadastroIndividualQuery__
 *
 * To run a query within a React component, call `useVinculacaoFichaCadastroIndividualQuery` and pass it any options that fit your needs.
 * When your component renders, `useVinculacaoFichaCadastroIndividualQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVinculacaoFichaCadastroIndividualQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVinculacaoFichaCadastroIndividualQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.VinculacaoFichaCadastroIndividualQuery,
    Types.VinculacaoFichaCadastroIndividualQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    Types.VinculacaoFichaCadastroIndividualQuery,
    Types.VinculacaoFichaCadastroIndividualQueryVariables
  >(VinculacaoFichaCadastroIndividualDocument, baseOptions)
}
export function useVinculacaoFichaCadastroIndividualLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.VinculacaoFichaCadastroIndividualQuery,
    Types.VinculacaoFichaCadastroIndividualQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    Types.VinculacaoFichaCadastroIndividualQuery,
    Types.VinculacaoFichaCadastroIndividualQueryVariables
  >(VinculacaoFichaCadastroIndividualDocument, baseOptions)
}
export type VinculacaoFichaCadastroIndividualQueryHookResult = ReturnType<
  typeof useVinculacaoFichaCadastroIndividualQuery
>
export type VinculacaoFichaCadastroIndividualLazyQueryHookResult = ReturnType<
  typeof useVinculacaoFichaCadastroIndividualLazyQuery
>
export type VinculacaoFichaCadastroIndividualQueryResult = ApolloReactCommon.QueryResult<
  Types.VinculacaoFichaCadastroIndividualQuery,
  Types.VinculacaoFichaCadastroIndividualQueryVariables
>
export const BuscaCidadaoCadsusDocument = gql`
  query BuscaCidadaoCadsus($filter: BuscaListaCidadaoCadsusInput!) {
    buscaCidadaosCadsus(filtro: $filter)
  }
`

/**
 * __useBuscaCidadaoCadsusQuery__
 *
 * To run a query within a React component, call `useBuscaCidadaoCadsusQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuscaCidadaoCadsusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuscaCidadaoCadsusQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useBuscaCidadaoCadsusQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.BuscaCidadaoCadsusQuery, Types.BuscaCidadaoCadsusQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.BuscaCidadaoCadsusQuery, Types.BuscaCidadaoCadsusQueryVariables>(
    BuscaCidadaoCadsusDocument,
    baseOptions
  )
}
export function useBuscaCidadaoCadsusLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.BuscaCidadaoCadsusQuery,
    Types.BuscaCidadaoCadsusQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<Types.BuscaCidadaoCadsusQuery, Types.BuscaCidadaoCadsusQueryVariables>(
    BuscaCidadaoCadsusDocument,
    baseOptions
  )
}
export type BuscaCidadaoCadsusQueryHookResult = ReturnType<typeof useBuscaCidadaoCadsusQuery>
export type BuscaCidadaoCadsusLazyQueryHookResult = ReturnType<typeof useBuscaCidadaoCadsusLazyQuery>
export type BuscaCidadaoCadsusQueryResult = ApolloReactCommon.QueryResult<
  Types.BuscaCidadaoCadsusQuery,
  Types.BuscaCidadaoCadsusQueryVariables
>
export const ConfiguracaoCadsusDocument = gql`
  query configuracaoCadsus {
    conexao {
      internet {
        habilitado
      }
      cadsus {
        habilitado
      }
    }
  }
`

/**
 * __useConfiguracaoCadsusQuery__
 *
 * To run a query within a React component, call `useConfiguracaoCadsusQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfiguracaoCadsusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfiguracaoCadsusQuery({
 *   variables: {
 *   },
 * });
 */
export function useConfiguracaoCadsusQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ConfiguracaoCadsusQuery, Types.ConfiguracaoCadsusQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.ConfiguracaoCadsusQuery, Types.ConfiguracaoCadsusQueryVariables>(
    ConfiguracaoCadsusDocument,
    baseOptions
  )
}
export function useConfiguracaoCadsusLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.ConfiguracaoCadsusQuery,
    Types.ConfiguracaoCadsusQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<Types.ConfiguracaoCadsusQuery, Types.ConfiguracaoCadsusQueryVariables>(
    ConfiguracaoCadsusDocument,
    baseOptions
  )
}
export type ConfiguracaoCadsusQueryHookResult = ReturnType<typeof useConfiguracaoCadsusQuery>
export type ConfiguracaoCadsusLazyQueryHookResult = ReturnType<typeof useConfiguracaoCadsusLazyQuery>
export type ConfiguracaoCadsusQueryResult = ApolloReactCommon.QueryResult<
  Types.ConfiguracaoCadsusQuery,
  Types.ConfiguracaoCadsusQueryVariables
>
export const CreateCidadaoCadsusDocument = gql`
  mutation CreateCidadaoCadsus($input: SincronizaCidadaoCadsusInput!) {
    createCidadaoCadsus(input: $input)
  }
`
export type CreateCidadaoCadsusMutationFn = ApolloReactCommon.MutationFunction<
  Types.CreateCidadaoCadsusMutation,
  Types.CreateCidadaoCadsusMutationVariables
>

/**
 * __useCreateCidadaoCadsusMutation__
 *
 * To run a mutation, you first call `useCreateCidadaoCadsusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCidadaoCadsusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCidadaoCadsusMutation, { data, loading, error }] = useCreateCidadaoCadsusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCidadaoCadsusMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.CreateCidadaoCadsusMutation,
    Types.CreateCidadaoCadsusMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<Types.CreateCidadaoCadsusMutation, Types.CreateCidadaoCadsusMutationVariables>(
    CreateCidadaoCadsusDocument,
    baseOptions
  )
}
export type CreateCidadaoCadsusMutationHookResult = ReturnType<typeof useCreateCidadaoCadsusMutation>
export type CreateCidadaoCadsusMutationResult = ApolloReactCommon.MutationResult<Types.CreateCidadaoCadsusMutation>
export type CreateCidadaoCadsusMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.CreateCidadaoCadsusMutation,
  Types.CreateCidadaoCadsusMutationVariables
>
export const ForcaAtualizacaoCidadaoCadsusDocument = gql`
  query forcaAtualizacaoCidadaoCadsus($input: BuscaCidadaoCadsusInput!) {
    buscaCidadaoCadsusAtualizadoForcado(buscaCidadaoCadsusInput: $input)
  }
`

/**
 * __useForcaAtualizacaoCidadaoCadsusQuery__
 *
 * To run a query within a React component, call `useForcaAtualizacaoCidadaoCadsusQuery` and pass it any options that fit your needs.
 * When your component renders, `useForcaAtualizacaoCidadaoCadsusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useForcaAtualizacaoCidadaoCadsusQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useForcaAtualizacaoCidadaoCadsusQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.ForcaAtualizacaoCidadaoCadsusQuery,
    Types.ForcaAtualizacaoCidadaoCadsusQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    Types.ForcaAtualizacaoCidadaoCadsusQuery,
    Types.ForcaAtualizacaoCidadaoCadsusQueryVariables
  >(ForcaAtualizacaoCidadaoCadsusDocument, baseOptions)
}
export function useForcaAtualizacaoCidadaoCadsusLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.ForcaAtualizacaoCidadaoCadsusQuery,
    Types.ForcaAtualizacaoCidadaoCadsusQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    Types.ForcaAtualizacaoCidadaoCadsusQuery,
    Types.ForcaAtualizacaoCidadaoCadsusQueryVariables
  >(ForcaAtualizacaoCidadaoCadsusDocument, baseOptions)
}
export type ForcaAtualizacaoCidadaoCadsusQueryHookResult = ReturnType<typeof useForcaAtualizacaoCidadaoCadsusQuery>
export type ForcaAtualizacaoCidadaoCadsusLazyQueryHookResult = ReturnType<
  typeof useForcaAtualizacaoCidadaoCadsusLazyQuery
>
export type ForcaAtualizacaoCidadaoCadsusQueryResult = ApolloReactCommon.QueryResult<
  Types.ForcaAtualizacaoCidadaoCadsusQuery,
  Types.ForcaAtualizacaoCidadaoCadsusQueryVariables
>
export const ImportacoesCnesDocument = gql`
  query ImportacoesCnes($input: ImportacoesCnesQueryInput!) {
    importacoesCnes(input: $input) {
      content {
        id
        dataImportacao
        equipesNovas
        equipesAtualizadas
        lotacoesNovas
        lotacoesAtualizadas
        processo {
          id
          status
        }
        profissional {
          id
          nome
        }
        profissionaisNovos
        profissionaisAtualizados
        unidadesSaudeNovas
        unidadesSaudeAtualizadas
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${PageInfoFragmentDoc}
`

/**
 * __useImportacoesCnesQuery__
 *
 * To run a query within a React component, call `useImportacoesCnesQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportacoesCnesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportacoesCnesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportacoesCnesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ImportacoesCnesQuery, Types.ImportacoesCnesQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.ImportacoesCnesQuery, Types.ImportacoesCnesQueryVariables>(
    ImportacoesCnesDocument,
    baseOptions
  )
}
export function useImportacoesCnesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ImportacoesCnesQuery, Types.ImportacoesCnesQueryVariables>
) {
  return ApolloReactHooks.useLazyQuery<Types.ImportacoesCnesQuery, Types.ImportacoesCnesQueryVariables>(
    ImportacoesCnesDocument,
    baseOptions
  )
}
export type ImportacoesCnesQueryHookResult = ReturnType<typeof useImportacoesCnesQuery>
export type ImportacoesCnesLazyQueryHookResult = ReturnType<typeof useImportacoesCnesLazyQuery>
export type ImportacoesCnesQueryResult = ApolloReactCommon.QueryResult<
  Types.ImportacoesCnesQuery,
  Types.ImportacoesCnesQueryVariables
>
export const OnImportacaoCnesAddedDocument = gql`
  subscription onImportacaoCnesAdded($municipio: Int!) {
    importacaoCnesAdded(municipio: $municipio) {
      id
    }
  }
`

/**
 * __useOnImportacaoCnesAddedSubscription__
 *
 * To run a query within a React component, call `useOnImportacaoCnesAddedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnImportacaoCnesAddedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnImportacaoCnesAddedSubscription({
 *   variables: {
 *      municipio: // value for 'municipio'
 *   },
 * });
 */
export function useOnImportacaoCnesAddedSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    Types.OnImportacaoCnesAddedSubscription,
    Types.OnImportacaoCnesAddedSubscriptionVariables
  >
) {
  return ApolloReactHooks.useSubscription<
    Types.OnImportacaoCnesAddedSubscription,
    Types.OnImportacaoCnesAddedSubscriptionVariables
  >(OnImportacaoCnesAddedDocument, baseOptions)
}
export type OnImportacaoCnesAddedSubscriptionHookResult = ReturnType<typeof useOnImportacaoCnesAddedSubscription>
export type OnImportacaoCnesAddedSubscriptionResult = ApolloReactCommon.SubscriptionResult<
  Types.OnImportacaoCnesAddedSubscription
>
export const OnImportacaoCnesUpdatedDocument = gql`
  subscription onImportacaoCnesUpdated($municipio: Int!) {
    importacaoCnesUpdated(municipio: $municipio) {
      id
      dataImportacao
      equipesNovas
      equipesAtualizadas
      lotacoesNovas
      lotacoesAtualizadas
      processo {
        id
        status
      }
      profissional {
        id
        nome
      }
      profissionaisNovos
      profissionaisAtualizados
      unidadesSaudeNovas
      unidadesSaudeAtualizadas
    }
  }
`

/**
 * __useOnImportacaoCnesUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnImportacaoCnesUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnImportacaoCnesUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnImportacaoCnesUpdatedSubscription({
 *   variables: {
 *      municipio: // value for 'municipio'
 *   },
 * });
 */
export function useOnImportacaoCnesUpdatedSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    Types.OnImportacaoCnesUpdatedSubscription,
    Types.OnImportacaoCnesUpdatedSubscriptionVariables
  >
) {
  return ApolloReactHooks.useSubscription<
    Types.OnImportacaoCnesUpdatedSubscription,
    Types.OnImportacaoCnesUpdatedSubscriptionVariables
  >(OnImportacaoCnesUpdatedDocument, baseOptions)
}
export type OnImportacaoCnesUpdatedSubscriptionHookResult = ReturnType<typeof useOnImportacaoCnesUpdatedSubscription>
export type OnImportacaoCnesUpdatedSubscriptionResult = ApolloReactCommon.SubscriptionResult<
  Types.OnImportacaoCnesUpdatedSubscription
>
export const DetalhesImportacaoCnesViewDocument = gql`
  query DetalhesImportacaoCnesView($id: ID!) {
    importacaoCnes(id: $id) {
      id
      dataImportacao
      detalhes
      equipesNovas
      equipesAtualizadas
      lotacoesNovas
      lotacoesAtualizadas
      profissionaisNovos
      profissionaisAtualizados
      unidadesSaudeNovas
      unidadesSaudeAtualizadas
      municipio {
        id
        nome
      }
    }
  }
`

/**
 * __useDetalhesImportacaoCnesViewQuery__
 *
 * To run a query within a React component, call `useDetalhesImportacaoCnesViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetalhesImportacaoCnesViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetalhesImportacaoCnesViewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDetalhesImportacaoCnesViewQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.DetalhesImportacaoCnesViewQuery,
    Types.DetalhesImportacaoCnesViewQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    Types.DetalhesImportacaoCnesViewQuery,
    Types.DetalhesImportacaoCnesViewQueryVariables
  >(DetalhesImportacaoCnesViewDocument, baseOptions)
}
export function useDetalhesImportacaoCnesViewLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.DetalhesImportacaoCnesViewQuery,
    Types.DetalhesImportacaoCnesViewQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    Types.DetalhesImportacaoCnesViewQuery,
    Types.DetalhesImportacaoCnesViewQueryVariables
  >(DetalhesImportacaoCnesViewDocument, baseOptions)
}
export type DetalhesImportacaoCnesViewQueryHookResult = ReturnType<typeof useDetalhesImportacaoCnesViewQuery>
export type DetalhesImportacaoCnesViewLazyQueryHookResult = ReturnType<typeof useDetalhesImportacaoCnesViewLazyQuery>
export type DetalhesImportacaoCnesViewQueryResult = ApolloReactCommon.QueryResult<
  Types.DetalhesImportacaoCnesViewQuery,
  Types.DetalhesImportacaoCnesViewQueryVariables
>
export const AlterarQtdRequisicoesDocument = gql`
  mutation AlterarQtdRequisicoes($qtdRequisicoesSimultaneas: Int) {
    alterarQtdRequisicoes(qtdRequisicoesSimultaneas: $qtdRequisicoesSimultaneas) {
      qtdRequisicoesSimultaneas
    }
  }
`
export type AlterarQtdRequisicoesMutationFn = ApolloReactCommon.MutationFunction<
  Types.AlterarQtdRequisicoesMutation,
  Types.AlterarQtdRequisicoesMutationVariables
>

/**
 * __useAlterarQtdRequisicoesMutation__
 *
 * To run a mutation, you first call `useAlterarQtdRequisicoesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlterarQtdRequisicoesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alterarQtdRequisicoesMutation, { data, loading, error }] = useAlterarQtdRequisicoesMutation({
 *   variables: {
 *      qtdRequisicoesSimultaneas: // value for 'qtdRequisicoesSimultaneas'
 *   },
 * });
 */
export function useAlterarQtdRequisicoesMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.AlterarQtdRequisicoesMutation,
    Types.AlterarQtdRequisicoesMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    Types.AlterarQtdRequisicoesMutation,
    Types.AlterarQtdRequisicoesMutationVariables
  >(AlterarQtdRequisicoesDocument, baseOptions)
}
export type AlterarQtdRequisicoesMutationHookResult = ReturnType<typeof useAlterarQtdRequisicoesMutation>
export type AlterarQtdRequisicoesMutationResult = ApolloReactCommon.MutationResult<Types.AlterarQtdRequisicoesMutation>
export type AlterarQtdRequisicoesMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.AlterarQtdRequisicoesMutation,
  Types.AlterarQtdRequisicoesMutationVariables
>
export const QuantidadeRequisicoesDocument = gql`
  query QuantidadeRequisicoes {
    avancada {
      performance {
        qtdRequisicoesSimultaneas
      }
    }
  }
`

/**
 * __useQuantidadeRequisicoesQuery__
 *
 * To run a query within a React component, call `useQuantidadeRequisicoesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuantidadeRequisicoesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuantidadeRequisicoesQuery({
 *   variables: {
 *   },
 * });
 */
export function useQuantidadeRequisicoesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.QuantidadeRequisicoesQuery,
    Types.QuantidadeRequisicoesQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<Types.QuantidadeRequisicoesQuery, Types.QuantidadeRequisicoesQueryVariables>(
    QuantidadeRequisicoesDocument,
    baseOptions
  )
}
export function useQuantidadeRequisicoesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.QuantidadeRequisicoesQuery,
    Types.QuantidadeRequisicoesQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<Types.QuantidadeRequisicoesQuery, Types.QuantidadeRequisicoesQueryVariables>(
    QuantidadeRequisicoesDocument,
    baseOptions
  )
}
export type QuantidadeRequisicoesQueryHookResult = ReturnType<typeof useQuantidadeRequisicoesQuery>
export type QuantidadeRequisicoesLazyQueryHookResult = ReturnType<typeof useQuantidadeRequisicoesLazyQuery>
export type QuantidadeRequisicoesQueryResult = ApolloReactCommon.QueryResult<
  Types.QuantidadeRequisicoesQuery,
  Types.QuantidadeRequisicoesQueryVariables
>
export const ConexaoDocument = gql`
  query Conexao {
    conexao {
      internet {
        habilitado
        dataUltimoTeste
        resultadoUltimoTeste
      }
      cadsus {
        id
        habilitado
        desabilitadoAteData
        intervalo
      }
      horus {
        id
        habilitado
        desabilitadoAteData
        intervalo
      }
      agendaOnline {
        ativa
        detalhesAtivacao {
          profissional {
            nome
          }
          dataEvento
        }
        testeConexao {
          sucesso
          dataEvento
        }
      }
    }
  }
`

/**
 * __useConexaoQuery__
 *
 * To run a query within a React component, call `useConexaoQuery` and pass it any options that fit your needs.
 * When your component renders, `useConexaoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConexaoQuery({
 *   variables: {
 *   },
 * });
 */
export function useConexaoQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ConexaoQuery, Types.ConexaoQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.ConexaoQuery, Types.ConexaoQueryVariables>(ConexaoDocument, baseOptions)
}
export function useConexaoLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ConexaoQuery, Types.ConexaoQueryVariables>
) {
  return ApolloReactHooks.useLazyQuery<Types.ConexaoQuery, Types.ConexaoQueryVariables>(ConexaoDocument, baseOptions)
}
export type ConexaoQueryHookResult = ReturnType<typeof useConexaoQuery>
export type ConexaoLazyQueryHookResult = ReturnType<typeof useConexaoLazyQuery>
export type ConexaoQueryResult = ApolloReactCommon.QueryResult<Types.ConexaoQuery, Types.ConexaoQueryVariables>
export const AlternarConexaoInternetDocument = gql`
  mutation AlternarConexaoInternet($habilitado: Boolean) {
    alternarInternet(habilitado: $habilitado) {
      habilitado
    }
  }
`
export type AlternarConexaoInternetMutationFn = ApolloReactCommon.MutationFunction<
  Types.AlternarConexaoInternetMutation,
  Types.AlternarConexaoInternetMutationVariables
>

/**
 * __useAlternarConexaoInternetMutation__
 *
 * To run a mutation, you first call `useAlternarConexaoInternetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlternarConexaoInternetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alternarConexaoInternetMutation, { data, loading, error }] = useAlternarConexaoInternetMutation({
 *   variables: {
 *      habilitado: // value for 'habilitado'
 *   },
 * });
 */
export function useAlternarConexaoInternetMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.AlternarConexaoInternetMutation,
    Types.AlternarConexaoInternetMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    Types.AlternarConexaoInternetMutation,
    Types.AlternarConexaoInternetMutationVariables
  >(AlternarConexaoInternetDocument, baseOptions)
}
export type AlternarConexaoInternetMutationHookResult = ReturnType<typeof useAlternarConexaoInternetMutation>
export type AlternarConexaoInternetMutationResult = ApolloReactCommon.MutationResult<
  Types.AlternarConexaoInternetMutation
>
export type AlternarConexaoInternetMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.AlternarConexaoInternetMutation,
  Types.AlternarConexaoInternetMutationVariables
>
export const TestarConexaoInternetDocument = gql`
  mutation TestarConexaoInternet {
    testarConexaoInternet {
      habilitado
      dataUltimoTeste
      resultadoUltimoTeste
    }
  }
`
export type TestarConexaoInternetMutationFn = ApolloReactCommon.MutationFunction<
  Types.TestarConexaoInternetMutation,
  Types.TestarConexaoInternetMutationVariables
>

/**
 * __useTestarConexaoInternetMutation__
 *
 * To run a mutation, you first call `useTestarConexaoInternetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTestarConexaoInternetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testarConexaoInternetMutation, { data, loading, error }] = useTestarConexaoInternetMutation({
 *   variables: {
 *   },
 * });
 */
export function useTestarConexaoInternetMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.TestarConexaoInternetMutation,
    Types.TestarConexaoInternetMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    Types.TestarConexaoInternetMutation,
    Types.TestarConexaoInternetMutationVariables
  >(TestarConexaoInternetDocument, baseOptions)
}
export type TestarConexaoInternetMutationHookResult = ReturnType<typeof useTestarConexaoInternetMutation>
export type TestarConexaoInternetMutationResult = ApolloReactCommon.MutationResult<Types.TestarConexaoInternetMutation>
export type TestarConexaoInternetMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.TestarConexaoInternetMutation,
  Types.TestarConexaoInternetMutationVariables
>
export const GerarChaveAtivacaoAgendaOnlineDocument = gql`
  mutation GerarChaveAtivacaoAgendaOnline {
    gerarChaveAtivacaoAgendaOnline
  }
`
export type GerarChaveAtivacaoAgendaOnlineMutationFn = ApolloReactCommon.MutationFunction<
  Types.GerarChaveAtivacaoAgendaOnlineMutation,
  Types.GerarChaveAtivacaoAgendaOnlineMutationVariables
>

/**
 * __useGerarChaveAtivacaoAgendaOnlineMutation__
 *
 * To run a mutation, you first call `useGerarChaveAtivacaoAgendaOnlineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGerarChaveAtivacaoAgendaOnlineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [gerarChaveAtivacaoAgendaOnlineMutation, { data, loading, error }] = useGerarChaveAtivacaoAgendaOnlineMutation({
 *   variables: {
 *   },
 * });
 */
export function useGerarChaveAtivacaoAgendaOnlineMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.GerarChaveAtivacaoAgendaOnlineMutation,
    Types.GerarChaveAtivacaoAgendaOnlineMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    Types.GerarChaveAtivacaoAgendaOnlineMutation,
    Types.GerarChaveAtivacaoAgendaOnlineMutationVariables
  >(GerarChaveAtivacaoAgendaOnlineDocument, baseOptions)
}
export type GerarChaveAtivacaoAgendaOnlineMutationHookResult = ReturnType<
  typeof useGerarChaveAtivacaoAgendaOnlineMutation
>
export type GerarChaveAtivacaoAgendaOnlineMutationResult = ApolloReactCommon.MutationResult<
  Types.GerarChaveAtivacaoAgendaOnlineMutation
>
export type GerarChaveAtivacaoAgendaOnlineMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.GerarChaveAtivacaoAgendaOnlineMutation,
  Types.GerarChaveAtivacaoAgendaOnlineMutationVariables
>
export const AtivarAgendaOnlineDocument = gql`
  mutation AtivarAgendaOnline($ativacaoAgendaOnlineInput: AtivacaoAgendaOnlineInput!) {
    ativarAgendaOnline(ativacaoAgendaOnlineInput: $ativacaoAgendaOnlineInput) {
      ativa
      detalhesAtivacao {
        profissional {
          nome
        }
        dataEvento
      }
    }
  }
`
export type AtivarAgendaOnlineMutationFn = ApolloReactCommon.MutationFunction<
  Types.AtivarAgendaOnlineMutation,
  Types.AtivarAgendaOnlineMutationVariables
>

/**
 * __useAtivarAgendaOnlineMutation__
 *
 * To run a mutation, you first call `useAtivarAgendaOnlineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAtivarAgendaOnlineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ativarAgendaOnlineMutation, { data, loading, error }] = useAtivarAgendaOnlineMutation({
 *   variables: {
 *      ativacaoAgendaOnlineInput: // value for 'ativacaoAgendaOnlineInput'
 *   },
 * });
 */
export function useAtivarAgendaOnlineMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.AtivarAgendaOnlineMutation,
    Types.AtivarAgendaOnlineMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<Types.AtivarAgendaOnlineMutation, Types.AtivarAgendaOnlineMutationVariables>(
    AtivarAgendaOnlineDocument,
    baseOptions
  )
}
export type AtivarAgendaOnlineMutationHookResult = ReturnType<typeof useAtivarAgendaOnlineMutation>
export type AtivarAgendaOnlineMutationResult = ApolloReactCommon.MutationResult<Types.AtivarAgendaOnlineMutation>
export type AtivarAgendaOnlineMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.AtivarAgendaOnlineMutation,
  Types.AtivarAgendaOnlineMutationVariables
>
export const TestarConexaoAgendaOnlineDocument = gql`
  mutation TestarConexaoAgendaOnline {
    testarConexaoAgendaOnline {
      sucesso
      dataEvento
    }
  }
`
export type TestarConexaoAgendaOnlineMutationFn = ApolloReactCommon.MutationFunction<
  Types.TestarConexaoAgendaOnlineMutation,
  Types.TestarConexaoAgendaOnlineMutationVariables
>

/**
 * __useTestarConexaoAgendaOnlineMutation__
 *
 * To run a mutation, you first call `useTestarConexaoAgendaOnlineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTestarConexaoAgendaOnlineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testarConexaoAgendaOnlineMutation, { data, loading, error }] = useTestarConexaoAgendaOnlineMutation({
 *   variables: {
 *   },
 * });
 */
export function useTestarConexaoAgendaOnlineMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.TestarConexaoAgendaOnlineMutation,
    Types.TestarConexaoAgendaOnlineMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    Types.TestarConexaoAgendaOnlineMutation,
    Types.TestarConexaoAgendaOnlineMutationVariables
  >(TestarConexaoAgendaOnlineDocument, baseOptions)
}
export type TestarConexaoAgendaOnlineMutationHookResult = ReturnType<typeof useTestarConexaoAgendaOnlineMutation>
export type TestarConexaoAgendaOnlineMutationResult = ApolloReactCommon.MutationResult<
  Types.TestarConexaoAgendaOnlineMutation
>
export type TestarConexaoAgendaOnlineMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.TestarConexaoAgendaOnlineMutation,
  Types.TestarConexaoAgendaOnlineMutationVariables
>
export const CfgLotacaoAgendaOnlineDocument = gql`
  query CfgLotacaoAgendaOnline {
    conexao {
      agendaOnline {
        ativa
      }
      hasLotacoesConfiguradasOnline
      lotacoesAgendaOnlineComDuracaoPadrao
    }
  }
`

/**
 * __useCfgLotacaoAgendaOnlineQuery__
 *
 * To run a query within a React component, call `useCfgLotacaoAgendaOnlineQuery` and pass it any options that fit your needs.
 * When your component renders, `useCfgLotacaoAgendaOnlineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCfgLotacaoAgendaOnlineQuery({
 *   variables: {
 *   },
 * });
 */
export function useCfgLotacaoAgendaOnlineQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.CfgLotacaoAgendaOnlineQuery,
    Types.CfgLotacaoAgendaOnlineQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<Types.CfgLotacaoAgendaOnlineQuery, Types.CfgLotacaoAgendaOnlineQueryVariables>(
    CfgLotacaoAgendaOnlineDocument,
    baseOptions
  )
}
export function useCfgLotacaoAgendaOnlineLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.CfgLotacaoAgendaOnlineQuery,
    Types.CfgLotacaoAgendaOnlineQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<Types.CfgLotacaoAgendaOnlineQuery, Types.CfgLotacaoAgendaOnlineQueryVariables>(
    CfgLotacaoAgendaOnlineDocument,
    baseOptions
  )
}
export type CfgLotacaoAgendaOnlineQueryHookResult = ReturnType<typeof useCfgLotacaoAgendaOnlineQuery>
export type CfgLotacaoAgendaOnlineLazyQueryHookResult = ReturnType<typeof useCfgLotacaoAgendaOnlineLazyQuery>
export type CfgLotacaoAgendaOnlineQueryResult = ApolloReactCommon.QueryResult<
  Types.CfgLotacaoAgendaOnlineQuery,
  Types.CfgLotacaoAgendaOnlineQueryVariables
>
export const DesativarAgendaOnlineDocument = gql`
  mutation DesativarAgendaOnline {
    desativarAgendaOnline {
      ativa
      detalhesAtivacao {
        profissional {
          nome
        }
        dataEvento
      }
    }
  }
`
export type DesativarAgendaOnlineMutationFn = ApolloReactCommon.MutationFunction<
  Types.DesativarAgendaOnlineMutation,
  Types.DesativarAgendaOnlineMutationVariables
>

/**
 * __useDesativarAgendaOnlineMutation__
 *
 * To run a mutation, you first call `useDesativarAgendaOnlineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDesativarAgendaOnlineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [desativarAgendaOnlineMutation, { data, loading, error }] = useDesativarAgendaOnlineMutation({
 *   variables: {
 *   },
 * });
 */
export function useDesativarAgendaOnlineMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.DesativarAgendaOnlineMutation,
    Types.DesativarAgendaOnlineMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    Types.DesativarAgendaOnlineMutation,
    Types.DesativarAgendaOnlineMutationVariables
  >(DesativarAgendaOnlineDocument, baseOptions)
}
export type DesativarAgendaOnlineMutationHookResult = ReturnType<typeof useDesativarAgendaOnlineMutation>
export type DesativarAgendaOnlineMutationResult = ApolloReactCommon.MutationResult<Types.DesativarAgendaOnlineMutation>
export type DesativarAgendaOnlineMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.DesativarAgendaOnlineMutation,
  Types.DesativarAgendaOnlineMutationVariables
>
export const AlterarCadsusDocument = gql`
  mutation AlterarCadsus($alterarCadsusInput: AlterarCadsusInput!) {
    alterarCadsus(alterarCadsusInput: $alterarCadsusInput) {
      id
      habilitado
      intervalo
      desabilitadoAteData
    }
  }
`
export type AlterarCadsusMutationFn = ApolloReactCommon.MutationFunction<
  Types.AlterarCadsusMutation,
  Types.AlterarCadsusMutationVariables
>

/**
 * __useAlterarCadsusMutation__
 *
 * To run a mutation, you first call `useAlterarCadsusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlterarCadsusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alterarCadsusMutation, { data, loading, error }] = useAlterarCadsusMutation({
 *   variables: {
 *      alterarCadsusInput: // value for 'alterarCadsusInput'
 *   },
 * });
 */
export function useAlterarCadsusMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AlterarCadsusMutation, Types.AlterarCadsusMutationVariables>
) {
  return ApolloReactHooks.useMutation<Types.AlterarCadsusMutation, Types.AlterarCadsusMutationVariables>(
    AlterarCadsusDocument,
    baseOptions
  )
}
export type AlterarCadsusMutationHookResult = ReturnType<typeof useAlterarCadsusMutation>
export type AlterarCadsusMutationResult = ApolloReactCommon.MutationResult<Types.AlterarCadsusMutation>
export type AlterarCadsusMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.AlterarCadsusMutation,
  Types.AlterarCadsusMutationVariables
>
export const AlterarHorusDocument = gql`
  mutation AlterarHorus($alterarHorusInput: AlterarHorusInput!) {
    alterarHorus(alterarHorusInput: $alterarHorusInput) {
      id
      habilitado
      intervalo
      desabilitadoAteData
    }
  }
`
export type AlterarHorusMutationFn = ApolloReactCommon.MutationFunction<
  Types.AlterarHorusMutation,
  Types.AlterarHorusMutationVariables
>

/**
 * __useAlterarHorusMutation__
 *
 * To run a mutation, you first call `useAlterarHorusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlterarHorusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alterarHorusMutation, { data, loading, error }] = useAlterarHorusMutation({
 *   variables: {
 *      alterarHorusInput: // value for 'alterarHorusInput'
 *   },
 * });
 */
export function useAlterarHorusMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AlterarHorusMutation, Types.AlterarHorusMutationVariables>
) {
  return ApolloReactHooks.useMutation<Types.AlterarHorusMutation, Types.AlterarHorusMutationVariables>(
    AlterarHorusDocument,
    baseOptions
  )
}
export type AlterarHorusMutationHookResult = ReturnType<typeof useAlterarHorusMutation>
export type AlterarHorusMutationResult = ApolloReactCommon.MutationResult<Types.AlterarHorusMutation>
export type AlterarHorusMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.AlterarHorusMutation,
  Types.AlterarHorusMutationVariables
>
export const HasMunicipioAtivoDocument = gql`
  query HasMunicipioAtivo {
    hasMunicipioAtivo
  }
`

/**
 * __useHasMunicipioAtivoQuery__
 *
 * To run a query within a React component, call `useHasMunicipioAtivoQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasMunicipioAtivoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasMunicipioAtivoQuery({
 *   variables: {
 *   },
 * });
 */
export function useHasMunicipioAtivoQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.HasMunicipioAtivoQuery, Types.HasMunicipioAtivoQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.HasMunicipioAtivoQuery, Types.HasMunicipioAtivoQueryVariables>(
    HasMunicipioAtivoDocument,
    baseOptions
  )
}
export function useHasMunicipioAtivoLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.HasMunicipioAtivoQuery,
    Types.HasMunicipioAtivoQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<Types.HasMunicipioAtivoQuery, Types.HasMunicipioAtivoQueryVariables>(
    HasMunicipioAtivoDocument,
    baseOptions
  )
}
export type HasMunicipioAtivoQueryHookResult = ReturnType<typeof useHasMunicipioAtivoQuery>
export type HasMunicipioAtivoLazyQueryHookResult = ReturnType<typeof useHasMunicipioAtivoLazyQuery>
export type HasMunicipioAtivoQueryResult = ApolloReactCommon.QueryResult<
  Types.HasMunicipioAtivoQuery,
  Types.HasMunicipioAtivoQueryVariables
>
export const MunicipiosResponsaveisDocument = gql`
  query MunicipiosResponsaveis($input: MunicipioResponsavelFiltroInput!) {
    municipiosResponsaveis(input: $input) {
      content {
        id
        profissional {
          id
          nome
        }
        municipio {
          id
          nome
          uf {
            id
            sigla
          }
        }
        habilitado
        ativo
        dataAdicao
        dataInativacao
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${PageInfoFragmentDoc}
`

/**
 * __useMunicipiosResponsaveisQuery__
 *
 * To run a query within a React component, call `useMunicipiosResponsaveisQuery` and pass it any options that fit your needs.
 * When your component renders, `useMunicipiosResponsaveisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMunicipiosResponsaveisQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMunicipiosResponsaveisQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.MunicipiosResponsaveisQuery,
    Types.MunicipiosResponsaveisQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<Types.MunicipiosResponsaveisQuery, Types.MunicipiosResponsaveisQueryVariables>(
    MunicipiosResponsaveisDocument,
    baseOptions
  )
}
export function useMunicipiosResponsaveisLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.MunicipiosResponsaveisQuery,
    Types.MunicipiosResponsaveisQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<Types.MunicipiosResponsaveisQuery, Types.MunicipiosResponsaveisQueryVariables>(
    MunicipiosResponsaveisDocument,
    baseOptions
  )
}
export type MunicipiosResponsaveisQueryHookResult = ReturnType<typeof useMunicipiosResponsaveisQuery>
export type MunicipiosResponsaveisLazyQueryHookResult = ReturnType<typeof useMunicipiosResponsaveisLazyQuery>
export type MunicipiosResponsaveisQueryResult = ApolloReactCommon.QueryResult<
  Types.MunicipiosResponsaveisQuery,
  Types.MunicipiosResponsaveisQueryVariables
>
export const InserirMunicipioResponsavelDocument = gql`
  mutation InserirMunicipioResponsavel($input: MunicipioResponsavelInput!) {
    inserirMunicipioResponsavel(input: $input) {
      id
      profissional {
        nome
      }
      municipio {
        nome
      }
      habilitado
      ativo
      dataAdicao
      dataInativacao
    }
  }
`
export type InserirMunicipioResponsavelMutationFn = ApolloReactCommon.MutationFunction<
  Types.InserirMunicipioResponsavelMutation,
  Types.InserirMunicipioResponsavelMutationVariables
>

/**
 * __useInserirMunicipioResponsavelMutation__
 *
 * To run a mutation, you first call `useInserirMunicipioResponsavelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInserirMunicipioResponsavelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inserirMunicipioResponsavelMutation, { data, loading, error }] = useInserirMunicipioResponsavelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInserirMunicipioResponsavelMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.InserirMunicipioResponsavelMutation,
    Types.InserirMunicipioResponsavelMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    Types.InserirMunicipioResponsavelMutation,
    Types.InserirMunicipioResponsavelMutationVariables
  >(InserirMunicipioResponsavelDocument, baseOptions)
}
export type InserirMunicipioResponsavelMutationHookResult = ReturnType<typeof useInserirMunicipioResponsavelMutation>
export type InserirMunicipioResponsavelMutationResult = ApolloReactCommon.MutationResult<
  Types.InserirMunicipioResponsavelMutation
>
export type InserirMunicipioResponsavelMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.InserirMunicipioResponsavelMutation,
  Types.InserirMunicipioResponsavelMutationVariables
>
export const AtualizarMunicipioResponsavelDocument = gql`
  mutation AtualizarMunicipioResponsavel($input: MunicipioResponsavelUpdateInput!) {
    atualizarMunicipioResponsavel(input: $input) {
      id
      profissional {
        id
        nome
      }
      municipio {
        id
        nome
        uf {
          id
          sigla
        }
      }
      habilitado
      ativo
      dataAdicao
      dataInativacao
    }
  }
`
export type AtualizarMunicipioResponsavelMutationFn = ApolloReactCommon.MutationFunction<
  Types.AtualizarMunicipioResponsavelMutation,
  Types.AtualizarMunicipioResponsavelMutationVariables
>

/**
 * __useAtualizarMunicipioResponsavelMutation__
 *
 * To run a mutation, you first call `useAtualizarMunicipioResponsavelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAtualizarMunicipioResponsavelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [atualizarMunicipioResponsavelMutation, { data, loading, error }] = useAtualizarMunicipioResponsavelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAtualizarMunicipioResponsavelMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.AtualizarMunicipioResponsavelMutation,
    Types.AtualizarMunicipioResponsavelMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    Types.AtualizarMunicipioResponsavelMutation,
    Types.AtualizarMunicipioResponsavelMutationVariables
  >(AtualizarMunicipioResponsavelDocument, baseOptions)
}
export type AtualizarMunicipioResponsavelMutationHookResult = ReturnType<
  typeof useAtualizarMunicipioResponsavelMutation
>
export type AtualizarMunicipioResponsavelMutationResult = ApolloReactCommon.MutationResult<
  Types.AtualizarMunicipioResponsavelMutation
>
export type AtualizarMunicipioResponsavelMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.AtualizarMunicipioResponsavelMutation,
  Types.AtualizarMunicipioResponsavelMutationVariables
>
export const ExcluirMunicipioResponsavelDocument = gql`
  mutation ExcluirMunicipioResponsavel($id: ID!) {
    excluirMunicipioResponsavel(id: $id)
  }
`
export type ExcluirMunicipioResponsavelMutationFn = ApolloReactCommon.MutationFunction<
  Types.ExcluirMunicipioResponsavelMutation,
  Types.ExcluirMunicipioResponsavelMutationVariables
>

/**
 * __useExcluirMunicipioResponsavelMutation__
 *
 * To run a mutation, you first call `useExcluirMunicipioResponsavelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExcluirMunicipioResponsavelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [excluirMunicipioResponsavelMutation, { data, loading, error }] = useExcluirMunicipioResponsavelMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExcluirMunicipioResponsavelMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.ExcluirMunicipioResponsavelMutation,
    Types.ExcluirMunicipioResponsavelMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    Types.ExcluirMunicipioResponsavelMutation,
    Types.ExcluirMunicipioResponsavelMutationVariables
  >(ExcluirMunicipioResponsavelDocument, baseOptions)
}
export type ExcluirMunicipioResponsavelMutationHookResult = ReturnType<typeof useExcluirMunicipioResponsavelMutation>
export type ExcluirMunicipioResponsavelMutationResult = ApolloReactCommon.MutationResult<
  Types.ExcluirMunicipioResponsavelMutation
>
export type ExcluirMunicipioResponsavelMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.ExcluirMunicipioResponsavelMutation,
  Types.ExcluirMunicipioResponsavelMutationVariables
>
export const AlterarNumeroTentativasLoginDocument = gql`
  mutation AlterarNumeroTentativasLogin($tentativas: Int) {
    alterarNumeroTentativasLogin(tentativas: $tentativas) {
      tentativasLogin
    }
  }
`
export type AlterarNumeroTentativasLoginMutationFn = ApolloReactCommon.MutationFunction<
  Types.AlterarNumeroTentativasLoginMutation,
  Types.AlterarNumeroTentativasLoginMutationVariables
>

/**
 * __useAlterarNumeroTentativasLoginMutation__
 *
 * To run a mutation, you first call `useAlterarNumeroTentativasLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlterarNumeroTentativasLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alterarNumeroTentativasLoginMutation, { data, loading, error }] = useAlterarNumeroTentativasLoginMutation({
 *   variables: {
 *      tentativas: // value for 'tentativas'
 *   },
 * });
 */
export function useAlterarNumeroTentativasLoginMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.AlterarNumeroTentativasLoginMutation,
    Types.AlterarNumeroTentativasLoginMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    Types.AlterarNumeroTentativasLoginMutation,
    Types.AlterarNumeroTentativasLoginMutationVariables
  >(AlterarNumeroTentativasLoginDocument, baseOptions)
}
export type AlterarNumeroTentativasLoginMutationHookResult = ReturnType<typeof useAlterarNumeroTentativasLoginMutation>
export type AlterarNumeroTentativasLoginMutationResult = ApolloReactCommon.MutationResult<
  Types.AlterarNumeroTentativasLoginMutation
>
export type AlterarNumeroTentativasLoginMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.AlterarNumeroTentativasLoginMutation,
  Types.AlterarNumeroTentativasLoginMutationVariables
>
export const AlterarPeriodoInatividadeDocument = gql`
  mutation AlterarPeriodoInatividade($periodo: Int) {
    alterarPeriodoInatividade(periodo: $periodo) {
      periodoInatividade
    }
  }
`
export type AlterarPeriodoInatividadeMutationFn = ApolloReactCommon.MutationFunction<
  Types.AlterarPeriodoInatividadeMutation,
  Types.AlterarPeriodoInatividadeMutationVariables
>

/**
 * __useAlterarPeriodoInatividadeMutation__
 *
 * To run a mutation, you first call `useAlterarPeriodoInatividadeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlterarPeriodoInatividadeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alterarPeriodoInatividadeMutation, { data, loading, error }] = useAlterarPeriodoInatividadeMutation({
 *   variables: {
 *      periodo: // value for 'periodo'
 *   },
 * });
 */
export function useAlterarPeriodoInatividadeMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.AlterarPeriodoInatividadeMutation,
    Types.AlterarPeriodoInatividadeMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    Types.AlterarPeriodoInatividadeMutation,
    Types.AlterarPeriodoInatividadeMutationVariables
  >(AlterarPeriodoInatividadeDocument, baseOptions)
}
export type AlterarPeriodoInatividadeMutationHookResult = ReturnType<typeof useAlterarPeriodoInatividadeMutation>
export type AlterarPeriodoInatividadeMutationResult = ApolloReactCommon.MutationResult<
  Types.AlterarPeriodoInatividadeMutation
>
export type AlterarPeriodoInatividadeMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.AlterarPeriodoInatividadeMutation,
  Types.AlterarPeriodoInatividadeMutationVariables
>
export const AlterarPeriodoRedefinicaoSenhaDocument = gql`
  mutation AlterarPeriodoRedefinicaoSenha($periodo: Int) {
    alterarPeriodoRedefinicaoSenha(periodo: $periodo) {
      redefinicaoSenha
    }
  }
`
export type AlterarPeriodoRedefinicaoSenhaMutationFn = ApolloReactCommon.MutationFunction<
  Types.AlterarPeriodoRedefinicaoSenhaMutation,
  Types.AlterarPeriodoRedefinicaoSenhaMutationVariables
>

/**
 * __useAlterarPeriodoRedefinicaoSenhaMutation__
 *
 * To run a mutation, you first call `useAlterarPeriodoRedefinicaoSenhaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlterarPeriodoRedefinicaoSenhaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alterarPeriodoRedefinicaoSenhaMutation, { data, loading, error }] = useAlterarPeriodoRedefinicaoSenhaMutation({
 *   variables: {
 *      periodo: // value for 'periodo'
 *   },
 * });
 */
export function useAlterarPeriodoRedefinicaoSenhaMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.AlterarPeriodoRedefinicaoSenhaMutation,
    Types.AlterarPeriodoRedefinicaoSenhaMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    Types.AlterarPeriodoRedefinicaoSenhaMutation,
    Types.AlterarPeriodoRedefinicaoSenhaMutationVariables
  >(AlterarPeriodoRedefinicaoSenhaDocument, baseOptions)
}
export type AlterarPeriodoRedefinicaoSenhaMutationHookResult = ReturnType<
  typeof useAlterarPeriodoRedefinicaoSenhaMutation
>
export type AlterarPeriodoRedefinicaoSenhaMutationResult = ApolloReactCommon.MutationResult<
  Types.AlterarPeriodoRedefinicaoSenhaMutation
>
export type AlterarPeriodoRedefinicaoSenhaMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.AlterarPeriodoRedefinicaoSenhaMutation,
  Types.AlterarPeriodoRedefinicaoSenhaMutationVariables
>
export const ForcarRedefinirSenhasDocument = gql`
  mutation ForcarRedefinirSenhas {
    forcarRedefinirSenhas {
      redefinicaoSenha
    }
  }
`
export type ForcarRedefinirSenhasMutationFn = ApolloReactCommon.MutationFunction<
  Types.ForcarRedefinirSenhasMutation,
  Types.ForcarRedefinirSenhasMutationVariables
>

/**
 * __useForcarRedefinirSenhasMutation__
 *
 * To run a mutation, you first call `useForcarRedefinirSenhasMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForcarRedefinirSenhasMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forcarRedefinirSenhasMutation, { data, loading, error }] = useForcarRedefinirSenhasMutation({
 *   variables: {
 *   },
 * });
 */
export function useForcarRedefinirSenhasMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.ForcarRedefinirSenhasMutation,
    Types.ForcarRedefinirSenhasMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    Types.ForcarRedefinirSenhasMutation,
    Types.ForcarRedefinirSenhasMutationVariables
  >(ForcarRedefinirSenhasDocument, baseOptions)
}
export type ForcarRedefinirSenhasMutationHookResult = ReturnType<typeof useForcarRedefinirSenhasMutation>
export type ForcarRedefinirSenhasMutationResult = ApolloReactCommon.MutationResult<Types.ForcarRedefinirSenhasMutation>
export type ForcarRedefinirSenhasMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.ForcarRedefinirSenhasMutation,
  Types.ForcarRedefinirSenhasMutationVariables
>
export const SegurancaDocument = gql`
  query Seguranca {
    seguranca {
      periodoEmMesesParaRedefinir {
        redefinicaoSenha
      }
      periodoEmMinutosInatividade {
        periodoInatividade
      }
      loginNumeroTentativas {
        tentativasLogin
      }
    }
  }
`

/**
 * __useSegurancaQuery__
 *
 * To run a query within a React component, call `useSegurancaQuery` and pass it any options that fit your needs.
 * When your component renders, `useSegurancaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSegurancaQuery({
 *   variables: {
 *   },
 * });
 */
export function useSegurancaQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.SegurancaQuery, Types.SegurancaQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.SegurancaQuery, Types.SegurancaQueryVariables>(SegurancaDocument, baseOptions)
}
export function useSegurancaLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.SegurancaQuery, Types.SegurancaQueryVariables>
) {
  return ApolloReactHooks.useLazyQuery<Types.SegurancaQuery, Types.SegurancaQueryVariables>(
    SegurancaDocument,
    baseOptions
  )
}
export type SegurancaQueryHookResult = ReturnType<typeof useSegurancaQuery>
export type SegurancaLazyQueryHookResult = ReturnType<typeof useSegurancaLazyQuery>
export type SegurancaQueryResult = ApolloReactCommon.QueryResult<Types.SegurancaQuery, Types.SegurancaQueryVariables>
export const AlterarDadosServidorInstalacaoDocument = gql`
  mutation AlterarDadosServidorInstalacao($input: ConfiguracaoDadosServidorInput!) {
    alterarDadosServidor(input: $input) {
      nomeInstalacao
      linkInstalacao
    }
  }
`
export type AlterarDadosServidorInstalacaoMutationFn = ApolloReactCommon.MutationFunction<
  Types.AlterarDadosServidorInstalacaoMutation,
  Types.AlterarDadosServidorInstalacaoMutationVariables
>

/**
 * __useAlterarDadosServidorInstalacaoMutation__
 *
 * To run a mutation, you first call `useAlterarDadosServidorInstalacaoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlterarDadosServidorInstalacaoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alterarDadosServidorInstalacaoMutation, { data, loading, error }] = useAlterarDadosServidorInstalacaoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAlterarDadosServidorInstalacaoMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.AlterarDadosServidorInstalacaoMutation,
    Types.AlterarDadosServidorInstalacaoMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    Types.AlterarDadosServidorInstalacaoMutation,
    Types.AlterarDadosServidorInstalacaoMutationVariables
  >(AlterarDadosServidorInstalacaoDocument, baseOptions)
}
export type AlterarDadosServidorInstalacaoMutationHookResult = ReturnType<
  typeof useAlterarDadosServidorInstalacaoMutation
>
export type AlterarDadosServidorInstalacaoMutationResult = ApolloReactCommon.MutationResult<
  Types.AlterarDadosServidorInstalacaoMutation
>
export type AlterarDadosServidorInstalacaoMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.AlterarDadosServidorInstalacaoMutation,
  Types.AlterarDadosServidorInstalacaoMutationVariables
>
export const AlterarServidorSmtpDocument = gql`
  mutation AlterarServidorSMTP($input: ConfiguracaoSMTPInput!) {
    alterarServidorSMTP(input: $input) {
      email
      senha
      usuario
      endereco
      porta
    }
  }
`
export type AlterarServidorSmtpMutationFn = ApolloReactCommon.MutationFunction<
  Types.AlterarServidorSmtpMutation,
  Types.AlterarServidorSmtpMutationVariables
>

/**
 * __useAlterarServidorSmtpMutation__
 *
 * To run a mutation, you first call `useAlterarServidorSmtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlterarServidorSmtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alterarServidorSmtpMutation, { data, loading, error }] = useAlterarServidorSmtpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAlterarServidorSmtpMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.AlterarServidorSmtpMutation,
    Types.AlterarServidorSmtpMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<Types.AlterarServidorSmtpMutation, Types.AlterarServidorSmtpMutationVariables>(
    AlterarServidorSmtpDocument,
    baseOptions
  )
}
export type AlterarServidorSmtpMutationHookResult = ReturnType<typeof useAlterarServidorSmtpMutation>
export type AlterarServidorSmtpMutationResult = ApolloReactCommon.MutationResult<Types.AlterarServidorSmtpMutation>
export type AlterarServidorSmtpMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.AlterarServidorSmtpMutation,
  Types.AlterarServidorSmtpMutationVariables
>
export const DesabilitarConexaoSmtpDocument = gql`
  mutation DesabilitarConexaoSMTP {
    desabilitarConexaoSMTP
  }
`
export type DesabilitarConexaoSmtpMutationFn = ApolloReactCommon.MutationFunction<
  Types.DesabilitarConexaoSmtpMutation,
  Types.DesabilitarConexaoSmtpMutationVariables
>

/**
 * __useDesabilitarConexaoSmtpMutation__
 *
 * To run a mutation, you first call `useDesabilitarConexaoSmtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDesabilitarConexaoSmtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [desabilitarConexaoSmtpMutation, { data, loading, error }] = useDesabilitarConexaoSmtpMutation({
 *   variables: {
 *   },
 * });
 */
export function useDesabilitarConexaoSmtpMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.DesabilitarConexaoSmtpMutation,
    Types.DesabilitarConexaoSmtpMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    Types.DesabilitarConexaoSmtpMutation,
    Types.DesabilitarConexaoSmtpMutationVariables
  >(DesabilitarConexaoSmtpDocument, baseOptions)
}
export type DesabilitarConexaoSmtpMutationHookResult = ReturnType<typeof useDesabilitarConexaoSmtpMutation>
export type DesabilitarConexaoSmtpMutationResult = ApolloReactCommon.MutationResult<
  Types.DesabilitarConexaoSmtpMutation
>
export type DesabilitarConexaoSmtpMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.DesabilitarConexaoSmtpMutation,
  Types.DesabilitarConexaoSmtpMutationVariables
>
export const DadosServidoresDocument = gql`
  query DadosServidores {
    servidores {
      internet {
        habilitado
      }
      dadosServidor {
        nomeInstalacao
        linkInstalacao
      }
      servidorSMTP {
        email
        senha
        usuario
        endereco
        porta
        ativo
        dataRegistro
      }
    }
  }
`

/**
 * __useDadosServidoresQuery__
 *
 * To run a query within a React component, call `useDadosServidoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useDadosServidoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDadosServidoresQuery({
 *   variables: {
 *   },
 * });
 */
export function useDadosServidoresQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.DadosServidoresQuery, Types.DadosServidoresQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.DadosServidoresQuery, Types.DadosServidoresQueryVariables>(
    DadosServidoresDocument,
    baseOptions
  )
}
export function useDadosServidoresLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.DadosServidoresQuery, Types.DadosServidoresQueryVariables>
) {
  return ApolloReactHooks.useLazyQuery<Types.DadosServidoresQuery, Types.DadosServidoresQueryVariables>(
    DadosServidoresDocument,
    baseOptions
  )
}
export type DadosServidoresQueryHookResult = ReturnType<typeof useDadosServidoresQuery>
export type DadosServidoresLazyQueryHookResult = ReturnType<typeof useDadosServidoresLazyQuery>
export type DadosServidoresQueryResult = ApolloReactCommon.QueryResult<
  Types.DadosServidoresQuery,
  Types.DadosServidoresQueryVariables
>
export const ConfiguracaoInternetDocument = gql`
  query ConfiguracaoInternet {
    conexao {
      internet {
        habilitado
      }
    }
  }
`

/**
 * __useConfiguracaoInternetQuery__
 *
 * To run a query within a React component, call `useConfiguracaoInternetQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfiguracaoInternetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfiguracaoInternetQuery({
 *   variables: {
 *   },
 * });
 */
export function useConfiguracaoInternetQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.ConfiguracaoInternetQuery,
    Types.ConfiguracaoInternetQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<Types.ConfiguracaoInternetQuery, Types.ConfiguracaoInternetQueryVariables>(
    ConfiguracaoInternetDocument,
    baseOptions
  )
}
export function useConfiguracaoInternetLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.ConfiguracaoInternetQuery,
    Types.ConfiguracaoInternetQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<Types.ConfiguracaoInternetQuery, Types.ConfiguracaoInternetQueryVariables>(
    ConfiguracaoInternetDocument,
    baseOptions
  )
}
export type ConfiguracaoInternetQueryHookResult = ReturnType<typeof useConfiguracaoInternetQuery>
export type ConfiguracaoInternetLazyQueryHookResult = ReturnType<typeof useConfiguracaoInternetLazyQuery>
export type ConfiguracaoInternetQueryResult = ApolloReactCommon.QueryResult<
  Types.ConfiguracaoInternetQuery,
  Types.ConfiguracaoInternetQueryVariables
>
export const TesteSaveProfissionaisDocument = gql`
  mutation testeSaveProfissionais {
    testeSaveProfissionais
  }
`
export type TesteSaveProfissionaisMutationFn = ApolloReactCommon.MutationFunction<
  Types.TesteSaveProfissionaisMutation,
  Types.TesteSaveProfissionaisMutationVariables
>

/**
 * __useTesteSaveProfissionaisMutation__
 *
 * To run a mutation, you first call `useTesteSaveProfissionaisMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTesteSaveProfissionaisMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testeSaveProfissionaisMutation, { data, loading, error }] = useTesteSaveProfissionaisMutation({
 *   variables: {
 *   },
 * });
 */
export function useTesteSaveProfissionaisMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.TesteSaveProfissionaisMutation,
    Types.TesteSaveProfissionaisMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    Types.TesteSaveProfissionaisMutation,
    Types.TesteSaveProfissionaisMutationVariables
  >(TesteSaveProfissionaisDocument, baseOptions)
}
export type TesteSaveProfissionaisMutationHookResult = ReturnType<typeof useTesteSaveProfissionaisMutation>
export type TesteSaveProfissionaisMutationResult = ApolloReactCommon.MutationResult<
  Types.TesteSaveProfissionaisMutation
>
export type TesteSaveProfissionaisMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.TesteSaveProfissionaisMutation,
  Types.TesteSaveProfissionaisMutationVariables
>
export const TesteEnvioProfissionaisDocument = gql`
  mutation testeEnvioProfissionais {
    testeEnvioProfissionais
  }
`
export type TesteEnvioProfissionaisMutationFn = ApolloReactCommon.MutationFunction<
  Types.TesteEnvioProfissionaisMutation,
  Types.TesteEnvioProfissionaisMutationVariables
>

/**
 * __useTesteEnvioProfissionaisMutation__
 *
 * To run a mutation, you first call `useTesteEnvioProfissionaisMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTesteEnvioProfissionaisMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testeEnvioProfissionaisMutation, { data, loading, error }] = useTesteEnvioProfissionaisMutation({
 *   variables: {
 *   },
 * });
 */
export function useTesteEnvioProfissionaisMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.TesteEnvioProfissionaisMutation,
    Types.TesteEnvioProfissionaisMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    Types.TesteEnvioProfissionaisMutation,
    Types.TesteEnvioProfissionaisMutationVariables
  >(TesteEnvioProfissionaisDocument, baseOptions)
}
export type TesteEnvioProfissionaisMutationHookResult = ReturnType<typeof useTesteEnvioProfissionaisMutation>
export type TesteEnvioProfissionaisMutationResult = ApolloReactCommon.MutationResult<
  Types.TesteEnvioProfissionaisMutation
>
export type TesteEnvioProfissionaisMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.TesteEnvioProfissionaisMutation,
  Types.TesteEnvioProfissionaisMutationVariables
>
export const ConfiguracaoAgendaMunicipioDocument = gql`
  query ConfiguracaoAgendaMunicipio {
    duracaoAtendimentoPadraoMunicipio {
      duracaoAtendimentoPadraoMunicipio
    }
    configuracaoHorariosMunicipio {
      id
      configuracaoHorarioAgenda {
        configuracaoDiasSemana {
          diaSemana
          periodos {
            periodo
            horarioInicial
            horarioFinal
          }
        }
      }
    }
  }
`

/**
 * __useConfiguracaoAgendaMunicipioQuery__
 *
 * To run a query within a React component, call `useConfiguracaoAgendaMunicipioQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfiguracaoAgendaMunicipioQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfiguracaoAgendaMunicipioQuery({
 *   variables: {
 *   },
 * });
 */
export function useConfiguracaoAgendaMunicipioQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.ConfiguracaoAgendaMunicipioQuery,
    Types.ConfiguracaoAgendaMunicipioQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    Types.ConfiguracaoAgendaMunicipioQuery,
    Types.ConfiguracaoAgendaMunicipioQueryVariables
  >(ConfiguracaoAgendaMunicipioDocument, baseOptions)
}
export function useConfiguracaoAgendaMunicipioLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.ConfiguracaoAgendaMunicipioQuery,
    Types.ConfiguracaoAgendaMunicipioQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    Types.ConfiguracaoAgendaMunicipioQuery,
    Types.ConfiguracaoAgendaMunicipioQueryVariables
  >(ConfiguracaoAgendaMunicipioDocument, baseOptions)
}
export type ConfiguracaoAgendaMunicipioQueryHookResult = ReturnType<typeof useConfiguracaoAgendaMunicipioQuery>
export type ConfiguracaoAgendaMunicipioLazyQueryHookResult = ReturnType<typeof useConfiguracaoAgendaMunicipioLazyQuery>
export type ConfiguracaoAgendaMunicipioQueryResult = ApolloReactCommon.QueryResult<
  Types.ConfiguracaoAgendaMunicipioQuery,
  Types.ConfiguracaoAgendaMunicipioQueryVariables
>
export const SalvarConfiguracaoHorariosMunicipioDocument = gql`
  mutation SalvarConfiguracaoHorariosMunicipio($configuracaoAgendaMunicipalInput: ConfiguracaoAgendaMunicipalInput) {
    salvarConfiguracaoHorariosMunicipio(configuracaoAgendaMunicipalInput: $configuracaoAgendaMunicipalInput) {
      id
      configuracaoHorarioAgenda {
        configuracaoDiasSemana {
          diaSemana
          periodos {
            periodo
            horarioInicial
            horarioFinal
          }
        }
      }
    }
  }
`
export type SalvarConfiguracaoHorariosMunicipioMutationFn = ApolloReactCommon.MutationFunction<
  Types.SalvarConfiguracaoHorariosMunicipioMutation,
  Types.SalvarConfiguracaoHorariosMunicipioMutationVariables
>

/**
 * __useSalvarConfiguracaoHorariosMunicipioMutation__
 *
 * To run a mutation, you first call `useSalvarConfiguracaoHorariosMunicipioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvarConfiguracaoHorariosMunicipioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvarConfiguracaoHorariosMunicipioMutation, { data, loading, error }] = useSalvarConfiguracaoHorariosMunicipioMutation({
 *   variables: {
 *      configuracaoAgendaMunicipalInput: // value for 'configuracaoAgendaMunicipalInput'
 *   },
 * });
 */
export function useSalvarConfiguracaoHorariosMunicipioMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.SalvarConfiguracaoHorariosMunicipioMutation,
    Types.SalvarConfiguracaoHorariosMunicipioMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    Types.SalvarConfiguracaoHorariosMunicipioMutation,
    Types.SalvarConfiguracaoHorariosMunicipioMutationVariables
  >(SalvarConfiguracaoHorariosMunicipioDocument, baseOptions)
}
export type SalvarConfiguracaoHorariosMunicipioMutationHookResult = ReturnType<
  typeof useSalvarConfiguracaoHorariosMunicipioMutation
>
export type SalvarConfiguracaoHorariosMunicipioMutationResult = ApolloReactCommon.MutationResult<
  Types.SalvarConfiguracaoHorariosMunicipioMutation
>
export type SalvarConfiguracaoHorariosMunicipioMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.SalvarConfiguracaoHorariosMunicipioMutation,
  Types.SalvarConfiguracaoHorariosMunicipioMutationVariables
>
export const SalvarConfiguracaoDuracaoAtendimentoMunicipioDocument = gql`
  mutation SalvarConfiguracaoDuracaoAtendimentoMunicipio(
    $duracaoAtendimentoPadraoMunicipioInput: DuracaoAtendimentoPadraoMunicipioInput!
  ) {
    alterarDuracaoPadraoAtendimento(duracaoAtendimentoPadraoMunicipioInput: $duracaoAtendimentoPadraoMunicipioInput) {
      duracaoAtendimentoPadraoMunicipio
    }
  }
`
export type SalvarConfiguracaoDuracaoAtendimentoMunicipioMutationFn = ApolloReactCommon.MutationFunction<
  Types.SalvarConfiguracaoDuracaoAtendimentoMunicipioMutation,
  Types.SalvarConfiguracaoDuracaoAtendimentoMunicipioMutationVariables
>

/**
 * __useSalvarConfiguracaoDuracaoAtendimentoMunicipioMutation__
 *
 * To run a mutation, you first call `useSalvarConfiguracaoDuracaoAtendimentoMunicipioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvarConfiguracaoDuracaoAtendimentoMunicipioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvarConfiguracaoDuracaoAtendimentoMunicipioMutation, { data, loading, error }] = useSalvarConfiguracaoDuracaoAtendimentoMunicipioMutation({
 *   variables: {
 *      duracaoAtendimentoPadraoMunicipioInput: // value for 'duracaoAtendimentoPadraoMunicipioInput'
 *   },
 * });
 */
export function useSalvarConfiguracaoDuracaoAtendimentoMunicipioMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.SalvarConfiguracaoDuracaoAtendimentoMunicipioMutation,
    Types.SalvarConfiguracaoDuracaoAtendimentoMunicipioMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    Types.SalvarConfiguracaoDuracaoAtendimentoMunicipioMutation,
    Types.SalvarConfiguracaoDuracaoAtendimentoMunicipioMutationVariables
  >(SalvarConfiguracaoDuracaoAtendimentoMunicipioDocument, baseOptions)
}
export type SalvarConfiguracaoDuracaoAtendimentoMunicipioMutationHookResult = ReturnType<
  typeof useSalvarConfiguracaoDuracaoAtendimentoMunicipioMutation
>
export type SalvarConfiguracaoDuracaoAtendimentoMunicipioMutationResult = ApolloReactCommon.MutationResult<
  Types.SalvarConfiguracaoDuracaoAtendimentoMunicipioMutation
>
export type SalvarConfiguracaoDuracaoAtendimentoMunicipioMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.SalvarConfiguracaoDuracaoAtendimentoMunicipioMutation,
  Types.SalvarConfiguracaoDuracaoAtendimentoMunicipioMutationVariables
>
export const ExcluirGrupoExameDocument = gql`
  mutation ExcluirGrupoExame($id: ID!) {
    excluirGrupoExame(id: $id)
  }
`
export type ExcluirGrupoExameMutationFn = ApolloReactCommon.MutationFunction<
  Types.ExcluirGrupoExameMutation,
  Types.ExcluirGrupoExameMutationVariables
>

/**
 * __useExcluirGrupoExameMutation__
 *
 * To run a mutation, you first call `useExcluirGrupoExameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExcluirGrupoExameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [excluirGrupoExameMutation, { data, loading, error }] = useExcluirGrupoExameMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExcluirGrupoExameMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.ExcluirGrupoExameMutation,
    Types.ExcluirGrupoExameMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<Types.ExcluirGrupoExameMutation, Types.ExcluirGrupoExameMutationVariables>(
    ExcluirGrupoExameDocument,
    baseOptions
  )
}
export type ExcluirGrupoExameMutationHookResult = ReturnType<typeof useExcluirGrupoExameMutation>
export type ExcluirGrupoExameMutationResult = ApolloReactCommon.MutationResult<Types.ExcluirGrupoExameMutation>
export type ExcluirGrupoExameMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.ExcluirGrupoExameMutation,
  Types.ExcluirGrupoExameMutationVariables
>
export const GrupoExamesDocument = gql`
  query GrupoExames($id: ID!) {
    grupoExame(id: $id) {
      id
      nome
      procedimentos {
        id
        descricao
        codigo
        procedimentoReferencia {
          id
          descricao
          codigo
        }
      }
    }
  }
`

/**
 * __useGrupoExamesQuery__
 *
 * To run a query within a React component, call `useGrupoExamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGrupoExamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGrupoExamesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGrupoExamesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.GrupoExamesQuery, Types.GrupoExamesQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.GrupoExamesQuery, Types.GrupoExamesQueryVariables>(
    GrupoExamesDocument,
    baseOptions
  )
}
export function useGrupoExamesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GrupoExamesQuery, Types.GrupoExamesQueryVariables>
) {
  return ApolloReactHooks.useLazyQuery<Types.GrupoExamesQuery, Types.GrupoExamesQueryVariables>(
    GrupoExamesDocument,
    baseOptions
  )
}
export type GrupoExamesQueryHookResult = ReturnType<typeof useGrupoExamesQuery>
export type GrupoExamesLazyQueryHookResult = ReturnType<typeof useGrupoExamesLazyQuery>
export type GrupoExamesQueryResult = ApolloReactCommon.QueryResult<
  Types.GrupoExamesQuery,
  Types.GrupoExamesQueryVariables
>
export const SalvarGrupoExameDocument = gql`
  mutation SalvarGrupoExame($input: GrupoExameInput!) {
    salvarGrupoExame(input: $input) {
      id
      nome
      procedimentos {
        id
        descricao
        codigo
        procedimentoReferencia {
          id
          descricao
          codigo
        }
      }
    }
  }
`
export type SalvarGrupoExameMutationFn = ApolloReactCommon.MutationFunction<
  Types.SalvarGrupoExameMutation,
  Types.SalvarGrupoExameMutationVariables
>

/**
 * __useSalvarGrupoExameMutation__
 *
 * To run a mutation, you first call `useSalvarGrupoExameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvarGrupoExameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvarGrupoExameMutation, { data, loading, error }] = useSalvarGrupoExameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSalvarGrupoExameMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.SalvarGrupoExameMutation,
    Types.SalvarGrupoExameMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<Types.SalvarGrupoExameMutation, Types.SalvarGrupoExameMutationVariables>(
    SalvarGrupoExameDocument,
    baseOptions
  )
}
export type SalvarGrupoExameMutationHookResult = ReturnType<typeof useSalvarGrupoExameMutation>
export type SalvarGrupoExameMutationResult = ApolloReactCommon.MutationResult<Types.SalvarGrupoExameMutation>
export type SalvarGrupoExameMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.SalvarGrupoExameMutation,
  Types.SalvarGrupoExameMutationVariables
>
export const GrupoExameTableDocument = gql`
  query GrupoExameTable($input: GrupoExameQueryInput!) {
    gruposExame(input: $input) {
      content {
        id
        nome
        quantidadeProcedimentos
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${PageInfoFragmentDoc}
`

/**
 * __useGrupoExameTableQuery__
 *
 * To run a query within a React component, call `useGrupoExameTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGrupoExameTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGrupoExameTableQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGrupoExameTableQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.GrupoExameTableQuery, Types.GrupoExameTableQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.GrupoExameTableQuery, Types.GrupoExameTableQueryVariables>(
    GrupoExameTableDocument,
    baseOptions
  )
}
export function useGrupoExameTableLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GrupoExameTableQuery, Types.GrupoExameTableQueryVariables>
) {
  return ApolloReactHooks.useLazyQuery<Types.GrupoExameTableQuery, Types.GrupoExameTableQueryVariables>(
    GrupoExameTableDocument,
    baseOptions
  )
}
export type GrupoExameTableQueryHookResult = ReturnType<typeof useGrupoExameTableQuery>
export type GrupoExameTableLazyQueryHookResult = ReturnType<typeof useGrupoExameTableLazyQuery>
export type GrupoExameTableQueryResult = ApolloReactCommon.QueryResult<
  Types.GrupoExameTableQuery,
  Types.GrupoExameTableQueryVariables
>
export const SalvarConfiguracaoRndsDocument = gql`
  mutation SalvarConfiguracaoRnds($configuracaoRndsInput: ConfiguracaoRndsInput!) {
    salvarConfiguracaoRnds(configuracaoRndsInput: $configuracaoRndsInput) {
      id
      dataInclusao
      admMunicipal {
        profissional {
          nome
        }
      }
      dataHabilitacao
      dataValidadeCertificado
      error
    }
  }
`
export type SalvarConfiguracaoRndsMutationFn = ApolloReactCommon.MutationFunction<
  Types.SalvarConfiguracaoRndsMutation,
  Types.SalvarConfiguracaoRndsMutationVariables
>

/**
 * __useSalvarConfiguracaoRndsMutation__
 *
 * To run a mutation, you first call `useSalvarConfiguracaoRndsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvarConfiguracaoRndsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvarConfiguracaoRndsMutation, { data, loading, error }] = useSalvarConfiguracaoRndsMutation({
 *   variables: {
 *      configuracaoRndsInput: // value for 'configuracaoRndsInput'
 *   },
 * });
 */
export function useSalvarConfiguracaoRndsMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.SalvarConfiguracaoRndsMutation,
    Types.SalvarConfiguracaoRndsMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    Types.SalvarConfiguracaoRndsMutation,
    Types.SalvarConfiguracaoRndsMutationVariables
  >(SalvarConfiguracaoRndsDocument, baseOptions)
}
export type SalvarConfiguracaoRndsMutationHookResult = ReturnType<typeof useSalvarConfiguracaoRndsMutation>
export type SalvarConfiguracaoRndsMutationResult = ApolloReactCommon.MutationResult<
  Types.SalvarConfiguracaoRndsMutation
>
export type SalvarConfiguracaoRndsMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.SalvarConfiguracaoRndsMutation,
  Types.SalvarConfiguracaoRndsMutationVariables
>
export const ConfiguracaoRndsHabilitadoDocument = gql`
  query ConfiguracaoRndsHabilitado {
    configuracaoRndsHabilitado {
      id
      dataInclusao
      admMunicipal {
        profissional {
          nome
        }
      }
      dataHabilitacao
      dataValidadeCertificado
      error
    }
    conexao {
      internet {
        habilitado
      }
    }
  }
`

/**
 * __useConfiguracaoRndsHabilitadoQuery__
 *
 * To run a query within a React component, call `useConfiguracaoRndsHabilitadoQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfiguracaoRndsHabilitadoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfiguracaoRndsHabilitadoQuery({
 *   variables: {
 *   },
 * });
 */
export function useConfiguracaoRndsHabilitadoQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.ConfiguracaoRndsHabilitadoQuery,
    Types.ConfiguracaoRndsHabilitadoQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    Types.ConfiguracaoRndsHabilitadoQuery,
    Types.ConfiguracaoRndsHabilitadoQueryVariables
  >(ConfiguracaoRndsHabilitadoDocument, baseOptions)
}
export function useConfiguracaoRndsHabilitadoLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.ConfiguracaoRndsHabilitadoQuery,
    Types.ConfiguracaoRndsHabilitadoQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    Types.ConfiguracaoRndsHabilitadoQuery,
    Types.ConfiguracaoRndsHabilitadoQueryVariables
  >(ConfiguracaoRndsHabilitadoDocument, baseOptions)
}
export type ConfiguracaoRndsHabilitadoQueryHookResult = ReturnType<typeof useConfiguracaoRndsHabilitadoQuery>
export type ConfiguracaoRndsHabilitadoLazyQueryHookResult = ReturnType<typeof useConfiguracaoRndsHabilitadoLazyQuery>
export type ConfiguracaoRndsHabilitadoQueryResult = ApolloReactCommon.QueryResult<
  Types.ConfiguracaoRndsHabilitadoQuery,
  Types.ConfiguracaoRndsHabilitadoQueryVariables
>
export const ContraChaveAtivacaoMunicipioDocument = gql`
  query ContraChaveAtivacaoMunicipio {
    contraChaveAtivacaoMunicipio
  }
`

/**
 * __useContraChaveAtivacaoMunicipioQuery__
 *
 * To run a query within a React component, call `useContraChaveAtivacaoMunicipioQuery` and pass it any options that fit your needs.
 * When your component renders, `useContraChaveAtivacaoMunicipioQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContraChaveAtivacaoMunicipioQuery({
 *   variables: {
 *   },
 * });
 */
export function useContraChaveAtivacaoMunicipioQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.ContraChaveAtivacaoMunicipioQuery,
    Types.ContraChaveAtivacaoMunicipioQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    Types.ContraChaveAtivacaoMunicipioQuery,
    Types.ContraChaveAtivacaoMunicipioQueryVariables
  >(ContraChaveAtivacaoMunicipioDocument, baseOptions)
}
export function useContraChaveAtivacaoMunicipioLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.ContraChaveAtivacaoMunicipioQuery,
    Types.ContraChaveAtivacaoMunicipioQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    Types.ContraChaveAtivacaoMunicipioQuery,
    Types.ContraChaveAtivacaoMunicipioQueryVariables
  >(ContraChaveAtivacaoMunicipioDocument, baseOptions)
}
export type ContraChaveAtivacaoMunicipioQueryHookResult = ReturnType<typeof useContraChaveAtivacaoMunicipioQuery>
export type ContraChaveAtivacaoMunicipioLazyQueryHookResult = ReturnType<
  typeof useContraChaveAtivacaoMunicipioLazyQuery
>
export type ContraChaveAtivacaoMunicipioQueryResult = ApolloReactCommon.QueryResult<
  Types.ContraChaveAtivacaoMunicipioQuery,
  Types.ContraChaveAtivacaoMunicipioQueryVariables
>
export const ExcluirConfiguracaoRndsDocument = gql`
  mutation ExcluirConfiguracaoRnds($configuracaoRndsId: ID!) {
    excluirConfiguracaoRnds(configuracaoRndsId: $configuracaoRndsId)
  }
`
export type ExcluirConfiguracaoRndsMutationFn = ApolloReactCommon.MutationFunction<
  Types.ExcluirConfiguracaoRndsMutation,
  Types.ExcluirConfiguracaoRndsMutationVariables
>

/**
 * __useExcluirConfiguracaoRndsMutation__
 *
 * To run a mutation, you first call `useExcluirConfiguracaoRndsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExcluirConfiguracaoRndsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [excluirConfiguracaoRndsMutation, { data, loading, error }] = useExcluirConfiguracaoRndsMutation({
 *   variables: {
 *      configuracaoRndsId: // value for 'configuracaoRndsId'
 *   },
 * });
 */
export function useExcluirConfiguracaoRndsMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.ExcluirConfiguracaoRndsMutation,
    Types.ExcluirConfiguracaoRndsMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    Types.ExcluirConfiguracaoRndsMutation,
    Types.ExcluirConfiguracaoRndsMutationVariables
  >(ExcluirConfiguracaoRndsDocument, baseOptions)
}
export type ExcluirConfiguracaoRndsMutationHookResult = ReturnType<typeof useExcluirConfiguracaoRndsMutation>
export type ExcluirConfiguracaoRndsMutationResult = ApolloReactCommon.MutationResult<
  Types.ExcluirConfiguracaoRndsMutation
>
export type ExcluirConfiguracaoRndsMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.ExcluirConfiguracaoRndsMutation,
  Types.ExcluirConfiguracaoRndsMutationVariables
>
export const RndsCertificadoSelectDocument = gql`
  query RndsCertificadoSelect($input: RndsCertificadoQueryInput!) {
    rndsCertificados(input: $input) {
      content {
        path
        nome
      }
    }
  }
`

/**
 * __useRndsCertificadoSelectQuery__
 *
 * To run a query within a React component, call `useRndsCertificadoSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useRndsCertificadoSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRndsCertificadoSelectQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRndsCertificadoSelectQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.RndsCertificadoSelectQuery,
    Types.RndsCertificadoSelectQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<Types.RndsCertificadoSelectQuery, Types.RndsCertificadoSelectQueryVariables>(
    RndsCertificadoSelectDocument,
    baseOptions
  )
}
export function useRndsCertificadoSelectLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.RndsCertificadoSelectQuery,
    Types.RndsCertificadoSelectQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<Types.RndsCertificadoSelectQuery, Types.RndsCertificadoSelectQueryVariables>(
    RndsCertificadoSelectDocument,
    baseOptions
  )
}
export type RndsCertificadoSelectQueryHookResult = ReturnType<typeof useRndsCertificadoSelectQuery>
export type RndsCertificadoSelectLazyQueryHookResult = ReturnType<typeof useRndsCertificadoSelectLazyQuery>
export type RndsCertificadoSelectQueryResult = ApolloReactCommon.QueryResult<
  Types.RndsCertificadoSelectQuery,
  Types.RndsCertificadoSelectQueryVariables
>
export const TipoServicoCheckDocument = gql`
  query TipoServicoCheck($input: TipoServicoQueryInput!) {
    tiposServico(input: $input) {
      content {
        id
        nome
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${PageInfoFragmentDoc}
`

/**
 * __useTipoServicoCheckQuery__
 *
 * To run a query within a React component, call `useTipoServicoCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useTipoServicoCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTipoServicoCheckQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTipoServicoCheckQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.TipoServicoCheckQuery, Types.TipoServicoCheckQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.TipoServicoCheckQuery, Types.TipoServicoCheckQueryVariables>(
    TipoServicoCheckDocument,
    baseOptions
  )
}
export function useTipoServicoCheckLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.TipoServicoCheckQuery, Types.TipoServicoCheckQueryVariables>
) {
  return ApolloReactHooks.useLazyQuery<Types.TipoServicoCheckQuery, Types.TipoServicoCheckQueryVariables>(
    TipoServicoCheckDocument,
    baseOptions
  )
}
export type TipoServicoCheckQueryHookResult = ReturnType<typeof useTipoServicoCheckQuery>
export type TipoServicoCheckLazyQueryHookResult = ReturnType<typeof useTipoServicoCheckLazyQuery>
export type TipoServicoCheckQueryResult = ApolloReactCommon.QueryResult<
  Types.TipoServicoCheckQuery,
  Types.TipoServicoCheckQueryVariables
>
export const TipoServicoTableDocument = gql`
  query TipoServicoTable($input: TipoServicoQueryInput!) {
    tiposServico(input: $input) {
      content {
        id
        nome
        municipio {
          id
        }
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${PageInfoFragmentDoc}
`

/**
 * __useTipoServicoTableQuery__
 *
 * To run a query within a React component, call `useTipoServicoTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useTipoServicoTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTipoServicoTableQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTipoServicoTableQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.TipoServicoTableQuery, Types.TipoServicoTableQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.TipoServicoTableQuery, Types.TipoServicoTableQueryVariables>(
    TipoServicoTableDocument,
    baseOptions
  )
}
export function useTipoServicoTableLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.TipoServicoTableQuery, Types.TipoServicoTableQueryVariables>
) {
  return ApolloReactHooks.useLazyQuery<Types.TipoServicoTableQuery, Types.TipoServicoTableQueryVariables>(
    TipoServicoTableDocument,
    baseOptions
  )
}
export type TipoServicoTableQueryHookResult = ReturnType<typeof useTipoServicoTableQuery>
export type TipoServicoTableLazyQueryHookResult = ReturnType<typeof useTipoServicoTableLazyQuery>
export type TipoServicoTableQueryResult = ApolloReactCommon.QueryResult<
  Types.TipoServicoTableQuery,
  Types.TipoServicoTableQueryVariables
>
export const AlterarTipoServicoDocument = gql`
  mutation AlterarTipoServico($input: TipoServicoUpdateInput!) {
    alterarTipoServico(input: $input) {
      id
      nome
    }
  }
`
export type AlterarTipoServicoMutationFn = ApolloReactCommon.MutationFunction<
  Types.AlterarTipoServicoMutation,
  Types.AlterarTipoServicoMutationVariables
>

/**
 * __useAlterarTipoServicoMutation__
 *
 * To run a mutation, you first call `useAlterarTipoServicoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlterarTipoServicoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alterarTipoServicoMutation, { data, loading, error }] = useAlterarTipoServicoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAlterarTipoServicoMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.AlterarTipoServicoMutation,
    Types.AlterarTipoServicoMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<Types.AlterarTipoServicoMutation, Types.AlterarTipoServicoMutationVariables>(
    AlterarTipoServicoDocument,
    baseOptions
  )
}
export type AlterarTipoServicoMutationHookResult = ReturnType<typeof useAlterarTipoServicoMutation>
export type AlterarTipoServicoMutationResult = ApolloReactCommon.MutationResult<Types.AlterarTipoServicoMutation>
export type AlterarTipoServicoMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.AlterarTipoServicoMutation,
  Types.AlterarTipoServicoMutationVariables
>
export const SalvarTipoServicoDocument = gql`
  mutation SalvarTipoServico($input: TipoServicoInput!) {
    salvarTipoServico(input: $input) {
      id
      nome
    }
  }
`
export type SalvarTipoServicoMutationFn = ApolloReactCommon.MutationFunction<
  Types.SalvarTipoServicoMutation,
  Types.SalvarTipoServicoMutationVariables
>

/**
 * __useSalvarTipoServicoMutation__
 *
 * To run a mutation, you first call `useSalvarTipoServicoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvarTipoServicoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvarTipoServicoMutation, { data, loading, error }] = useSalvarTipoServicoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSalvarTipoServicoMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.SalvarTipoServicoMutation,
    Types.SalvarTipoServicoMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<Types.SalvarTipoServicoMutation, Types.SalvarTipoServicoMutationVariables>(
    SalvarTipoServicoDocument,
    baseOptions
  )
}
export type SalvarTipoServicoMutationHookResult = ReturnType<typeof useSalvarTipoServicoMutation>
export type SalvarTipoServicoMutationResult = ApolloReactCommon.MutationResult<Types.SalvarTipoServicoMutation>
export type SalvarTipoServicoMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.SalvarTipoServicoMutation,
  Types.SalvarTipoServicoMutationVariables
>
export const ExcluirTipoServicoDocument = gql`
  mutation ExcluirTipoServico($id: ID!) {
    excluirTipoServico(id: $id)
  }
`
export type ExcluirTipoServicoMutationFn = ApolloReactCommon.MutationFunction<
  Types.ExcluirTipoServicoMutation,
  Types.ExcluirTipoServicoMutationVariables
>

/**
 * __useExcluirTipoServicoMutation__
 *
 * To run a mutation, you first call `useExcluirTipoServicoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExcluirTipoServicoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [excluirTipoServicoMutation, { data, loading, error }] = useExcluirTipoServicoMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExcluirTipoServicoMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.ExcluirTipoServicoMutation,
    Types.ExcluirTipoServicoMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<Types.ExcluirTipoServicoMutation, Types.ExcluirTipoServicoMutationVariables>(
    ExcluirTipoServicoDocument,
    baseOptions
  )
}
export type ExcluirTipoServicoMutationHookResult = ReturnType<typeof useExcluirTipoServicoMutation>
export type ExcluirTipoServicoMutationResult = ApolloReactCommon.MutationResult<Types.ExcluirTipoServicoMutation>
export type ExcluirTipoServicoMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.ExcluirTipoServicoMutation,
  Types.ExcluirTipoServicoMutationVariables
>
export const EquipeDetailDocument = gql`
  query EquipeDetail($id: ID!) {
    equipe(id: $id) {
      id
      nome
      ine
      area
      ativo
      tipoEquipe {
        nome
        sigla
      }
    }
  }
`

/**
 * __useEquipeDetailQuery__
 *
 * To run a query within a React component, call `useEquipeDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useEquipeDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEquipeDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEquipeDetailQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.EquipeDetailQuery, Types.EquipeDetailQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.EquipeDetailQuery, Types.EquipeDetailQueryVariables>(
    EquipeDetailDocument,
    baseOptions
  )
}
export function useEquipeDetailLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.EquipeDetailQuery, Types.EquipeDetailQueryVariables>
) {
  return ApolloReactHooks.useLazyQuery<Types.EquipeDetailQuery, Types.EquipeDetailQueryVariables>(
    EquipeDetailDocument,
    baseOptions
  )
}
export type EquipeDetailQueryHookResult = ReturnType<typeof useEquipeDetailQuery>
export type EquipeDetailLazyQueryHookResult = ReturnType<typeof useEquipeDetailLazyQuery>
export type EquipeDetailQueryResult = ApolloReactCommon.QueryResult<
  Types.EquipeDetailQuery,
  Types.EquipeDetailQueryVariables
>
export const EquipeTableDocument = gql`
  query EquipeTable($unidadeSaudeId: ID!, $input: EquipesConnectionInput!) {
    unidadeSaude(id: $unidadeSaudeId) {
      id
      equipes(input: $input) {
        content {
          id
          nome
          ine
          area
          tipoEquipe {
            nome
            sigla
          }
          ativo
        }
        pageInfo {
          first
          number
          size
          sort
          totalPages
          totalElements
          first
          last
          numberOfElements
        }
      }
    }
  }
`

/**
 * __useEquipeTableQuery__
 *
 * To run a query within a React component, call `useEquipeTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useEquipeTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEquipeTableQuery({
 *   variables: {
 *      unidadeSaudeId: // value for 'unidadeSaudeId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEquipeTableQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.EquipeTableQuery, Types.EquipeTableQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.EquipeTableQuery, Types.EquipeTableQueryVariables>(
    EquipeTableDocument,
    baseOptions
  )
}
export function useEquipeTableLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.EquipeTableQuery, Types.EquipeTableQueryVariables>
) {
  return ApolloReactHooks.useLazyQuery<Types.EquipeTableQuery, Types.EquipeTableQueryVariables>(
    EquipeTableDocument,
    baseOptions
  )
}
export type EquipeTableQueryHookResult = ReturnType<typeof useEquipeTableQuery>
export type EquipeTableLazyQueryHookResult = ReturnType<typeof useEquipeTableLazyQuery>
export type EquipeTableQueryResult = ApolloReactCommon.QueryResult<
  Types.EquipeTableQuery,
  Types.EquipeTableQueryVariables
>
export const AlterarUnidadePadraoHorusDocument = gql`
  mutation AlterarUnidadePadraoHorus($input: UnidadeConsultaHorusIds!) {
    alterarUnidadePadraoHorus(input: $input) {
      id
      nome
    }
  }
`
export type AlterarUnidadePadraoHorusMutationFn = ApolloReactCommon.MutationFunction<
  Types.AlterarUnidadePadraoHorusMutation,
  Types.AlterarUnidadePadraoHorusMutationVariables
>

/**
 * __useAlterarUnidadePadraoHorusMutation__
 *
 * To run a mutation, you first call `useAlterarUnidadePadraoHorusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlterarUnidadePadraoHorusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alterarUnidadePadraoHorusMutation, { data, loading, error }] = useAlterarUnidadePadraoHorusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAlterarUnidadePadraoHorusMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.AlterarUnidadePadraoHorusMutation,
    Types.AlterarUnidadePadraoHorusMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    Types.AlterarUnidadePadraoHorusMutation,
    Types.AlterarUnidadePadraoHorusMutationVariables
  >(AlterarUnidadePadraoHorusDocument, baseOptions)
}
export type AlterarUnidadePadraoHorusMutationHookResult = ReturnType<typeof useAlterarUnidadePadraoHorusMutation>
export type AlterarUnidadePadraoHorusMutationResult = ApolloReactCommon.MutationResult<
  Types.AlterarUnidadePadraoHorusMutation
>
export type AlterarUnidadePadraoHorusMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.AlterarUnidadePadraoHorusMutation,
  Types.AlterarUnidadePadraoHorusMutationVariables
>
export const CadastroUnidadeConsultaHorusDocument = gql`
  mutation CadastroUnidadeConsultaHorus($input: UnidadeConsultaHorusIds!) {
    adicionarUnidadeConsultaHorus(input: $input) {
      id
      nome
    }
  }
`
export type CadastroUnidadeConsultaHorusMutationFn = ApolloReactCommon.MutationFunction<
  Types.CadastroUnidadeConsultaHorusMutation,
  Types.CadastroUnidadeConsultaHorusMutationVariables
>

/**
 * __useCadastroUnidadeConsultaHorusMutation__
 *
 * To run a mutation, you first call `useCadastroUnidadeConsultaHorusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCadastroUnidadeConsultaHorusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cadastroUnidadeConsultaHorusMutation, { data, loading, error }] = useCadastroUnidadeConsultaHorusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCadastroUnidadeConsultaHorusMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.CadastroUnidadeConsultaHorusMutation,
    Types.CadastroUnidadeConsultaHorusMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    Types.CadastroUnidadeConsultaHorusMutation,
    Types.CadastroUnidadeConsultaHorusMutationVariables
  >(CadastroUnidadeConsultaHorusDocument, baseOptions)
}
export type CadastroUnidadeConsultaHorusMutationHookResult = ReturnType<typeof useCadastroUnidadeConsultaHorusMutation>
export type CadastroUnidadeConsultaHorusMutationResult = ApolloReactCommon.MutationResult<
  Types.CadastroUnidadeConsultaHorusMutation
>
export type CadastroUnidadeConsultaHorusMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.CadastroUnidadeConsultaHorusMutation,
  Types.CadastroUnidadeConsultaHorusMutationVariables
>
export const HorusListViewDocument = gql`
  query HorusListView($unidadeSaudeId: ID!) {
    unidadesConsultaHorus(id: $unidadeSaudeId) {
      unidadeSaude {
        id
        nome
        cnes
      }
      unidadePadrao
    }
    unidadeSaude(id: $unidadeSaudeId) {
      id
      actions {
        permissaoConexaoHorus {
          enabled
          hint
        }
      }
    }
    conexao {
      horus {
        id
        habilitado
      }
    }
  }
`

/**
 * __useHorusListViewQuery__
 *
 * To run a query within a React component, call `useHorusListViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useHorusListViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHorusListViewQuery({
 *   variables: {
 *      unidadeSaudeId: // value for 'unidadeSaudeId'
 *   },
 * });
 */
export function useHorusListViewQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.HorusListViewQuery, Types.HorusListViewQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.HorusListViewQuery, Types.HorusListViewQueryVariables>(
    HorusListViewDocument,
    baseOptions
  )
}
export function useHorusListViewLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.HorusListViewQuery, Types.HorusListViewQueryVariables>
) {
  return ApolloReactHooks.useLazyQuery<Types.HorusListViewQuery, Types.HorusListViewQueryVariables>(
    HorusListViewDocument,
    baseOptions
  )
}
export type HorusListViewQueryHookResult = ReturnType<typeof useHorusListViewQuery>
export type HorusListViewLazyQueryHookResult = ReturnType<typeof useHorusListViewLazyQuery>
export type HorusListViewQueryResult = ApolloReactCommon.QueryResult<
  Types.HorusListViewQuery,
  Types.HorusListViewQueryVariables
>
export const RemoverUnidadeConsultaHorusDocument = gql`
  mutation RemoverUnidadeConsultaHorus($input: UnidadeConsultaHorusIds!) {
    removerUnidadeConsultaHorus(input: $input) {
      id
      nome
    }
  }
`
export type RemoverUnidadeConsultaHorusMutationFn = ApolloReactCommon.MutationFunction<
  Types.RemoverUnidadeConsultaHorusMutation,
  Types.RemoverUnidadeConsultaHorusMutationVariables
>

/**
 * __useRemoverUnidadeConsultaHorusMutation__
 *
 * To run a mutation, you first call `useRemoverUnidadeConsultaHorusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoverUnidadeConsultaHorusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removerUnidadeConsultaHorusMutation, { data, loading, error }] = useRemoverUnidadeConsultaHorusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoverUnidadeConsultaHorusMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.RemoverUnidadeConsultaHorusMutation,
    Types.RemoverUnidadeConsultaHorusMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    Types.RemoverUnidadeConsultaHorusMutation,
    Types.RemoverUnidadeConsultaHorusMutationVariables
  >(RemoverUnidadeConsultaHorusDocument, baseOptions)
}
export type RemoverUnidadeConsultaHorusMutationHookResult = ReturnType<typeof useRemoverUnidadeConsultaHorusMutation>
export type RemoverUnidadeConsultaHorusMutationResult = ApolloReactCommon.MutationResult<
  Types.RemoverUnidadeConsultaHorusMutation
>
export type RemoverUnidadeConsultaHorusMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.RemoverUnidadeConsultaHorusMutation,
  Types.RemoverUnidadeConsultaHorusMutationVariables
>
export const InstalarDocument = gql`
  mutation Instalar($input: InstalacaoInput!) {
    instalar(input: $input)
  }
`
export type InstalarMutationFn = ApolloReactCommon.MutationFunction<
  Types.InstalarMutation,
  Types.InstalarMutationVariables
>

/**
 * __useInstalarMutation__
 *
 * To run a mutation, you first call `useInstalarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInstalarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [instalarMutation, { data, loading, error }] = useInstalarMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInstalarMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<Types.InstalarMutation, Types.InstalarMutationVariables>
) {
  return ApolloReactHooks.useMutation<Types.InstalarMutation, Types.InstalarMutationVariables>(
    InstalarDocument,
    baseOptions
  )
}
export type InstalarMutationHookResult = ReturnType<typeof useInstalarMutation>
export type InstalarMutationResult = ApolloReactCommon.MutationResult<Types.InstalarMutation>
export type InstalarMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.InstalarMutation,
  Types.InstalarMutationVariables
>
export const LoginDocument = gql`
  mutation Login($input: LoginInput!) {
    login(input: $input) {
      success
    }
  }
`
export type LoginMutationFn = ApolloReactCommon.MutationFunction<Types.LoginMutation, Types.LoginMutationVariables>

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<Types.LoginMutation, Types.LoginMutationVariables>
) {
  return ApolloReactHooks.useMutation<Types.LoginMutation, Types.LoginMutationVariables>(LoginDocument, baseOptions)
}
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>
export type LoginMutationResult = ApolloReactCommon.MutationResult<Types.LoginMutation>
export type LoginMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.LoginMutation,
  Types.LoginMutationVariables
>
export const SelecionarAcessoDocument = gql`
  mutation SelecionarAcesso($input: SelecionarAcessoInput!) {
    selecionarAcesso(input: $input) {
      id
      profissional {
        id
        nome
      }
      acesso {
        id
        moduloInicial
      }
      recursos
    }
  }
`
export type SelecionarAcessoMutationFn = ApolloReactCommon.MutationFunction<
  Types.SelecionarAcessoMutation,
  Types.SelecionarAcessoMutationVariables
>

/**
 * __useSelecionarAcessoMutation__
 *
 * To run a mutation, you first call `useSelecionarAcessoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelecionarAcessoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selecionarAcessoMutation, { data, loading, error }] = useSelecionarAcessoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSelecionarAcessoMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.SelecionarAcessoMutation,
    Types.SelecionarAcessoMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<Types.SelecionarAcessoMutation, Types.SelecionarAcessoMutationVariables>(
    SelecionarAcessoDocument,
    baseOptions
  )
}
export type SelecionarAcessoMutationHookResult = ReturnType<typeof useSelecionarAcessoMutation>
export type SelecionarAcessoMutationResult = ApolloReactCommon.MutationResult<Types.SelecionarAcessoMutation>
export type SelecionarAcessoMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.SelecionarAcessoMutation,
  Types.SelecionarAcessoMutationVariables
>
export const ImunobiologicoComboDocument = gql`
  query ImunobiologicoCombo($input: ImunobiologicoQueryInput!) {
    imunobiologicos(input: $input) {
      content {
        id
        sigla
        nome
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${PageInfoFragmentDoc}
`

/**
 * __useImunobiologicoComboQuery__
 *
 * To run a query within a React component, call `useImunobiologicoComboQuery` and pass it any options that fit your needs.
 * When your component renders, `useImunobiologicoComboQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImunobiologicoComboQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImunobiologicoComboQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.ImunobiologicoComboQuery,
    Types.ImunobiologicoComboQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<Types.ImunobiologicoComboQuery, Types.ImunobiologicoComboQueryVariables>(
    ImunobiologicoComboDocument,
    baseOptions
  )
}
export function useImunobiologicoComboLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.ImunobiologicoComboQuery,
    Types.ImunobiologicoComboQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<Types.ImunobiologicoComboQuery, Types.ImunobiologicoComboQueryVariables>(
    ImunobiologicoComboDocument,
    baseOptions
  )
}
export type ImunobiologicoComboQueryHookResult = ReturnType<typeof useImunobiologicoComboQuery>
export type ImunobiologicoComboLazyQueryHookResult = ReturnType<typeof useImunobiologicoComboLazyQuery>
export type ImunobiologicoComboQueryResult = ApolloReactCommon.QueryResult<
  Types.ImunobiologicoComboQuery,
  Types.ImunobiologicoComboQueryVariables
>
export const ExcluirLoteImunobiologicoDocument = gql`
  mutation excluirLoteImunobiologico($idLote: ID!) {
    excluirLoteImunobiologico(idLote: $idLote)
  }
`
export type ExcluirLoteImunobiologicoMutationFn = ApolloReactCommon.MutationFunction<
  Types.ExcluirLoteImunobiologicoMutation,
  Types.ExcluirLoteImunobiologicoMutationVariables
>

/**
 * __useExcluirLoteImunobiologicoMutation__
 *
 * To run a mutation, you first call `useExcluirLoteImunobiologicoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExcluirLoteImunobiologicoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [excluirLoteImunobiologicoMutation, { data, loading, error }] = useExcluirLoteImunobiologicoMutation({
 *   variables: {
 *      idLote: // value for 'idLote'
 *   },
 * });
 */
export function useExcluirLoteImunobiologicoMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.ExcluirLoteImunobiologicoMutation,
    Types.ExcluirLoteImunobiologicoMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    Types.ExcluirLoteImunobiologicoMutation,
    Types.ExcluirLoteImunobiologicoMutationVariables
  >(ExcluirLoteImunobiologicoDocument, baseOptions)
}
export type ExcluirLoteImunobiologicoMutationHookResult = ReturnType<typeof useExcluirLoteImunobiologicoMutation>
export type ExcluirLoteImunobiologicoMutationResult = ApolloReactCommon.MutationResult<
  Types.ExcluirLoteImunobiologicoMutation
>
export type ExcluirLoteImunobiologicoMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.ExcluirLoteImunobiologicoMutation,
  Types.ExcluirLoteImunobiologicoMutationVariables
>
export const LoteImunobiologicoFabricanteDocument = gql`
  query LoteImunobiologicoFabricante($input: ImunobiologicoFabricanteQueryInput!) {
    fabricantesImunobiologico(input: $input) {
      content {
        id
        nome
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${PageInfoFragmentDoc}
`

/**
 * __useLoteImunobiologicoFabricanteQuery__
 *
 * To run a query within a React component, call `useLoteImunobiologicoFabricanteQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoteImunobiologicoFabricanteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoteImunobiologicoFabricanteQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoteImunobiologicoFabricanteQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.LoteImunobiologicoFabricanteQuery,
    Types.LoteImunobiologicoFabricanteQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    Types.LoteImunobiologicoFabricanteQuery,
    Types.LoteImunobiologicoFabricanteQueryVariables
  >(LoteImunobiologicoFabricanteDocument, baseOptions)
}
export function useLoteImunobiologicoFabricanteLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.LoteImunobiologicoFabricanteQuery,
    Types.LoteImunobiologicoFabricanteQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    Types.LoteImunobiologicoFabricanteQuery,
    Types.LoteImunobiologicoFabricanteQueryVariables
  >(LoteImunobiologicoFabricanteDocument, baseOptions)
}
export type LoteImunobiologicoFabricanteQueryHookResult = ReturnType<typeof useLoteImunobiologicoFabricanteQuery>
export type LoteImunobiologicoFabricanteLazyQueryHookResult = ReturnType<
  typeof useLoteImunobiologicoFabricanteLazyQuery
>
export type LoteImunobiologicoFabricanteQueryResult = ApolloReactCommon.QueryResult<
  Types.LoteImunobiologicoFabricanteQuery,
  Types.LoteImunobiologicoFabricanteQueryVariables
>
export const LoteImunobiologicoDocument = gql`
  query LoteImunobiologico($input: LoteImunobiologicoQueryInput!) {
    lotesImunobiologico(input: $input) {
      content {
        id
        lote
        fabricante {
          id
          nome
        }
        imunobiologico {
          id
          nome
          sigla
        }
        validade
        ativo
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${PageInfoFragmentDoc}
`

/**
 * __useLoteImunobiologicoQuery__
 *
 * To run a query within a React component, call `useLoteImunobiologicoQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoteImunobiologicoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoteImunobiologicoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoteImunobiologicoQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.LoteImunobiologicoQuery, Types.LoteImunobiologicoQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.LoteImunobiologicoQuery, Types.LoteImunobiologicoQueryVariables>(
    LoteImunobiologicoDocument,
    baseOptions
  )
}
export function useLoteImunobiologicoLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.LoteImunobiologicoQuery,
    Types.LoteImunobiologicoQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<Types.LoteImunobiologicoQuery, Types.LoteImunobiologicoQueryVariables>(
    LoteImunobiologicoDocument,
    baseOptions
  )
}
export type LoteImunobiologicoQueryHookResult = ReturnType<typeof useLoteImunobiologicoQuery>
export type LoteImunobiologicoLazyQueryHookResult = ReturnType<typeof useLoteImunobiologicoLazyQuery>
export type LoteImunobiologicoQueryResult = ApolloReactCommon.QueryResult<
  Types.LoteImunobiologicoQuery,
  Types.LoteImunobiologicoQueryVariables
>
export const SetAtivadoLoteImunobiologicoDocument = gql`
  mutation setAtivadoLoteImunobiologico($input: LoteImunobiologicoInput!, $ativado: Boolean) {
    setAtivadoLoteImunobiologico(input: $input, ativado: $ativado)
  }
`
export type SetAtivadoLoteImunobiologicoMutationFn = ApolloReactCommon.MutationFunction<
  Types.SetAtivadoLoteImunobiologicoMutation,
  Types.SetAtivadoLoteImunobiologicoMutationVariables
>

/**
 * __useSetAtivadoLoteImunobiologicoMutation__
 *
 * To run a mutation, you first call `useSetAtivadoLoteImunobiologicoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAtivadoLoteImunobiologicoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAtivadoLoteImunobiologicoMutation, { data, loading, error }] = useSetAtivadoLoteImunobiologicoMutation({
 *   variables: {
 *      input: // value for 'input'
 *      ativado: // value for 'ativado'
 *   },
 * });
 */
export function useSetAtivadoLoteImunobiologicoMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.SetAtivadoLoteImunobiologicoMutation,
    Types.SetAtivadoLoteImunobiologicoMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    Types.SetAtivadoLoteImunobiologicoMutation,
    Types.SetAtivadoLoteImunobiologicoMutationVariables
  >(SetAtivadoLoteImunobiologicoDocument, baseOptions)
}
export type SetAtivadoLoteImunobiologicoMutationHookResult = ReturnType<typeof useSetAtivadoLoteImunobiologicoMutation>
export type SetAtivadoLoteImunobiologicoMutationResult = ApolloReactCommon.MutationResult<
  Types.SetAtivadoLoteImunobiologicoMutation
>
export type SetAtivadoLoteImunobiologicoMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.SetAtivadoLoteImunobiologicoMutation,
  Types.SetAtivadoLoteImunobiologicoMutationVariables
>
export const SalvarLoteImunobiologicoDocument = gql`
  mutation SalvarLoteImunobiologico($input: LoteImunobiologicoInput!) {
    salvarLoteImunobiologico(input: $input) {
      id
    }
  }
`
export type SalvarLoteImunobiologicoMutationFn = ApolloReactCommon.MutationFunction<
  Types.SalvarLoteImunobiologicoMutation,
  Types.SalvarLoteImunobiologicoMutationVariables
>

/**
 * __useSalvarLoteImunobiologicoMutation__
 *
 * To run a mutation, you first call `useSalvarLoteImunobiologicoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvarLoteImunobiologicoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvarLoteImunobiologicoMutation, { data, loading, error }] = useSalvarLoteImunobiologicoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSalvarLoteImunobiologicoMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.SalvarLoteImunobiologicoMutation,
    Types.SalvarLoteImunobiologicoMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    Types.SalvarLoteImunobiologicoMutation,
    Types.SalvarLoteImunobiologicoMutationVariables
  >(SalvarLoteImunobiologicoDocument, baseOptions)
}
export type SalvarLoteImunobiologicoMutationHookResult = ReturnType<typeof useSalvarLoteImunobiologicoMutation>
export type SalvarLoteImunobiologicoMutationResult = ApolloReactCommon.MutationResult<
  Types.SalvarLoteImunobiologicoMutation
>
export type SalvarLoteImunobiologicoMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.SalvarLoteImunobiologicoMutation,
  Types.SalvarLoteImunobiologicoMutationVariables
>
export const VisualizouNovidadesDocument = gql`
  mutation VisualizouNovidades {
    visualizarNovidades
  }
`
export type VisualizouNovidadesMutationFn = ApolloReactCommon.MutationFunction<
  Types.VisualizouNovidadesMutation,
  Types.VisualizouNovidadesMutationVariables
>

/**
 * __useVisualizouNovidadesMutation__
 *
 * To run a mutation, you first call `useVisualizouNovidadesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVisualizouNovidadesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [visualizouNovidadesMutation, { data, loading, error }] = useVisualizouNovidadesMutation({
 *   variables: {
 *   },
 * });
 */
export function useVisualizouNovidadesMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.VisualizouNovidadesMutation,
    Types.VisualizouNovidadesMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<Types.VisualizouNovidadesMutation, Types.VisualizouNovidadesMutationVariables>(
    VisualizouNovidadesDocument,
    baseOptions
  )
}
export type VisualizouNovidadesMutationHookResult = ReturnType<typeof useVisualizouNovidadesMutation>
export type VisualizouNovidadesMutationResult = ApolloReactCommon.MutationResult<Types.VisualizouNovidadesMutation>
export type VisualizouNovidadesMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.VisualizouNovidadesMutation,
  Types.VisualizouNovidadesMutationVariables
>
export const VisualizarNovidadesDocument = gql`
  query VisualizarNovidades {
    sessao {
      id
      profissional {
        id
        usuario {
          id
          visualizouNovidades
        }
      }
    }
  }
`

/**
 * __useVisualizarNovidadesQuery__
 *
 * To run a query within a React component, call `useVisualizarNovidadesQuery` and pass it any options that fit your needs.
 * When your component renders, `useVisualizarNovidadesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVisualizarNovidadesQuery({
 *   variables: {
 *   },
 * });
 */
export function useVisualizarNovidadesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.VisualizarNovidadesQuery,
    Types.VisualizarNovidadesQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<Types.VisualizarNovidadesQuery, Types.VisualizarNovidadesQueryVariables>(
    VisualizarNovidadesDocument,
    baseOptions
  )
}
export function useVisualizarNovidadesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.VisualizarNovidadesQuery,
    Types.VisualizarNovidadesQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<Types.VisualizarNovidadesQuery, Types.VisualizarNovidadesQueryVariables>(
    VisualizarNovidadesDocument,
    baseOptions
  )
}
export type VisualizarNovidadesQueryHookResult = ReturnType<typeof useVisualizarNovidadesQuery>
export type VisualizarNovidadesLazyQueryHookResult = ReturnType<typeof useVisualizarNovidadesLazyQuery>
export type VisualizarNovidadesQueryResult = ApolloReactCommon.QueryResult<
  Types.VisualizarNovidadesQuery,
  Types.VisualizarNovidadesQueryVariables
>
export const AtivarPerfilDocument = gql`
  mutation AtivarPerfil($id: ID!) {
    ativarPerfil(id: $id) {
      id
      ativo
    }
  }
`
export type AtivarPerfilMutationFn = ApolloReactCommon.MutationFunction<
  Types.AtivarPerfilMutation,
  Types.AtivarPerfilMutationVariables
>

/**
 * __useAtivarPerfilMutation__
 *
 * To run a mutation, you first call `useAtivarPerfilMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAtivarPerfilMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ativarPerfilMutation, { data, loading, error }] = useAtivarPerfilMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAtivarPerfilMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AtivarPerfilMutation, Types.AtivarPerfilMutationVariables>
) {
  return ApolloReactHooks.useMutation<Types.AtivarPerfilMutation, Types.AtivarPerfilMutationVariables>(
    AtivarPerfilDocument,
    baseOptions
  )
}
export type AtivarPerfilMutationHookResult = ReturnType<typeof useAtivarPerfilMutation>
export type AtivarPerfilMutationResult = ApolloReactCommon.MutationResult<Types.AtivarPerfilMutation>
export type AtivarPerfilMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.AtivarPerfilMutation,
  Types.AtivarPerfilMutationVariables
>
export const CriarPerfilDocument = gql`
  mutation CriarPerfil($input: PerfilInput!) {
    criarPerfil(input: $input) {
      id
      nome
      ativo
    }
  }
`
export type CriarPerfilMutationFn = ApolloReactCommon.MutationFunction<
  Types.CriarPerfilMutation,
  Types.CriarPerfilMutationVariables
>

/**
 * __useCriarPerfilMutation__
 *
 * To run a mutation, you first call `useCriarPerfilMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCriarPerfilMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [criarPerfilMutation, { data, loading, error }] = useCriarPerfilMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCriarPerfilMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<Types.CriarPerfilMutation, Types.CriarPerfilMutationVariables>
) {
  return ApolloReactHooks.useMutation<Types.CriarPerfilMutation, Types.CriarPerfilMutationVariables>(
    CriarPerfilDocument,
    baseOptions
  )
}
export type CriarPerfilMutationHookResult = ReturnType<typeof useCriarPerfilMutation>
export type CriarPerfilMutationResult = ApolloReactCommon.MutationResult<Types.CriarPerfilMutation>
export type CriarPerfilMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.CriarPerfilMutation,
  Types.CriarPerfilMutationVariables
>
export const ExcluirPerfilDocument = gql`
  mutation ExcluirPerfil($id: ID!) {
    excluirPerfil(id: $id) {
      id
    }
  }
`
export type ExcluirPerfilMutationFn = ApolloReactCommon.MutationFunction<
  Types.ExcluirPerfilMutation,
  Types.ExcluirPerfilMutationVariables
>

/**
 * __useExcluirPerfilMutation__
 *
 * To run a mutation, you first call `useExcluirPerfilMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExcluirPerfilMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [excluirPerfilMutation, { data, loading, error }] = useExcluirPerfilMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExcluirPerfilMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ExcluirPerfilMutation, Types.ExcluirPerfilMutationVariables>
) {
  return ApolloReactHooks.useMutation<Types.ExcluirPerfilMutation, Types.ExcluirPerfilMutationVariables>(
    ExcluirPerfilDocument,
    baseOptions
  )
}
export type ExcluirPerfilMutationHookResult = ReturnType<typeof useExcluirPerfilMutation>
export type ExcluirPerfilMutationResult = ApolloReactCommon.MutationResult<Types.ExcluirPerfilMutation>
export type ExcluirPerfilMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.ExcluirPerfilMutation,
  Types.ExcluirPerfilMutationVariables
>
export const InativarPerfilDocument = gql`
  mutation InativarPerfil($id: ID!) {
    inativarPerfil(id: $id) {
      id
      ativo
    }
  }
`
export type InativarPerfilMutationFn = ApolloReactCommon.MutationFunction<
  Types.InativarPerfilMutation,
  Types.InativarPerfilMutationVariables
>

/**
 * __useInativarPerfilMutation__
 *
 * To run a mutation, you first call `useInativarPerfilMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInativarPerfilMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inativarPerfilMutation, { data, loading, error }] = useInativarPerfilMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInativarPerfilMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.InativarPerfilMutation,
    Types.InativarPerfilMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<Types.InativarPerfilMutation, Types.InativarPerfilMutationVariables>(
    InativarPerfilDocument,
    baseOptions
  )
}
export type InativarPerfilMutationHookResult = ReturnType<typeof useInativarPerfilMutation>
export type InativarPerfilMutationResult = ApolloReactCommon.MutationResult<Types.InativarPerfilMutation>
export type InativarPerfilMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.InativarPerfilMutation,
  Types.InativarPerfilMutationVariables
>
export const RecursosDocument = gql`
  query Recursos($tipoAcesso: TipoAcesso!) {
    recursos(tipoAcesso: $tipoAcesso)
  }
`

/**
 * __useRecursosQuery__
 *
 * To run a query within a React component, call `useRecursosQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecursosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecursosQuery({
 *   variables: {
 *      tipoAcesso: // value for 'tipoAcesso'
 *   },
 * });
 */
export function useRecursosQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.RecursosQuery, Types.RecursosQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.RecursosQuery, Types.RecursosQueryVariables>(RecursosDocument, baseOptions)
}
export function useRecursosLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.RecursosQuery, Types.RecursosQueryVariables>
) {
  return ApolloReactHooks.useLazyQuery<Types.RecursosQuery, Types.RecursosQueryVariables>(RecursosDocument, baseOptions)
}
export type RecursosQueryHookResult = ReturnType<typeof useRecursosQuery>
export type RecursosLazyQueryHookResult = ReturnType<typeof useRecursosLazyQuery>
export type RecursosQueryResult = ApolloReactCommon.QueryResult<Types.RecursosQuery, Types.RecursosQueryVariables>
export const PerfilDetailDocument = gql`
  query PerfilDetail($perfilId: ID!) {
    perfil(id: $perfilId) {
      id
      nome
      tipoPerfil
      recursos
      perfilPadrao
    }
  }
`

/**
 * __usePerfilDetailQuery__
 *
 * To run a query within a React component, call `usePerfilDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `usePerfilDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePerfilDetailQuery({
 *   variables: {
 *      perfilId: // value for 'perfilId'
 *   },
 * });
 */
export function usePerfilDetailQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.PerfilDetailQuery, Types.PerfilDetailQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.PerfilDetailQuery, Types.PerfilDetailQueryVariables>(
    PerfilDetailDocument,
    baseOptions
  )
}
export function usePerfilDetailLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.PerfilDetailQuery, Types.PerfilDetailQueryVariables>
) {
  return ApolloReactHooks.useLazyQuery<Types.PerfilDetailQuery, Types.PerfilDetailQueryVariables>(
    PerfilDetailDocument,
    baseOptions
  )
}
export type PerfilDetailQueryHookResult = ReturnType<typeof usePerfilDetailQuery>
export type PerfilDetailLazyQueryHookResult = ReturnType<typeof usePerfilDetailLazyQuery>
export type PerfilDetailQueryResult = ApolloReactCommon.QueryResult<
  Types.PerfilDetailQuery,
  Types.PerfilDetailQueryVariables
>
export const AtualizarPerfilDocument = gql`
  mutation AtualizarPerfil($input: PerfilInput!) {
    atualizarPerfil(input: $input) {
      id
      nome
      ativo
    }
  }
`
export type AtualizarPerfilMutationFn = ApolloReactCommon.MutationFunction<
  Types.AtualizarPerfilMutation,
  Types.AtualizarPerfilMutationVariables
>

/**
 * __useAtualizarPerfilMutation__
 *
 * To run a mutation, you first call `useAtualizarPerfilMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAtualizarPerfilMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [atualizarPerfilMutation, { data, loading, error }] = useAtualizarPerfilMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAtualizarPerfilMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.AtualizarPerfilMutation,
    Types.AtualizarPerfilMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<Types.AtualizarPerfilMutation, Types.AtualizarPerfilMutationVariables>(
    AtualizarPerfilDocument,
    baseOptions
  )
}
export type AtualizarPerfilMutationHookResult = ReturnType<typeof useAtualizarPerfilMutation>
export type AtualizarPerfilMutationResult = ApolloReactCommon.MutationResult<Types.AtualizarPerfilMutation>
export type AtualizarPerfilMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.AtualizarPerfilMutation,
  Types.AtualizarPerfilMutationVariables
>
export const PerfilEditDocument = gql`
  query PerfilEdit($perfilId: ID!) {
    perfil(id: $perfilId) {
      id
      nome
      tipoPerfil
      recursos
      perfilPadrao
    }
  }
`

/**
 * __usePerfilEditQuery__
 *
 * To run a query within a React component, call `usePerfilEditQuery` and pass it any options that fit your needs.
 * When your component renders, `usePerfilEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePerfilEditQuery({
 *   variables: {
 *      perfilId: // value for 'perfilId'
 *   },
 * });
 */
export function usePerfilEditQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.PerfilEditQuery, Types.PerfilEditQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.PerfilEditQuery, Types.PerfilEditQueryVariables>(
    PerfilEditDocument,
    baseOptions
  )
}
export function usePerfilEditLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.PerfilEditQuery, Types.PerfilEditQueryVariables>
) {
  return ApolloReactHooks.useLazyQuery<Types.PerfilEditQuery, Types.PerfilEditQueryVariables>(
    PerfilEditDocument,
    baseOptions
  )
}
export type PerfilEditQueryHookResult = ReturnType<typeof usePerfilEditQuery>
export type PerfilEditLazyQueryHookResult = ReturnType<typeof usePerfilEditLazyQuery>
export type PerfilEditQueryResult = ApolloReactCommon.QueryResult<Types.PerfilEditQuery, Types.PerfilEditQueryVariables>
export const PerfilTableDocument = gql`
  query PerfilTable($input: PerfisQueryInput!) {
    perfis(input: $input) {
      content {
        id
        nome
        ativo
        tipoPerfil
        perfilPadrao
        actions {
          excluir {
            enabled
            hint
          }
        }
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${PageInfoFragmentDoc}
`

/**
 * __usePerfilTableQuery__
 *
 * To run a query within a React component, call `usePerfilTableQuery` and pass it any options that fit your needs.
 * When your component renders, `usePerfilTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePerfilTableQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePerfilTableQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.PerfilTableQuery, Types.PerfilTableQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.PerfilTableQuery, Types.PerfilTableQueryVariables>(
    PerfilTableDocument,
    baseOptions
  )
}
export function usePerfilTableLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.PerfilTableQuery, Types.PerfilTableQueryVariables>
) {
  return ApolloReactHooks.useLazyQuery<Types.PerfilTableQuery, Types.PerfilTableQueryVariables>(
    PerfilTableDocument,
    baseOptions
  )
}
export type PerfilTableQueryHookResult = ReturnType<typeof usePerfilTableQuery>
export type PerfilTableLazyQueryHookResult = ReturnType<typeof usePerfilTableLazyQuery>
export type PerfilTableQueryResult = ApolloReactCommon.QueryResult<
  Types.PerfilTableQuery,
  Types.PerfilTableQueryVariables
>
export const ResponderPesquisaSatisfacaoDocument = gql`
  mutation responderPesquisaSatisfacao($input: RespostaPesquisa!) {
    responderPesquisaSatisfacao(input: $input) {
      id
      mostrarPesquisaSatisfacao
    }
  }
`
export type ResponderPesquisaSatisfacaoMutationFn = ApolloReactCommon.MutationFunction<
  Types.ResponderPesquisaSatisfacaoMutation,
  Types.ResponderPesquisaSatisfacaoMutationVariables
>

/**
 * __useResponderPesquisaSatisfacaoMutation__
 *
 * To run a mutation, you first call `useResponderPesquisaSatisfacaoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResponderPesquisaSatisfacaoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [responderPesquisaSatisfacaoMutation, { data, loading, error }] = useResponderPesquisaSatisfacaoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResponderPesquisaSatisfacaoMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.ResponderPesquisaSatisfacaoMutation,
    Types.ResponderPesquisaSatisfacaoMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    Types.ResponderPesquisaSatisfacaoMutation,
    Types.ResponderPesquisaSatisfacaoMutationVariables
  >(ResponderPesquisaSatisfacaoDocument, baseOptions)
}
export type ResponderPesquisaSatisfacaoMutationHookResult = ReturnType<typeof useResponderPesquisaSatisfacaoMutation>
export type ResponderPesquisaSatisfacaoMutationResult = ApolloReactCommon.MutationResult<
  Types.ResponderPesquisaSatisfacaoMutation
>
export type ResponderPesquisaSatisfacaoMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.ResponderPesquisaSatisfacaoMutation,
  Types.ResponderPesquisaSatisfacaoMutationVariables
>
export const ProfissionalEditDocument = gql`
  query ProfissionalEdit($id: ID!) {
    profissional(id: $id) {
      id
      nome
      numeroConselhoClasse
      sexo
      telefone
      cns
      cpf
      dataNascimento
      email
      conselhoClasse {
        id
        descricao
        sigla
      }
      ufEmissoraConselhoClasse {
        id
        nome
        sigla
      }
      endereco {
        bairro
        cep
        complemento
        logradouro
        numero
        pontoReferencia
        municipio {
          id
          ibge
          nome
          uf {
            id
            nome
            sigla
          }
        }
        semNumero
        tipoLogradouro {
          id
          nome
          numeroDne
        }
        uf {
          id
          nome
          sigla
        }
      }
      lotacoes {
        id
        ativo
      }
    }
  }
`

/**
 * __useProfissionalEditQuery__
 *
 * To run a query within a React component, call `useProfissionalEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfissionalEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfissionalEditQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProfissionalEditQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ProfissionalEditQuery, Types.ProfissionalEditQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.ProfissionalEditQuery, Types.ProfissionalEditQueryVariables>(
    ProfissionalEditDocument,
    baseOptions
  )
}
export function useProfissionalEditLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ProfissionalEditQuery, Types.ProfissionalEditQueryVariables>
) {
  return ApolloReactHooks.useLazyQuery<Types.ProfissionalEditQuery, Types.ProfissionalEditQueryVariables>(
    ProfissionalEditDocument,
    baseOptions
  )
}
export type ProfissionalEditQueryHookResult = ReturnType<typeof useProfissionalEditQuery>
export type ProfissionalEditLazyQueryHookResult = ReturnType<typeof useProfissionalEditLazyQuery>
export type ProfissionalEditQueryResult = ApolloReactCommon.QueryResult<
  Types.ProfissionalEditQuery,
  Types.ProfissionalEditQueryVariables
>
export const SalvarProfissionalDocument = gql`
  mutation SalvarProfissional($input: ProfissionalInput!) {
    salvarProfissional(input: $input) {
      id
      nome
    }
  }
`
export type SalvarProfissionalMutationFn = ApolloReactCommon.MutationFunction<
  Types.SalvarProfissionalMutation,
  Types.SalvarProfissionalMutationVariables
>

/**
 * __useSalvarProfissionalMutation__
 *
 * To run a mutation, you first call `useSalvarProfissionalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvarProfissionalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvarProfissionalMutation, { data, loading, error }] = useSalvarProfissionalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSalvarProfissionalMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.SalvarProfissionalMutation,
    Types.SalvarProfissionalMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<Types.SalvarProfissionalMutation, Types.SalvarProfissionalMutationVariables>(
    SalvarProfissionalDocument,
    baseOptions
  )
}
export type SalvarProfissionalMutationHookResult = ReturnType<typeof useSalvarProfissionalMutation>
export type SalvarProfissionalMutationResult = ApolloReactCommon.MutationResult<Types.SalvarProfissionalMutation>
export type SalvarProfissionalMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.SalvarProfissionalMutation,
  Types.SalvarProfissionalMutationVariables
>
export const ConfiguracaoAgendaOnlineLotacaoDocument = gql`
  query ConfiguracaoAgendaOnlineLotacao($lotacaoId: ID!) {
    lotacao(id: $lotacaoId) {
      id
      hasConfiguracaoAgendaOnline
      cbo {
        id
        nome
        cbo2002
      }
      equipe {
        id
        ine
        nome
      }
      unidadeSaude {
        id
        nome
      }
      profissional {
        nome
      }
      gradeConfiguracaoAgendaOnline {
        horariosConsolidados
        configuracoesSemana {
          diaSemana
          configuracoes {
            horario
            ativo
          }
        }
      }
      actions {
        permissaoConfigurarAgendaOnline {
          enabled
        }
      }
    }
  }
`

/**
 * __useConfiguracaoAgendaOnlineLotacaoQuery__
 *
 * To run a query within a React component, call `useConfiguracaoAgendaOnlineLotacaoQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfiguracaoAgendaOnlineLotacaoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfiguracaoAgendaOnlineLotacaoQuery({
 *   variables: {
 *      lotacaoId: // value for 'lotacaoId'
 *   },
 * });
 */
export function useConfiguracaoAgendaOnlineLotacaoQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.ConfiguracaoAgendaOnlineLotacaoQuery,
    Types.ConfiguracaoAgendaOnlineLotacaoQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    Types.ConfiguracaoAgendaOnlineLotacaoQuery,
    Types.ConfiguracaoAgendaOnlineLotacaoQueryVariables
  >(ConfiguracaoAgendaOnlineLotacaoDocument, baseOptions)
}
export function useConfiguracaoAgendaOnlineLotacaoLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.ConfiguracaoAgendaOnlineLotacaoQuery,
    Types.ConfiguracaoAgendaOnlineLotacaoQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    Types.ConfiguracaoAgendaOnlineLotacaoQuery,
    Types.ConfiguracaoAgendaOnlineLotacaoQueryVariables
  >(ConfiguracaoAgendaOnlineLotacaoDocument, baseOptions)
}
export type ConfiguracaoAgendaOnlineLotacaoQueryHookResult = ReturnType<typeof useConfiguracaoAgendaOnlineLotacaoQuery>
export type ConfiguracaoAgendaOnlineLotacaoLazyQueryHookResult = ReturnType<
  typeof useConfiguracaoAgendaOnlineLotacaoLazyQuery
>
export type ConfiguracaoAgendaOnlineLotacaoQueryResult = ApolloReactCommon.QueryResult<
  Types.ConfiguracaoAgendaOnlineLotacaoQuery,
  Types.ConfiguracaoAgendaOnlineLotacaoQueryVariables
>
export const SalvarConfiguracaoAgendaOnlineLotacaoDocument = gql`
  mutation SalvarConfiguracaoAgendaOnlineLotacao(
    $configuracaoAgendaOnlineLotacaoInput: ConfiguracaoAgendaOnlineLotacaoInput
  ) {
    salvarConfiguracaoAgendaOnlineLotacao(configuracaoAgendaOnlineLotacaoInput: $configuracaoAgendaOnlineLotacaoInput)
  }
`
export type SalvarConfiguracaoAgendaOnlineLotacaoMutationFn = ApolloReactCommon.MutationFunction<
  Types.SalvarConfiguracaoAgendaOnlineLotacaoMutation,
  Types.SalvarConfiguracaoAgendaOnlineLotacaoMutationVariables
>

/**
 * __useSalvarConfiguracaoAgendaOnlineLotacaoMutation__
 *
 * To run a mutation, you first call `useSalvarConfiguracaoAgendaOnlineLotacaoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvarConfiguracaoAgendaOnlineLotacaoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvarConfiguracaoAgendaOnlineLotacaoMutation, { data, loading, error }] = useSalvarConfiguracaoAgendaOnlineLotacaoMutation({
 *   variables: {
 *      configuracaoAgendaOnlineLotacaoInput: // value for 'configuracaoAgendaOnlineLotacaoInput'
 *   },
 * });
 */
export function useSalvarConfiguracaoAgendaOnlineLotacaoMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.SalvarConfiguracaoAgendaOnlineLotacaoMutation,
    Types.SalvarConfiguracaoAgendaOnlineLotacaoMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    Types.SalvarConfiguracaoAgendaOnlineLotacaoMutation,
    Types.SalvarConfiguracaoAgendaOnlineLotacaoMutationVariables
  >(SalvarConfiguracaoAgendaOnlineLotacaoDocument, baseOptions)
}
export type SalvarConfiguracaoAgendaOnlineLotacaoMutationHookResult = ReturnType<
  typeof useSalvarConfiguracaoAgendaOnlineLotacaoMutation
>
export type SalvarConfiguracaoAgendaOnlineLotacaoMutationResult = ApolloReactCommon.MutationResult<
  Types.SalvarConfiguracaoAgendaOnlineLotacaoMutation
>
export type SalvarConfiguracaoAgendaOnlineLotacaoMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.SalvarConfiguracaoAgendaOnlineLotacaoMutation,
  Types.SalvarConfiguracaoAgendaOnlineLotacaoMutationVariables
>
export const ConfiguracaoAgendaLotacaoDocument = gql`
  query ConfiguracaoAgendaLotacao($lotacaoId: ID!) {
    lotacao(id: $lotacaoId) {
      id
      hasConfiguracaoAgenda
      hasConfiguracaoAgendaOnline
      hasAgendamentoFuturo
      cbo {
        id
        nome
        cbo2002
      }
      equipe {
        id
        ine
        nome
      }
      unidadeSaude {
        id
        nome
        cnes
      }
      profissional {
        nome
      }
      configuracaoAgenda {
        configuracaoHorarioAgenda {
          configuracaoDiasSemana {
            diaSemana
            periodos {
              periodo
              horarioInicial
              horarioFinal
            }
          }
        }
      }
      actions {
        permissaoConfigurarAgenda {
          enabled
        }
        permissaoFecharAgenda {
          enabled
        }
      }
    }
    conexao {
      agendaOnline {
        ativa
      }
    }
    duracaoAtendimentoPadraoMunicipio {
      duracaoAtendimentoPadraoMunicipio
    }
    configuracaoHorariosMunicipio {
      id
      configuracaoHorarioAgenda {
        configuracaoDiasSemana {
          diaSemana
          periodos {
            periodo
            horarioInicial
            horarioFinal
          }
        }
      }
    }
  }
`

/**
 * __useConfiguracaoAgendaLotacaoQuery__
 *
 * To run a query within a React component, call `useConfiguracaoAgendaLotacaoQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfiguracaoAgendaLotacaoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfiguracaoAgendaLotacaoQuery({
 *   variables: {
 *      lotacaoId: // value for 'lotacaoId'
 *   },
 * });
 */
export function useConfiguracaoAgendaLotacaoQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.ConfiguracaoAgendaLotacaoQuery,
    Types.ConfiguracaoAgendaLotacaoQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<Types.ConfiguracaoAgendaLotacaoQuery, Types.ConfiguracaoAgendaLotacaoQueryVariables>(
    ConfiguracaoAgendaLotacaoDocument,
    baseOptions
  )
}
export function useConfiguracaoAgendaLotacaoLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.ConfiguracaoAgendaLotacaoQuery,
    Types.ConfiguracaoAgendaLotacaoQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    Types.ConfiguracaoAgendaLotacaoQuery,
    Types.ConfiguracaoAgendaLotacaoQueryVariables
  >(ConfiguracaoAgendaLotacaoDocument, baseOptions)
}
export type ConfiguracaoAgendaLotacaoQueryHookResult = ReturnType<typeof useConfiguracaoAgendaLotacaoQuery>
export type ConfiguracaoAgendaLotacaoLazyQueryHookResult = ReturnType<typeof useConfiguracaoAgendaLotacaoLazyQuery>
export type ConfiguracaoAgendaLotacaoQueryResult = ApolloReactCommon.QueryResult<
  Types.ConfiguracaoAgendaLotacaoQuery,
  Types.ConfiguracaoAgendaLotacaoQueryVariables
>
export const DesativarConfiguracaoAgendaOnlineLotacaoDocument = gql`
  mutation DesativarConfiguracaoAgendaOnlineLotacao($id: ID!) {
    desativarConfiguracaoAgendaOnlineLotacao(id: $id)
  }
`
export type DesativarConfiguracaoAgendaOnlineLotacaoMutationFn = ApolloReactCommon.MutationFunction<
  Types.DesativarConfiguracaoAgendaOnlineLotacaoMutation,
  Types.DesativarConfiguracaoAgendaOnlineLotacaoMutationVariables
>

/**
 * __useDesativarConfiguracaoAgendaOnlineLotacaoMutation__
 *
 * To run a mutation, you first call `useDesativarConfiguracaoAgendaOnlineLotacaoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDesativarConfiguracaoAgendaOnlineLotacaoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [desativarConfiguracaoAgendaOnlineLotacaoMutation, { data, loading, error }] = useDesativarConfiguracaoAgendaOnlineLotacaoMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDesativarConfiguracaoAgendaOnlineLotacaoMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.DesativarConfiguracaoAgendaOnlineLotacaoMutation,
    Types.DesativarConfiguracaoAgendaOnlineLotacaoMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    Types.DesativarConfiguracaoAgendaOnlineLotacaoMutation,
    Types.DesativarConfiguracaoAgendaOnlineLotacaoMutationVariables
  >(DesativarConfiguracaoAgendaOnlineLotacaoDocument, baseOptions)
}
export type DesativarConfiguracaoAgendaOnlineLotacaoMutationHookResult = ReturnType<
  typeof useDesativarConfiguracaoAgendaOnlineLotacaoMutation
>
export type DesativarConfiguracaoAgendaOnlineLotacaoMutationResult = ApolloReactCommon.MutationResult<
  Types.DesativarConfiguracaoAgendaOnlineLotacaoMutation
>
export type DesativarConfiguracaoAgendaOnlineLotacaoMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.DesativarConfiguracaoAgendaOnlineLotacaoMutation,
  Types.DesativarConfiguracaoAgendaOnlineLotacaoMutationVariables
>
export const ExcluirConfiguracaoAgendaLotacaoDocument = gql`
  mutation ExcluirConfiguracaoAgendaLotacao($id: ID!) {
    excluirConfiguracaoAgendaLotacao(id: $id)
  }
`
export type ExcluirConfiguracaoAgendaLotacaoMutationFn = ApolloReactCommon.MutationFunction<
  Types.ExcluirConfiguracaoAgendaLotacaoMutation,
  Types.ExcluirConfiguracaoAgendaLotacaoMutationVariables
>

/**
 * __useExcluirConfiguracaoAgendaLotacaoMutation__
 *
 * To run a mutation, you first call `useExcluirConfiguracaoAgendaLotacaoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExcluirConfiguracaoAgendaLotacaoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [excluirConfiguracaoAgendaLotacaoMutation, { data, loading, error }] = useExcluirConfiguracaoAgendaLotacaoMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExcluirConfiguracaoAgendaLotacaoMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.ExcluirConfiguracaoAgendaLotacaoMutation,
    Types.ExcluirConfiguracaoAgendaLotacaoMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    Types.ExcluirConfiguracaoAgendaLotacaoMutation,
    Types.ExcluirConfiguracaoAgendaLotacaoMutationVariables
  >(ExcluirConfiguracaoAgendaLotacaoDocument, baseOptions)
}
export type ExcluirConfiguracaoAgendaLotacaoMutationHookResult = ReturnType<
  typeof useExcluirConfiguracaoAgendaLotacaoMutation
>
export type ExcluirConfiguracaoAgendaLotacaoMutationResult = ApolloReactCommon.MutationResult<
  Types.ExcluirConfiguracaoAgendaLotacaoMutation
>
export type ExcluirConfiguracaoAgendaLotacaoMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.ExcluirConfiguracaoAgendaLotacaoMutation,
  Types.ExcluirConfiguracaoAgendaLotacaoMutationVariables
>
export const SalvarConfiguracaoAgendaLotacaoDocument = gql`
  mutation SalvarConfiguracaoAgendaLotacao($configuracaoAgendaLotacaoInput: ConfiguracaoAgendaLotacaoInput) {
    salvarConfiguracaoAgendaLotacao(configuracaoAgendaLotacaoInput: $configuracaoAgendaLotacaoInput)
  }
`
export type SalvarConfiguracaoAgendaLotacaoMutationFn = ApolloReactCommon.MutationFunction<
  Types.SalvarConfiguracaoAgendaLotacaoMutation,
  Types.SalvarConfiguracaoAgendaLotacaoMutationVariables
>

/**
 * __useSalvarConfiguracaoAgendaLotacaoMutation__
 *
 * To run a mutation, you first call `useSalvarConfiguracaoAgendaLotacaoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvarConfiguracaoAgendaLotacaoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvarConfiguracaoAgendaLotacaoMutation, { data, loading, error }] = useSalvarConfiguracaoAgendaLotacaoMutation({
 *   variables: {
 *      configuracaoAgendaLotacaoInput: // value for 'configuracaoAgendaLotacaoInput'
 *   },
 * });
 */
export function useSalvarConfiguracaoAgendaLotacaoMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.SalvarConfiguracaoAgendaLotacaoMutation,
    Types.SalvarConfiguracaoAgendaLotacaoMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    Types.SalvarConfiguracaoAgendaLotacaoMutation,
    Types.SalvarConfiguracaoAgendaLotacaoMutationVariables
  >(SalvarConfiguracaoAgendaLotacaoDocument, baseOptions)
}
export type SalvarConfiguracaoAgendaLotacaoMutationHookResult = ReturnType<
  typeof useSalvarConfiguracaoAgendaLotacaoMutation
>
export type SalvarConfiguracaoAgendaLotacaoMutationResult = ApolloReactCommon.MutationResult<
  Types.SalvarConfiguracaoAgendaLotacaoMutation
>
export type SalvarConfiguracaoAgendaLotacaoMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.SalvarConfiguracaoAgendaLotacaoMutation,
  Types.SalvarConfiguracaoAgendaLotacaoMutationVariables
>
export const ExcluirFechamentoDocument = gql`
  mutation ExcluirFechamento($id: ID!) {
    excluirFechamento(id: $id)
  }
`
export type ExcluirFechamentoMutationFn = ApolloReactCommon.MutationFunction<
  Types.ExcluirFechamentoMutation,
  Types.ExcluirFechamentoMutationVariables
>

/**
 * __useExcluirFechamentoMutation__
 *
 * To run a mutation, you first call `useExcluirFechamentoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExcluirFechamentoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [excluirFechamentoMutation, { data, loading, error }] = useExcluirFechamentoMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExcluirFechamentoMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.ExcluirFechamentoMutation,
    Types.ExcluirFechamentoMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<Types.ExcluirFechamentoMutation, Types.ExcluirFechamentoMutationVariables>(
    ExcluirFechamentoDocument,
    baseOptions
  )
}
export type ExcluirFechamentoMutationHookResult = ReturnType<typeof useExcluirFechamentoMutation>
export type ExcluirFechamentoMutationResult = ApolloReactCommon.MutationResult<Types.ExcluirFechamentoMutation>
export type ExcluirFechamentoMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.ExcluirFechamentoMutation,
  Types.ExcluirFechamentoMutationVariables
>
export const FechamentoTableDocument = gql`
  query FechamentoTable($input: AgendaFechamentoQueryInput!) {
    fechamentos(input: $input) {
      id
      dataInicial
      dataFinal
      motivo
      especifique
    }
  }
`

/**
 * __useFechamentoTableQuery__
 *
 * To run a query within a React component, call `useFechamentoTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useFechamentoTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFechamentoTableQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFechamentoTableQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.FechamentoTableQuery, Types.FechamentoTableQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.FechamentoTableQuery, Types.FechamentoTableQueryVariables>(
    FechamentoTableDocument,
    baseOptions
  )
}
export function useFechamentoTableLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.FechamentoTableQuery, Types.FechamentoTableQueryVariables>
) {
  return ApolloReactHooks.useLazyQuery<Types.FechamentoTableQuery, Types.FechamentoTableQueryVariables>(
    FechamentoTableDocument,
    baseOptions
  )
}
export type FechamentoTableQueryHookResult = ReturnType<typeof useFechamentoTableQuery>
export type FechamentoTableLazyQueryHookResult = ReturnType<typeof useFechamentoTableLazyQuery>
export type FechamentoTableQueryResult = ApolloReactCommon.QueryResult<
  Types.FechamentoTableQuery,
  Types.FechamentoTableQueryVariables
>
export const SalvarFechamentoDocument = gql`
  mutation SalvarFechamento($input: AgendaFechamentoInput!) {
    salvarFechamento(input: $input) {
      id
    }
  }
`
export type SalvarFechamentoMutationFn = ApolloReactCommon.MutationFunction<
  Types.SalvarFechamentoMutation,
  Types.SalvarFechamentoMutationVariables
>

/**
 * __useSalvarFechamentoMutation__
 *
 * To run a mutation, you first call `useSalvarFechamentoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvarFechamentoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvarFechamentoMutation, { data, loading, error }] = useSalvarFechamentoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSalvarFechamentoMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.SalvarFechamentoMutation,
    Types.SalvarFechamentoMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<Types.SalvarFechamentoMutation, Types.SalvarFechamentoMutationVariables>(
    SalvarFechamentoDocument,
    baseOptions
  )
}
export type SalvarFechamentoMutationHookResult = ReturnType<typeof useSalvarFechamentoMutation>
export type SalvarFechamentoMutationResult = ApolloReactCommon.MutationResult<Types.SalvarFechamentoMutation>
export type SalvarFechamentoMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.SalvarFechamentoMutation,
  Types.SalvarFechamentoMutationVariables
>
export const ProfissionalAcessosDocument = gql`
  query ProfissionalAcessos($profissionalId: ID!) {
    profissional(id: $profissionalId) {
      id
      cns
      acessos(input: { mostrarInativos: true }) {
        id
        tipo
        ativo
        perfis {
          id
          nome
          ativo
        }
        actions {
          permissaoEdicao {
            enabled
            hint
          }
          permissaoExclusao {
            enabled
            hint
          }
          permissaoAtivacaoInativacao {
            enabled
            hint
          }
          ... on LotacaoActions {
            permissaoConfigurarAgenda {
              enabled
              hint
            }
            permissaoConfigurarAgendaOnline {
              enabled
              hint
            }
            permissaoFecharAgenda {
              enabled
              hint
            }
          }
        }
        ... on AdministradorMunicipal {
          municipio {
            id
            nome
          }
        }
        ... on GestorEstadual {
          uf {
            id
            nome
          }
        }
        ... on GestorMunicipal {
          municipio {
            id
            nome
          }
        }
        ... on Lotacao {
          importada
          hasConfiguracaoAgenda
          hasConfiguracaoAgendaOnline
          hasAgendamentoFuturo
          cbo {
            id
            nome
            cbo2002
          }
          equipe {
            id
            nome
            ine
            tipoEquipe {
              id
              descricao
            }
          }
          unidadeSaude {
            id
            nome
          }
        }
      }
    }
  }
`

/**
 * __useProfissionalAcessosQuery__
 *
 * To run a query within a React component, call `useProfissionalAcessosQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfissionalAcessosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfissionalAcessosQuery({
 *   variables: {
 *      profissionalId: // value for 'profissionalId'
 *   },
 * });
 */
export function useProfissionalAcessosQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.ProfissionalAcessosQuery,
    Types.ProfissionalAcessosQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<Types.ProfissionalAcessosQuery, Types.ProfissionalAcessosQueryVariables>(
    ProfissionalAcessosDocument,
    baseOptions
  )
}
export function useProfissionalAcessosLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.ProfissionalAcessosQuery,
    Types.ProfissionalAcessosQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<Types.ProfissionalAcessosQuery, Types.ProfissionalAcessosQueryVariables>(
    ProfissionalAcessosDocument,
    baseOptions
  )
}
export type ProfissionalAcessosQueryHookResult = ReturnType<typeof useProfissionalAcessosQuery>
export type ProfissionalAcessosLazyQueryHookResult = ReturnType<typeof useProfissionalAcessosLazyQuery>
export type ProfissionalAcessosQueryResult = ApolloReactCommon.QueryResult<
  Types.ProfissionalAcessosQuery,
  Types.ProfissionalAcessosQueryVariables
>
export const ProfissionalDetailDocument = gql`
  query profissionalDetail($id: ID!) {
    profissional(id: $id) {
      lotacoes {
        ativo
        cbo {
          id
          nome
          cbo2002
        }
        equipe {
          id
          ine
          nome
          tipoEquipe {
            id
            nome
            sigla
          }
        }
        id
        unidadeSaude {
          id
          nome
          cnes
        }
      }
      ...ProfissionalDetail
    }
  }
  ${ProfissionalDetailFragmentDoc}
`

/**
 * __useProfissionalDetailQuery__
 *
 * To run a query within a React component, call `useProfissionalDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfissionalDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfissionalDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProfissionalDetailQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ProfissionalDetailQuery, Types.ProfissionalDetailQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.ProfissionalDetailQuery, Types.ProfissionalDetailQueryVariables>(
    ProfissionalDetailDocument,
    baseOptions
  )
}
export function useProfissionalDetailLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.ProfissionalDetailQuery,
    Types.ProfissionalDetailQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<Types.ProfissionalDetailQuery, Types.ProfissionalDetailQueryVariables>(
    ProfissionalDetailDocument,
    baseOptions
  )
}
export type ProfissionalDetailQueryHookResult = ReturnType<typeof useProfissionalDetailQuery>
export type ProfissionalDetailLazyQueryHookResult = ReturnType<typeof useProfissionalDetailLazyQuery>
export type ProfissionalDetailQueryResult = ApolloReactCommon.QueryResult<
  Types.ProfissionalDetailQuery,
  Types.ProfissionalDetailQueryVariables
>
export const AgendaEmConflitoDocument = gql`
  query AgendaEmConflito($id: ID!) {
    agendaEmConflito(idLotacao: $id)
  }
`

/**
 * __useAgendaEmConflitoQuery__
 *
 * To run a query within a React component, call `useAgendaEmConflitoQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgendaEmConflitoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgendaEmConflitoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAgendaEmConflitoQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.AgendaEmConflitoQuery, Types.AgendaEmConflitoQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.AgendaEmConflitoQuery, Types.AgendaEmConflitoQueryVariables>(
    AgendaEmConflitoDocument,
    baseOptions
  )
}
export function useAgendaEmConflitoLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AgendaEmConflitoQuery, Types.AgendaEmConflitoQueryVariables>
) {
  return ApolloReactHooks.useLazyQuery<Types.AgendaEmConflitoQuery, Types.AgendaEmConflitoQueryVariables>(
    AgendaEmConflitoDocument,
    baseOptions
  )
}
export type AgendaEmConflitoQueryHookResult = ReturnType<typeof useAgendaEmConflitoQuery>
export type AgendaEmConflitoLazyQueryHookResult = ReturnType<typeof useAgendaEmConflitoLazyQuery>
export type AgendaEmConflitoQueryResult = ApolloReactCommon.QueryResult<
  Types.AgendaEmConflitoQuery,
  Types.AgendaEmConflitoQueryVariables
>
export const AlterarAtivacaoLotacaoDocument = gql`
  mutation AlterarAtivacaoLotacao($lotacaoId: ID!) {
    alterarAtivacaoLotacao(lotacaoId: $lotacaoId)
  }
`
export type AlterarAtivacaoLotacaoMutationFn = ApolloReactCommon.MutationFunction<
  Types.AlterarAtivacaoLotacaoMutation,
  Types.AlterarAtivacaoLotacaoMutationVariables
>

/**
 * __useAlterarAtivacaoLotacaoMutation__
 *
 * To run a mutation, you first call `useAlterarAtivacaoLotacaoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlterarAtivacaoLotacaoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alterarAtivacaoLotacaoMutation, { data, loading, error }] = useAlterarAtivacaoLotacaoMutation({
 *   variables: {
 *      lotacaoId: // value for 'lotacaoId'
 *   },
 * });
 */
export function useAlterarAtivacaoLotacaoMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.AlterarAtivacaoLotacaoMutation,
    Types.AlterarAtivacaoLotacaoMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    Types.AlterarAtivacaoLotacaoMutation,
    Types.AlterarAtivacaoLotacaoMutationVariables
  >(AlterarAtivacaoLotacaoDocument, baseOptions)
}
export type AlterarAtivacaoLotacaoMutationHookResult = ReturnType<typeof useAlterarAtivacaoLotacaoMutation>
export type AlterarAtivacaoLotacaoMutationResult = ApolloReactCommon.MutationResult<
  Types.AlterarAtivacaoLotacaoMutation
>
export type AlterarAtivacaoLotacaoMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.AlterarAtivacaoLotacaoMutation,
  Types.AlterarAtivacaoLotacaoMutationVariables
>
export const ExcluirLotacaoDocument = gql`
  mutation ExcluirLotacao($lotacaoId: ID!) {
    excluirLotacao(lotacaoId: $lotacaoId)
  }
`
export type ExcluirLotacaoMutationFn = ApolloReactCommon.MutationFunction<
  Types.ExcluirLotacaoMutation,
  Types.ExcluirLotacaoMutationVariables
>

/**
 * __useExcluirLotacaoMutation__
 *
 * To run a mutation, you first call `useExcluirLotacaoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExcluirLotacaoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [excluirLotacaoMutation, { data, loading, error }] = useExcluirLotacaoMutation({
 *   variables: {
 *      lotacaoId: // value for 'lotacaoId'
 *   },
 * });
 */
export function useExcluirLotacaoMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.ExcluirLotacaoMutation,
    Types.ExcluirLotacaoMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<Types.ExcluirLotacaoMutation, Types.ExcluirLotacaoMutationVariables>(
    ExcluirLotacaoDocument,
    baseOptions
  )
}
export type ExcluirLotacaoMutationHookResult = ReturnType<typeof useExcluirLotacaoMutation>
export type ExcluirLotacaoMutationResult = ApolloReactCommon.MutationResult<Types.ExcluirLotacaoMutation>
export type ExcluirLotacaoMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.ExcluirLotacaoMutation,
  Types.ExcluirLotacaoMutationVariables
>
export const ProfissionaisLotacoesSectionDocument = gql`
  query ProfissionaisLotacoesSection {
    conexao {
      agendaOnline {
        ativa
      }
    }
  }
`

/**
 * __useProfissionaisLotacoesSectionQuery__
 *
 * To run a query within a React component, call `useProfissionaisLotacoesSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfissionaisLotacoesSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfissionaisLotacoesSectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useProfissionaisLotacoesSectionQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.ProfissionaisLotacoesSectionQuery,
    Types.ProfissionaisLotacoesSectionQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    Types.ProfissionaisLotacoesSectionQuery,
    Types.ProfissionaisLotacoesSectionQueryVariables
  >(ProfissionaisLotacoesSectionDocument, baseOptions)
}
export function useProfissionaisLotacoesSectionLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.ProfissionaisLotacoesSectionQuery,
    Types.ProfissionaisLotacoesSectionQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    Types.ProfissionaisLotacoesSectionQuery,
    Types.ProfissionaisLotacoesSectionQueryVariables
  >(ProfissionaisLotacoesSectionDocument, baseOptions)
}
export type ProfissionaisLotacoesSectionQueryHookResult = ReturnType<typeof useProfissionaisLotacoesSectionQuery>
export type ProfissionaisLotacoesSectionLazyQueryHookResult = ReturnType<
  typeof useProfissionaisLotacoesSectionLazyQuery
>
export type ProfissionaisLotacoesSectionQueryResult = ApolloReactCommon.QueryResult<
  Types.ProfissionaisLotacoesSectionQuery,
  Types.ProfissionaisLotacoesSectionQueryVariables
>
export const AlterarAtivacaoAcessoDocument = gql`
  mutation AlterarAtivacaoAcesso($id: ID!) {
    alterarAtivacaoAcesso(id: $id)
  }
`
export type AlterarAtivacaoAcessoMutationFn = ApolloReactCommon.MutationFunction<
  Types.AlterarAtivacaoAcessoMutation,
  Types.AlterarAtivacaoAcessoMutationVariables
>

/**
 * __useAlterarAtivacaoAcessoMutation__
 *
 * To run a mutation, you first call `useAlterarAtivacaoAcessoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlterarAtivacaoAcessoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alterarAtivacaoAcessoMutation, { data, loading, error }] = useAlterarAtivacaoAcessoMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAlterarAtivacaoAcessoMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.AlterarAtivacaoAcessoMutation,
    Types.AlterarAtivacaoAcessoMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    Types.AlterarAtivacaoAcessoMutation,
    Types.AlterarAtivacaoAcessoMutationVariables
  >(AlterarAtivacaoAcessoDocument, baseOptions)
}
export type AlterarAtivacaoAcessoMutationHookResult = ReturnType<typeof useAlterarAtivacaoAcessoMutation>
export type AlterarAtivacaoAcessoMutationResult = ApolloReactCommon.MutationResult<Types.AlterarAtivacaoAcessoMutation>
export type AlterarAtivacaoAcessoMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.AlterarAtivacaoAcessoMutation,
  Types.AlterarAtivacaoAcessoMutationVariables
>
export const ExcluirAcessoDocument = gql`
  mutation ExcluirAcesso($id: ID!) {
    excluirAcesso(id: $id)
  }
`
export type ExcluirAcessoMutationFn = ApolloReactCommon.MutationFunction<
  Types.ExcluirAcessoMutation,
  Types.ExcluirAcessoMutationVariables
>

/**
 * __useExcluirAcessoMutation__
 *
 * To run a mutation, you first call `useExcluirAcessoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExcluirAcessoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [excluirAcessoMutation, { data, loading, error }] = useExcluirAcessoMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExcluirAcessoMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ExcluirAcessoMutation, Types.ExcluirAcessoMutationVariables>
) {
  return ApolloReactHooks.useMutation<Types.ExcluirAcessoMutation, Types.ExcluirAcessoMutationVariables>(
    ExcluirAcessoDocument,
    baseOptions
  )
}
export type ExcluirAcessoMutationHookResult = ReturnType<typeof useExcluirAcessoMutation>
export type ExcluirAcessoMutationResult = ApolloReactCommon.MutationResult<Types.ExcluirAcessoMutation>
export type ExcluirAcessoMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.ExcluirAcessoMutation,
  Types.ExcluirAcessoMutationVariables
>
export const AcessoCreateDocument = gql`
  query AcessoCreate($profissionalId: ID!) {
    profissional(id: $profissionalId) {
      id
      nome
    }
  }
`

/**
 * __useAcessoCreateQuery__
 *
 * To run a query within a React component, call `useAcessoCreateQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcessoCreateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcessoCreateQuery({
 *   variables: {
 *      profissionalId: // value for 'profissionalId'
 *   },
 * });
 */
export function useAcessoCreateQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.AcessoCreateQuery, Types.AcessoCreateQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.AcessoCreateQuery, Types.AcessoCreateQueryVariables>(
    AcessoCreateDocument,
    baseOptions
  )
}
export function useAcessoCreateLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AcessoCreateQuery, Types.AcessoCreateQueryVariables>
) {
  return ApolloReactHooks.useLazyQuery<Types.AcessoCreateQuery, Types.AcessoCreateQueryVariables>(
    AcessoCreateDocument,
    baseOptions
  )
}
export type AcessoCreateQueryHookResult = ReturnType<typeof useAcessoCreateQuery>
export type AcessoCreateLazyQueryHookResult = ReturnType<typeof useAcessoCreateLazyQuery>
export type AcessoCreateQueryResult = ApolloReactCommon.QueryResult<
  Types.AcessoCreateQuery,
  Types.AcessoCreateQueryVariables
>
export const AcessoEditDocument = gql`
  query AcessoEdit($acessoId: ID!, $profissionalId: ID!) {
    acesso(id: $acessoId) {
      tipo
      actions {
        permissaoEdicao {
          enabled
        }
      }
      perfis {
        id
        nome
        ativo
      }
      ... on GestorEstadual {
        uf {
          id
          nome
          sigla
        }
      }
      ... on GestorMunicipal {
        municipio {
          id
          nome
          uf {
            id
            nome
            sigla
          }
        }
      }
    }
    profissional(id: $profissionalId) {
      id
      nome
    }
  }
`

/**
 * __useAcessoEditQuery__
 *
 * To run a query within a React component, call `useAcessoEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcessoEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcessoEditQuery({
 *   variables: {
 *      acessoId: // value for 'acessoId'
 *      profissionalId: // value for 'profissionalId'
 *   },
 * });
 */
export function useAcessoEditQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.AcessoEditQuery, Types.AcessoEditQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.AcessoEditQuery, Types.AcessoEditQueryVariables>(
    AcessoEditDocument,
    baseOptions
  )
}
export function useAcessoEditLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AcessoEditQuery, Types.AcessoEditQueryVariables>
) {
  return ApolloReactHooks.useLazyQuery<Types.AcessoEditQuery, Types.AcessoEditQueryVariables>(
    AcessoEditDocument,
    baseOptions
  )
}
export type AcessoEditQueryHookResult = ReturnType<typeof useAcessoEditQuery>
export type AcessoEditLazyQueryHookResult = ReturnType<typeof useAcessoEditLazyQuery>
export type AcessoEditQueryResult = ApolloReactCommon.QueryResult<Types.AcessoEditQuery, Types.AcessoEditQueryVariables>
export const SalvarAcessoDocument = gql`
  mutation SalvarAcesso($input: OutroAcessoInput!) {
    salvarOutroAcesso(input: $input) {
      id
    }
  }
`
export type SalvarAcessoMutationFn = ApolloReactCommon.MutationFunction<
  Types.SalvarAcessoMutation,
  Types.SalvarAcessoMutationVariables
>

/**
 * __useSalvarAcessoMutation__
 *
 * To run a mutation, you first call `useSalvarAcessoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvarAcessoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvarAcessoMutation, { data, loading, error }] = useSalvarAcessoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSalvarAcessoMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<Types.SalvarAcessoMutation, Types.SalvarAcessoMutationVariables>
) {
  return ApolloReactHooks.useMutation<Types.SalvarAcessoMutation, Types.SalvarAcessoMutationVariables>(
    SalvarAcessoDocument,
    baseOptions
  )
}
export type SalvarAcessoMutationHookResult = ReturnType<typeof useSalvarAcessoMutation>
export type SalvarAcessoMutationResult = ApolloReactCommon.MutationResult<Types.SalvarAcessoMutation>
export type SalvarAcessoMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.SalvarAcessoMutation,
  Types.SalvarAcessoMutationVariables
>
export const AlterarLotacaoDocument = gql`
  mutation AlterarLotacao($input: AlterarLotacaoInput!) {
    alterarLotacao(input: $input) {
      id
    }
  }
`
export type AlterarLotacaoMutationFn = ApolloReactCommon.MutationFunction<
  Types.AlterarLotacaoMutation,
  Types.AlterarLotacaoMutationVariables
>

/**
 * __useAlterarLotacaoMutation__
 *
 * To run a mutation, you first call `useAlterarLotacaoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlterarLotacaoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alterarLotacaoMutation, { data, loading, error }] = useAlterarLotacaoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAlterarLotacaoMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.AlterarLotacaoMutation,
    Types.AlterarLotacaoMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<Types.AlterarLotacaoMutation, Types.AlterarLotacaoMutationVariables>(
    AlterarLotacaoDocument,
    baseOptions
  )
}
export type AlterarLotacaoMutationHookResult = ReturnType<typeof useAlterarLotacaoMutation>
export type AlterarLotacaoMutationResult = ApolloReactCommon.MutationResult<Types.AlterarLotacaoMutation>
export type AlterarLotacaoMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.AlterarLotacaoMutation,
  Types.AlterarLotacaoMutationVariables
>
export const CriarLotacaoDocument = gql`
  mutation CriarLotacao($input: LotacaoInput!) {
    criarLotacao(input: $input) {
      id
    }
  }
`
export type CriarLotacaoMutationFn = ApolloReactCommon.MutationFunction<
  Types.CriarLotacaoMutation,
  Types.CriarLotacaoMutationVariables
>

/**
 * __useCriarLotacaoMutation__
 *
 * To run a mutation, you first call `useCriarLotacaoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCriarLotacaoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [criarLotacaoMutation, { data, loading, error }] = useCriarLotacaoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCriarLotacaoMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<Types.CriarLotacaoMutation, Types.CriarLotacaoMutationVariables>
) {
  return ApolloReactHooks.useMutation<Types.CriarLotacaoMutation, Types.CriarLotacaoMutationVariables>(
    CriarLotacaoDocument,
    baseOptions
  )
}
export type CriarLotacaoMutationHookResult = ReturnType<typeof useCriarLotacaoMutation>
export type CriarLotacaoMutationResult = ApolloReactCommon.MutationResult<Types.CriarLotacaoMutation>
export type CriarLotacaoMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.CriarLotacaoMutation,
  Types.CriarLotacaoMutationVariables
>
export const LotacaoCreateDocument = gql`
  query LotacaoCreate($profissionalId: ID!) {
    profissional(id: $profissionalId) {
      id
      nome
    }
  }
`

/**
 * __useLotacaoCreateQuery__
 *
 * To run a query within a React component, call `useLotacaoCreateQuery` and pass it any options that fit your needs.
 * When your component renders, `useLotacaoCreateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLotacaoCreateQuery({
 *   variables: {
 *      profissionalId: // value for 'profissionalId'
 *   },
 * });
 */
export function useLotacaoCreateQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.LotacaoCreateQuery, Types.LotacaoCreateQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.LotacaoCreateQuery, Types.LotacaoCreateQueryVariables>(
    LotacaoCreateDocument,
    baseOptions
  )
}
export function useLotacaoCreateLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.LotacaoCreateQuery, Types.LotacaoCreateQueryVariables>
) {
  return ApolloReactHooks.useLazyQuery<Types.LotacaoCreateQuery, Types.LotacaoCreateQueryVariables>(
    LotacaoCreateDocument,
    baseOptions
  )
}
export type LotacaoCreateQueryHookResult = ReturnType<typeof useLotacaoCreateQuery>
export type LotacaoCreateLazyQueryHookResult = ReturnType<typeof useLotacaoCreateLazyQuery>
export type LotacaoCreateQueryResult = ApolloReactCommon.QueryResult<
  Types.LotacaoCreateQuery,
  Types.LotacaoCreateQueryVariables
>
export const LotacaoEditViewDocument = gql`
  query LotacaoEditView($id: ID!) {
    lotacao(id: $id) {
      id
      importada
      hasConfiguracaoAgenda
      atualizaPerfil
      ativo
      profissional {
        nome
      }
      cbo {
        id
        nome
        cbo2002
      }
      equipe {
        id
        nome
        ine
        tipoEquipe {
          id
          nome
          sigla
        }
      }
      perfis {
        id
        nome
        ativo
      }
      unidadeSaude {
        id
        nome
        cnes
      }
      actions {
        permissaoEdicao {
          enabled
        }
      }
    }
  }
`

/**
 * __useLotacaoEditViewQuery__
 *
 * To run a query within a React component, call `useLotacaoEditViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useLotacaoEditViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLotacaoEditViewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLotacaoEditViewQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.LotacaoEditViewQuery, Types.LotacaoEditViewQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.LotacaoEditViewQuery, Types.LotacaoEditViewQueryVariables>(
    LotacaoEditViewDocument,
    baseOptions
  )
}
export function useLotacaoEditViewLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.LotacaoEditViewQuery, Types.LotacaoEditViewQueryVariables>
) {
  return ApolloReactHooks.useLazyQuery<Types.LotacaoEditViewQuery, Types.LotacaoEditViewQueryVariables>(
    LotacaoEditViewDocument,
    baseOptions
  )
}
export type LotacaoEditViewQueryHookResult = ReturnType<typeof useLotacaoEditViewQuery>
export type LotacaoEditViewLazyQueryHookResult = ReturnType<typeof useLotacaoEditViewLazyQuery>
export type LotacaoEditViewQueryResult = ApolloReactCommon.QueryResult<
  Types.LotacaoEditViewQuery,
  Types.LotacaoEditViewQueryVariables
>
export const DefinirSenhaPadraoDocument = gql`
  mutation DefinirSenhaPadrao($usuarioId: ID!) {
    definirSenhaPadrao(usuarioId: $usuarioId)
  }
`
export type DefinirSenhaPadraoMutationFn = ApolloReactCommon.MutationFunction<
  Types.DefinirSenhaPadraoMutation,
  Types.DefinirSenhaPadraoMutationVariables
>

/**
 * __useDefinirSenhaPadraoMutation__
 *
 * To run a mutation, you first call `useDefinirSenhaPadraoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDefinirSenhaPadraoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [definirSenhaPadraoMutation, { data, loading, error }] = useDefinirSenhaPadraoMutation({
 *   variables: {
 *      usuarioId: // value for 'usuarioId'
 *   },
 * });
 */
export function useDefinirSenhaPadraoMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.DefinirSenhaPadraoMutation,
    Types.DefinirSenhaPadraoMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<Types.DefinirSenhaPadraoMutation, Types.DefinirSenhaPadraoMutationVariables>(
    DefinirSenhaPadraoDocument,
    baseOptions
  )
}
export type DefinirSenhaPadraoMutationHookResult = ReturnType<typeof useDefinirSenhaPadraoMutation>
export type DefinirSenhaPadraoMutationResult = ApolloReactCommon.MutationResult<Types.DefinirSenhaPadraoMutation>
export type DefinirSenhaPadraoMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.DefinirSenhaPadraoMutation,
  Types.DefinirSenhaPadraoMutationVariables
>
export const ExcluirProfissionalDocument = gql`
  mutation ExcluirProfissional($profissionalId: ID!) {
    excluirProfissional(profissionalId: $profissionalId)
  }
`
export type ExcluirProfissionalMutationFn = ApolloReactCommon.MutationFunction<
  Types.ExcluirProfissionalMutation,
  Types.ExcluirProfissionalMutationVariables
>

/**
 * __useExcluirProfissionalMutation__
 *
 * To run a mutation, you first call `useExcluirProfissionalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExcluirProfissionalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [excluirProfissionalMutation, { data, loading, error }] = useExcluirProfissionalMutation({
 *   variables: {
 *      profissionalId: // value for 'profissionalId'
 *   },
 * });
 */
export function useExcluirProfissionalMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.ExcluirProfissionalMutation,
    Types.ExcluirProfissionalMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<Types.ExcluirProfissionalMutation, Types.ExcluirProfissionalMutationVariables>(
    ExcluirProfissionalDocument,
    baseOptions
  )
}
export type ExcluirProfissionalMutationHookResult = ReturnType<typeof useExcluirProfissionalMutation>
export type ExcluirProfissionalMutationResult = ApolloReactCommon.MutationResult<Types.ExcluirProfissionalMutation>
export type ExcluirProfissionalMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.ExcluirProfissionalMutation,
  Types.ExcluirProfissionalMutationVariables
>
export const ProfissionalTableDocument = gql`
  query ProfissionalTable($input: ProfissionaisQueryInput!) {
    profissionais(input: $input) {
      content {
        id
        nome
        cpf
        cns
        lotacoes {
          id
          ativo
          cbo {
            id
            nome
          }
        }
        usuario {
          id
          bloqueado
        }
        actions {
          redefinirSenha {
            enabled
            hint
          }
        }
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${PageInfoFragmentDoc}
`

/**
 * __useProfissionalTableQuery__
 *
 * To run a query within a React component, call `useProfissionalTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfissionalTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfissionalTableQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProfissionalTableQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ProfissionalTableQuery, Types.ProfissionalTableQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.ProfissionalTableQuery, Types.ProfissionalTableQueryVariables>(
    ProfissionalTableDocument,
    baseOptions
  )
}
export function useProfissionalTableLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.ProfissionalTableQuery,
    Types.ProfissionalTableQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<Types.ProfissionalTableQuery, Types.ProfissionalTableQueryVariables>(
    ProfissionalTableDocument,
    baseOptions
  )
}
export type ProfissionalTableQueryHookResult = ReturnType<typeof useProfissionalTableQuery>
export type ProfissionalTableLazyQueryHookResult = ReturnType<typeof useProfissionalTableLazyQuery>
export type ProfissionalTableQueryResult = ApolloReactCommon.QueryResult<
  Types.ProfissionalTableQuery,
  Types.ProfissionalTableQueryVariables
>
export const LotacaoSelectFieldDocument = gql`
  query LotacaoSelectField($input: LotacoesInput!) {
    lotacoes(input: $input) {
      content {
        id
        profissional {
          id
          nome
          cpf
        }
        unidadeSaude {
          id
          nome
          cnes
        }
        cbo {
          id
          nome
          cbo2002
        }
        equipe {
          id
          ine
          nome
        }
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${PageInfoFragmentDoc}
`

/**
 * __useLotacaoSelectFieldQuery__
 *
 * To run a query within a React component, call `useLotacaoSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useLotacaoSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLotacaoSelectFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLotacaoSelectFieldQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.LotacaoSelectFieldQuery, Types.LotacaoSelectFieldQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.LotacaoSelectFieldQuery, Types.LotacaoSelectFieldQueryVariables>(
    LotacaoSelectFieldDocument,
    baseOptions
  )
}
export function useLotacaoSelectFieldLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.LotacaoSelectFieldQuery,
    Types.LotacaoSelectFieldQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<Types.LotacaoSelectFieldQuery, Types.LotacaoSelectFieldQueryVariables>(
    LotacaoSelectFieldDocument,
    baseOptions
  )
}
export type LotacaoSelectFieldQueryHookResult = ReturnType<typeof useLotacaoSelectFieldQuery>
export type LotacaoSelectFieldLazyQueryHookResult = ReturnType<typeof useLotacaoSelectFieldLazyQuery>
export type LotacaoSelectFieldQueryResult = ApolloReactCommon.QueryResult<
  Types.LotacaoSelectFieldQuery,
  Types.LotacaoSelectFieldQueryVariables
>
export const RecuperarSenhaDocument = gql`
  mutation RecuperarSenha($input: RecuperarSenhaInput!) {
    recuperaSenha(input: $input)
  }
`
export type RecuperarSenhaMutationFn = ApolloReactCommon.MutationFunction<
  Types.RecuperarSenhaMutation,
  Types.RecuperarSenhaMutationVariables
>

/**
 * __useRecuperarSenhaMutation__
 *
 * To run a mutation, you first call `useRecuperarSenhaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecuperarSenhaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recuperarSenhaMutation, { data, loading, error }] = useRecuperarSenhaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecuperarSenhaMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.RecuperarSenhaMutation,
    Types.RecuperarSenhaMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<Types.RecuperarSenhaMutation, Types.RecuperarSenhaMutationVariables>(
    RecuperarSenhaDocument,
    baseOptions
  )
}
export type RecuperarSenhaMutationHookResult = ReturnType<typeof useRecuperarSenhaMutation>
export type RecuperarSenhaMutationResult = ApolloReactCommon.MutationResult<Types.RecuperarSenhaMutation>
export type RecuperarSenhaMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.RecuperarSenhaMutation,
  Types.RecuperarSenhaMutationVariables
>
export const SolicitacaoRecuperarSenhaDocument = gql`
  mutation SolicitacaoRecuperarSenha($input: SolicitacaoRecuperarSenhaInput!) {
    solicitarRecuperarSenha(input: $input)
  }
`
export type SolicitacaoRecuperarSenhaMutationFn = ApolloReactCommon.MutationFunction<
  Types.SolicitacaoRecuperarSenhaMutation,
  Types.SolicitacaoRecuperarSenhaMutationVariables
>

/**
 * __useSolicitacaoRecuperarSenhaMutation__
 *
 * To run a mutation, you first call `useSolicitacaoRecuperarSenhaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSolicitacaoRecuperarSenhaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [solicitacaoRecuperarSenhaMutation, { data, loading, error }] = useSolicitacaoRecuperarSenhaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSolicitacaoRecuperarSenhaMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.SolicitacaoRecuperarSenhaMutation,
    Types.SolicitacaoRecuperarSenhaMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    Types.SolicitacaoRecuperarSenhaMutation,
    Types.SolicitacaoRecuperarSenhaMutationVariables
  >(SolicitacaoRecuperarSenhaDocument, baseOptions)
}
export type SolicitacaoRecuperarSenhaMutationHookResult = ReturnType<typeof useSolicitacaoRecuperarSenhaMutation>
export type SolicitacaoRecuperarSenhaMutationResult = ApolloReactCommon.MutationResult<
  Types.SolicitacaoRecuperarSenhaMutation
>
export type SolicitacaoRecuperarSenhaMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.SolicitacaoRecuperarSenhaMutation,
  Types.SolicitacaoRecuperarSenhaMutationVariables
>
export const AbsenteismosDocument = gql`
  query Absenteismos($input: AbsenteismosQueryInput!) {
    absenteismos(input: $input) {
      id
      nomeMunicipio
      nomeUnidadeSaude
      nomeEquipe
      nomeProfissional
      nomeSituacaoAgendamento
      categoriaProfissional
      turno
      intervaloAgendamento
    }
  }
`

/**
 * __useAbsenteismosQuery__
 *
 * To run a query within a React component, call `useAbsenteismosQuery` and pass it any options that fit your needs.
 * When your component renders, `useAbsenteismosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAbsenteismosQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAbsenteismosQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.AbsenteismosQuery, Types.AbsenteismosQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.AbsenteismosQuery, Types.AbsenteismosQueryVariables>(
    AbsenteismosDocument,
    baseOptions
  )
}
export function useAbsenteismosLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AbsenteismosQuery, Types.AbsenteismosQueryVariables>
) {
  return ApolloReactHooks.useLazyQuery<Types.AbsenteismosQuery, Types.AbsenteismosQueryVariables>(
    AbsenteismosDocument,
    baseOptions
  )
}
export type AbsenteismosQueryHookResult = ReturnType<typeof useAbsenteismosQuery>
export type AbsenteismosLazyQueryHookResult = ReturnType<typeof useAbsenteismosLazyQuery>
export type AbsenteismosQueryResult = ApolloReactCommon.QueryResult<
  Types.AbsenteismosQuery,
  Types.AbsenteismosQueryVariables
>
export const InfoProfissionalCpfDocument = gql`
  query InfoProfissionalCpf($cpf: String!) {
    profissionalByCpf(cpf: $cpf) {
      id
    }
  }
`

/**
 * __useInfoProfissionalCpfQuery__
 *
 * To run a query within a React component, call `useInfoProfissionalCpfQuery` and pass it any options that fit your needs.
 * When your component renders, `useInfoProfissionalCpfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInfoProfissionalCpfQuery({
 *   variables: {
 *      cpf: // value for 'cpf'
 *   },
 * });
 */
export function useInfoProfissionalCpfQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.InfoProfissionalCpfQuery,
    Types.InfoProfissionalCpfQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<Types.InfoProfissionalCpfQuery, Types.InfoProfissionalCpfQueryVariables>(
    InfoProfissionalCpfDocument,
    baseOptions
  )
}
export function useInfoProfissionalCpfLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.InfoProfissionalCpfQuery,
    Types.InfoProfissionalCpfQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<Types.InfoProfissionalCpfQuery, Types.InfoProfissionalCpfQueryVariables>(
    InfoProfissionalCpfDocument,
    baseOptions
  )
}
export type InfoProfissionalCpfQueryHookResult = ReturnType<typeof useInfoProfissionalCpfQuery>
export type InfoProfissionalCpfLazyQueryHookResult = ReturnType<typeof useInfoProfissionalCpfLazyQuery>
export type InfoProfissionalCpfQueryResult = ApolloReactCommon.QueryResult<
  Types.InfoProfissionalCpfQuery,
  Types.InfoProfissionalCpfQueryVariables
>
export const ResetSenhaAdminDocument = gql`
  mutation ResetSenhaAdmin($input: ResetSenhaAdminInput!) {
    resetSenhaAdministrador(input: $input)
  }
`
export type ResetSenhaAdminMutationFn = ApolloReactCommon.MutationFunction<
  Types.ResetSenhaAdminMutation,
  Types.ResetSenhaAdminMutationVariables
>

/**
 * __useResetSenhaAdminMutation__
 *
 * To run a mutation, you first call `useResetSenhaAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetSenhaAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetSenhaAdminMutation, { data, loading, error }] = useResetSenhaAdminMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetSenhaAdminMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.ResetSenhaAdminMutation,
    Types.ResetSenhaAdminMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<Types.ResetSenhaAdminMutation, Types.ResetSenhaAdminMutationVariables>(
    ResetSenhaAdminDocument,
    baseOptions
  )
}
export type ResetSenhaAdminMutationHookResult = ReturnType<typeof useResetSenhaAdminMutation>
export type ResetSenhaAdminMutationResult = ApolloReactCommon.MutationResult<Types.ResetSenhaAdminMutation>
export type ResetSenhaAdminMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.ResetSenhaAdminMutation,
  Types.ResetSenhaAdminMutationVariables
>
export const SaveAdminProfissionalDocument = gql`
  mutation SaveAdminProfissional($input: ProfissionalContraChaveInput!) {
    salvarProfissionalContraChave(input: $input) {
      id
    }
  }
`
export type SaveAdminProfissionalMutationFn = ApolloReactCommon.MutationFunction<
  Types.SaveAdminProfissionalMutation,
  Types.SaveAdminProfissionalMutationVariables
>

/**
 * __useSaveAdminProfissionalMutation__
 *
 * To run a mutation, you first call `useSaveAdminProfissionalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAdminProfissionalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAdminProfissionalMutation, { data, loading, error }] = useSaveAdminProfissionalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveAdminProfissionalMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.SaveAdminProfissionalMutation,
    Types.SaveAdminProfissionalMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    Types.SaveAdminProfissionalMutation,
    Types.SaveAdminProfissionalMutationVariables
  >(SaveAdminProfissionalDocument, baseOptions)
}
export type SaveAdminProfissionalMutationHookResult = ReturnType<typeof useSaveAdminProfissionalMutation>
export type SaveAdminProfissionalMutationResult = ApolloReactCommon.MutationResult<Types.SaveAdminProfissionalMutation>
export type SaveAdminProfissionalMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.SaveAdminProfissionalMutation,
  Types.SaveAdminProfissionalMutationVariables
>
export const ValidateNovoAdminDocument = gql`
  query validateNovoAdmin($input: ValidateNovoAdminInput!) {
    validatePermissaoNovoAdmin(input: $input)
  }
`

/**
 * __useValidateNovoAdminQuery__
 *
 * To run a query within a React component, call `useValidateNovoAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateNovoAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateNovoAdminQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateNovoAdminQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ValidateNovoAdminQuery, Types.ValidateNovoAdminQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.ValidateNovoAdminQuery, Types.ValidateNovoAdminQueryVariables>(
    ValidateNovoAdminDocument,
    baseOptions
  )
}
export function useValidateNovoAdminLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.ValidateNovoAdminQuery,
    Types.ValidateNovoAdminQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<Types.ValidateNovoAdminQuery, Types.ValidateNovoAdminQueryVariables>(
    ValidateNovoAdminDocument,
    baseOptions
  )
}
export type ValidateNovoAdminQueryHookResult = ReturnType<typeof useValidateNovoAdminQuery>
export type ValidateNovoAdminLazyQueryHookResult = ReturnType<typeof useValidateNovoAdminLazyQuery>
export type ValidateNovoAdminQueryResult = ApolloReactCommon.QueryResult<
  Types.ValidateNovoAdminQuery,
  Types.ValidateNovoAdminQueryVariables
>
export const ValidateResetAdminDocument = gql`
  query ValidateResetAdmin($input: ResetSenhaAdminInput!) {
    validateResetAdmin(input: $input) {
      possuiCns
    }
  }
`

/**
 * __useValidateResetAdminQuery__
 *
 * To run a query within a React component, call `useValidateResetAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateResetAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateResetAdminQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateResetAdminQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ValidateResetAdminQuery, Types.ValidateResetAdminQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.ValidateResetAdminQuery, Types.ValidateResetAdminQueryVariables>(
    ValidateResetAdminDocument,
    baseOptions
  )
}
export function useValidateResetAdminLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.ValidateResetAdminQuery,
    Types.ValidateResetAdminQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<Types.ValidateResetAdminQuery, Types.ValidateResetAdminQueryVariables>(
    ValidateResetAdminDocument,
    baseOptions
  )
}
export type ValidateResetAdminQueryHookResult = ReturnType<typeof useValidateResetAdminQuery>
export type ValidateResetAdminLazyQueryHookResult = ReturnType<typeof useValidateResetAdminLazyQuery>
export type ValidateResetAdminQueryResult = ApolloReactCommon.QueryResult<
  Types.ValidateResetAdminQuery,
  Types.ValidateResetAdminQueryVariables
>
export const AlteraAdminDocument = gql`
  mutation AlteraAdmin($input: ValidateNovoAdminInput!) {
    denifinirNovoAdministrador(input: $input)
  }
`
export type AlteraAdminMutationFn = ApolloReactCommon.MutationFunction<
  Types.AlteraAdminMutation,
  Types.AlteraAdminMutationVariables
>

/**
 * __useAlteraAdminMutation__
 *
 * To run a mutation, you first call `useAlteraAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlteraAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alteraAdminMutation, { data, loading, error }] = useAlteraAdminMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAlteraAdminMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AlteraAdminMutation, Types.AlteraAdminMutationVariables>
) {
  return ApolloReactHooks.useMutation<Types.AlteraAdminMutation, Types.AlteraAdminMutationVariables>(
    AlteraAdminDocument,
    baseOptions
  )
}
export type AlteraAdminMutationHookResult = ReturnType<typeof useAlteraAdminMutation>
export type AlteraAdminMutationResult = ApolloReactCommon.MutationResult<Types.AlteraAdminMutation>
export type AlteraAdminMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.AlteraAdminMutation,
  Types.AlteraAdminMutationVariables
>
export const ChaveByCpfDocument = gql`
  query chaveByCpf($cpf: String!) {
    chaveByCpf(cpf: $cpf)
  }
`

/**
 * __useChaveByCpfQuery__
 *
 * To run a query within a React component, call `useChaveByCpfQuery` and pass it any options that fit your needs.
 * When your component renders, `useChaveByCpfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChaveByCpfQuery({
 *   variables: {
 *      cpf: // value for 'cpf'
 *   },
 * });
 */
export function useChaveByCpfQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ChaveByCpfQuery, Types.ChaveByCpfQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.ChaveByCpfQuery, Types.ChaveByCpfQueryVariables>(
    ChaveByCpfDocument,
    baseOptions
  )
}
export function useChaveByCpfLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ChaveByCpfQuery, Types.ChaveByCpfQueryVariables>
) {
  return ApolloReactHooks.useLazyQuery<Types.ChaveByCpfQuery, Types.ChaveByCpfQueryVariables>(
    ChaveByCpfDocument,
    baseOptions
  )
}
export type ChaveByCpfQueryHookResult = ReturnType<typeof useChaveByCpfQuery>
export type ChaveByCpfLazyQueryHookResult = ReturnType<typeof useChaveByCpfLazyQuery>
export type ChaveByCpfQueryResult = ApolloReactCommon.QueryResult<Types.ChaveByCpfQuery, Types.ChaveByCpfQueryVariables>
export const ProfissionalAdminDetailDocument = gql`
  query profissionalAdminDetail($cpf: String!) {
    profissionalByCpf(cpf: $cpf) {
      ...ProfissionalDetail
      usuario {
        id
      }
    }
  }
  ${ProfissionalDetailFragmentDoc}
`

/**
 * __useProfissionalAdminDetailQuery__
 *
 * To run a query within a React component, call `useProfissionalAdminDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfissionalAdminDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfissionalAdminDetailQuery({
 *   variables: {
 *      cpf: // value for 'cpf'
 *   },
 * });
 */
export function useProfissionalAdminDetailQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.ProfissionalAdminDetailQuery,
    Types.ProfissionalAdminDetailQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<Types.ProfissionalAdminDetailQuery, Types.ProfissionalAdminDetailQueryVariables>(
    ProfissionalAdminDetailDocument,
    baseOptions
  )
}
export function useProfissionalAdminDetailLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.ProfissionalAdminDetailQuery,
    Types.ProfissionalAdminDetailQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<Types.ProfissionalAdminDetailQuery, Types.ProfissionalAdminDetailQueryVariables>(
    ProfissionalAdminDetailDocument,
    baseOptions
  )
}
export type ProfissionalAdminDetailQueryHookResult = ReturnType<typeof useProfissionalAdminDetailQuery>
export type ProfissionalAdminDetailLazyQueryHookResult = ReturnType<typeof useProfissionalAdminDetailLazyQuery>
export type ProfissionalAdminDetailQueryResult = ApolloReactCommon.QueryResult<
  Types.ProfissionalAdminDetailQuery,
  Types.ProfissionalAdminDetailQueryVariables
>
export const SobreDocument = gql`
  query Sobre {
    info {
      commit
      competenciaSigtap
      databaseVendor
      databaseSchemaVersion
      recursosDisponiveis
      versao
      internetHabilitada
      smtpConfigurado
      linkInstalacaoConfigurado
    }
  }
`

/**
 * __useSobreQuery__
 *
 * To run a query within a React component, call `useSobreQuery` and pass it any options that fit your needs.
 * When your component renders, `useSobreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSobreQuery({
 *   variables: {
 *   },
 * });
 */
export function useSobreQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.SobreQuery, Types.SobreQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.SobreQuery, Types.SobreQueryVariables>(SobreDocument, baseOptions)
}
export function useSobreLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.SobreQuery, Types.SobreQueryVariables>
) {
  return ApolloReactHooks.useLazyQuery<Types.SobreQuery, Types.SobreQueryVariables>(SobreDocument, baseOptions)
}
export type SobreQueryHookResult = ReturnType<typeof useSobreQuery>
export type SobreLazyQueryHookResult = ReturnType<typeof useSobreLazyQuery>
export type SobreQueryResult = ApolloReactCommon.QueryResult<Types.SobreQuery, Types.SobreQueryVariables>
export const AceitarTermosUsoDocument = gql`
  mutation AceitarTermosUso {
    aceitarTermosUso {
      id
      trocarSenha
      aceitouTermosUso
    }
  }
`
export type AceitarTermosUsoMutationFn = ApolloReactCommon.MutationFunction<
  Types.AceitarTermosUsoMutation,
  Types.AceitarTermosUsoMutationVariables
>

/**
 * __useAceitarTermosUsoMutation__
 *
 * To run a mutation, you first call `useAceitarTermosUsoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAceitarTermosUsoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aceitarTermosUsoMutation, { data, loading, error }] = useAceitarTermosUsoMutation({
 *   variables: {
 *   },
 * });
 */
export function useAceitarTermosUsoMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.AceitarTermosUsoMutation,
    Types.AceitarTermosUsoMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<Types.AceitarTermosUsoMutation, Types.AceitarTermosUsoMutationVariables>(
    AceitarTermosUsoDocument,
    baseOptions
  )
}
export type AceitarTermosUsoMutationHookResult = ReturnType<typeof useAceitarTermosUsoMutation>
export type AceitarTermosUsoMutationResult = ApolloReactCommon.MutationResult<Types.AceitarTermosUsoMutation>
export type AceitarTermosUsoMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.AceitarTermosUsoMutation,
  Types.AceitarTermosUsoMutationVariables
>
export const AlternarTransmissaoLinkDocument = gql`
  mutation AlternarTransmissaoLink($id: ID!) {
    alternarTransmissaoLink(id: $id)
  }
`
export type AlternarTransmissaoLinkMutationFn = ApolloReactCommon.MutationFunction<
  Types.AlternarTransmissaoLinkMutation,
  Types.AlternarTransmissaoLinkMutationVariables
>

/**
 * __useAlternarTransmissaoLinkMutation__
 *
 * To run a mutation, you first call `useAlternarTransmissaoLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlternarTransmissaoLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alternarTransmissaoLinkMutation, { data, loading, error }] = useAlternarTransmissaoLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAlternarTransmissaoLinkMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.AlternarTransmissaoLinkMutation,
    Types.AlternarTransmissaoLinkMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    Types.AlternarTransmissaoLinkMutation,
    Types.AlternarTransmissaoLinkMutationVariables
  >(AlternarTransmissaoLinkDocument, baseOptions)
}
export type AlternarTransmissaoLinkMutationHookResult = ReturnType<typeof useAlternarTransmissaoLinkMutation>
export type AlternarTransmissaoLinkMutationResult = ApolloReactCommon.MutationResult<
  Types.AlternarTransmissaoLinkMutation
>
export type AlternarTransmissaoLinkMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.AlternarTransmissaoLinkMutation,
  Types.AlternarTransmissaoLinkMutationVariables
>
export const ExcluirTransmissaoLinkDocument = gql`
  mutation ExcluirTransmissaoLink($id: ID!) {
    excluirTransmissaoLink(id: $id)
  }
`
export type ExcluirTransmissaoLinkMutationFn = ApolloReactCommon.MutationFunction<
  Types.ExcluirTransmissaoLinkMutation,
  Types.ExcluirTransmissaoLinkMutationVariables
>

/**
 * __useExcluirTransmissaoLinkMutation__
 *
 * To run a mutation, you first call `useExcluirTransmissaoLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExcluirTransmissaoLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [excluirTransmissaoLinkMutation, { data, loading, error }] = useExcluirTransmissaoLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExcluirTransmissaoLinkMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.ExcluirTransmissaoLinkMutation,
    Types.ExcluirTransmissaoLinkMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    Types.ExcluirTransmissaoLinkMutation,
    Types.ExcluirTransmissaoLinkMutationVariables
  >(ExcluirTransmissaoLinkDocument, baseOptions)
}
export type ExcluirTransmissaoLinkMutationHookResult = ReturnType<typeof useExcluirTransmissaoLinkMutation>
export type ExcluirTransmissaoLinkMutationResult = ApolloReactCommon.MutationResult<
  Types.ExcluirTransmissaoLinkMutation
>
export type ExcluirTransmissaoLinkMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.ExcluirTransmissaoLinkMutation,
  Types.ExcluirTransmissaoLinkMutationVariables
>
export const InserirTransmissaoLinkDocument = gql`
  mutation InserirTransmissaoLink($form: TransmissaoLinkInsertDto!) {
    inserirTransmissaoLink(form: $form)
  }
`
export type InserirTransmissaoLinkMutationFn = ApolloReactCommon.MutationFunction<
  Types.InserirTransmissaoLinkMutation,
  Types.InserirTransmissaoLinkMutationVariables
>

/**
 * __useInserirTransmissaoLinkMutation__
 *
 * To run a mutation, you first call `useInserirTransmissaoLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInserirTransmissaoLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inserirTransmissaoLinkMutation, { data, loading, error }] = useInserirTransmissaoLinkMutation({
 *   variables: {
 *      form: // value for 'form'
 *   },
 * });
 */
export function useInserirTransmissaoLinkMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.InserirTransmissaoLinkMutation,
    Types.InserirTransmissaoLinkMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    Types.InserirTransmissaoLinkMutation,
    Types.InserirTransmissaoLinkMutationVariables
  >(InserirTransmissaoLinkDocument, baseOptions)
}
export type InserirTransmissaoLinkMutationHookResult = ReturnType<typeof useInserirTransmissaoLinkMutation>
export type InserirTransmissaoLinkMutationResult = ApolloReactCommon.MutationResult<
  Types.InserirTransmissaoLinkMutation
>
export type InserirTransmissaoLinkMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.InserirTransmissaoLinkMutation,
  Types.InserirTransmissaoLinkMutationVariables
>
export const TransmissaoLinkDocument = gql`
  query TransmissaoLink($input: TransmissaoLinkPagingQueryFiltroDto!) {
    transmissaoLink(input: $input) {
      content {
        id
        hostname
        name
        ativo
        statusConexao
        dataTesteConexao
        actions {
          alternarAtivacao {
            enabled
            hint
          }
          excluir {
            enabled
            hint
          }
          editar {
            enabled
            hint
          }
        }
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${PageInfoFragmentDoc}
`

/**
 * __useTransmissaoLinkQuery__
 *
 * To run a query within a React component, call `useTransmissaoLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransmissaoLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransmissaoLinkQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTransmissaoLinkQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.TransmissaoLinkQuery, Types.TransmissaoLinkQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.TransmissaoLinkQuery, Types.TransmissaoLinkQueryVariables>(
    TransmissaoLinkDocument,
    baseOptions
  )
}
export function useTransmissaoLinkLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.TransmissaoLinkQuery, Types.TransmissaoLinkQueryVariables>
) {
  return ApolloReactHooks.useLazyQuery<Types.TransmissaoLinkQuery, Types.TransmissaoLinkQueryVariables>(
    TransmissaoLinkDocument,
    baseOptions
  )
}
export type TransmissaoLinkQueryHookResult = ReturnType<typeof useTransmissaoLinkQuery>
export type TransmissaoLinkLazyQueryHookResult = ReturnType<typeof useTransmissaoLinkLazyQuery>
export type TransmissaoLinkQueryResult = ApolloReactCommon.QueryResult<
  Types.TransmissaoLinkQuery,
  Types.TransmissaoLinkQueryVariables
>
export const TestarConexaoLinkTransmissaoDocument = gql`
  mutation TestarConexaoLinkTransmissao($id: ID!) {
    testarConexaoLinkTransmissao(id: $id) {
      link {
        id
        hostname
        name
        ativo
        statusConexao
        dataTesteConexao
      }
      validationDescription
    }
  }
`
export type TestarConexaoLinkTransmissaoMutationFn = ApolloReactCommon.MutationFunction<
  Types.TestarConexaoLinkTransmissaoMutation,
  Types.TestarConexaoLinkTransmissaoMutationVariables
>

/**
 * __useTestarConexaoLinkTransmissaoMutation__
 *
 * To run a mutation, you first call `useTestarConexaoLinkTransmissaoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTestarConexaoLinkTransmissaoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testarConexaoLinkTransmissaoMutation, { data, loading, error }] = useTestarConexaoLinkTransmissaoMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTestarConexaoLinkTransmissaoMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.TestarConexaoLinkTransmissaoMutation,
    Types.TestarConexaoLinkTransmissaoMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    Types.TestarConexaoLinkTransmissaoMutation,
    Types.TestarConexaoLinkTransmissaoMutationVariables
  >(TestarConexaoLinkTransmissaoDocument, baseOptions)
}
export type TestarConexaoLinkTransmissaoMutationHookResult = ReturnType<typeof useTestarConexaoLinkTransmissaoMutation>
export type TestarConexaoLinkTransmissaoMutationResult = ApolloReactCommon.MutationResult<
  Types.TestarConexaoLinkTransmissaoMutation
>
export type TestarConexaoLinkTransmissaoMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.TestarConexaoLinkTransmissaoMutation,
  Types.TestarConexaoLinkTransmissaoMutationVariables
>
export const UpdateTransmissaoLinkDocument = gql`
  mutation UpdateTransmissaoLink($form: TransmissaoLinkUpdateDto!) {
    updateTransmissaoLink(form: $form)
  }
`
export type UpdateTransmissaoLinkMutationFn = ApolloReactCommon.MutationFunction<
  Types.UpdateTransmissaoLinkMutation,
  Types.UpdateTransmissaoLinkMutationVariables
>

/**
 * __useUpdateTransmissaoLinkMutation__
 *
 * To run a mutation, you first call `useUpdateTransmissaoLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTransmissaoLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTransmissaoLinkMutation, { data, loading, error }] = useUpdateTransmissaoLinkMutation({
 *   variables: {
 *      form: // value for 'form'
 *   },
 * });
 */
export function useUpdateTransmissaoLinkMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.UpdateTransmissaoLinkMutation,
    Types.UpdateTransmissaoLinkMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    Types.UpdateTransmissaoLinkMutation,
    Types.UpdateTransmissaoLinkMutationVariables
  >(UpdateTransmissaoLinkDocument, baseOptions)
}
export type UpdateTransmissaoLinkMutationHookResult = ReturnType<typeof useUpdateTransmissaoLinkMutation>
export type UpdateTransmissaoLinkMutationResult = ApolloReactCommon.MutationResult<Types.UpdateTransmissaoLinkMutation>
export type UpdateTransmissaoLinkMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.UpdateTransmissaoLinkMutation,
  Types.UpdateTransmissaoLinkMutationVariables
>
export const TransmissaoRecebimentoLotesDocument = gql`
  query TransmissaoRecebimentoLotes($input: TransmissaoRecebimentoLoteFiltro!) {
    transmissaoRecebimentoLotes(input: $input) {
      content {
        id
        numeroLote
        responsavel
        processado
        data
        counts {
          fichasValidas
          fichasInvalidas
          totalFichas
          fichasRepetidas
        }
        possuiInconsistencia
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${PageInfoFragmentDoc}
`

/**
 * __useTransmissaoRecebimentoLotesQuery__
 *
 * To run a query within a React component, call `useTransmissaoRecebimentoLotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransmissaoRecebimentoLotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransmissaoRecebimentoLotesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTransmissaoRecebimentoLotesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.TransmissaoRecebimentoLotesQuery,
    Types.TransmissaoRecebimentoLotesQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    Types.TransmissaoRecebimentoLotesQuery,
    Types.TransmissaoRecebimentoLotesQueryVariables
  >(TransmissaoRecebimentoLotesDocument, baseOptions)
}
export function useTransmissaoRecebimentoLotesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.TransmissaoRecebimentoLotesQuery,
    Types.TransmissaoRecebimentoLotesQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    Types.TransmissaoRecebimentoLotesQuery,
    Types.TransmissaoRecebimentoLotesQueryVariables
  >(TransmissaoRecebimentoLotesDocument, baseOptions)
}
export type TransmissaoRecebimentoLotesQueryHookResult = ReturnType<typeof useTransmissaoRecebimentoLotesQuery>
export type TransmissaoRecebimentoLotesLazyQueryHookResult = ReturnType<typeof useTransmissaoRecebimentoLotesLazyQuery>
export type TransmissaoRecebimentoLotesQueryResult = ApolloReactCommon.QueryResult<
  Types.TransmissaoRecebimentoLotesQuery,
  Types.TransmissaoRecebimentoLotesQueryVariables
>
export const AlterarHorarioGeracaoLotesProcessamentoFichasDocument = gql`
  mutation AlterarHorarioGeracaoLotesProcessamentoFichas($horario: LocalTime!) {
    alterarHorarioGeracaoLotesProcessamentoFichas(horario: $horario)
  }
`
export type AlterarHorarioGeracaoLotesProcessamentoFichasMutationFn = ApolloReactCommon.MutationFunction<
  Types.AlterarHorarioGeracaoLotesProcessamentoFichasMutation,
  Types.AlterarHorarioGeracaoLotesProcessamentoFichasMutationVariables
>

/**
 * __useAlterarHorarioGeracaoLotesProcessamentoFichasMutation__
 *
 * To run a mutation, you first call `useAlterarHorarioGeracaoLotesProcessamentoFichasMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlterarHorarioGeracaoLotesProcessamentoFichasMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alterarHorarioGeracaoLotesProcessamentoFichasMutation, { data, loading, error }] = useAlterarHorarioGeracaoLotesProcessamentoFichasMutation({
 *   variables: {
 *      horario: // value for 'horario'
 *   },
 * });
 */
export function useAlterarHorarioGeracaoLotesProcessamentoFichasMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.AlterarHorarioGeracaoLotesProcessamentoFichasMutation,
    Types.AlterarHorarioGeracaoLotesProcessamentoFichasMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    Types.AlterarHorarioGeracaoLotesProcessamentoFichasMutation,
    Types.AlterarHorarioGeracaoLotesProcessamentoFichasMutationVariables
  >(AlterarHorarioGeracaoLotesProcessamentoFichasDocument, baseOptions)
}
export type AlterarHorarioGeracaoLotesProcessamentoFichasMutationHookResult = ReturnType<
  typeof useAlterarHorarioGeracaoLotesProcessamentoFichasMutation
>
export type AlterarHorarioGeracaoLotesProcessamentoFichasMutationResult = ApolloReactCommon.MutationResult<
  Types.AlterarHorarioGeracaoLotesProcessamentoFichasMutation
>
export type AlterarHorarioGeracaoLotesProcessamentoFichasMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.AlterarHorarioGeracaoLotesProcessamentoFichasMutation,
  Types.AlterarHorarioGeracaoLotesProcessamentoFichasMutationVariables
>
export const LoadHorarioGeracaoLotesProcessamentoFichasDocument = gql`
  query LoadHorarioGeracaoLotesProcessamentoFichas {
    loadHorarioGeracaoLotesProcessamentoFichas
  }
`

/**
 * __useLoadHorarioGeracaoLotesProcessamentoFichasQuery__
 *
 * To run a query within a React component, call `useLoadHorarioGeracaoLotesProcessamentoFichasQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadHorarioGeracaoLotesProcessamentoFichasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadHorarioGeracaoLotesProcessamentoFichasQuery({
 *   variables: {
 *   },
 * });
 */
export function useLoadHorarioGeracaoLotesProcessamentoFichasQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.LoadHorarioGeracaoLotesProcessamentoFichasQuery,
    Types.LoadHorarioGeracaoLotesProcessamentoFichasQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    Types.LoadHorarioGeracaoLotesProcessamentoFichasQuery,
    Types.LoadHorarioGeracaoLotesProcessamentoFichasQueryVariables
  >(LoadHorarioGeracaoLotesProcessamentoFichasDocument, baseOptions)
}
export function useLoadHorarioGeracaoLotesProcessamentoFichasLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.LoadHorarioGeracaoLotesProcessamentoFichasQuery,
    Types.LoadHorarioGeracaoLotesProcessamentoFichasQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    Types.LoadHorarioGeracaoLotesProcessamentoFichasQuery,
    Types.LoadHorarioGeracaoLotesProcessamentoFichasQueryVariables
  >(LoadHorarioGeracaoLotesProcessamentoFichasDocument, baseOptions)
}
export type LoadHorarioGeracaoLotesProcessamentoFichasQueryHookResult = ReturnType<
  typeof useLoadHorarioGeracaoLotesProcessamentoFichasQuery
>
export type LoadHorarioGeracaoLotesProcessamentoFichasLazyQueryHookResult = ReturnType<
  typeof useLoadHorarioGeracaoLotesProcessamentoFichasLazyQuery
>
export type LoadHorarioGeracaoLotesProcessamentoFichasQueryResult = ApolloReactCommon.QueryResult<
  Types.LoadHorarioGeracaoLotesProcessamentoFichasQuery,
  Types.LoadHorarioGeracaoLotesProcessamentoFichasQueryVariables
>
export const LoteEnvioDocument = gql`
  query LoteEnvio($idLote: ID!, $filtroHistorico: HistoricoExportacaoFiltro!) {
    loteEnvio(idLote: $idLote) {
      id
      dataCriacao
      quantidadeFichas
      nodos {
        id
        dataEnvio
        nodeNome
        statusEnvio
      }
      historicoExportacao(filtro: $filtroHistorico) {
        content {
          id
          nomeProfissional
          dataExportacao
        }
        pageInfo {
          ...PageInfo
        }
      }
    }
  }
  ${PageInfoFragmentDoc}
`

/**
 * __useLoteEnvioQuery__
 *
 * To run a query within a React component, call `useLoteEnvioQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoteEnvioQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoteEnvioQuery({
 *   variables: {
 *      idLote: // value for 'idLote'
 *      filtroHistorico: // value for 'filtroHistorico'
 *   },
 * });
 */
export function useLoteEnvioQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.LoteEnvioQuery, Types.LoteEnvioQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.LoteEnvioQuery, Types.LoteEnvioQueryVariables>(LoteEnvioDocument, baseOptions)
}
export function useLoteEnvioLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.LoteEnvioQuery, Types.LoteEnvioQueryVariables>
) {
  return ApolloReactHooks.useLazyQuery<Types.LoteEnvioQuery, Types.LoteEnvioQueryVariables>(
    LoteEnvioDocument,
    baseOptions
  )
}
export type LoteEnvioQueryHookResult = ReturnType<typeof useLoteEnvioQuery>
export type LoteEnvioLazyQueryHookResult = ReturnType<typeof useLoteEnvioLazyQuery>
export type LoteEnvioQueryResult = ApolloReactCommon.QueryResult<Types.LoteEnvioQuery, Types.LoteEnvioQueryVariables>
export const GerarLotesDocument = gql`
  mutation GerarLotes {
    gerarLote
  }
`
export type GerarLotesMutationFn = ApolloReactCommon.MutationFunction<
  Types.GerarLotesMutation,
  Types.GerarLotesMutationVariables
>

/**
 * __useGerarLotesMutation__
 *
 * To run a mutation, you first call `useGerarLotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGerarLotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [gerarLotesMutation, { data, loading, error }] = useGerarLotesMutation({
 *   variables: {
 *   },
 * });
 */
export function useGerarLotesMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<Types.GerarLotesMutation, Types.GerarLotesMutationVariables>
) {
  return ApolloReactHooks.useMutation<Types.GerarLotesMutation, Types.GerarLotesMutationVariables>(
    GerarLotesDocument,
    baseOptions
  )
}
export type GerarLotesMutationHookResult = ReturnType<typeof useGerarLotesMutation>
export type GerarLotesMutationResult = ApolloReactCommon.MutationResult<Types.GerarLotesMutation>
export type GerarLotesMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.GerarLotesMutation,
  Types.GerarLotesMutationVariables
>
export const OnLoteGeradoDocument = gql`
  subscription onLoteGerado {
    onLoteGerado {
      message
    }
  }
`

/**
 * __useOnLoteGeradoSubscription__
 *
 * To run a query within a React component, call `useOnLoteGeradoSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnLoteGeradoSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnLoteGeradoSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnLoteGeradoSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    Types.OnLoteGeradoSubscription,
    Types.OnLoteGeradoSubscriptionVariables
  >
) {
  return ApolloReactHooks.useSubscription<Types.OnLoteGeradoSubscription, Types.OnLoteGeradoSubscriptionVariables>(
    OnLoteGeradoDocument,
    baseOptions
  )
}
export type OnLoteGeradoSubscriptionHookResult = ReturnType<typeof useOnLoteGeradoSubscription>
export type OnLoteGeradoSubscriptionResult = ApolloReactCommon.SubscriptionResult<Types.OnLoteGeradoSubscription>
export const LotesEnvioDocument = gql`
  query LotesEnvio($input: LotesEnvioFiltro!) {
    lotesEnvio(input: $input) {
      content {
        id
        statusEnvio
        dataCriacao
        quantidadeFichas
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${PageInfoFragmentDoc}
`

/**
 * __useLotesEnvioQuery__
 *
 * To run a query within a React component, call `useLotesEnvioQuery` and pass it any options that fit your needs.
 * When your component renders, `useLotesEnvioQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLotesEnvioQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLotesEnvioQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.LotesEnvioQuery, Types.LotesEnvioQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.LotesEnvioQuery, Types.LotesEnvioQueryVariables>(
    LotesEnvioDocument,
    baseOptions
  )
}
export function useLotesEnvioLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.LotesEnvioQuery, Types.LotesEnvioQueryVariables>
) {
  return ApolloReactHooks.useLazyQuery<Types.LotesEnvioQuery, Types.LotesEnvioQueryVariables>(
    LotesEnvioDocument,
    baseOptions
  )
}
export type LotesEnvioQueryHookResult = ReturnType<typeof useLotesEnvioQuery>
export type LotesEnvioLazyQueryHookResult = ReturnType<typeof useLotesEnvioLazyQuery>
export type LotesEnvioQueryResult = ApolloReactCommon.QueryResult<Types.LotesEnvioQuery, Types.LotesEnvioQueryVariables>
export const TransmissaoRecebimentoCnesDetailItemsDocument = gql`
  query TransmissaoRecebimentoCnesDetailItems($input: TransmissaoRecebimentoCnesDetailFiltro!) {
    transmissaoRecebimentoCnesDetailItems(input: $input) {
      nomeEstabelecimento
      tipoFicha
      quantidade
    }
  }
`

/**
 * __useTransmissaoRecebimentoCnesDetailItemsQuery__
 *
 * To run a query within a React component, call `useTransmissaoRecebimentoCnesDetailItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransmissaoRecebimentoCnesDetailItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransmissaoRecebimentoCnesDetailItemsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTransmissaoRecebimentoCnesDetailItemsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.TransmissaoRecebimentoCnesDetailItemsQuery,
    Types.TransmissaoRecebimentoCnesDetailItemsQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    Types.TransmissaoRecebimentoCnesDetailItemsQuery,
    Types.TransmissaoRecebimentoCnesDetailItemsQueryVariables
  >(TransmissaoRecebimentoCnesDetailItemsDocument, baseOptions)
}
export function useTransmissaoRecebimentoCnesDetailItemsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.TransmissaoRecebimentoCnesDetailItemsQuery,
    Types.TransmissaoRecebimentoCnesDetailItemsQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    Types.TransmissaoRecebimentoCnesDetailItemsQuery,
    Types.TransmissaoRecebimentoCnesDetailItemsQueryVariables
  >(TransmissaoRecebimentoCnesDetailItemsDocument, baseOptions)
}
export type TransmissaoRecebimentoCnesDetailItemsQueryHookResult = ReturnType<
  typeof useTransmissaoRecebimentoCnesDetailItemsQuery
>
export type TransmissaoRecebimentoCnesDetailItemsLazyQueryHookResult = ReturnType<
  typeof useTransmissaoRecebimentoCnesDetailItemsLazyQuery
>
export type TransmissaoRecebimentoCnesDetailItemsQueryResult = ApolloReactCommon.QueryResult<
  Types.TransmissaoRecebimentoCnesDetailItemsQuery,
  Types.TransmissaoRecebimentoCnesDetailItemsQueryVariables
>
export const TransmissaoRecebimentoCnesDocument = gql`
  query TransmissaoRecebimentoCnes($input: TransmissaoRecebimentoCnesFiltro!) {
    transmissaoRecebimentoCnes(input: $input) {
      content {
        numCnes
        mesRecebimento
        anoRecebimento
        fichasRecebidas
        estabelecimentoOrigem
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${PageInfoFragmentDoc}
`

/**
 * __useTransmissaoRecebimentoCnesQuery__
 *
 * To run a query within a React component, call `useTransmissaoRecebimentoCnesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransmissaoRecebimentoCnesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransmissaoRecebimentoCnesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTransmissaoRecebimentoCnesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.TransmissaoRecebimentoCnesQuery,
    Types.TransmissaoRecebimentoCnesQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    Types.TransmissaoRecebimentoCnesQuery,
    Types.TransmissaoRecebimentoCnesQueryVariables
  >(TransmissaoRecebimentoCnesDocument, baseOptions)
}
export function useTransmissaoRecebimentoCnesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.TransmissaoRecebimentoCnesQuery,
    Types.TransmissaoRecebimentoCnesQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    Types.TransmissaoRecebimentoCnesQuery,
    Types.TransmissaoRecebimentoCnesQueryVariables
  >(TransmissaoRecebimentoCnesDocument, baseOptions)
}
export type TransmissaoRecebimentoCnesQueryHookResult = ReturnType<typeof useTransmissaoRecebimentoCnesQuery>
export type TransmissaoRecebimentoCnesLazyQueryHookResult = ReturnType<typeof useTransmissaoRecebimentoCnesLazyQuery>
export type TransmissaoRecebimentoCnesQueryResult = ApolloReactCommon.QueryResult<
  Types.TransmissaoRecebimentoCnesQuery,
  Types.TransmissaoRecebimentoCnesQueryVariables
>
export const ExistemFichasParaProcessarDocument = gql`
  query ExistemFichasParaProcessar {
    existemFichasParaProcessar
  }
`

/**
 * __useExistemFichasParaProcessarQuery__
 *
 * To run a query within a React component, call `useExistemFichasParaProcessarQuery` and pass it any options that fit your needs.
 * When your component renders, `useExistemFichasParaProcessarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExistemFichasParaProcessarQuery({
 *   variables: {
 *   },
 * });
 */
export function useExistemFichasParaProcessarQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.ExistemFichasParaProcessarQuery,
    Types.ExistemFichasParaProcessarQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    Types.ExistemFichasParaProcessarQuery,
    Types.ExistemFichasParaProcessarQueryVariables
  >(ExistemFichasParaProcessarDocument, baseOptions)
}
export function useExistemFichasParaProcessarLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.ExistemFichasParaProcessarQuery,
    Types.ExistemFichasParaProcessarQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    Types.ExistemFichasParaProcessarQuery,
    Types.ExistemFichasParaProcessarQueryVariables
  >(ExistemFichasParaProcessarDocument, baseOptions)
}
export type ExistemFichasParaProcessarQueryHookResult = ReturnType<typeof useExistemFichasParaProcessarQuery>
export type ExistemFichasParaProcessarLazyQueryHookResult = ReturnType<typeof useExistemFichasParaProcessarLazyQuery>
export type ExistemFichasParaProcessarQueryResult = ApolloReactCommon.QueryResult<
  Types.ExistemFichasParaProcessarQuery,
  Types.ExistemFichasParaProcessarQueryVariables
>
export const OnTransmissaoUpdatedDocument = gql`
  subscription onTransmissaoUpdated {
    transmissaoUpdated {
      id
      importacaoArquivo {
        dataEvento
        status
        message
      }
    }
  }
`

/**
 * __useOnTransmissaoUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnTransmissaoUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnTransmissaoUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnTransmissaoUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnTransmissaoUpdatedSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    Types.OnTransmissaoUpdatedSubscription,
    Types.OnTransmissaoUpdatedSubscriptionVariables
  >
) {
  return ApolloReactHooks.useSubscription<
    Types.OnTransmissaoUpdatedSubscription,
    Types.OnTransmissaoUpdatedSubscriptionVariables
  >(OnTransmissaoUpdatedDocument, baseOptions)
}
export type OnTransmissaoUpdatedSubscriptionHookResult = ReturnType<typeof useOnTransmissaoUpdatedSubscription>
export type OnTransmissaoUpdatedSubscriptionResult = ApolloReactCommon.SubscriptionResult<
  Types.OnTransmissaoUpdatedSubscription
>
export const TransmissaoDocument = gql`
  query Transmissao {
    transmissao {
      id
      importacaoArquivo {
        dataEvento
        status
        message
      }
    }
  }
`

/**
 * __useTransmissaoQuery__
 *
 * To run a query within a React component, call `useTransmissaoQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransmissaoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransmissaoQuery({
 *   variables: {
 *   },
 * });
 */
export function useTransmissaoQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.TransmissaoQuery, Types.TransmissaoQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.TransmissaoQuery, Types.TransmissaoQueryVariables>(
    TransmissaoDocument,
    baseOptions
  )
}
export function useTransmissaoLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.TransmissaoQuery, Types.TransmissaoQueryVariables>
) {
  return ApolloReactHooks.useLazyQuery<Types.TransmissaoQuery, Types.TransmissaoQueryVariables>(
    TransmissaoDocument,
    baseOptions
  )
}
export type TransmissaoQueryHookResult = ReturnType<typeof useTransmissaoQuery>
export type TransmissaoLazyQueryHookResult = ReturnType<typeof useTransmissaoLazyQuery>
export type TransmissaoQueryResult = ApolloReactCommon.QueryResult<
  Types.TransmissaoQuery,
  Types.TransmissaoQueryVariables
>
export const AtivarTipoServicoDocument = gql`
  mutation AtivarTipoServico($unidadeSaudeTipoServicoFormInput: UnidadeSaudeTipoServicoFormInput!) {
    ativarTipoServico(unidadeSaudeTipoServicoFormInput: $unidadeSaudeTipoServicoFormInput) {
      unidadeSaudeId
      tipoServicoId
    }
  }
`
export type AtivarTipoServicoMutationFn = ApolloReactCommon.MutationFunction<
  Types.AtivarTipoServicoMutation,
  Types.AtivarTipoServicoMutationVariables
>

/**
 * __useAtivarTipoServicoMutation__
 *
 * To run a mutation, you first call `useAtivarTipoServicoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAtivarTipoServicoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ativarTipoServicoMutation, { data, loading, error }] = useAtivarTipoServicoMutation({
 *   variables: {
 *      unidadeSaudeTipoServicoFormInput: // value for 'unidadeSaudeTipoServicoFormInput'
 *   },
 * });
 */
export function useAtivarTipoServicoMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.AtivarTipoServicoMutation,
    Types.AtivarTipoServicoMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<Types.AtivarTipoServicoMutation, Types.AtivarTipoServicoMutationVariables>(
    AtivarTipoServicoDocument,
    baseOptions
  )
}
export type AtivarTipoServicoMutationHookResult = ReturnType<typeof useAtivarTipoServicoMutation>
export type AtivarTipoServicoMutationResult = ApolloReactCommon.MutationResult<Types.AtivarTipoServicoMutation>
export type AtivarTipoServicoMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.AtivarTipoServicoMutation,
  Types.AtivarTipoServicoMutationVariables
>
export const DesativarTipoServicoDocument = gql`
  mutation DesativarTipoServico($unidadeSaudeTipoServicoFormInput: UnidadeSaudeTipoServicoFormInput!) {
    desativarTipoServico(unidadeSaudeTipoServicoFormInput: $unidadeSaudeTipoServicoFormInput) {
      unidadeSaudeId
      tipoServicoId
    }
  }
`
export type DesativarTipoServicoMutationFn = ApolloReactCommon.MutationFunction<
  Types.DesativarTipoServicoMutation,
  Types.DesativarTipoServicoMutationVariables
>

/**
 * __useDesativarTipoServicoMutation__
 *
 * To run a mutation, you first call `useDesativarTipoServicoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDesativarTipoServicoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [desativarTipoServicoMutation, { data, loading, error }] = useDesativarTipoServicoMutation({
 *   variables: {
 *      unidadeSaudeTipoServicoFormInput: // value for 'unidadeSaudeTipoServicoFormInput'
 *   },
 * });
 */
export function useDesativarTipoServicoMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.DesativarTipoServicoMutation,
    Types.DesativarTipoServicoMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<Types.DesativarTipoServicoMutation, Types.DesativarTipoServicoMutationVariables>(
    DesativarTipoServicoDocument,
    baseOptions
  )
}
export type DesativarTipoServicoMutationHookResult = ReturnType<typeof useDesativarTipoServicoMutation>
export type DesativarTipoServicoMutationResult = ApolloReactCommon.MutationResult<Types.DesativarTipoServicoMutation>
export type DesativarTipoServicoMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.DesativarTipoServicoMutation,
  Types.DesativarTipoServicoMutationVariables
>
export const UnidadeSaudeDetailDocument = gql`
  query UnidadeSaudeDetail($id: ID!) {
    unidadeSaude(id: $id) {
      id
      nome
      cnes
      cnpj
      email
      telefone1
      telefone2
      fax
      tipo {
        id
        descricao
      }
      complexidades {
        id
        nome
      }
      ativo
      endereco {
        cep
        municipio {
          nome
        }
        uf {
          sigla
        }
        tipoLogradouro {
          nome
        }
        logradouro
        numero
        semNumero
        complemento
        pontoReferencia
        bairro
      }
      actions {
        permissaoAtivarInativarTipoServico {
          enabled
          hint
        }
      }
    }
  }
`

/**
 * __useUnidadeSaudeDetailQuery__
 *
 * To run a query within a React component, call `useUnidadeSaudeDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnidadeSaudeDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnidadeSaudeDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnidadeSaudeDetailQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.UnidadeSaudeDetailQuery, Types.UnidadeSaudeDetailQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.UnidadeSaudeDetailQuery, Types.UnidadeSaudeDetailQueryVariables>(
    UnidadeSaudeDetailDocument,
    baseOptions
  )
}
export function useUnidadeSaudeDetailLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.UnidadeSaudeDetailQuery,
    Types.UnidadeSaudeDetailQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<Types.UnidadeSaudeDetailQuery, Types.UnidadeSaudeDetailQueryVariables>(
    UnidadeSaudeDetailDocument,
    baseOptions
  )
}
export type UnidadeSaudeDetailQueryHookResult = ReturnType<typeof useUnidadeSaudeDetailQuery>
export type UnidadeSaudeDetailLazyQueryHookResult = ReturnType<typeof useUnidadeSaudeDetailLazyQuery>
export type UnidadeSaudeDetailQueryResult = ApolloReactCommon.QueryResult<
  Types.UnidadeSaudeDetailQuery,
  Types.UnidadeSaudeDetailQueryVariables
>
export const UnidadeSaudeTipoServicoDocument = gql`
  query UnidadeSaudeTipoServico($input: UnidadeSaudeTipoServicoQueryInput!) {
    unidadeSaudeTiposServico(input: $input) {
      content {
        tipoServico {
          id
          nome
        }
        ativo
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${PageInfoFragmentDoc}
`

/**
 * __useUnidadeSaudeTipoServicoQuery__
 *
 * To run a query within a React component, call `useUnidadeSaudeTipoServicoQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnidadeSaudeTipoServicoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnidadeSaudeTipoServicoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnidadeSaudeTipoServicoQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.UnidadeSaudeTipoServicoQuery,
    Types.UnidadeSaudeTipoServicoQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<Types.UnidadeSaudeTipoServicoQuery, Types.UnidadeSaudeTipoServicoQueryVariables>(
    UnidadeSaudeTipoServicoDocument,
    baseOptions
  )
}
export function useUnidadeSaudeTipoServicoLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.UnidadeSaudeTipoServicoQuery,
    Types.UnidadeSaudeTipoServicoQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<Types.UnidadeSaudeTipoServicoQuery, Types.UnidadeSaudeTipoServicoQueryVariables>(
    UnidadeSaudeTipoServicoDocument,
    baseOptions
  )
}
export type UnidadeSaudeTipoServicoQueryHookResult = ReturnType<typeof useUnidadeSaudeTipoServicoQuery>
export type UnidadeSaudeTipoServicoLazyQueryHookResult = ReturnType<typeof useUnidadeSaudeTipoServicoLazyQuery>
export type UnidadeSaudeTipoServicoQueryResult = ApolloReactCommon.QueryResult<
  Types.UnidadeSaudeTipoServicoQuery,
  Types.UnidadeSaudeTipoServicoQueryVariables
>
export const UnidadeSaudeTableDocument = gql`
  query UnidadeSaudeTable($input: UnidadesSaudeQueryInput!) {
    unidadesSaude(input: $input) {
      content {
        id
        cnes
        nome
        telefone1
        telefone2
        endereco {
          bairro
        }
        ativo
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${PageInfoFragmentDoc}
`

/**
 * __useUnidadeSaudeTableQuery__
 *
 * To run a query within a React component, call `useUnidadeSaudeTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnidadeSaudeTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnidadeSaudeTableQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnidadeSaudeTableQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<Types.UnidadeSaudeTableQuery, Types.UnidadeSaudeTableQueryVariables>
) {
  return ApolloReactHooks.useQuery<Types.UnidadeSaudeTableQuery, Types.UnidadeSaudeTableQueryVariables>(
    UnidadeSaudeTableDocument,
    baseOptions
  )
}
export function useUnidadeSaudeTableLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.UnidadeSaudeTableQuery,
    Types.UnidadeSaudeTableQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<Types.UnidadeSaudeTableQuery, Types.UnidadeSaudeTableQueryVariables>(
    UnidadeSaudeTableDocument,
    baseOptions
  )
}
export type UnidadeSaudeTableQueryHookResult = ReturnType<typeof useUnidadeSaudeTableQuery>
export type UnidadeSaudeTableLazyQueryHookResult = ReturnType<typeof useUnidadeSaudeTableLazyQuery>
export type UnidadeSaudeTableQueryResult = ApolloReactCommon.QueryResult<
  Types.UnidadeSaudeTableQuery,
  Types.UnidadeSaudeTableQueryVariables
>
export const UnificaCadastrosDocument = gql`
  mutation UnificaCadastros($input: UnificacaoCadastroInput!) {
    unificaCadastros(input: $input)
  }
`
export type UnificaCadastrosMutationFn = ApolloReactCommon.MutationFunction<
  Types.UnificaCadastrosMutation,
  Types.UnificaCadastrosMutationVariables
>

/**
 * __useUnificaCadastrosMutation__
 *
 * To run a mutation, you first call `useUnificaCadastrosMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnificaCadastrosMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unificaCadastrosMutation, { data, loading, error }] = useUnificaCadastrosMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnificaCadastrosMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    Types.UnificaCadastrosMutation,
    Types.UnificaCadastrosMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<Types.UnificaCadastrosMutation, Types.UnificaCadastrosMutationVariables>(
    UnificaCadastrosDocument,
    baseOptions
  )
}
export type UnificaCadastrosMutationHookResult = ReturnType<typeof useUnificaCadastrosMutation>
export type UnificaCadastrosMutationResult = ApolloReactCommon.MutationResult<Types.UnificaCadastrosMutation>
export type UnificaCadastrosMutationOptions = ApolloReactCommon.BaseMutationOptions<
  Types.UnificaCadastrosMutation,
  Types.UnificaCadastrosMutationVariables
>
export const UnificacaoCidadaosListingDocument = gql`
  query UnificacaoCidadaosListing($input: CidadaosQueryInput!) {
    listagemCidadaos(input: $input) {
      content {
        id
        nome
        nomeSocial
        cpf
        cns
        nomeMae
        dataNascimento
        telefoneCelular
        telefoneResidencial
        sexo
        identidadeGeneroDbEnum
        ativo
        unificado
        faleceu
        prontuario {
          id
        }
        localidadeNascimento {
          id
          nome
          uf {
            id
            nome
            sigla
          }
        }
        cidadaoVinculacaoEquipe {
          id
          dataAtualizacaoCadastro
          unidadeSaude {
            id
            nome
          }
          equipe {
            id
            nome
            ine
          }
        }
        uuidUltimaFicha
      }
      pageInfo {
        numberOfElements
        totalElements
      }
    }
  }
`

/**
 * __useUnificacaoCidadaosListingQuery__
 *
 * To run a query within a React component, call `useUnificacaoCidadaosListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnificacaoCidadaosListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnificacaoCidadaosListingQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnificacaoCidadaosListingQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.UnificacaoCidadaosListingQuery,
    Types.UnificacaoCidadaosListingQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<Types.UnificacaoCidadaosListingQuery, Types.UnificacaoCidadaosListingQueryVariables>(
    UnificacaoCidadaosListingDocument,
    baseOptions
  )
}
export function useUnificacaoCidadaosListingLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.UnificacaoCidadaosListingQuery,
    Types.UnificacaoCidadaosListingQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    Types.UnificacaoCidadaosListingQuery,
    Types.UnificacaoCidadaosListingQueryVariables
  >(UnificacaoCidadaosListingDocument, baseOptions)
}
export type UnificacaoCidadaosListingQueryHookResult = ReturnType<typeof useUnificacaoCidadaosListingQuery>
export type UnificacaoCidadaosListingLazyQueryHookResult = ReturnType<typeof useUnificacaoCidadaosListingLazyQuery>
export type UnificacaoCidadaosListingQueryResult = ApolloReactCommon.QueryResult<
  Types.UnificacaoCidadaosListingQuery,
  Types.UnificacaoCidadaosListingQueryVariables
>
